<template>
  <div class="import-job-main">
    <div class="left-menu-wrapper">
      <div class="left-menu" ref="leftMenu">
        <Menus :menu="[]" @menuClicked="menuClicked">
          <BoxContainer
            title="Job Actions"
            :isCollapsible="true"
            style="width: 100%; padding-top: 15px"
            :isCollapsed.sync="actionsBoxContainer"
          >
            <button
              class="menu-action"
              @click="customMenuClicked('MnuNew', `New ${pageType} Job`)"
              :disabled="!isMenuEnabled('MnuNew')"
            >
              <img class="menu-action-icon" src="https://dsmlib.logistics.systems/Icons/icons8-add-new-50.png" />
              {{ getMenuTitle('MnuNew', `New ${pageType} Job`) }}
            </button>
            <button
              class="menu-action"
              @click="customMenuClicked('MnuEdit', `Edit ${pageType} Job`)"
              :disabled="!isMenuEnabled('MnuEdit')"
            >
              <img class="menu-action-icon" src="https://dsmlib.logistics.systems/Icons/icons8-edit-64%20(1).png" />
              {{ getMenuTitle('MnuEdit', `Edit ${pageType} Job`) }}
            </button>
            <button
              class="menu-action"
              @click="customMenuClicked('MnuDelete', `Delete ${pageType} Job`)"
              :disabled="!isMenuEnabled('MnuDelete')"
            >
              <img class="menu-action-icon" src="https://dsmlib.logistics.systems/Icons/icons8-reduce-50.png" />
              {{ getMenuTitle('MnuDelete', `Delete ${pageType} Job`) }}
            </button>
            <button
              class="menu-action"
              @click="customMenuClicked('MnuView', `View ${pageType} Job`)"
              :disabled="menuLoading"
            >
              <img class="menu-action-icon" src="https://dsmlib.logistics.systems/Icons/icons8-view-64.png" />
              {{ getMenuTitle('MnuView', `View ${pageType} Job`) }}
            </button>
            <button class="menu-action" @click="customMenuClicked(null, 'Duplicate')" :disabled="menuLoading">
              <img
                class="menu-action-icon"
                src="https://dsmlib.logistics.systems/Icons/DuplicateJob.png"
                alt="Duplicate"
              />
              Duplicate
            </button>
            <button
              class="menu-action"
              @click="customMenuClicked(null, 'Duplicate From Other Company')"
              :disabled="!isMenuEnabled('MnuNew')"
            >
              <img
                class="menu-action-icon"
                src="https://dsmlib.logistics.systems/Icons/DuplicateJob.png"
                alt="Duplicate From Other Company"
              />
              <div>Duplicate From Other Company</div>
            </button>
            <button class="menu-action" @click="customMenuClicked(null, 'Scan Document')" :disabled="menuLoading">
              <img
                class="menu-action-icon"
                src="https://dsmlib.logistics.systems/Icons/ScanDocument.png"
                alt="Scan Document"
              />
              Scan Document
            </button>
            <button class="menu-action" @click="customMenuClicked(null, 'eJob')" :disabled="menuLoading">
              <img class="menu-action-icon" src="https://dsmlib.logistics.systems/Icons/eJob.png" alt="eJob" />
              eJob
            </button>
          </BoxContainer>
          <div style="width: 100%">
            <BoxContainer
              title="Reports / Links"
              :isCollapsible="true"
              style="width: 100%; padding-top: 15px"
              :isCollapsed.sync="othersBoxContainer"
            >
              <button class="menu-action" @click="customMenuClicked(null, 'Print Job Sheet')">
                <img
                  class="menu-action-icon"
                  src="https://dsmlib.logistics.systems/Icons/Print.png"
                  alt="Print Job Sheet"
                />
                Print Job Sheet
              </button>
              <button class="menu-action" @click="customMenuClicked(null, 'Print Import ...')">
                <img class="menu-action-icon" src="https://dsmlib.logistics.systems/Icons/Print.png" />
                {{ getMenuTitle('Print Import ...', `Print ${pageType} ...`) }}
              </button>
              <button class="menu-action" @click="customMenuClicked(null, 'ROT')" :disabled="menuLoading">
                <img class="menu-action-icon" src="https://dsmlib.logistics.systems/Icons/eROT.png" alt="ROT" />
                ROT
              </button>
              <button class="menu-action" @click="customMenuClicked(null, 'Delivery Note')" :disabled="menuLoading">
                <img
                  class="menu-action-icon"
                  src="https://dsmlib.logistics.systems/Icons/eROT.png"
                  alt="Delivery Note"
                />
                Delivery Note
              </button>
              <button
                class="menu-action"
                @click="customMenuClicked('mnuJobCharges', 'Job Charges')"
                :disabled="!isMenuEnabled('mnuJobCharges')"
              >
                <img
                  class="menu-action-icon"
                  src="https://dsmlib.logistics.systems/Icons/money.png"
                  alt="Job Charges"
                />
                Job Charges
              </button>
            </BoxContainer>
          </div>
          <div v-if="enableSMKmodule" style="width: 100%">
            <BoxContainer
              :title="(selectedsmkPartJob || []).length > 0 ? 'SMK Part Job' : 'SMK'"
              :isCollapsible="true"
              style="width: 100%; padding-top: 15px"
              :isCollapsed.sync="smkBoxContainer"
            >
              <button
                class="menu-action"
                @click="menuClicked({ title: 'New Part Job', enabled: !disableSMKButtons })"
                :disabled="disableSMKButtons"
              >
                <img
                  class="menu-action-icon"
                  src="https://dsmlib.logistics.systems/Icons/icons8-add-new-50.png"
                  alt="New Part Job"
                />
                New Part Job
              </button>

              <button
                v-if="(selectedsmkPartJob || []).length > 0"
                class="menu-action"
                @click="menuClicked({ title: 'Edit Part Job', enabled: !disableSMKButtons })"
                :disabled="disableSMKButtons"
              >
                <img
                  class="menu-action-icon"
                  src="https://dsmlib.logistics.systems/Icons/icons8-edit-64%20(1).png"
                  alt="Edit Part Job"
                />
                Edit Part Job
              </button>
              <button
                v-if="(selectedsmkPartJob || []).length > 0"
                class="menu-action"
                @click="menuClicked({ title: 'Delete Part Job', enabled: !disableSMKButtons })"
                :disabled="disableSMKButtons"
              >
                <img
                  class="menu-action-icon"
                  src="https://dsmlib.logistics.systems/Icons/icons8-reduce-50.png"
                  alt="Delete Part Job"
                />
                Delete Part Job
              </button>
              <button
                v-if="(selectedsmkPartJob || []).length > 0"
                class="menu-action"
                @click="menuClicked({ title: 'View Part Job', enabled: !disableSMKButtons })"
                :disabled="disableSMKButtons"
              >
                <img
                  class="menu-action-icon"
                  src="https://dsmlib.logistics.systems/Icons/icons8-view-64.png"
                  alt="View Part Job"
                />
                View Part Job
              </button>
              <button
                v-if="(selectedsmkPartJob || []).length > 0"
                class="menu-action"
                @click="menuClicked({ title: 'Duplicate Part Job', enabled: !disableSMKButtons })"
                :disabled="disableSMKButtons"
              >
                <img
                  class="menu-action-icon"
                  src="https://dsmlib.logistics.systems/Icons/DuplicateJob.png"
                  alt="Duplicate Part Job"
                />
                Duplicate Part Job
              </button>
              <span class="menu-disabled-wrapper" title="Under development">
                <button
                  class="menu-action"
                  @click="menuClicked({ title: 'Print SMK ...', enabled: !disableSMKButtons })"
                  :disabled="true"
                >
                  <img
                    class="menu-action-icon"
                    src="https://dsmlib.logistics.systems/Icons/Print.png"
                    alt="Print SMK ..."
                  />
                  Print SMK ...
                </button>
              </span>
            </BoxContainer>
          </div>
        </Menus>
      </div>
    </div>
    <div class="page-layout">
      <!-- Top Section -->
      <div
        class="top-section-job"
        :style="showSMKDetails && enableSMKmodule ? { flex: `0 0 ${topSectionHeight}%` } : { flex: '1 1 auto' }"
      >
        <!-- <div class="menu-section">
            <Menus :menu="menu" @menuClicked="menuClicked" />
          </div> -->
        <div class="section-content">
          <div class="right-tabulator">
            <div class="filter-area">
              <div>{{ filterText }}</div>
              <ButtonFilter
                class="button-filter"
                filterPosition="right"
                buttonText="Change Filter"
                :filterWidth="300"
                :isOpen.sync="mainFilterIsOpen"
              >
                <div class="filter-item">
                  <BoxContainer
                    class="filter-check"
                    title="Date"
                    :isChecked.sync="dateFilterChecked"
                    :isCheckBox="true"
                    style="margin-bottom: 5px"
                  >
                    <div class="dates">
                      <DateTimePicker
                        placeholder="Start"
                        title="Start"
                        :showTime="false"
                        :value.sync="refreshStart"
                        :isDisabled="!dateFilterChecked"
                        :maxDate="smallDateTimeMaxDate"
                        :minDate="smallDateTimeMinValue"
                      />
                      <DateTimePicker
                        placeholder="End"
                        title="End"
                        :showTime="false"
                        :value.sync="refreshEnd"
                        :isDisabled="!dateFilterChecked"
                        :maxDate="smallDateTimeMaxDate"
                        :minDate="smallDateTimeMinValue"
                      />
                    </div>
                  </BoxContainer>
                </div>
                <div class="filter-item">
                  <BoxContainer
                    class="filter-check"
                    title="Search"
                    :isChecked.sync="searchFilterChecked"
                    :isCheckBox="true"
                    style="margin-bottom: 5px"
                  >
                    <Dropdown
                      placeholder="Search By"
                      :items="searchFilterItems"
                      itemKey="Search Criteria"
                      :isDisabled="!searchFilterChecked"
                      :isRequired="searchFilterChecked"
                      :selectedObject.sync="selectedSearchBy"
                      :errorMessage.sync="searchByError"
                      @selected="searchBySelected"
                      validator="text,40"
                    />
                    <Dropdown
                      placeholder="Search Criteria"
                      :items="searchCriteriaItems"
                      itemKey="name"
                      :isDisabled="!searchFilterChecked || criteriaDisabled"
                      :isRequired="searchFilterChecked"
                      :selectedObject.sync="selectedCriteria"
                      validator="text,40"
                    />
                    <Input
                      placeholder="Search"
                      :inputValue.sync="searchByValue"
                      :isDisabled="!searchFilterChecked"
                      :isRequired="searchFilterChecked"
                      :errorMessage.sync="searchByValueError"
                    />
                  </BoxContainer>
                </div>
                <button @click="refreshClicked" :disabled="!dateFilterChecked && !searchFilterChecked">Refresh</button>
              </ButtonFilter>
              <div>Last Refreshed: {{ lastRefreshed }}</div>
            </div>
            <div v-if="pageType == 'Export'" class="tabulator-area" :style="jobSectionStyling">
              <TableBox
                :tableData="jobsList"
                :title="tableTitle"
                :selectedRow.sync="selectedJob"
                :loading="tableLoading"
                :dataType="{ 'Job DateTime': 'datetime' }"
                :columnOrderViews.sync="tableBoxColumnOrderViewsExp"
                :columnOrderID="tableBoxColumnOrderIDExp"
                @rowSelected="(selectedRow, selected) => tableBoxRowSelected(selectedRow, selected, 'EXP')"
              />
            </div>
            <div v-if="pageType == 'Import'" class="tabulator-area" :style="jobSectionStyling">
              <TableBox
                :tableData="jobsList"
                :title="tableTitle"
                :selectedRow.sync="selectedJob"
                :loading="tableLoading"
                :dataType="{ 'Job DateTime': 'datetime' }"
                :hideColumns="['Closing Time']"
                :columnOrderViews.sync="tableBoxColumnOrderViewsImp"
                :columnOrderID="tableBoxColumnOrderIDImp"
                @rowSelected="(selectedRow, selected) => tableBoxRowSelected(selectedRow, selected, 'IMP')"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- #region Horizontal Resizer -->
      <div
        v-if="showSMKDetails && enableSMKmodule"
        class="resizer vresizer"
        @mousedown="verticalResizerMousedown"
      ></div>
      <!-- #endregion -->

      <!-- Bottom right content -->
      <div v-if="showSMKDetails && enableSMKmodule" class="bottom-section-job" style="flex: 1 1 0">
        <!-- <div class="menu-section">
            <Menus :menu="smkMenu" @menuClicked="menuClicked" />
          </div> -->
        <div class="job-listing-section">
          <div class="smk-content">
            <TableBox
              :title="`SMK Part Job`"
              :tableData="smkPartJobList"
              :selectedRow.sync="selectedsmkPartJob"
              @rowSelected="(selectedRow, selected) => tableBoxRowSelected(selectedRow, selected, 'PART')"
            />
          </div>
        </div>
      </div>
    </div>

    <RightMenu v-if="enableSMKmodule" :showMenu.sync="showSMKRightMenu" :maxWidth="1000">
      <div class="right-menu">
        <div class="right-menu-body-scroll">
          <SMKDetails
            ref="smkDetailsSideBar"
            :smkDetails="(smkSideSummaryDetails || []).length > 0 ? smkSideSummaryDetails[0] : {}"
            :smkJobDetailRows="smkSideJobDetailRows"
            :smkExempt="(smkSideExemptDetails || []).length > 0 ? smkSideExemptDetails[0] : {}"
            :smkDoc="smkSideDocList || []"
            :smkItems="smkSideItemList || []"
            :smkItemColumns="visibleSMKItemColumns"
            :jobDetails="smkSideJobSummaryDetails || {}"
            :smkStatus="smkSideSubmissionList"
            :selectedJob="(selectedJob || []).length > 0 ? selectedJob[0] : {}"
            :attachmentList="[attachmentList]"
            :pageType="pageType"
            :isLoading="smkDetailsFulfill"
            :smkItemDutyRowsGetter="buildSMKItemDutyRows"
            :smkItemCessRowsGetter="buildSMKItemCessRows"
            :showSMKCessTable="showSMKSideCessTable"
            @deleteSMKItemAllSideBar="deleteSMKItemAllSideBar"
            :showSMKItemHoverTables.sync="showSMKItemHoverTables"
            :showSMKVehicleColumns.sync="showSMKVehicleColumns"
            :showSMKWarehouseColumns.sync="showSMKWarehouseColumns"
          />
        </div>

        <div class="right-menu-footer">
          <!-- <div class="message-container" :style="messageContainerStyling" style="font-weight: bold" /> -->
          <div class="buttons-container">
            <button @click="approvalResendClicked" :disabled="true">Approval To Re-send</button>
            <button @click="previewFlatFileClicked" :disabled="false">Preview FlatFile</button>
            <button @click="emailDagangClicked" :disabled="false">Email Careline</button>
          </div>
        </div>
      </div>
    </RightMenu>
    <PopupEntry
      v-if="showPopup"
      :show.sync="showPopup"
      :title="popupTitle"
      @save="saveClicked"
      @requiredClicked="requiredClicked"
      :createdBy="createdBy"
      :updatedBy="updatedBy"
      :errorMessages="eMessages"
      :successMessages="sMessages"
      :requiredError="rMessages"
      :viewMode="viewMode"
      :cancelButton="viewMode ? 'Close' : 'Cancel'"
    >
      <div v-if="milestonesItem && currentTabIndex != 9" class="popup-milestones" id="popupMilestone">
        <img
          class="collapse-milestone"
          src="https://dsmapi.logistics.systems/dsm6gicons/icons8-expand-arrow-24.png"
          @click="toggleMilestones"
          :style="{ transform: `rotate(${showMilestones ? 180 : 0}deg)` }"
        />
        <div class="milestones-row" v-if="showMilestones">
          <div class="milestones-block" v-for="(m, i) in milestonesItem['milestones']" :key="i">
            <div class="milestones-item" :style="{ backgroundColor: `${m['BackColor']}` }">{{ m['ShowText'] }}</div>
            <Tooltip class="milestone-tooltip" :tooltipText="m['ShowText']">
              <div></div>
            </Tooltip>
          </div>
        </div>
        <div class="milestones-row" v-if="showMilestones">
          <div v-for="(l, i) in Object.keys(milestonesItem['legend'])" :key="i" class="legend-items">
            <div class="legend-box" :style="{ backgroundColor: `${milestonesItem['legend'][l]}` }"></div>
            {{ l }}
          </div>
        </div>
        <div v-else>Milestones</div>
      </div>
      <div v-if="currentTabIndex == 9" class="popup-milestones" id="popupMilestone">
        <img
          class="collapse-milestone"
          src="https://dsmapi.logistics.systems/dsm6gicons/icons8-expand-arrow-24.png"
          @click="toggleMilestones"
          :style="{ transform: `rotate(${showMilestones ? 180 : 0}deg)` }"
        />

        <div class="milestones-row" v-if="showMilestones">
          <div class="milestones-block" v-for="(s, i) in smkSubmissionList" :key="i">
            <div class="milestones-item-smk" :style="{ backgroundColor: s['BackColor'] }">
              <div class="smk-request-type">{{ s['Request Type'] }}</div>
              <div class="smk-status-code">{{ s['Status Code'] }}</div>
              <div class="smk-remarks">{{ s['Remarks'] }}</div>
            </div>

            <Tooltip class="milestone-tooltip" :tooltipText="getSMKSubmissionTooltip(s)">
              <div></div>
            </Tooltip>
          </div>
        </div>

        <div class="milestones-row" v-if="showMilestones">
          <div class="legend-items" v-for="item in smkLegendItems" :key="item.label">
            <div class="legend-box" :style="{ backgroundColor: getSMKSubmissionBackColor(item.sample) }"></div>
            {{ item.label }}
          </div>
        </div>

        <div v-else>SMK Tracking</div>
      </div>
      <div class="popup-details" id="popupDetails" :style="{ height: `calc(100% - ${milestoneHeight}px)` }">
        <div v-if="currentTabIndex != 1 && currentTabIndex != 9" class="summary">
          <div style="margin-bottom: 5px">Header Info</div>
          <Input
            :isDisabled="true"
            placeholder="Trans Mode"
            :inputValue="
              selectedHeaderInfoData['selectedTransMode'] ?
                selectedHeaderInfoData['selectedTransMode']['Description']
              : ''
            "
            :title="
              selectedHeaderInfoData['selectedTransMode'] ?
                selectedHeaderInfoData['selectedTransMode']['Description']
              : ''
            "
            :style="{ opacity: selectedHeaderInfoData['selectedTransMode'] ? '1' : '0.5' }"
          />

          <Input
            :isDisabled="true"
            placeholder="Cargo Type"
            :inputValue="
              selectedHeaderInfoData['selectedCargoType'] ?
                selectedHeaderInfoData['selectedCargoType']['Cargo Type']
              : ''
            "
            :title="
              selectedHeaderInfoData['selectedCargoType'] ?
                selectedHeaderInfoData['selectedCargoType']['Cargo Type']
              : ''
            "
            :style="{ opacity: selectedHeaderInfoData['selectedCargoType'] ? '1' : '0.5' }"
          />

          <Input
            :isDisabled="true"
            placeholder="Shipper"
            :inputValue="
              selectedHeaderInfoData['selectedShipper'] ? selectedHeaderInfoData['selectedShipper']['Shipper Name'] : ''
            "
            :title="
              selectedHeaderInfoData['selectedShipper'] ? selectedHeaderInfoData['selectedShipper']['Shipper Name'] : ''
            "
            :style="{ opacity: selectedHeaderInfoData['selectedShipper'] ? '1' : '0.5' }"
          />

          <Input
            :isDisabled="true"
            placeholder="Consignee"
            :inputValue="
              selectedHeaderInfoData['selectedConsignee'] ?
                selectedHeaderInfoData['selectedConsignee']['Consignee Name']
              : ''
            "
            :title="
              selectedHeaderInfoData['selectedConsignee'] ?
                selectedHeaderInfoData['selectedConsignee']['Consignee Name']
              : ''
            "
            :style="{ opacity: selectedHeaderInfoData['selectedConsignee'] ? '1' : '0.5' }"
          />

          <Input
            :isDisabled="true"
            placeholder="Notify Party"
            :inputValue="
              selectedHeaderInfoData['selectedNotifyParty'] ?
                selectedHeaderInfoData['selectedNotifyParty']['Notify Party Name']
              : ''
            "
            :title="
              selectedHeaderInfoData['selectedNotifyParty'] ?
                selectedHeaderInfoData['selectedNotifyParty']['Notify Party Name']
              : ''
            "
            :style="{ opacity: selectedHeaderInfoData['selectedNotifyParty'] ? '1' : '0.5' }"
          />

          <Input
            :isDisabled="true"
            placeholder="Customer Ref #"
            :inputValue="selectedHeaderInfoData['custRefNo'] ? selectedHeaderInfoData['custRefNo'] : ''"
            :title="selectedHeaderInfoData['custRefNo'] ? selectedHeaderInfoData['custRefNo'] : ''"
            :style="{ opacity: selectedHeaderInfoData['custRefNo'] ? '1' : '0.5' }"
          />

          <Input
            :isDisabled="true"
            :placeholder="pageType == 'Import' ? 'B/L #' : 'VBkg Ref #'"
            :inputValue="selectedHeaderInfoData['vbkgRefNo'] ? selectedHeaderInfoData['vbkgRefNo'] : ''"
            :title="selectedHeaderInfoData['vbkgRefNo'] ? selectedHeaderInfoData['vbkgRefNo'] : ''"
            :style="{ opacity: selectedHeaderInfoData['vbkgRefNo'] ? '1' : '0.5' }"
          />

          <Input
            :isDisabled="true"
            placeholder="Bill To"
            :inputValue="
              selectedHeaderInfoData['selectedBillTo'] ? selectedHeaderInfoData['selectedBillTo']['Customer Name'] : ''
            "
            :title="
              selectedHeaderInfoData['selectedBillTo'] ? selectedHeaderInfoData['selectedBillTo']['Customer Name'] : ''
            "
            :style="{ opacity: selectedHeaderInfoData['selectedBillTo'] ? '1' : '0.5' }"
          />

          <Input
            :isDisabled="true"
            placeholder="Job #"
            :inputValue="selectedHeaderInfoData['jobNo'] ? selectedHeaderInfoData['jobNo'] : ''"
            :title="selectedHeaderInfoData['jobNo'] ? selectedHeaderInfoData['jobNo'] : ''"
            :style="{ opacity: selectedHeaderInfoData['jobNo'] ? '1' : '0.5' }"
          />

          <Input
            :isDisabled="true"
            placeholder="Job Time"
            :inputValue="
              selectedHeaderInfoData['jobTime'] ?
                new Date(selectedHeaderInfoData['jobTime']).formatString('dd/MM/yyyy HH:mm')
              : ''
            "
            :title="
              selectedHeaderInfoData['jobTime'] ?
                new Date(selectedHeaderInfoData['jobTime']).formatString('dd/MM/yyyy HH:mm')
              : ''
            "
            :style="{ opacity: selectedHeaderInfoData['jobTime'] ? '1' : '0.5' }"
          />

          <Input
            :isDisabled="true"
            placeholder="Job State"
            :inputValue="selectedHeaderInfoData['jobStatus'] ? selectedHeaderInfoData['jobStatus'] : ''"
            :title="selectedHeaderInfoData['jobStatus'] ? selectedHeaderInfoData['jobStatus'] : ''"
            :style="{ opacity: selectedHeaderInfoData['jobStatus'] ? '1' : '0.5' }"
          />
        </div>
        <Tab
          :style="{ width: currentTabIndex != 1 && currentTabIndex != 9 ? 'calc(100% - 120px)' : '100%' }"
          :tabs="tabsItems"
          :tabIndex.sync="currentTabIndex"
        >
          <!-- Quick Entry tab -->
          <div slot="Quick Entry">
            <div class="tab-block">
              <div class="tab-title">Header Info</div>
              <div class="details-column">
                <Dropdown
                  placeholder="Trans Mode"
                  :items="headerInfoData['transMode']"
                  itemKey="Description"
                  ref="transmode"
                  :errorMessage.sync="errorMessages['transmode']"
                  :selectedObject.sync="selectedHeaderInfoData['selectedTransMode']"
                  :isRequired="true"
                  :isDisabled="viewMode"
                  validator="text,50"
                />
                <InputQuery
                  placeholder="Cargo Type"
                  :items="headerInfoData['cargoType']"
                  itemKey="Cargo Type"
                  descKey="Description"
                  ref="cargotype_code"
                  :errorMessage.sync="errorMessages['cargotype_code']"
                  :selectedObject.sync="selectedHeaderInfoData['selectedCargoType']"
                  :isRequired="true"
                  :isDisabled="viewMode"
                  @selected="cargoTypeSelected"
                  validator="text,50"
                />
              </div>
              <div class="details-column">
                <InputQuery
                  placeholder="Shipper"
                  v-if="pageType == 'Export'"
                  :items="headerInfoData['shipper']"
                  itemKey="Code - Name"
                  descKey="Shipper Name"
                  :errorMessage.sync="errorMessages['shipper']"
                  :selectedObject.sync="selectedHeaderInfoData['selectedShipper']"
                  :isRequired="true"
                  :isDisabled="viewMode || (billingCheckDisabled && pageType == 'Export')"
                  ref="shipper"
                  @selected="shipperSelected"
                  :allowFreeText="false"
                  validator="text,115"
                />
                <InputQuery
                  placeholder="Consignee"
                  v-if="pageType == 'Import'"
                  :items.sync="headerInfoData['consignee']"
                  itemKey="Code - Name"
                  descKey="Consignee Name"
                  :errorMessage.sync="errorMessages['consignee']"
                  :selectedObject.sync="selectedHeaderInfoData['selectedConsignee']"
                  :isRequired="true"
                  :isDisabled="viewMode || (billingCheckDisabled && pageType == 'Import')"
                  ref="consignee"
                  @selected="consigneeSelected"
                  addLink="/Home/MasterFiles/ProfileMaster/ShipperConsignee?new=1"
                  :canRefresh="true"
                  @refreshClicked="consigneeInputQueryRefreshClicked"
                  :allowFreeText="false"
                  validator="text,115"
                />
                <Input
                  v-if="pageType == 'Export'"
                  :placeholder="pageType == 'Import' ? 'B/L #' : 'VBkg Ref #'"
                  :inputValue.sync="selectedHeaderInfoData['vbkgRefNo']"
                  :isDisabled="viewMode"
                  :isRequired="pageType == 'Export'"
                  ref="vbkgRefNo"
                  :errorMessage.sync="errorMessages['vbkgRefNo']"
                />
                <InputQuery
                  placeholder="Bill To"
                  :items.sync="headerInfoData['billTo']"
                  itemKey="Code - Name"
                  descKey="Customer Name"
                  ref="billcu_no"
                  :errorMessage.sync="errorMessages['billcu_no']"
                  :selectedObject.sync="selectedHeaderInfoData['selectedBillTo']"
                  @selected="billToSelected"
                  :isRequired="true"
                  :isDisabled="viewMode || billingCheckDisabled"
                  addLink="/Home/MasterFiles/ProfileMaster/Customer?new=1"
                  :canRefresh="true"
                  @refreshClicked="billToInputQueryRefreshClicked"
                  validator="text,115"
                />
              </div>
              <div class="details-column">
                <Input
                  placeholder="Job #"
                  :inputValue.sync="selectedHeaderInfoData['jobNo']"
                  :isRequired="true"
                  :isDisabled="true"
                />
                <DateTimePicker
                  placeholder="Job Time"
                  title="Job Time"
                  :value.sync="selectedHeaderInfoData['jobTime']"
                  :isRequired="true"
                  :isDisabled="viewMode"
                  :maxDate="smallDateTimeMaxDate"
                  :minDate="smallDateTimeMinValue"
                  :errorMessage.sync="errorMessages['jobtime']"
                  ref="jobtime"
                  @dateChanged="checkDateTime('jobtime', $event)"
                />
              </div>
            </div>
            <div class="tab-block">
              <div class="tab-title">Shipping Info</div>
              <div class="details-column">
                <InputQuery
                  :placeholder="transportMethodPlaceholders('ShipCallNo')"
                  :items="shippingInfoData['shipCallNoList']"
                  itemKey="SCN - Terminal"
                  descKey="Vessel Name"
                  :isRequired="true"
                  :isDisabled="viewMode"
                  :selectedObject.sync="selectedShippingInfoData['selectedShipCall']"
                  ref="shipcall_no"
                  :errorMessage.sync="errorMessages['shipcall_no']"
                  @selected="shipCallNoSelected"
                  :search.sync="shipCallNoSearch"
                  validator="text,45"
                  :allowFreeText="true"
                  :isLoading="shipCallNoLoading"
                />
                <Input
                  placeholder="Voyage #"
                  :inputValue.sync="selectedShippingInfoData['voyNo']"
                  :isRequired="true"
                  ref="voyno"
                  :isDisabled="viewMode"
                  :errorMessage.sync="errorMessages['voyno']"
                  validator="text,10,uppercase"
                />
                <InputQuery
                  :placeholder="transportMethodPlaceholders('ShippingAgent')"
                  :items="shippingInfoData['shippingAgentList']"
                  itemKey="Code - Name"
                  descKey="Agent Name"
                  :isRequired="true"
                  :isDisabled="viewMode"
                  @selected="calculateDefaultDates('Agent', $event)"
                  :selectedObject.sync="selectedShippingInfoData['selectedAgentList']"
                  ref="ag_code"
                  :errorMessage.sync="errorMessages['ag_code']"
                  :canRefresh="true"
                  @refreshClicked="shippingAgentInputQueryRefreshClicked"
                  addLink="/Home/MasterFiles/ProfileMaster/Supplier?new=1&supplier=SA"
                  validator="text,115"
                />
              </div>
              <div class="details-column">
                <InputQuery
                  placeholder="Port of Loading"
                  :items.sync="shippingInfoData['portOfLoading']"
                  itemKey="Code - Desc"
                  descKey="Port Location"
                  :isRequired="true"
                  :isDisabled="viewMode"
                  :selectedObject.sync="selectedShippingInfoData['selectedPortLoading']"
                  ref="imp_port"
                  :errorMessage.sync="errorMessages['imp_port']"
                  addLink="/Home/MasterFiles/OperationMaster/Port?new=1"
                  :canRefresh="true"
                  @refreshClicked="portOfLoadingInputQueryRefreshClicked"
                  validator="text,10"
                />
                <InputQuery
                  placeholder="Port of Discharge"
                  :items.sync="shippingInfoData['portOfDischarge']"
                  itemKey="Code - Desc"
                  descKey="Port Location"
                  :isRequired="true"
                  :isDisabled="viewMode"
                  :selectedObject.sync="selectedShippingInfoData['selectedPortDischarge']"
                  ref="load_port"
                  :errorMessage.sync="errorMessages['load_port']"
                  addLink="/Home/MasterFiles/OperationMaster/Port?new=1"
                  :canRefresh="true"
                  @refreshClicked="portOfDischargeInputQueryRefreshClicked"
                  validator="text,10"
                />
              </div>
              <div class="details-column">
                <DateTimePicker
                  v-if="pageType != 'Import'"
                  placeholder="Closing"
                  title="Closing"
                  :isDisabled="viewMode"
                  :value.sync="selectedShippingInfoData['closingTime']"
                  :isRequired="true"
                  ref="closing_time"
                  :maxDate="smallDateTimeMaxDate"
                  :minDate="smallDateTimeMinValue"
                  :errorMessage.sync="errorMessages['closing_time']"
                  @dateChanged="checkDateTime('closing_time', $event)"
                />
                <div v-else style="min-height: 25px; margin: 2px 0"></div>
                <DateTimePicker
                  v-if="pageType != 'Import'"
                  :placeholder="getPOLPlaceholderAndTitle"
                  :value.sync="selectedShippingInfoData['polETD']"
                  :isRequired="true"
                  ref="timedchgload"
                  :isDisabled="viewMode"
                  :errorMessage.sync="errorMessages['timedchgload']"
                  :maxDate="smallDateTimeMaxDate"
                  :minDate="smallDateTimeMinValue"
                  @dateChanged="checkDateTime('timedchgload', $event)"
                />
                <div v-else style="min-height: 25px; margin: 2px 0"></div>
                <DateTimePicker
                  placeholder="POD ETA"
                  title="POD ETA"
                  :value.sync="selectedShippingInfoData['polETA']"
                  :isRequired="true"
                  ref="time_eta"
                  :isDisabled="viewMode"
                  :errorMessage.sync="errorMessages['time_eta']"
                  @dateChanged="checkDateTime('time_eta', $event)"
                  :maxDate="smallDateTimeMaxDate"
                  :minDate="smallDateTimeMinValue"
                />
              </div>
            </div>
            <div class="tab-block">
              <div class="tab-title">Cargo Info</div>
              <div
                class="details-column"
                v-if="
                  selectedHeaderInfoData['selectedCargoType'] ?
                    selectedHeaderInfoData['selectedCargoType']['Cargo Type'][0] != 'F'
                  : false
                "
              >
                <div style="display: flex; align-items: center">
                  <Input
                    placeholder="Gross Weight"
                    textAlign="right"
                    :inputValue.sync="selectedCargoInfoData['gWeight']"
                    ref="gWeightInput"
                    :isDisabled="viewMode"
                    :isRequired="
                      selectedHeaderInfoData['selectedCargoType'] ?
                        selectedHeaderInfoData['selectedCargoType']['Cargo Type'][0] != 'F'
                      : false
                    "
                    validator="positiveDecimal,5,4"
                  />
                  KG
                </div>
              </div>
              <div class="details-column">
                <InputQuery
                  placeholder="Packing Material"
                  :items="cargoInfoData['pMaterialList']"
                  itemKey="Code - Desc"
                  descKey="Material Description"
                  :selectedObject.sync="selectedCargoInfoData['selectedPMaterial']"
                  :isRequired="true"
                  :isDisabled="viewMode"
                  ref="packmat"
                  :errorMessage.sync="errorMessages['packmat']"
                  validator="text,58"
                />
                <div style="display: flex; width: 600px">
                  <Input
                    style="margin-right: 5px; width: 200px"
                    placeholder="No. of Pkg"
                    textAlign="right"
                    :isRequired="true"
                    :isDisabled="viewMode"
                    :inputValue.sync="selectedCargoInfoData['packageCount']"
                    ref="no_package"
                    :errorMessage.sync="errorMessages['no_package']"
                    validator="positiveDecimal,8,2"
                  />
                  <InputQuery
                    placeholder="Pkg Type"
                    :items="cargoInfoData['pkgTypeList']"
                    itemKey="Code - Desc"
                    descKey="Description"
                    :selectedObject.sync="selectedCargoInfoData['selectedPackageType']"
                    :isRequired="true"
                    :isDisabled="viewMode"
                    ref="package_code"
                    :errorMessage.sync="errorMessages['package_code']"
                    validator="text,65,uppercase"
                  />
                </div>
              </div>
              <div class="details-column"> </div>
            </div>
          </div>
          <!-- Header Info tab -->
          <div slot="Header Info" style="height: 100%">
            <div class="slot-body-block" style="height: 100%">
              <div class="slot-content-column column-flex">
                <Dropdown
                  placeholder="Trans Mode"
                  :items="headerInfoData['transMode']"
                  itemKey="Description"
                  :isDisabled="viewMode"
                  :selectedObject.sync="selectedHeaderInfoData['selectedTransMode']"
                  :isRequired="true"
                  validator="text,50"
                />
                <InputQuery
                  placeholder="Cargo Type"
                  :items="headerInfoData['cargoType']"
                  itemKey="Cargo Type"
                  descKey="Description"
                  :isDisabled="viewMode"
                  :selectedObject.sync="selectedHeaderInfoData['selectedCargoType']"
                  :isRequired="true"
                  @selected="cargoTypeSelected"
                  validator="text,50"
                />
                <Dropdown
                  placeholder="SMK Form Type"
                  :items="headerInfoData['smkFormType']"
                  itemKey="Form Type"
                  :isDisabled="viewMode"
                  :selectedObject.sync="selectedHeaderInfoData['selectedSmkFormType']"
                  validator="text,3"
                />
                <InputQuery
                  placeholder="Shipper"
                  :items.sync="headerInfoData['shipper']"
                  itemKey="Code - Name"
                  descKey="Shipper Name"
                  :isDisabled="viewMode || (billingCheckDisabled && pageType == 'Export')"
                  :selectedObject.sync="selectedHeaderInfoData['selectedShipper']"
                  :isRequired="pageType == 'Export'"
                  @selected="shipperSelected"
                  addLink="/Home/MasterFiles/ProfileMaster/ShipperConsignee?new=1"
                  :canRefresh="true"
                  @refreshClicked="shipperInputQueryRefreshClicked"
                  :allowFreeText="false"
                  validator="text,115"
                />
                <div class="address" :class="{ 'address-collapse': !showShipperAddress }">
                  <div class="edit-area">
                    <button v-if="!viewMode" @click="editDetailsPopup('shipper')">{{
                      selectedHeaderInfoData['selectedShipper'] !== null || shipperAddress ? 'Edit' : 'Add'
                    }}</button>
                    <img
                      src="https://dsmlib.logistics.systems/Icons/icons8-expand-arrow-24.png"
                      alt=""
                      height="20"
                      @click="showHideAddress('shipper')"
                      :class="[showShipperAddress ? 'img-show' : 'img-hide']"
                    />
                  </div>

                  <div v-if="showShipperAddress" class="address-block">
                    <div v-if="shipperAddress">
                      {{ shipperAddress['name'] }}<br />
                      {{ shipperAddress['add1'] }}<br />
                      {{ shipperAddress['add2'] }}<br />
                      {{ shipperAddress['add3'] }}<br />
                      {{ shipperAddress['add4'] }}<br />
                      {{ shipperAddress['postcode'] }} {{ shipperAddress['city'] }}<br />
                      {{ shipperAddress['state'] }} {{ shipperAddress['country'] }}<br /><br />
                      Attn: {{ shipperAddress['attn'] }}<br />
                      Tel: {{ shipperAddress['tel'] }}<br />
                      Fax: {{ shipperAddress['fax'] }}<br />
                      GST No: {{ shipperAddress['gst'] }}<br />
                    </div>
                    <div v-else> No Shipper Selected </div>
                  </div>
                  <div v-else> Shipper Details </div>
                </div>
                <InputQuery
                  placeholder="Consignee"
                  :items.sync="headerInfoData['consignee']"
                  itemKey="Code - Name"
                  descKey="Consignee Name"
                  :isDisabled="viewMode || (billingCheckDisabled && pageType == 'Import')"
                  :selectedObject.sync="selectedHeaderInfoData['selectedConsignee']"
                  :isRequired="pageType == 'Import'"
                  @selected="consigneeSelected"
                  addLink="/Home/MasterFiles/ProfileMaster/ShipperConsignee?new=1"
                  :canRefresh="true"
                  @refreshClicked="consigneeInputQueryRefreshClicked"
                  :allowFreeText="false"
                  validator="text,115"
                />
                <div class="address" :class="{ 'address-collapse': !showConsigneeAddress }">
                  <div class="edit-area">
                    <button v-if="!viewMode" @click="editDetailsPopup('consignee')">{{
                      selectedHeaderInfoData['selectedConsignee'] !== null || consigneeAddress ? 'Edit' : 'Add'
                    }}</button>
                    <img
                      src="https://dsmlib.logistics.systems/Icons/icons8-expand-arrow-24.png"
                      alt=""
                      height="20"
                      @click="showHideAddress('consignee')"
                      :class="[showConsigneeAddress ? 'img-show' : 'img-hide']"
                    />
                  </div>

                  <div v-if="showConsigneeAddress" class="address-block">
                    <div v-if="consigneeAddress">
                      {{ consigneeAddress['name'] }}<br />
                      {{ consigneeAddress['add1'] }}<br />
                      {{ consigneeAddress['add2'] }}<br />
                      {{ consigneeAddress['add3'] }}<br />
                      {{ consigneeAddress['add4'] }}<br />
                      {{ consigneeAddress['postcode'] }} {{ consigneeAddress['city'] }}<br />
                      {{ consigneeAddress['state'] }} {{ consigneeAddress['country'] }}<br /><br />
                      Attn: {{ consigneeAddress['attn'] }}<br />
                      Tel: {{ consigneeAddress['tel'] }}<br />
                      Fax: {{ consigneeAddress['fax'] }}<br />
                      GST No: {{ consigneeAddress['gst'] }}<br />
                    </div>
                    <div v-else> No Consignee Selected </div>
                  </div>
                  <div v-else> Consignee Details </div>
                </div>
                <InputQuery
                  placeholder="Notify Party"
                  :items="headerInfoData['notifyParty']"
                  itemKey="Code - Name"
                  descKey="Notify Party Name"
                  :isDisabled="viewMode"
                  :selectedObject.sync="selectedHeaderInfoData['selectedNotifyParty']"
                  @selected="npartySelected"
                  validator="text,115"
                />
                <div class="address" :class="{ 'address-collapse': !showNPartyAddress }">
                  <div class="edit-area">
                    <button v-if="!viewMode" @click="editDetailsPopup('nparty')">{{
                      selectedHeaderInfoData['selectedNotifyParty'] !== null || notifyPartyAddress ? 'Edit' : 'Add'
                    }}</button>

                    <img
                      src="https://dsmlib.logistics.systems/Icons/icons8-expand-arrow-24.png"
                      alt=""
                      height="20"
                      @click="showHideAddress('nparty')"
                      :class="[showNPartyAddress ? 'img-show' : 'img-hide']"
                    />
                  </div>

                  <div v-if="showNPartyAddress" class="address-block">
                    <div v-if="notifyPartyAddress">
                      {{ notifyPartyAddress['name'] }}<br />
                      {{ notifyPartyAddress['add1'] }}<br />
                      {{ notifyPartyAddress['add2'] }}<br />
                      {{ notifyPartyAddress['add3'] }}<br />
                      {{ notifyPartyAddress['add4'] }}<br />
                      {{ notifyPartyAddress['postcode'] }} {{ notifyPartyAddress['city'] }}<br />
                      {{ notifyPartyAddress['state'] }} {{ notifyPartyAddress['country'] }}<br /><br />
                      Attn: {{ notifyPartyAddress['attn'] }}<br />
                      Tel: {{ notifyPartyAddress['tel'] }}<br />
                      Fax: {{ notifyPartyAddress['fax'] }}<br />
                      GST No: {{ notifyPartyAddress['gst'] }}<br />
                    </div>
                    <div v-else> No Notify Party Selected </div>
                  </div>
                  <div v-else> Notify Party Details </div>
                </div>
              </div>
              <div class="slot-content-column">
                <Input
                  placeholder="Project #"
                  :inputValue.sync="selectedHeaderInfoData['projectNo']"
                  :isDisabled="viewMode"
                  validator="text,25"
                />
                <Input
                  placeholder="Customer Ref #"
                  :inputValue.sync="selectedHeaderInfoData['custRefNo']"
                  :isDisabled="viewMode"
                  validator="text,40"
                />
                <Input
                  :placeholder="pageType == 'Import' ? 'B/L #' : 'VBkg Ref #'"
                  :inputValue.sync="selectedHeaderInfoData['vbkgRefNo']"
                  :isDisabled="viewMode"
                  :isRequired="
                    pageType == 'Export' &&
                    (selectedHeaderInfoData['selectedTransMode'] ?
                      selectedHeaderInfoData['selectedTransMode']['Trans Mode'] == 'S'
                    : false)
                  "
                  :validator="pageType === 'Export' ? 'text,25' : 'text,35'"
                />

                <InputQuery
                  placeholder="Quotation #"
                  :items.sync="headerInfoData['quotationNo']"
                  itemKey="Quotation No"
                  descKey="Valid From - Valid To"
                  :isDisabled="viewMode"
                  :selectedObject.sync="selectedHeaderInfoData['selectedQuotationNo']"
                  validator="text,25"
                  :showDesc="true"
                />

                <InputQuery
                  placeholder="Bill To"
                  :items.sync="headerInfoData['billTo']"
                  itemKey="Code - Name"
                  descKey="Customer Name"
                  :isDisabled="viewMode || billingCheckDisabled"
                  :selectedObject.sync="selectedHeaderInfoData['selectedBillTo']"
                  @selected="billToSelected"
                  :isRequired="true"
                  ref="billToInput"
                  addLink="/Home/MasterFiles/ProfileMaster/Customer?new=1"
                  :canRefresh="true"
                  @refreshClicked="billToInputQueryRefreshClicked"
                  validator="text,115"
                />
                <div v-if="selectedHeaderInfoData['billToDetails']" style="display: flex; align-items: center">
                  <span>Status</span>
                  <span
                    class="status-container"
                    :style="{ backgroundColor: selectedHeaderInfoData['billToDetails']['status']['color'] }"
                  >
                    {{ selectedHeaderInfoData['billToDetails']['status']['text'] }}
                  </span>
                  <span>Outstanding</span>
                  <Tooltip
                    position="top"
                    :tooltipText="`${selectedHeaderInfoData['billToDetails']['currency']} ${currencyFormattedValue}`"
                    style="width: 100%"
                    :xOffset="6"
                    :yOffset="2"
                  >
                    <span class="outstanding-prog">
                      <div style="z-index: 1; display: flex; justify-content: center; width: 100%; cursor: default"
                        >{{ selectedHeaderInfoData['billToDetails']['outstanding']['perc'] }}%</div
                      >
                      <div
                        class="progress-ind"
                        :style="{
                          width: `${selectedHeaderInfoData['billToDetails']['outstanding']['perc'] > 100 ? 100 : selectedHeaderInfoData['billToDetails']['outstanding']['perc']}%`,
                          backgroundColor: selectedHeaderInfoData['billToDetails']['outstanding']['color'],
                        }"
                      ></div>
                    </span>
                  </Tooltip>
                </div>
                <span v-if="selectedHeaderInfoData['billToDetails']"
                  >Credit Limit : {{ selectedHeaderInfoData['billToDetails']['currency'] }}
                  {{ selectedHeaderInfoData['billToDetails']['creditLimit'] }} Credit Terms :
                  {{ selectedHeaderInfoData['billToDetails']['creditTerms'] }}</span
                >
              </div>
              <div class="slot-content-column" style="display: flex; flex-direction: column">
                <Input
                  placeholder="Job #"
                  :inputValue.sync="selectedHeaderInfoData['jobNo']"
                  :isRequired="true"
                  :isDisabled="true"
                />
                <DateTimePicker
                  placeholder="Job Time"
                  title="Job Time"
                  :value.sync="selectedHeaderInfoData['jobTime']"
                  :isRequired="true"
                  :isDisabled="viewMode"
                  :maxDate="smallDateTimeMaxDate"
                  :minDate="smallDateTimeMinValue"
                  :errorMessage.sync="errorMessages['jobtime']"
                  @dateChanged="checkDateTime('jobtime', $event)"
                />
                <DateTimePicker
                  placeholder="Required Date"
                  title="Required Date"
                  :value.sync="selectedHeaderInfoData['requiredDate']"
                  :isDisabled="viewMode"
                  :showTime="false"
                  :maxDate="smallDateTimeMaxDate"
                  :minDate="smallDateTimeMinValue"
                  :errorMessage.sync="errorMessages['requireddate']"
                  ref="requireddate"
                  @dateChanged="checkDateTime('requireddate', $event)"
                />
                <Input
                  placeholder="Job State"
                  :inputValue.sync="selectedHeaderInfoData['jobStatus']"
                  :isDisabled="true"
                />
                <ItemListing
                  style="min-height: 150px; max-height: 300px"
                  title="Services"
                  :items="headerInfoData['services']"
                  :isDisabled="viewMode"
                />
              </div>

              <div class="edit-address-popup" v-if="edittingDetails">
                <div class="edit-content">
                  <div class="title">Edit {{ detailsEditTitle }} Details</div>
                  <Input placeholder="Name" :inputValue.sync="detailsEditObject['name']" validator="text,100" />
                  <AddressFormV2
                    :address.sync="detailsEditObject"
                    :postcodes="addressDetails.postcodeList"
                    :states="addressDetails.stateList"
                    :countries="addressDetails.countryList"
                  />
                  <Input placeholder="Attn To" :inputValue.sync="detailsEditObject['attn']" validator="text,100" />
                  <div style="display: flex">
                    <Input
                      placeholder="Tel #"
                      style="padding-right: 5px"
                      :inputValue.sync="detailsEditObject['tel']"
                      validator="text,20"
                    />
                    <Input
                      placeholder="Fax #"
                      style="padding-left: 5px"
                      :inputValue.sync="detailsEditObject['fax']"
                      validator="text,20"
                    />
                  </div>
                  <Input placeholder="GST License #" :inputValue.sync="detailsEditObject['gst']" validator="text,50" />
                  <div class="button-section">
                    <button @click="detailsEditSave('save')" style="background-color: green; color: white"
                      >Update</button
                    >
                    <button @click="detailsEditSave('cancel')" style="background-color: red; color: white"
                      >Cancel</button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- General Info tab -->
          <div slot="General Info">
            <div class="slot-body-block">
              <div class="slot-content-column">
                <Input
                  placeholder="Vendor"
                  :inputValue.sync="selectedGeneralInfoData['vendor']"
                  :isDisabled="viewMode"
                  validator="text,10"
                />
                <Input
                  placeholder="Vessel Bkg By"
                  :inputValue.sync="selectedGeneralInfoData['vesselBkgBy']"
                  :isDisabled="viewMode"
                />
                <Input
                  placeholder="No. of Original B/L"
                  :inputValue.sync="selectedGeneralInfoData['oriBL']"
                  :isDisabled="viewMode"
                  validator="integer,3"
                  ref="No. of Original B/L"
                  :errorMessage.sync="selectedGeneralInfoData['oriBLError']"
                />
                <Input
                  placeholder="No. of Non-Nego B/L"
                  :inputValue.sync="selectedGeneralInfoData['nonNegoBL']"
                  :isDisabled="viewMode"
                  validator="integer,3"
                  ref="No. of Non-Nego B/L"
                  :errorMessage.sync="selectedGeneralInfoData['nonNegoBLError']"
                />
                <Dropdown
                  placeholder="Freight Type"
                  :items="generalInfoData['freightTypeList']"
                  itemKey="Freight Type Desc"
                  :isDisabled="viewMode"
                  :selectedObject.sync="selectedGeneralInfoData['selectedFreightType']"
                  validator="text,100"
                />
                <InputQuery
                  placeholder="Pay Country"
                  :items="generalInfoData['countryList']"
                  itemKey="Country Code"
                  descKey="Country"
                  :isDisabled="viewMode"
                  :selectedObject.sync="selectedGeneralInfoData['selectedCountry']"
                  validator="text,2"
                />
                <InputQuery
                  placeholder="Currency"
                  :items="generalInfoData['currencyList']"
                  itemKey="Currency Code"
                  descKey="Description"
                  :isDisabled="viewMode"
                  :selectedObject.sync="selectedGeneralInfoData['selectedCurrency']"
                  validator="text,3"
                />
                <InputQuery
                  placeholder="INCO Term"
                  :items="generalInfoData['incoTermsList']"
                  itemKey="Incoterm"
                  descKey="Incoterm Desc"
                  :isDisabled="viewMode"
                  :selectedObject.sync="selectedGeneralInfoData['selectedIncoTerms']"
                  validator="text,10"
                />
                <Dropdown
                  placeholder="Insurance"
                  :items="generalInfoData['insuranceList']"
                  itemKey="Insurance"
                  :isDisabled="viewMode"
                  :selectedObject.sync="selectedGeneralInfoData['selectedInsurance']"
                  validator="text,5"
                />
                <Input
                  placeholder="House B/L"
                  :inputValue.sync="selectedGeneralInfoData['houseBL']"
                  :isDisabled="viewMode"
                  validator="integer,35"
                />
                <Dropdown
                  placeholder="Branch"
                  :items="generalInfoData['branchList']"
                  itemKey="Branch Code"
                  :isDisabled="viewMode"
                  :selectedObject.sync="selectedGeneralInfoData['selectedBranch']"
                  validator="text,2"
                />
                <Input placeholder="Base" :isDisabled="true" />
                <Input placeholder="Prev Job #" :isDisabled="true" :inputValue="selectedGeneralInfoData['prevJobNo']" />
              </div>
              <div class="slot-content-column">
                <InputQuery
                  placeholder="Service PIC"
                  :items="generalInfoData['servicePICList']"
                  itemKey="Service Person Code"
                  descKey="Service Person Name"
                  :isDisabled="viewMode"
                  :selectedObject.sync="selectedGeneralInfoData['selectedServicePIC']"
                  validator="text,10"
                />
                <InputQuery
                  placeholder="Service Team"
                  :items="generalInfoData['serviceTeamList']"
                  itemKey="Service Team Code"
                  descKey="Service Team Name"
                  :isDisabled="viewMode"
                  :selectedObject.sync="selectedGeneralInfoData['selectedServiceTeam']"
                  validator="text,10"
                />
                <InputQuery
                  placeholder="Sales PIC"
                  :items="generalInfoData['salesPICList']"
                  itemKey="Sales Person Code"
                  descKey="Sales Person Name"
                  :isDisabled="viewMode"
                  :selectedObject.sync="selectedGeneralInfoData['selectedSalesPIC']"
                  validator="text,10"
                />
                <InputQuery
                  placeholder="Sales Team"
                  :items="generalInfoData['salesTeamList']"
                  itemKey="Sales Team Code"
                  descKey="Sales Team Name"
                  :isDisabled="viewMode"
                  :selectedObject.sync="selectedGeneralInfoData['selectedSalesTeam']"
                  validator="text,10"
                />
                <RemarksBox
                  :style="{ height: 'calc(100% - 116px)' }"
                  :maxLength="200"
                  :text.sync="selectedGeneralInfoData['remarks']"
                  :isDisabled="viewMode"
                />
              </div>
              <div class="slot-content-column"> </div>
            </div>
          </div>
          <!-- Shipping Info Tab -->
          <div slot="Shipping Info" style="height: 100%">
            <div class="slot-body-block">
              <div class="slot-content-column">
                <InputQuery
                  :placeholder="transportMethodPlaceholders('ShipCallNo')"
                  :items="shippingInfoData['shipCallNoList']"
                  itemKey="SCN - Terminal"
                  descKey="Vessel Name"
                  :isDisabled="viewMode"
                  :selectedObject.sync="selectedShippingInfoData['selectedShipCall']"
                  :isRequired="true"
                  @selected="shipCallNoSelected"
                  :search.sync="shipCallNoSearch"
                  validator="text,45"
                  :allowFreeText="true"
                  :isLoading="shipCallNoLoading"
                />
                <Input
                  placeholder="Voyage #"
                  :inputValue.sync="selectedShippingInfoData['voyNo']"
                  :isRequired="true"
                  :isDisabled="viewMode"
                  validator="text,10,uppercase"
                />
                <InputQuery
                  :placeholder="transportMethodPlaceholders('VesselID')"
                  :items="shippingInfoData['vesselIDList']"
                  itemKey="ID - Name"
                  descKey="Vessel Name"
                  :isDisabled="viewMode"
                  :selectedObject.sync="selectedShippingInfoData['selectedVesselID']"
                  :search.sync="vesselIDSearch"
                  :canRefresh="true"
                  @refreshClicked="vesselIDInputQueryRefreshClicked"
                  validator="text,45"
                />
                <InputQuery
                  :placeholder="transportMethodPlaceholders('ShippingAgent')"
                  :items="shippingInfoData['shippingAgentList']"
                  itemKey="Code - Name"
                  descKey="Agent Name"
                  :isDisabled="viewMode"
                  @selected="calculateDefaultDates('Agent', $event)"
                  :selectedObject.sync="selectedShippingInfoData['selectedAgentList']"
                  :isRequired="true"
                  :canRefresh="true"
                  @refreshClicked="shippingAgentInputQueryRefreshClicked"
                  addLink="/Home/MasterFiles/ProfileMaster/Supplier?new=1&supplier=SA"
                  validator="text,115"
                />
                <InputQuery
                  :placeholder="transportMethodPlaceholders('ShipLineCode')"
                  :items="shippingInfoData['shippingLineList']"
                  itemKey="Code - Name"
                  descKey="Agent Name"
                  :isDisabled="viewMode"
                  :selectedObject.sync="selectedShippingInfoData['selectedShippingLine']"
                  validator="text,115"
                />
                <InputQuery
                  placeholder="Frt Forwarder"
                  :items="shippingInfoData['frtForwarderList']"
                  itemKey="Code - Name"
                  descKey="Agent Name"
                  :isDisabled="viewMode"
                  :selectedObject.sync="selectedShippingInfoData['selectedFrtForwarder']"
                  validator="text,115"
                />
                <InputQuery
                  placeholder="Forwarding Agent"
                  :items="shippingInfoData['fwdgAgentList']"
                  itemKey="FA Code"
                  descKey="FA Name"
                  :isDisabled="viewMode"
                  :selectedObject.sync="selectedShippingInfoData['selectedFwdgAgent']"
                  validator="text,115"
                />
                <InputQuery
                  placeholder="Special Treatment"
                  :items="shippingInfoData['specialTreatment']"
                  itemKey="Code - Desc"
                  descKey="ST Desc"
                  :isDisabled="viewMode"
                  :selectedObject.sync="selectedShippingInfoData['selectedSpecialTreatment']"
                  validator="text,65"
                />
                <InputQuery
                  placeholder="Station"
                  :items="shippingInfoData['station']"
                  itemKey="Code - Name"
                  descKey="Station Name"
                  :isDisabled="viewMode"
                  :selectedObject.sync="selectedShippingInfoData['selectedStation']"
                  validator="text,50"
                />
                <InputQuery
                  placeholder="Port Operator"
                  :items="shippingInfoData['portOperator']"
                  itemKey="Code - Name"
                  descKey="Operator Name"
                  :isDisabled="viewMode"
                  :selectedObject.sync="selectedShippingInfoData['selectedPortOperator']"
                  validator="text,115"
                />
                <Input
                  placeholder="Warehouse"
                  :inputValue.sync="selectedShippingInfoData['warehouse']"
                  :isDisabled="viewMode"
                  validator="text,10"
                />
              </div>
              <div class="slot-content-column">
                <InputQuery
                  placeholder="Port of Loading"
                  :items.sync="shippingInfoData['portOfLoading']"
                  itemKey="Code - Desc"
                  descKey="Port Location"
                  :isDisabled="viewMode"
                  :selectedObject.sync="selectedShippingInfoData['selectedPortLoading']"
                  :isRequired="true"
                  addLink="/Home/MasterFiles/OperationMaster/Port?new=1"
                  :canRefresh="true"
                  @refreshClicked="portOfLoadingInputQueryRefreshClicked"
                  validator="text,10"
                />
                <InputQuery
                  placeholder="Port of Discharge"
                  :items.sync="shippingInfoData['portOfDischarge']"
                  itemKey="Code - Desc"
                  descKey="Port Location"
                  :isDisabled="viewMode"
                  :selectedObject.sync="selectedShippingInfoData['selectedPortDischarge']"
                  :isRequired="true"
                  addLink="/Home/MasterFiles/OperationMaster/Port?new=1"
                  :canRefresh="true"
                  @refreshClicked="portOfDischargeInputQueryRefreshClicked"
                  validator="text,10"
                />
                <InputQuery
                  placeholder="Final Destination"
                  :items.sync="shippingInfoData['finalDestination']"
                  itemKey="Code - Desc"
                  descKey="Port Location"
                  :isDisabled="viewMode"
                  :selectedObject.sync="selectedShippingInfoData['selectedFinalDestination']"
                  addLink="/Home/MasterFiles/OperationMaster/Port?new=1"
                  :canRefresh="true"
                  @refreshClicked="finalDestinationInputQueryRefreshClicked"
                  validator="text,10"
                />
                <div style="display: flex; align-items: center">
                  <DateTimePicker
                    :placeholder="demurragePlaceholder"
                    title="Demurrage"
                    :value.sync="selectedShippingInfoData['demurageTime']"
                    :isDisabled="viewMode || pageType == 'Import'"
                    :maxDate="smallDateTimeMaxDate"
                    :minDate="smallDateTimeMinValue"
                    :errorMessage.sync="errorMessages['demuragetime']"
                    ref="demuragetime"
                    @dateChanged="checkDateTime('demuragetime', $event)"
                  />
                  <DateTimePicker
                    style="margin-left: 5px"
                    v-if="pageType != 'Import'"
                    placeholder="Closing"
                    title="Closing"
                    :value.sync="selectedShippingInfoData['closingTime']"
                    :isRequired="true"
                    :isDisabled="viewMode"
                    :maxDate="smallDateTimeMaxDate"
                    :minDate="smallDateTimeMinValue"
                    :errorMessage.sync="errorMessages['closing_time']"
                    @dateChanged="checkDateTime('closing_time', $event)"
                  />
                </div>
                <DateTimePicker
                  v-if="
                    pageType == 'Import' ?
                      selectedHeaderInfoData['selectedCargoType'] ?
                        selectedHeaderInfoData['selectedCargoType']['Cargo Type'][0] == 'F'
                      : true
                    : true
                  "
                  placeholder="Detention"
                  title="Detention"
                  :value.sync="selectedShippingInfoData['detention']"
                  :isDisabled="viewMode || pageType == 'Import'"
                  :maxDate="smallDateTimeMaxDate"
                  :minDate="smallDateTimeMinValue"
                  :errorMessage.sync="errorMessages['detention']"
                  ref="detention"
                  @dateChanged="checkDateTime('detention', $event)"
                />
                <div class="box-container">
                  <CheckBoxV2
                    title="Transhipment"
                    :isChecked.sync="selectedShippingInfoData['isTranshipment']"
                    :isDisabled="viewMode"
                    style="position: absolute; background-color: white; padding: 0 5px; top: -10px"
                  />
                  <InputQuery
                    placeholder="M. Vessel ID"
                    :items="shippingInfoData['vesselIDList']"
                    itemKey="ID - Name"
                    descKey="Vessel Name"
                    :isDisabled="isTranshipmentDisabled"
                    :isRequired="isTranshipmentRequired"
                    :errorMessage.sync="errorMessages['vesselID']"
                    ref="vesselID"
                    :selectedObject.sync="selectedShippingInfoData['selectedMVesselID']"
                    :canRefresh="true"
                    @refreshClicked="vesselIDInputQueryRefreshClicked"
                    validator="text,45"
                  />
                  <Input
                    placeholder="M. Voyage #"
                    :inputValue.sync="selectedShippingInfoData['mVoyNo']"
                    :isDisabled="isTranshipmentDisabled"
                    :isRequired="isTranshipmentRequired"
                    :errorMessage.sync="errorMessages['voyageNo']"
                    ref="voyageNo"
                    validator="text,10,uppercase"
                  />
                  <InputQuery
                    placeholder="Transhipment Port of Discharge"
                    :items="shippingInfoData['portOfDischarge']"
                    itemKey="Port Code"
                    descKey="Port Location"
                    :isDisabled="isTranshipmentDisabled"
                    :selectedObject.sync="selectedShippingInfoData['selectedPortDischarge2']"
                    validator="text,10"
                  />
                  <DateTimePicker
                    placeholder="ETA"
                    :value.sync="selectedShippingInfoData['ETATime']"
                    :isDisabled="isTranshipmentDisabled"
                    :maxDate="smallDateTimeMaxDate"
                    :minDate="smallDateTimeMinValue"
                    :errorMessage.sync="errorMessages['etatime']"
                    ref="etatime"
                    @dateChanged="checkDateTime('etatime', $event)"
                  />
                </div>
              </div>
              <div class="slot-content-column">
                <div class="datetime-row">
                  <DateTimePicker
                    :placeholder="pageType == 'Import' ? 'POL ETD' : 'POL ETA'"
                    :title="pageType == 'Import' ? 'POL ETD' : 'POL ETA'"
                    :value.sync="selectedShippingInfoData['polETD']"
                    :isRequired="pageType != 'Import'"
                    :isDisabled="viewMode"
                    ref="polETD"
                    :maxDate="smallDateTimeMaxDate"
                    :minDate="smallDateTimeMinValue"
                    :errorMessage.sync="errorMessages['polETD']"
                    @dateChanged="checkDateTime('polETD', $event)"
                  />
                  <div v-if="pageType == 'Import'" class="free-input-group">
                    <Input
                      placeholder="Free Storage"
                      :inputValue.sync="selectedShippingInfoData['freeStorage']"
                      :isDisabled="viewMode"
                      validator="positiveInteger,3"
                    />
                    <div class="unit-toggle" :class="{ disabled: viewMode }">
                      <button
                        :class="['toggle-btn', { active: selectedShippingInfoData['storageUnit'] === 'D' }]"
                        :disabled="viewMode"
                        @click="setUnit('storageUnit', 'D')"
                        >Days</button
                      >
                      <button
                        :class="['toggle-btn', { active: selectedShippingInfoData['storageUnit'] === 'H' }]"
                        :disabled="viewMode"
                        @click="setUnit('storageUnit', 'H')"
                        >Hours</button
                      >
                    </div>
                  </div>
                </div>
                <div class="datetime-row">
                  <DateTimePicker
                    placeholder="POD ETA"
                    title="POD ETA "
                    :value.sync="selectedShippingInfoData['polETA']"
                    :isRequired="true"
                    :isDisabled="viewMode"
                    ref="polETA"
                    :maxDate="smallDateTimeMaxDate"
                    :minDate="smallDateTimeMinValue"
                    :errorMessage.sync="errorMessages['polETA']"
                    @dateChanged="checkDateTime('polETA', $event)"
                  />
                  <div v-if="pageType == 'Import'" class="free-input-group">
                    <Input
                      placeholder="Free Demurrage"
                      :inputValue.sync="selectedShippingInfoData['freeDemurrage']"
                      :isDisabled="viewMode"
                      validator="positiveInteger,3"
                    />
                    <div class="unit-toggle" :class="{ disabled: viewMode }">
                      <button
                        :class="['toggle-btn', { active: selectedShippingInfoData['demurrageUnit'] === 'D' }]"
                        :disabled="viewMode"
                        @click="setUnit('demurrageUnit', 'D')"
                        >Days</button
                      >
                      <button
                        :class="['toggle-btn', { active: selectedShippingInfoData['demurrageUnit'] === 'H' }]"
                        :disabled="viewMode"
                        @click="setUnit('demurrageUnit', 'H')"
                        >Hours</button
                      >
                    </div>
                  </div>
                </div>
                <div class="datetime-row">
                  <DateTimePicker
                    placeholder="Final Dest. ETA"
                    title="Final Dest. ETA"
                    :value.sync="selectedShippingInfoData['fDestETA']"
                    :isDisabled="viewMode"
                    ref="fDestETA"
                    :maxDate="smallDateTimeMaxDate"
                    :minDate="smallDateTimeMinValue"
                    :errorMessage.sync="errorMessages['fDestETA']"
                    @dateChanged="checkDateTime('fDestETA', $event)"
                  />
                  <div v-if="pageType == 'Import'" class="free-input-group">
                    <Input
                      placeholder="Free Detention"
                      :inputValue.sync="selectedShippingInfoData['freeDetention']"
                      :isDisabled="viewMode"
                      validator="positiveInteger,3"
                    />
                    <div class="unit-toggle" :class="{ disabled: viewMode }">
                      <button
                        :class="['toggle-btn', { active: selectedShippingInfoData['detentionUnit'] === 'D' }]"
                        :disabled="viewMode"
                        @click="setUnit('detentionUnit', 'D')"
                        >Days</button
                      >
                      <button
                        :class="['toggle-btn', { active: selectedShippingInfoData['detentionUnit'] === 'H' }]"
                        :disabled="viewMode"
                        @click="setUnit('detentionUnit', 'H')"
                        >Hours</button
                      >
                    </div>
                  </div>
                </div>
                <div class="box-container">
                  <CheckBoxV2
                    title="Fumigation"
                    :isChecked.sync="selectedShippingInfoData['isFumigation']"
                    :isDisabled="viewMode"
                    style="position: absolute; background-color: white; padding: 0 5px; top: -10px"
                  />
                  <InputQuery
                    placeholder="Fumigator"
                    :items="shippingInfoData['fumigatorList']"
                    itemKey="Supplier Code"
                    descKey="Supplier Name"
                    :isDisabled="isFumigationDisabled"
                    :isRequired="isFumigationRequired"
                    :errorMessage.sync="errorMessages['fumigator']"
                    ref="fumigator"
                    :selectedObject.sync="selectedShippingInfoData['selectedFumigator']"
                    validator="text,10"
                  />
                  <InputQuery
                    placeholder="Location"
                    :items="shippingInfoData['fumigatorLocationList']"
                    itemKey="Destination Code"
                    descKey="Company"
                    :isDisabled="isFumigationDisabled"
                    :isRequired="isFumigationRequired"
                    :errorMessage.sync="errorMessages['location']"
                    ref="location"
                    :selectedObject.sync="selectedShippingInfoData['selectedLocation']"
                    validator="text,10"
                  />
                  <DateTimePicker
                    placeholder="Fumigate on"
                    title="Fumigate on"
                    :value.sync="selectedShippingInfoData['fumigateTime']"
                    :isDisabled="isFumigationDisabled"
                    :isRequired="isFumigationRequired"
                    :errorMessage.sync="errorMessages['fumigate_on']"
                    ref="fumigate_on"
                    :maxDate="smallDateTimeMaxDate"
                    :minDate="smallDateTimeMinValue"
                    @dateChanged="checkDateTime('fumigate_on', $event)"
                  />
                  <DateTimePicker
                    placeholder="Ventilation"
                    title="Ventilation"
                    :value.sync="selectedShippingInfoData['ventilationTime']"
                    :isDisabled="isFumigationDisabled"
                    :isRequired="isFumigationRequired"
                    :errorMessage.sync="errorMessages['ventilation']"
                    ref="ventilation"
                    :maxDate="smallDateTimeMaxDate"
                    :minDate="smallDateTimeMinValue"
                    @dateChanged="checkDateTime('ventilation', $event)"
                  />
                  <Input
                    placeholder="Phyto Marking"
                    :inputValue.sync="selectedShippingInfoData['phytoMarking']"
                    :isDisabled="isFumigationDisabled"
                    validator="text,30"
                  />
                </div>
              </div>
            </div>
            <div class="shipping-textarea">
              <RemarksBox
                title="Goods Description"
                :text.sync="selectedShippingInfoData['goodsDescription']"
                style="height: 100%"
                :freeText="true"
                :isDisabled="viewMode"
              />
              <Tooltip
                position="left"
                :minWidth="300"
                tooltipText="The text will be reformatted upon save to accommodate printing of official forms and EDI declaration."
              />
              <RemarksBox
                title="Shipping Marks"
                :text.sync="selectedShippingInfoData['shippingMarks']"
                style="height: 100%"
                :freeText="true"
                :isDisabled="viewMode"
              />
              <Tooltip
                position="left"
                :minWidth="300"
                tooltipText="The text will be reformatted upon save to accommodate printing of official forms and EDI declaration."
              />
            </div>
          </div>
          <!-- Cargo Info Tab -->
          <div slot="Cargo Info">
            <div style="display: flex">
              <div style="margin-right: 20px">
                <div style="display: flex; align-items: center">
                  <Input
                    placeholder="Gross Weight"
                    textAlign="right"
                    :inputValue.sync="selectedCargoInfoData['gWeight']"
                    :isDisabled="viewMode"
                    :isRequired="
                      selectedHeaderInfoData['selectedCargoType'] ?
                        selectedHeaderInfoData['selectedCargoType']['Cargo Type'][0] != 'F'
                      : false
                    "
                    validator="positiveDecimal,5,4"
                  />
                  <span style="margin-left: 8px">KG</span>
                </div>
                <div style="display: flex; align-items: center">
                  <Input
                    placeholder="Volume"
                    textAlign="right"
                    :inputValue.sync="selectedCargoInfoData['volume']"
                    validator="positiveDecimal,5,4"
                    :isDisabled="viewMode"
                  />
                  <span style="margin-left: 8px">M<sup>3</sup></span>
                </div>
                <div style="display: flex; align-items: center">
                  <Input
                    placeholder="Chargeable"
                    textAlign="right"
                    :inputValue.sync="selectedCargoInfoData['chargeable']"
                    validator="positiveDecimal,5,4"
                    :isDisabled="viewMode"
                  />
                  <span style="margin-left: 8px">KG</span>
                </div>
              </div>
              <div style="width: 440px">
                <InputQuery
                  placeholder="Commodity"
                  :items="cargoInfoData['commodityList']"
                  itemKey="Commodity Code"
                  descKey="Description"
                  :isDisabled="viewMode"
                  :selectedObject.sync="selectedCargoInfoData['selectedCommodity']"
                  validator="text,10"
                />
                <InputQuery
                  placeholder="Packing Material"
                  :items="cargoInfoData['pMaterialList']"
                  itemKey="Code - Desc"
                  descKey="Material Description"
                  :isDisabled="viewMode"
                  :selectedObject.sync="selectedCargoInfoData['selectedPMaterial']"
                  :isRequired="true"
                  validator="text,58"
                />
                <div style="display: flex; width: 600px">
                  <Input
                    style="margin-right: 5px; width: 200px"
                    placeholder="No. of Pkg"
                    textAlign="right"
                    :isDisabled="viewMode"
                    :inputValue.sync="selectedCargoInfoData['packageCount']"
                    :isRequired="true"
                    validator="positiveDecimal,8,2"
                  />
                  <InputQuery
                    placeholder="Pkg Type"
                    :items="cargoInfoData['pkgTypeList']"
                    itemKey="Code - Desc"
                    descKey="Description"
                    :isDisabled="viewMode"
                    :selectedObject.sync="selectedCargoInfoData['selectedPackageType']"
                    :isRequired="true"
                    validator="text,65,uppercase"
                  />
                </div>
              </div>
            </div>

            <div class="table-container">
              <div class="tabulator-title">
                <div style="flex-grow: 1; display: flex; justify-content: flex-end; margin-right: 5px"
                  >Sub Package Details</div
                >
                <button v-if="!viewMode" @click="showHideDetailsPopup('sub')">Add Package</button>
                <button v-if="!viewMode" @click="showHideDetailsPopup('sub', true)">Edit Package</button>
                <button v-if="!viewMode" @click="cargoInfoPopupDeleteDetails('sub')">Delete Package</button>
              </div>
              <TableBox
                title="Sub Package Details"
                tableID="subpkg"
                :tableData="selectedCargoInfoData['subPkgList']"
                :selectedRow.sync="selectedCargoInfoData['selectedSubPkgs']"
                :hideColumns="['item_action', 'seq_no']"
              />
            </div>
            <div class="table-container">
              <div class="tabulator-title">
                <div style="flex-grow: 1; display: flex; justify-content: flex-end; margin-right: 5px"
                  >Container Details</div
                >
                <input
                  type="file"
                  accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  style="display: none"
                  ref="excelCont"
                  @change="excelContChange"
                />
                <button v-if="!viewMode" @click="importFromExcel">Import From Excel</button>
                <button v-if="!viewMode" @click="addContainerClicked">Add Container</button>
                <button v-if="!viewMode" @click="editContainerClicked">Edit Container</button>
                <button v-if="!viewMode" @click="deleteContainerClicked">Delete Container</button>
              </div>
              <TableBox
                title="Container Details"
                tableID="contDetails"
                :tableData.sync="selectedCargoInfoData['contDetailsList']"
                :selectedRow.sync="selectedCargoInfoData['selectedContDetails']"
                :hideColumns="[
                  'item_action',
                  'Old Cont #',
                  'Old Seal No',
                  'Old Cont Size',
                  'Old Cont Type',
                  'Old Handling Type',
                  'Old Delivery Type',
                  'ContCharges',
                  'Invoices',
                  'UpdateType',
                  'From API',
                ]"
              />
            </div>
            <br /><br /><br /><br /><br />

            <JobPageCargoInfoPopup
              v-if="cargoPopupDetails['cargoAddType']"
              :title="cargoPopupDetails['cargoAddType'] == 'sub' ? 'Sub Package Details' : 'Container Details'"
              @cancel="cargoPopupCancel"
              @addDetails="cargoInfoPopupAddDetails"
              :pageType="pageType"
              :isEdit="cargoPopupDetails['isEdit']"
              :editDetails="cargoPopupDetails['editDetails']"
              :pkgTypeList="cargoInfoData['pkgTypeList']"
              :itemCode="cargoInfoData['itemCode']"
              :contSizeList="cargoInfoData['contSizeList']"
              :contTypeList="cargoInfoData['contTypeList']"
              :contStatusList="cargoInfoData['contStatusList']"
              :soccocTypeList="cargoInfoData['soccocTypeList']"
              :contHandlingTypeList="cargoInfoData['contHandlingTypeList']"
              :contDeliveryTypeList="cargoInfoData['contDeliveryTypeList']"
              :contSendToList="cargoInfoData['contSendToList']"
            />
          </div>
          <!-- Documents Tab -->
          <div slot="Documents" :style="{ height: viewMode ? '100%' : 'calc(100% - 28px)' }">
            <div class="top-button-section" id="docPopup" v-if="!viewMode">
              <button @click="addDoc">
                <img src="https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png" height="15" />
                Add Documents
              </button>
              <button @click="editDoc">
                <img src="https://dsmapi.logistics.systems/dsm6gicons/icons8-edit-64%20(1).png" height="15" />
                Edit Documents
              </button>
              <button @click="deleteDoc">
                <img src="https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png" height="15" />
                Delete Documents
              </button>
            </div>

            <DocStatusUpdate
              :showPopup.sync="documentInfoData['updatePopup']"
              :statusList.sync="documentInfoData['statusList']"
              :docTypeList.sync="documentInfoData['docTypeList']"
              :docStatusList.sync="documentInfoData['docStatusList']"
              defaultCategory="document"
              @updateClicked="documentUpdate"
              :title="`Update Documents for Job # ${selectedHeaderInfoData['jobNo']}`"
              :editDetailsList.sync="editDocumentsList"
            />

            <div class="job-documents-table">
              <TableBox
                :tableData="selectedDocumentInfoData['docData']"
                groupBy="ID"
                :selectedRow.sync="selectedDocumentInfoData['selectedDoc']"
                :additionalButtons="viewDocumentButtons"
                @buttonClicked="viewDocumentClicked"
                title="Documents"
                :maxSelection="1"
                :hideColumns="['documentguid', 'statusseqno', 'ID', 'fileAtt', 'filetype', 'Action', 'Row #']"
              />
            </div>
          </div>
          <!-- Delivery Note -->
          <div slot="Delivery Note">
            <button @click="addDeliveryNote">New Delivery Note</button>
            <TableBox :tableData="dnListing" title="Delivery Note" />
          </div>
          <!-- ROT -->
          <div slot="ROT" style="height: calc(100% - 28px)">
            <button @click="addROT">New ROT</button>
            <TableBox :tableData="rotListing" title="ROT" />
          </div>
          <!-- TAS & KPI -->
          <div slot="TAS & KPI" class="tas-kpi-slot">
            <StatusPage
              :isComponent="true"
              :statusData.sync="statusTaskData['statusTaskListing']"
              :statusJobNo="statusTaskData['statusJobNo']"
              :statusDocuments.sync="statusTaskData['statusDocumentListing']"
            />
          </div>
          <div v-if="!enableSMKmodule" slot="SMK" style="height: calc(100%)">
            <TableBox :tableData="smkListing" title="SMK" />
          </div>
          <!-- SMK -->
          <div v-if="enableSMKmodule" slot="SMK" style="height: calc(100%)">
            <Tab style="height: calc(100%)" :tabs="smktabsItems" :tabIndex.sync="smkTabIndex">
              <div slot="SMK & Invoice Details">
                <div class="details-wrapper-smk">
                  <div class="tab-block-smk smk-panel">
                    <div class="tab-title-smk">SMK Job Detail</div>
                    <Dropdown
                      placeholder="Form Type"
                      :items="headerInfoData['smkFormType']"
                      itemKey="Form Type"
                      :isDisabled="viewMode"
                      :selectedObject.sync="selectedSmkInfoData['selectedSmkFormType']"
                      validator="text,3"
                    />
                    <Input
                      placeholder="Job #"
                      :isDisabled="true"
                      :inputValue.sync="selectedHeaderInfoData['jobNo']"
                      validator="text,25"
                    />

                    <Input
                      placeholder="SMK #"
                      :isDisabled="true"
                      :inputValue.sync="selectedSmkInfoData['smkNo']"
                      validator="text,25"
                    />

                    <InputQuery
                      style="margin-top: 25px"
                      placeholder="Declaration Type"
                      :items="filteredDeclarationTypeList"
                      itemKey="Code - Name"
                      descKey="Declare Name"
                      :selectedObject.sync="selectedSmkInfoData['selectedDeclarationType']"
                      :isDisabled="viewMode || !selectedSmkInfoData['selectedSmkFormType']"
                      validator="text,50"
                    />
                    <InputQuery
                      placeholder="Shipment Type"
                      :items="smkInfoData['shipmentType']"
                      itemKey="Code - Desc"
                      descKey="Description"
                      :selectedObject.sync="selectedSmkInfoData['selectedShipmentType']"
                      :isDisabled="viewMode"
                      validator="text,20"
                    />
                    <InputQuery
                      placeholder="Country Of Origin"
                      :items="generalInfoData['countryList']"
                      itemKey="Code - Desc"
                      descKey="Country"
                      :selectedObject.sync="selectedSmkInfoData['selectedCountryOfOrigin']"
                      :isDisabled="viewMode"
                      validator="text,2"
                    />

                    <!-- K3 -->
                    <template v-if="currentSMKFormType === 'K3'">
                      <Dropdown
                        placeholder="K3 Type"
                        :items="smkK3TypeList"
                        itemKey="Code - Desc"
                        :selectedObject.sync="selectedSmkInfoData['k3Type']"
                        :isDisabled="viewMode"
                      />

                      <InputQuery
                        placeholder="Move To"
                        :items="shippingInfoData['station']"
                        itemKey="Code - Name"
                        :selectedObject.sync="selectedSmkInfoData['k3MoveTo']"
                        :isDisabled="viewMode"
                      />
                    </template>

                    <!-- K8 -->
                    <template v-if="currentSMKFormType === 'K8'">
                      <Dropdown
                        placeholder="K8 Type"
                        :items="smkK8TypeList"
                        itemKey="Code - Desc"
                        :selectedObject.sync="selectedSmkInfoData['k8Type']"
                        :isDisabled="viewMode"
                      />

                      <Dropdown
                        placeholder="Move Type"
                        :items="smkInfoData['movementType']"
                        itemKey="Code - Name"
                        descKey="Move Desc"
                        :selectedObject.sync="selectedSmkInfoData['movementType']"
                        :isDisabled="viewMode"
                      />

                      <DateTimePicker
                        placeholder="Move Date"
                        title="Move Date"
                        :value.sync="selectedSmkInfoData['moveDate']"
                        :isDisabled="viewMode"
                        :showTime="false"
                      />

                      <InputQuery
                        placeholder="From Station"
                        :items="shippingInfoData['station']"
                        itemKey="Code - Name"
                        :selectedObject.sync="selectedSmkInfoData['moveFromStation']"
                        :isDisabled="viewMode"
                      />

                      <InputQuery
                        placeholder="To Station"
                        :items="shippingInfoData['station']"
                        itemKey="Code - Name"
                        :selectedObject.sync="selectedSmkInfoData['moveToStation']"
                        :isDisabled="viewMode"
                      />

                      <Input
                        placeholder="From Warehouse"
                        :inputValue.sync="selectedSmkInfoData['moveFromWarehouse']"
                        :isDisabled="viewMode"
                        validator="text,10"
                      />

                      <Input
                        placeholder="To Warehouse"
                        :inputValue.sync="selectedSmkInfoData['moveToWarehouse']"
                        :isDisabled="viewMode"
                        validator="text,10"
                      />
                    </template>

                    <!-- K9 -->
                    <template v-if="currentSMKFormType === 'K9'">
                      <InputQuery
                        placeholder="Warehouse Code"
                        :items="smkInfoData['warehouseList']"
                        itemKey="Code - Name"
                        :selectedObject.sync="selectedSmkInfoData['k9Warehouse']"
                        :isDisabled="viewMode"
                        @selected="smkWarehouseSelected"
                      />

                      <InputQuery
                        placeholder="Warehouse Type"
                        :items="smkInfoData['warehouseTypeList']"
                        itemKey="Code - Name"
                        :selectedObject.sync="selectedSmkInfoData['k9WarehouseType']"
                        :isDisabled="viewMode"
                      />

                      <InputQuery
                        placeholder="Station Code"
                        :items="shippingInfoData['station']"
                        itemKey="Code - Name"
                        :selectedObject.sync="selectedSmkInfoData['k9Station']"
                        :isDisabled="viewMode"
                      />

                      <Input
                        placeholder="License #"
                        :inputValue.sync="selectedSmkInfoData['k9License']"
                        :isDisabled="viewMode"
                        validator="text,8"
                      />

                      <DateTimePicker
                        placeholder="License Date"
                        title="License Date"
                        :value.sync="selectedSmkInfoData['k9LicenseDate']"
                        :isDisabled="viewMode"
                        :showTime="false"
                      />

                      <DateTimePicker
                        placeholder="Deposit Date"
                        title="Deposit Date"
                        :value.sync="selectedSmkInfoData['k9DepositDate']"
                        :isDisabled="viewMode"
                        :showTime="false"
                      />

                      <Input
                        placeholder="Deposit Receipt #"
                        :inputValue.sync="selectedSmkInfoData['k9DepositReceipt']"
                        :isDisabled="viewMode"
                        validator="text,10"
                      />
                    </template>
                  </div>

                  <div class="tab-block-smk invoice-panel">
                    <div class="tab-title-smk">Invoice Details</div>

                    <div class="invoice-layout">
                      <!-- LEFT: Invoice fields -->
                      <div class="invoice-left">
                        <div class="invoice-headings">
                          <span></span>
                          <strong>Type</strong>
                          <strong>Amount</strong>
                          <strong>Qualifier</strong>
                        </div>

                        <!-- Freight -->
                        <div class="invoice-row">
                          <div class="label">
                            Freight
                            <span
                              v-if="hasSMKAdditionalFreightCurrency"
                              :title="smkFreightCurrencyTooltip"
                              style="padding-left: 4px; cursor: help; font-size: 16px"
                            >
                              💱
                            </span>
                          </div>

                          <Dropdown
                            placeholder="Type"
                            :items="smkInvoiceTypeList"
                            itemKey="Currency Code"
                            descKey="Description"
                            :isDisabled="viewMode"
                            :selectedObject.sync="selectedSmkInfoData['invoiceTypeFreight']"
                            @selected="smkFreightTypeSelected"
                            validator="text,3"
                          />

                          <Input
                            placeholder="Amount"
                            :isDisabled="viewMode"
                            :inputValue.sync="selectedSmkInfoData['amountFreight']"
                            validator="positiveInteger,15"
                          />

                          <Dropdown
                            placeholder="Qualifier"
                            :items="smkInvoiceQualifierList"
                            itemKey="Qualifier"
                            :isDisabled="true"
                            :selectedObject.sync="selectedSmkInfoData['qualifierFreight']"
                          />
                        </div>

                        <!-- Insurance -->
                        <div class="invoice-row">
                          <div class="label">Insurance</div>

                          <Dropdown
                            placeholder="Type"
                            :items="smkInvoiceTypeList"
                            itemKey="Currency Code"
                            descKey="Description"
                            :isDisabled="viewMode"
                            :selectedObject.sync="selectedSmkInfoData['invoiceTypeInsurance']"
                            validator="text,3"
                          />

                          <Input
                            placeholder="Amount"
                            :isDisabled="viewMode"
                            :inputValue.sync="selectedSmkInfoData['amountInsurance']"
                            validator="positiveInteger,15"
                          />

                          <Dropdown
                            placeholder="Qualifier"
                            :items="smkInvoiceQualifierList"
                            itemKey="Qualifier"
                            :isDisabled="viewMode"
                            :selectedObject.sync="selectedSmkInfoData['qualifierInsurance']"
                          />
                        </div>

                        <!-- Uplift -->
                        <div class="invoice-row">
                          <div class="label">Uplift</div>

                          <Dropdown
                            placeholder="Type"
                            :items="smkInvoiceTypeList"
                            itemKey="Currency Code"
                            descKey="Description"
                            :isDisabled="viewMode"
                            :selectedObject.sync="selectedSmkInfoData['invoiceTypeUplift']"
                            validator="text,3"
                          />

                          <Input
                            placeholder="Amount"
                            :isDisabled="viewMode"
                            :inputValue.sync="selectedSmkInfoData['amountUplift']"
                            validator="positiveInteger,15"
                          />

                          <Dropdown
                            placeholder="Qualifier"
                            :items="smkInvoiceQualifierList"
                            itemKey="Qualifier"
                            :isDisabled="viewMode"
                            :selectedObject.sync="selectedSmkInfoData['qualifierUplift']"
                          />
                        </div>

                        <!-- Buying Commission -->
                        <div class="invoice-row">
                          <div class="label">Buying Comm</div>

                          <Dropdown
                            placeholder="Type"
                            :items="smkInvoiceTypeList"
                            itemKey="Currency Code"
                            descKey="Description"
                            :isDisabled="viewMode"
                            :selectedObject.sync="selectedSmkInfoData['invoiceTypeBuyingComm']"
                            validator="text,3"
                          />

                          <Input
                            placeholder="Amount"
                            :isDisabled="viewMode"
                            :inputValue.sync="selectedSmkInfoData['amountBuyingComm']"
                            validator="positiveInteger,15"
                          />

                          <Dropdown
                            placeholder="Qualifier"
                            :items="smkInvoiceQualifierList"
                            itemKey="Qualifier"
                            :isDisabled="viewMode"
                            :selectedObject.sync="selectedSmkInfoData['qualifierBuyingComm']"
                          />
                        </div>

                        <!-- Port Charges -->
                        <div class="invoice-row">
                          <div class="label">Port Charges</div>

                          <Dropdown
                            placeholder="Type"
                            :items="smkInvoiceTypeList"
                            itemKey="Currency Code"
                            descKey="Description"
                            :isDisabled="viewMode"
                            :selectedObject.sync="selectedSmkInfoData['invoiceTypePortCharges']"
                            validator="text,3"
                          />

                          <Input
                            placeholder="Amount"
                            :isDisabled="viewMode"
                            :inputValue.sync="selectedSmkInfoData['amountPortCharges']"
                            validator="positiveInteger,15"
                          />

                          <Dropdown
                            placeholder="Qualifier"
                            :items="smkPortQualifierList"
                            itemKey="Qualifier"
                            :isDisabled="viewMode"
                            :selectedObject.sync="selectedSmkInfoData['qualifierPortCharges']"
                          />
                        </div>

                        <!-- Discount -->
                        <div class="invoice-row">
                          <div class="label">Discount</div>

                          <Dropdown
                            placeholder="Type"
                            :items="smkInvoiceTypeList"
                            itemKey="Currency Code"
                            descKey="Description"
                            :isDisabled="viewMode"
                            :selectedObject.sync="selectedSmkInfoData['invoiceTypeDiscount']"
                            validator="text,3"
                          />

                          <Input
                            placeholder="Amount"
                            :isDisabled="viewMode"
                            :inputValue.sync="selectedSmkInfoData['amountDiscount']"
                            validator="positiveInteger,15"
                          />

                          <Dropdown
                            placeholder="Qualifier"
                            :items="smkInvoiceQualifierList"
                            itemKey="Qualifier"
                            :isDisabled="viewMode"
                            :selectedObject.sync="selectedSmkInfoData['qualifierDiscount']"
                          />
                        </div>

                        <!-- Other -->
                        <div class="invoice-row">
                          <div class="label">Other</div>

                          <Dropdown
                            placeholder="Type"
                            :items="smkInvoiceTypeList"
                            itemKey="Currency Code"
                            descKey="Description"
                            :isDisabled="viewMode"
                            :selectedObject.sync="selectedSmkInfoData['invoiceTypeOther']"
                            validator="text,3"
                          />

                          <Input
                            placeholder="Amount"
                            :isDisabled="viewMode"
                            :inputValue.sync="selectedSmkInfoData['amountOther']"
                            validator="positiveInteger,15"
                          />

                          <Dropdown
                            placeholder="Qualifier"
                            :items="smkInvoiceQualifierList"
                            itemKey="Qualifier"
                            :isDisabled="viewMode"
                            :selectedObject.sync="selectedSmkInfoData['qualifierOther']"
                          />
                        </div>

                        <!-- Total invoice Amount -->
                        <div class="invoice-row">
                          <div class="label">Amount</div>

                          <Dropdown
                            placeholder="Type"
                            :items="smkInvoiceAmountTypeList"
                            itemKey="Currency Code"
                            descKey="Description"
                            :isDisabled="viewMode"
                            :selectedObject.sync="selectedSmkInfoData['invoiceTypeAmount']"
                            validator="text,3"
                          />

                          <Input
                            placeholder="Amount"
                            :isDisabled="viewMode"
                            :inputValue.sync="selectedSmkInfoData['amountAmount']"
                            validator="positiveInteger,15"
                          />

                          <Dropdown
                            placeholder="Qualifier"
                            :items="smkInvoiceQualifierList"
                            itemKey="Qualifier"
                            :isDisabled="viewMode"
                            :selectedObject.sync="selectedSmkInfoData['qualifierAmount']"
                            @update:selectedObject="smkAmountQualifierSelected"
                          />
                        </div>

                        <!-- Total Item Amount -->
                        <div class="invoice-total-row">
                          <div class="invoice-total-label"> Total Item Amount </div>

                          <div class="total-block invoice-total-value">
                            {{ smkTotalItemAmountDisplay }}
                          </div>
                        </div>
                      </div>

                      <!-- RIGHT: Currency and exchange rates -->
                      <div class="invoice-exchange-panel">
                        <div class="exchange-field-row">
                          <div class="exchange-label">Currency Code</div>

                          <Dropdown
                            placeholder="Currency"
                            :items="generalInfoData['currencyList']"
                            itemKey="Currency Code"
                            descKey="Description"
                            :isDisabled="viewMode"
                            :selectedObject.sync="selectedSmkInfoData['currency1']"
                            @update:selectedObject="smkCurrencyChanged"
                          />
                        </div>

                        <div class="exchange-rate-row">
                          <div class="exchange-label">Exchange Rate</div>

                          <Input
                            placeholder="Rate"
                            :isDisabled="viewMode"
                            :inputValue.sync="selectedSmkInfoData['exchangeRate1']"
                            validator="decimal,15,4"
                          />

                          <DateTimePicker
                            placeholder="Date"
                            title="Exchange Rate Date"
                            :value.sync="selectedHeaderInfoData['exchangeRateDate1']"
                            :isDisabled="viewMode"
                            :showTime="false"
                          />
                        </div>

                        <div v-if="smkExchangeRates" class="smk-exchange-rate-options">
                          <button
                            class="smk-exchange-rate-button"
                            type="button"
                            @click="
                              selectSMKExchangeRate(smkExchangeRates.thisWeekRate, smkExchangeRates.thisWeekStart)
                            "
                          >
                            <strong>This Week Exchange Rate</strong>

                            <span>
                              {{ smkExchangeRates.thisWeekStart }}
                              To
                              {{ smkExchangeRates.thisWeekEnd }}
                            </span>

                            <span>
                              {{ smkExchangeRates.thisWeekRate }}
                            </span>
                          </button>

                          <button
                            class="smk-exchange-rate-button"
                            type="button"
                            @click="
                              selectSMKExchangeRate(smkExchangeRates.nextWeekRate, smkExchangeRates.nextWeekStart)
                            "
                          >
                            <strong>Next Week Exchange Rate</strong>

                            <span>
                              {{ smkExchangeRates.nextWeekStart }}
                              To
                              {{ smkExchangeRates.nextWeekEnd }}
                            </span>

                            <span>
                              {{ smkExchangeRates.nextWeekRate }}
                            </span>
                          </button>
                        </div>

                        <div
                          v-if="hasSMKAdditionalFreightCurrency"
                          style="margin-top: 12px; border-top: 1px solid #ccc; padding-top: 10px"
                        >
                          <div style="font-weight: bold; margin-bottom: 8px"> Additional Freight Currency </div>

                          <div class="exchange-field-row">
                            <div class="exchange-label">Currency Code</div>

                            <div style="padding: 6px 0; font-weight: bold">
                              {{ getSmkInvoiceCode('invoiceTypeFreight') }}
                            </div>
                          </div>

                          <div class="exchange-rate-row">
                            <div class="exchange-label">Exchange Rate</div>

                            <Input
                              placeholder="Rate"
                              :isDisabled="viewMode"
                              :inputValue.sync="selectedSmkInfoData['freightForeignRate']"
                              validator="decimal,15,4"
                            />

                            <DateTimePicker
                              placeholder="Date"
                              title="Exchange Rate Date"
                              :value.sync="selectedSmkInfoData['freightForeignDate']"
                              :isDisabled="viewMode"
                              :showTime="false"
                            />
                          </div>

                          <div class="exchange-rate-row">
                            <div class="exchange-label">Amount MYR</div>

                            <Input
                              placeholder="Amount MYR"
                              :isDisabled="true"
                              :inputValue="selectedSmkInfoData['freightAmountMYR']"
                              validator="decimal,15,4"
                            />
                          </div>

                          <div v-if="smkFreightExchangeRates" class="smk-exchange-rate-options">
                            <button
                              class="smk-exchange-rate-button"
                              type="button"
                              @click="
                                selectSMKFreightExchangeRate(
                                  smkFreightExchangeRates.thisWeekRate,
                                  smkFreightExchangeRates.thisWeekStart,
                                )
                              "
                            >
                              <strong>This Week Exchange Rate</strong>
                              <span>
                                {{ smkFreightExchangeRates.thisWeekStart }}
                                To
                                {{ smkFreightExchangeRates.thisWeekEnd }}
                              </span>
                              <span>{{ smkFreightExchangeRates.thisWeekRate }}</span>
                            </button>

                            <button
                              class="smk-exchange-rate-button"
                              type="button"
                              @click="
                                selectSMKFreightExchangeRate(
                                  smkFreightExchangeRates.nextWeekRate,
                                  smkFreightExchangeRates.nextWeekStart,
                                )
                              "
                            >
                              <strong>Next Week Exchange Rate</strong>
                              <span>
                                {{ smkFreightExchangeRates.nextWeekStart }}
                                To
                                {{ smkFreightExchangeRates.nextWeekEnd }}
                              </span>
                              <span>{{ smkFreightExchangeRates.nextWeekRate }}</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="currentSMKFormType === 'K8'"
                  class="exemption-layout smk-documents-layout"
                  style="margin-top: 15px"
                >
                  <div class="smk-documents-split">
                    <BoxContainer
                      class="smk-documents-list-pane"
                      :class="{ 'smk-documents-list-pane--half': !!smkTransportMode }"
                    >
                      <div class="tabulator-title smk-documents-toolbar">
                        <strong>Transport Details</strong>

                        <div v-if="!viewMode">
                          <button type="button" :disabled="!!smkTransportMode" @click.stop="startSMKTransportAdd">
                            Add
                          </button>

                          <button
                            type="button"
                            :disabled="!!smkTransportMode || !selectedSMKTransportRow"
                            @click.stop="startSMKTransportEdit"
                          >
                            Edit
                          </button>

                          <button
                            type="button"
                            :disabled="!!smkTransportMode || !selectedSMKTransportRow"
                            @click.stop="deleteSMKTransport"
                          >
                            Delete
                          </button>
                        </div>
                      </div>

                      <div class="smk-documents-table-scroll">
                        <TableBox
                          class="smk-documents-tablebox"
                          :key="smkTransportTableVersion"
                          title=""
                          :tableData="smkTransportList"
                          :selectedRow.sync="selectedSMKTransportRows"
                          :maxSelection="1"
                          :hideColumns="['SeqNo', '_smkTransportUid', '_smkSaved']"
                        />
                      </div>
                    </BoxContainer>

                    <BoxContainer v-if="smkTransportMode && smkTransportDraft" class="smk-documents-editor-pane">
                      <div class="tabulator-title smk-documents-toolbar">
                        <strong>
                          {{ smkTransportMode === 'N' ? 'New Transport Detail' : 'Edit Transport Detail' }}
                        </strong>

                        <div>
                          <button type="button" @click.stop="updateSMKTransport">
                            {{ smkTransportMode === 'N' ? 'Add' : 'Update' }}
                          </button>

                          <button type="button" @click.stop="cancelSMKTransport"> Cancel </button>
                        </div>
                      </div>

                      <div class="smk-documents-editor-fields">
                        <InputQuery
                          placeholder="Transport Type"
                          :items="smkInfoData['transportTypeList']"
                          itemKey="Code - Desc"
                          descKey="Transport Description"
                          :selectedObject.sync="smkTransportDraft.transportType"
                          :isRequired="true"
                          validator="text,2"
                          :errorMessage.sync="smkTransportErrors.transportType"
                        />

                        <Input
                          placeholder="Transport ID"
                          :inputValue.sync="smkTransportDraft.transportId"
                          validator="text,9"
                        />

                        <InputQuery
                          placeholder="Station"
                          :items="shippingInfoData['station']"
                          itemKey="Code - Name"
                          descKey="Station Name"
                          :selectedObject.sync="smkTransportDraft.station"
                          validator="text,3"
                        />

                        <Input placeholder="License" :inputValue.sync="smkTransportDraft.license" validator="text,8" />

                        <Input
                          placeholder="Year"
                          :inputValue.sync="smkTransportDraft.year"
                          validator="positiveInteger,4"
                          :errorMessage.sync="smkTransportErrors.year"
                        />
                      </div>
                      <div v-if="smkTransportErrors.form" class="smk-doc-form-error">
                        {{ smkTransportErrors.form }}
                      </div>
                    </BoxContainer>
                  </div>
                </div>
                <br /><br /><br /><br /><br />
              </div>
              <div slot="Exemption / Clause / Documents">
                <div class="exemption-layout">
                  <div class="left-section">
                    <div class="details-wrapper-exemption">
                      <div class="tab-block-smk exemption-panel">
                        <div class="tab-title-smk">Treasury Exemption</div>
                        <div class="exemption-row">
                          <div class="field-wrapper">
                            <InputQuery
                              placeholder="Ref No"
                              :items="smkInfoData['exemptNoListTE']"
                              itemKey="Exemption No"
                              :selectedObject.sync="selectedSmkInfoData['exemptNoTreasury']"
                              :isDisabled="viewMode"
                              validator="text,50"
                              @selected="teExemptNoSelected"
                            />
                          </div>
                          <div class="field-wrapper">
                            <InputQuery
                              placeholder="Exempt Type"
                              :items="smkInfoData['exemptTypeListTE']"
                              itemKey="Type"
                              :selectedObject.sync="selectedSmkInfoData['exemptTypeTreasury']"
                              :isDisabled="viewMode"
                              validator="text,2"
                            />
                          </div>
                          <div class="field-wrapper">
                            <DateTimePicker
                              placeholder="Expiry Date"
                              title="Expiry Date"
                              :value.sync="selectedSmkInfoData['expiryDateTE']"
                              :isDisabled="viewMode || !!selectedSmkInfoData['exemptNoTreasury']"
                              :showTime="false"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="tab-block-smk exemption-panel">
                        <div class="tab-title-smk">Sales Tax Exemption</div>
                        <div class="exemption-row">
                          <div class="field-wrapper">
                            <InputQuery
                              placeholder="Ref No"
                              :items="smkInfoData['exemptNoListST']"
                              itemKey="Exemption No"
                              :selectedObject.sync="selectedSmkInfoData['exemptNoSalesTax']"
                              :isDisabled="viewMode"
                              validator="text,50"
                              @selected="stExemptNoSelected"
                            />
                          </div>
                          <div class="field-wrapper">
                            <InputQuery
                              placeholder="Exempt Type"
                              :items="smkInfoData['exemptTypeListST']"
                              itemKey="Type"
                              :selectedObject.sync="selectedSmkInfoData['exemptTypeSalesTax']"
                              :isDisabled="viewMode"
                              validator="text,2"
                            />
                          </div>
                          <div class="field-wrapper">
                            <DateTimePicker
                              placeholder="Registration Date"
                              title="Registration Date"
                              :value.sync="selectedSmkInfoData['registrationDateST']"
                              :isDisabled="viewMode || !!selectedSmkInfoData['exemptNoSalesTax']"
                              :showTime="false"
                            />
                          </div>
                        </div>
                        <div class="exemption-row">
                          <div class="field-wrapper">
                            <Input
                              placeholder="Station Code"
                              :isDisabled="true"
                              :inputValue.sync="selectedSmkInfoData['stationCode']"
                              validator="text,25"
                            />
                          </div>
                          <div class="field-wrapper">
                            <DateTimePicker
                              placeholder="Expiry Date"
                              title="Expiry Date"
                              :value.sync="selectedSmkInfoData['expiryDateST']"
                              :isDisabled="viewMode || selectedSmkInfoData['exemptNoSalesTax']"
                              :showTime="false"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="tab-block-smk exemption-panel" style="width: 50%">
                        <div class="tab-title-smk">Special Treatment</div>
                        <div class="exemption-row">
                          <div class="field-wrapper">
                            <InputQuery
                              placeholder="Ref No"
                              :items="smkInfoData['exemptNoListAP']"
                              itemKey="Exemption No"
                              :selectedObject.sync="selectedSmkInfoData['exemptNoSpecialTreatment']"
                              :isDisabled="viewMode"
                              validator="text,50"
                              @selected="apExemptNoSelected"
                            />
                          </div>
                          <div class="field-wrapper">
                            <InputQuery
                              placeholder="Exempt Type"
                              :items="smkInfoData['exemptTypeListAP']"
                              itemKey="Type"
                              :selectedObject.sync="selectedSmkInfoData['exemptTypeSpecialTreatment']"
                              :isDisabled="viewMode"
                              validator="text,2"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="tab-block-smk exemption-panel">
                        <div class="tab-title-smk">Claiment Details</div>
                        <div class="exemption-row">
                          <div class="field-wrapper">
                            <Input
                              placeholder="Name"
                              :inputValue.sync="selectedSmkInfoData['claimentName']"
                              validator="text,25"
                              :isDisabled="viewMode"
                            />
                          </div>
                          <div class="field-wrapper">
                            <Input
                              placeholder="Company"
                              :inputValue.sync="selectedSmkInfoData['claimentCompany']"
                              validator="text,50"
                              :isDisabled="viewMode"
                            />
                          </div>
                        </div>
                        <div class="exemption-row">
                          <div class="field-wrapper">
                            <Input
                              placeholder="Status"
                              :inputValue.sync="selectedSmkInfoData['claimentStatus']"
                              validator="text,25"
                              :isDisabled="viewMode"
                            />
                          </div>
                          <div class="field-wrapper">
                            <Input
                              placeholder="NRIC"
                              :inputValue.sync="selectedSmkInfoData['claimentNRIC']"
                              validator="text,50"
                              :isDisabled="viewMode"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="right-section">
                    <div class="details-wrapper-exemption">
                      <div class="tab-block-smk exemption-panel">
                        <div class="tab-title-smk">Clause</div>
                        <div class="field-wrapper">
                          <InputQuery
                            placeholder="Clause Code"
                            :items="smkInfoData['clauseList']"
                            itemKey="Clause Code"
                            :selectedObject.sync="selectedSmkInfoData['clauseCode']"
                            :isDisabled="viewMode"
                            validator="text,50"
                            @selected="clauseCodeSelected"
                          />
                        </div>
                        <div class="field-wrapper">
                          <RemarksBox
                            class="clause-container"
                            title=""
                            :freeText="true"
                            :text.sync="clauseText"
                            :isDisabled="true"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="exemption-layout smk-documents-layout" style="margin-top: 15px">
                  <div class="smk-documents-split">
                    <BoxContainer
                      class="smk-documents-list-pane"
                      :class="{ 'smk-documents-list-pane--half': !!smkDocMode }"
                    >
                      <div class="tabulator-title smk-documents-toolbar">
                        <strong>SMK Documents</strong>

                        <div v-if="!viewMode">
                          <button type="button" :disabled="!!smkDocMode" @click.stop="startSMKDocAdd">
                            Add Document
                          </button>
                          <button
                            type="button"
                            :disabled="!!smkDocMode || !selectedSMKDocRow"
                            @click.stop="startSMKDocEdit"
                          >
                            Edit
                          </button>
                          <button
                            type="button"
                            :disabled="!!smkDocMode || !selectedSMKDocRow"
                            @click.stop="deleteSMKDoc"
                          >
                            Delete
                          </button>
                        </div>
                      </div>

                      <div class="smk-documents-table-scroll">
                        <TableBox
                          class="smk-documents-tablebox"
                          :key="smkDocTableVersion"
                          title=""
                          :tableData="smkDocList"
                          :selectedRow.sync="selectedSmkInfoData.selectedDoc"
                          :maxSelection="1"
                          :hideColumns="[
                            'CoCode',
                            'StationCode',
                            'OGACode',
                            'OGABranchCode',
                            '_smkDocUid',
                            '_smkSaved',
                            '_smkOriginalCategory',
                            '_smkOriginalRef',
                          ]"
                        />
                      </div>
                    </BoxContainer>

                    <BoxContainer v-if="smkDocMode && smkDocDraft" class="smk-documents-editor-pane">
                      <div class="tabulator-title smk-documents-toolbar">
                        <strong>{{ smkDocMode === 'N' ? 'New SMK Document' : 'Edit SMK Document' }}</strong>

                        <div>
                          <button type="button" @click.stop="updateSMKDoc">
                            {{ smkDocMode === 'N' ? 'Add' : 'Update' }}
                          </button>
                          <button type="button" @click.stop="cancelSMKDoc">Cancel</button>
                        </div>
                      </div>

                      <div class="smk-documents-editor-fields">
                        <InputQuery
                          placeholder="Document Code"
                          :items="availableSMKDocMasterList"
                          itemKey="Doc Code"
                          descKey="Description"
                          :selectedObject.sync="smkDocDraft.master"
                          :isDisabled="smkDocMode === 'E'"
                          :isRequired="true"
                          validator="text,10"
                          @selected="smkDocMasterSelected"
                          :errorMessage.sync="smkDocErrors.master"
                        />

                        <template v-if="smkDocDraft.master">
                          <Input
                            v-if="smkDocDraft.master['Detail 1']"
                            :placeholder="smkDocDraft.master['Detail 1']"
                            :inputValue.sync="smkDocDraft.part1"
                            :isRequired="true"
                            :validator="`text,${smkDocDraft.master['Size 1'] || 35}`"
                            :errorMessage.sync="smkDocErrors.part1"
                          />

                          <Input
                            v-if="smkDocDraft.master['Detail 2']"
                            :placeholder="smkDocDraft.master['Detail 2']"
                            :inputValue.sync="smkDocDraft.part2"
                            :validator="`text,${smkDocDraft.master['Size 2'] || 35}`"
                          />

                          <Input
                            v-if="smkDocDraft.master['Detail 3']"
                            :placeholder="smkDocDraft.master['Detail 3']"
                            :inputValue.sync="smkDocDraft.part3"
                            :validator="`text,${smkDocDraft.master['Size 3'] || 35}`"
                          />

                          <Input
                            v-if="smkDocDraft.master['Detail 4']"
                            :placeholder="smkDocDraft.master['Detail 4']"
                            :inputValue.sync="smkDocDraft.part4"
                            :validator="`text,${smkDocDraft.master['Size 4'] || 35}`"
                          />

                          <DateTimePicker
                            v-if="['I', 'B'].includes(smkDocDraft.master['Date Type'])"
                            placeholder="Issue Date"
                            :value.sync="smkDocDraft.issueDate"
                            :showTime="false"
                          />

                          <DateTimePicker
                            v-if="['E', 'B'].includes(smkDocDraft.master['Date Type'])"
                            placeholder="Expiry Date"
                            :value.sync="smkDocDraft.expiryDate"
                            :showTime="false"
                          />

                          <DateTimePicker
                            v-if="smkDocDraft.master['Date Type'] === 'V'"
                            placeholder="Invoice Date"
                            :value.sync="smkDocDraft.invoiceDate"
                            :showTime="false"
                            :errorMessage.sync="smkDocErrors.invoiceDate"
                          />
                        </template>
                      </div>
                      <div v-if="smkDocErrors.form" class="smk-doc-form-error">
                        {{ smkDocErrors.form }}
                      </div>
                    </BoxContainer>
                  </div>
                </div>

                <!-- <div class="exemption-layout smk-documents-layout" style="margin-top: 15px">
                  <div class="details-wrapper-exemption smk-documents-section">
                    <div class="tab-block-smk exemption-panel smk-documents-panel">
                      <div class="smk-documents-table-scroll">
                        <TableBox
                          class="smk-documents-tablebox"
                          title="SMK Documents"
                          :tableData="smkDocList"
                          :selectedRow.sync="selectedSmkInfoData['selectedDoc']"
                          :maxSelection="1"
                        />
                      </div>
                    </div>
                  </div>
                </div> -->
                <br /><br /><br /><br /><br />
                <!-- <div class="exemption-layout" style="margin-top: 15px;">
                    <div class="details-wrapper-exemption">
                      <div class="tab-block-smk exemption-panel">
                        <div class="tab-title-smk">SMK Documents</div>
                        <div class="exemption-row">
                          <div class="field-wrapper">
                            

                            <div slot="Documents">
                              <div class="top-button-section" id="docPopup" v-if="!viewMode">
                                <button @click="addDoc">
                                  <img src="https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png" height="15" />
                                  Add Documents
                                </button>
                                <button @click="editDoc">
                                  <img src="https://dsmapi.logistics.systems/dsm6gicons/icons8-edit-64%20(1).png" height="15" />
                                  Edit Documents
                                </button>
                                <button @click="deleteDoc">
                                  <img src="https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png" height="15" />
                                  Delete Documents
                                </button>
                              </div>

                                <DocStatusUpdate
                                  :showPopup.sync="documentInfoData['updatePopup']"
                                  :statusList.sync="documentInfoData['statusList']"
                                  :docTypeList.sync="documentInfoData['docTypeList']"
                                  :docStatusList.sync="documentInfoData['docStatusList']"
                                  defaultCategory="document"
                                  @updateClicked="documentUpdate"
                                  :title="`Update Documents for Job # ${selectedHeaderInfoData['jobNo']}`"
                                  :editDetailsList.sync="editDocumentsList"
                                />

                                <TableBox
                                  :tableData="selectedDocumentInfoData['docData']"
                                  groupBy="ID"
                                  :selectedRow.sync="selectedDocumentInfoData['selectedDoc']"
                                  :additionalButtons="viewDocumentButtons"
                                  @buttonClicked="viewDocumentClicked"
                                  title="Documents"
                                  :maxSelection="1"
                                  :hideColumns="['documentguid', 'statusseqno', 'ID', 'fileAtt', 'filetype', 'Action', 'Row #']"
                                />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                 </div> -->
              </div>
              <div slot="Item" class="smk-item-slot" :class="{ 'smk-item-popup-expanded': isSMKItemExpanded }">
                <div
                  class="table-container top-right-div"
                  :class="{ 'has-batch-panel': selectedCount > 0 }"
                  id="right-pane"
                  :style="topRightDivWidth"
                >
                  <div class="add-button-container" v-if="!viewMode">
                    <button
                      type="button"
                      class="smk-column-toggle-button"
                      :class="{ active: showSMKItemHoverTables }"
                      :aria-pressed="showSMKItemHoverTables"
                      title="Show/Hide Duty/Cess Table"
                      @click="showSMKItemHoverTables = !showSMKItemHoverTables"
                    >
                      <img src="https://dsmlib.logistics.systems/Icons/table.png" alt="Duty/Cess Table" />
                    </button>

                    <button
                      type="button"
                      class="smk-column-toggle-button"
                      :class="{ active: showSMKVehicleColumns }"
                      :aria-pressed="showSMKVehicleColumns"
                      title="Show/Hide Vehicle columns"
                      @click="showSMKVehicleColumns = !showSMKVehicleColumns"
                    >
                      <img src="https://dsmlib.logistics.systems/Icons/car.png" alt="Vehicle" />
                    </button>

                    <button
                      type="button"
                      class="smk-column-toggle-button"
                      :class="{ active: showSMKWarehouseColumns }"
                      :aria-pressed="showSMKWarehouseColumns"
                      title="Show/Hide Warehouse columns"
                      @click="showSMKWarehouseColumns = !showSMKWarehouseColumns"
                    >
                      <img src="https://dsmlib.logistics.systems/Icons/smk-warehouse.png" alt="Warehouse" />
                    </button>

                    <button @click="addSMKItem" class="add-item-btn">Add Item</button>

                    <button @click="openBatchAddPopup" class="add-item-btn" style="margin-left: 5px; width: 30%">
                      Batch Add
                    </button>

                    <button
                      @click="deleteSMKItemAll"
                      :disabled="smkItemList.length === 0"
                      class="deleteall-item-btn"
                      style="margin-left: 5px; width: 20%"
                    >
                      Delete All
                    </button>
                  </div>

                  <div class="batch-panel sticky-top" v-if="selectedCount && !isSMKItemViewOnly > 0">
                    <span>{{ selectedCount }} selected</span>

                    <Dropdown
                      placeholder="Select field"
                      :items="batchFieldOptions"
                      itemKey="label"
                      :selectedObject.sync="selectedBatchFieldObj"
                      style="width: 180px"
                    />

                    <div v-if="batchField">
                      <Input
                        v-if="fieldConfig[batchField].type === 'text' || fieldConfig[batchField].type === 'number'"
                        :validator="fieldConfig[batchField].type === 'number' ? 'decimal,15,4' : 'text,50'"
                        :inputValue.sync="batchValue"
                        :placeholder="'Enter ' + fieldConfig[batchField].label"
                        style="width: 150px"
                      />

                      <InputQuery
                        v-else-if="fieldConfig[batchField].type === 'dropdown'"
                        :items="
                          batchField === 'ItemCode' ? generalInfoData.smkItemMasterList
                          : batchField === 'Product' ? generalInfoData.smkProductList
                          : generalInfoData[fieldConfig[batchField].source]
                        "
                        :itemKey="fieldConfig[batchField].itemKey"
                        :descKey="fieldConfig[batchField].descKey"
                        :selectedObject.sync="batchQueryObject"
                        :search.sync="batchValue"
                        :allowFreeText="true"
                        style="width: 180px"
                        :placeholder="'Select ' + fieldConfig[batchField].label"
                      />

                      <label v-else-if="fieldConfig[batchField].type === 'checkbox'" class="smk-batch-checkbox">
                        <input type="checkbox" v-model="batchValue" />
                        <span>{{ fieldConfig[batchField].label }}</span>
                      </label>
                    </div>

                    <button @click="applyBatchEdit">Apply</button>
                    <button @click="deleteSelected">Delete Selected</button>
                    <button @click="clearSelected">Clear</button>
                  </div>

                  <div class="smk-wrapper">
                    <div class="smk-title-row" v-if="smkItemList && smkItemList.length > 0">
                      <span class="title">SMK Item</span>

                      <Tooltip
                        @click.native="exportSMKItemExcel"
                        icon="https://dsmapi.logistics.systems/dsm6gIcons/ExportExcel.png"
                        tooltipText="Export to Excel"
                        style="cursor: pointer; margin-left: 5px"
                      />

                      <div
                        style="
                          margin-left: auto;
                          display: flex;
                          align-items: center;
                          gap: 5px;
                          font-size: 13px;
                          white-space: nowrap;
                        "
                      >
                        <span style="padding: 3px 7px; background: #eef2f7; border-radius: 3px">
                          Total Item #:
                          <b style="font-family: Arial, sans-serif">
                            {{ smkItemList.length }}
                          </b>
                        </span>

                        <span style="padding: 3px 7px; background: #eef2f7; border-radius: 3px">
                          Total Item Amount:
                          <b style="font-family: Arial, sans-serif">
                            {{ formatSMKItemSummaryAmount(smkItemSummaryAmount) }}
                          </b>
                        </span>

                        <span style="padding: 3px 7px; background: #e8f3f1; border-radius: 3px">
                          Total CIF:
                          <b style="font-family: Arial, sans-serif">
                            {{ formatSMKItemSummaryAmount(smkItemSummaryCIF) }}
                          </b>
                        </span>

                        <span style="padding: 3px 7px; background: #e8f3f1; border-radius: 3px">
                          Total FOB:
                          <b style="font-family: Arial, sans-serif">
                            {{ formatSMKItemSummaryAmount(smkItemSummaryFOB) }}
                          </b>
                        </span>
                      </div>

                      <button
                        @click="toggleSMKItemExpand"
                        class="smk-item-expand-btn"
                        style="margin-left: 8px"
                        type="button"
                      >
                        <img
                          :src="
                            isSMKItemExpanded ?
                              'https://dsmlib.logistics.systems/Icons/Collapse.png'
                            : 'https://dsmlib.logistics.systems/Icons/Expand.png'
                          "
                          class="smk-item-expand-icon"
                        />
                      </button>
                    </div>
                    <div
                      v-if="selectedSMKItemRowForDuty && canShowSMKItemHoverTables"
                      class="smk-item-duty-panel"
                      :class="{ pinned: smkItemDutyPanelPinned, 'with-cess': showSMKCessOnHover }"
                      :style="{ left: hoverSMKItemPanelX + 'px', top: hoverSMKItemPanelY + 'px' }"
                      @mouseenter="cancelSMKItemDutyHide"
                      @mouseleave="hideSMKItemDutyPanel(selectedSMKItemRowForDuty)"
                      @click.stop="pinSMKItemDutyPanel"
                    >
                      <div class="smk-item-hover-tables">
                        <table class="smk-item-duty-table">
                          <thead>
                            <tr>
                              <th rowspan="2" class="smk-item-duty-edit-header">
                                <span v-if="!smkItemDutyPanelPinned">Click to Edit</span>

                                <div v-else class="smk-item-duty-actions">
                                  <button type="button" class="smk-duty-update" @click.stop="updateSMKItemDuty">
                                    Update
                                  </button>
                                  <button type="button" class="smk-duty-cancel" @click.stop="cancelSMKItemDuty">
                                    Cancel
                                  </button>
                                </div>
                              </th>
                              <th colspan="3">Duty</th>
                              <th colspan="3">Exemption</th>
                            </tr>
                            <tr>
                              <th>%</th>
                              <th>$</th>
                              <th>Amount</th>
                              <th>%</th>
                              <th>$</th>
                              <th>Amount</th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr v-for="dutyRow in smkItemDutyRows" :key="dutyRow.label">
                              <td>{{ dutyRow.label }}</td>
                              <td>{{ dutyRow.dutyPercent }}</td>
                              <td>{{ dutyRow.dutyFixed }}</td>
                              <td>{{ dutyRow.dutyAmount }}</td>

                              <td>
                                <input
                                  v-if="smkItemDutyPanelPinned && !isSMKItemViewOnly && dutyRow.exemptPercentField"
                                  type="text"
                                  inputmode="decimal"
                                  class="smk-duty-edit"
                                  :value="dutyRow.exemptPercent"
                                  @change="smkExemptionChanged(dutyRow.exemptPercentField, '%', $event)"
                                  @keyup.enter="$event.target.blur()"
                                  @click.stop
                                />
                                <span v-else>{{ dutyRow.exemptPercent }}</span>
                              </td>

                              <td>
                                <input
                                  v-if="smkItemDutyPanelPinned && !isSMKItemViewOnly && dutyRow.exemptFixedField"
                                  type="text"
                                  inputmode="decimal"
                                  class="smk-duty-edit"
                                  :value="dutyRow.exemptFixed"
                                  @change="smkExemptionChanged(dutyRow.exemptFixedField, '$', $event)"
                                  @keyup.enter="$event.target.blur()"
                                  @click.stop
                                />
                                <span v-else>{{ dutyRow.exemptFixed }}</span>
                              </td>

                              <td>{{ dutyRow.exemptAmount }}</td>
                            </tr>
                          </tbody>
                        </table>

                        <table v-if="showSMKCessOnHover" class="smk-item-cess-table">
                          <thead>
                            <tr>
                              <th></th>
                              <th>Cess Rate</th>
                              <th>CessAmt</th>
                              <th>Xm%</th>
                              <th>Cess XM</th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr v-for="cessRow in smkItemCessRows" :key="cessRow.label">
                              <td>{{ cessRow.label }}</td>
                              <td>{{ cessRow.cessRate }}</td>
                              <td>{{ cessRow.cessAmount }}</td>

                              <td>
                                <input
                                  v-if="smkItemDutyPanelPinned && !isSMKItemViewOnly && cessRow.exemptPercentField"
                                  type="text"
                                  inputmode="decimal"
                                  class="smk-duty-edit"
                                  :value="cessRow.exemptPercent"
                                  @change="smkExemptionChanged(cessRow.exemptPercentField, '%', $event)"
                                  @keyup.enter="$event.target.blur()"
                                  @click.stop
                                />
                                <span v-else>{{ cessRow.exemptPercent }}</span>
                              </td>

                              <td>{{ cessRow.exemptAmount }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div class="table-box-main smk-edit-table" v-if="smkItemList && smkItemList.length > 0">
                      <!-- toolbar -->
                      <div class="top-block">
                        <div class="right-section">
                          <input v-model="searchText" class="table-search" placeholder="Search..." />
                        </div>

                        <div class="left-section">
                          <span>{{ filteredSMKItemList.length }} of {{ smkItemList.length }} records</span>
                        </div>
                      </div>

                      <div class="table-block" ref="scrollBlock">
                        <!-- HEADER -->
                        <div class="table-header">
                          <div
                            v-for="(col, colIndex) in visibleSMKItemColumns"
                            :key="col.key"
                            class="table-column blue-theme"
                            :class="[
                              col.group ? `smk-field-group smk-group-${col.group}` : '',
                              {
                                'sticky-column': col.key === 'select',
                                'select-col': col.key === 'select',
                                'seq-col': col.key === 'seq',
                                'action-col': col.key === 'action',
                                'smk-group-start': col.groupStart,
                                'smk-group-end': col.groupEnd,
                              },
                            ]"
                            draggable="true"
                            @dragstart="onColumnDragStart(colIndex)"
                            @dragover.prevent
                            @drop="onColumnDrop(colIndex)"
                            @dblclick="autoFit($event, colIndex)"
                            :style="{
                              width: (col.width || 140) + 'px',
                              minWidth: (col.width || 140) + 'px',
                              maxWidth: (col.width || 140) + 'px',
                            }"
                          >
                            <div class="title-block">
                              <template v-if="col.key === 'select'">
                                <input
                                  v-if="!isSMKItemViewOnly"
                                  type="checkbox"
                                  class="big-checkbox"
                                  v-model="selectAll"
                                  @change="toggleSelectAll"
                                />
                              </template>

                              <template v-else-if="col.key === 'ItemCode'">
                                <div class="smk-column-title-with-toggle">
                                  <span>{{ col.label }}</span>

                                  <label
                                    class="smk-header-toggle"
                                    title="Show all item master records"
                                    @click.stop
                                    @mousedown.stop
                                    @dblclick.stop
                                  >
                                    <input
                                      type="checkbox"
                                      v-model="showAllSMKItems"
                                      :disabled="isSMKItemViewOnly"
                                      @click.stop
                                      @mousedown.stop
                                    />
                                    <span>All</span>
                                  </label>
                                </div>
                              </template>

                              <template v-else-if="col.key === 'Product'">
                                <div class="smk-column-title-with-toggle">
                                  <span>{{ col.label }}</span>

                                  <label
                                    class="smk-header-toggle"
                                    title="Show all product master records"
                                    @click.stop
                                    @mousedown.stop
                                    @dblclick.stop
                                  >
                                    <input
                                      type="checkbox"
                                      v-model="showAllSMKProducts"
                                      :disabled="isSMKItemViewOnly"
                                      @click.stop
                                      @mousedown.stop
                                    />
                                    <span>All</span>
                                  </label>
                                </div>
                              </template>

                              <template v-else>
                                <span>{{ col.label }}</span>
                              </template>
                            </div>

                            <!-- simple filter row -->
                            <div v-if="!['select', 'seq', 'action'].includes(col.key)" class="filter-block">
                              <input
                                v-model="columnFilters[col.key]"
                                class="column-filter"
                                placeholder="Search"
                                @click.stop
                              />
                            </div>

                            <span
                              class="col-resizer"
                              @mousedown.stop.prevent="startColResize($event, colIndex)"
                              @dragstart.stop.prevent
                            ></span>
                          </div>
                        </div>

                        <!-- BODY -->
                        <div
                          v-for="(row, index) in filteredSMKItemList"
                          :key="row._rowKey"
                          class="table-row blue-theme-row"
                          :class="{
                            'blue-theme-row-selected': row.selected,
                            'blue-theme-row-active': activeSMKItemRow === row,
                          }"
                          @mousedown.capture="setActiveSMKItemRow(row, $event)"
                          @click="setActiveSMKItemRow(row)"
                          @mouseenter="showSMKItemDutyPanel(row, $event)"
                          @mousemove="moveSMKItemDutyPanel($event)"
                          @mouseleave="hideSMKItemDutyPanel(row)"
                        >
                          <div
                            v-for="col in visibleSMKItemColumns"
                            :key="col.key"
                            class="row-data"
                            :class="[
                              col.group ? `smk-field-group smk-group-${col.group}` : '',
                              {
                                'sticky-column': col.key === 'select',
                                'select-col': col.key === 'select',
                                'seq-col': col.key === 'seq',
                                'action-col': col.key === 'action',
                                'smk-group-start': col.groupStart,
                                'smk-group-end': col.groupEnd,
                                'input-with-icon': [
                                  'ItemCode',
                                  'Product',
                                  'HSCode',
                                  'InvoiceUOM',
                                  'TariffUOQ',
                                  'DutyUOM',
                                ].includes(col.key),
                              },
                            ]"
                            :style="{
                              width: (col.width || 140) + 'px',
                              minWidth: (col.width || 140) + 'px',
                              maxWidth: (col.width || 140) + 'px',
                            }"
                          >
                            <!-- select -->
                            <template v-if="col.key === 'select'">
                              <input
                                type="checkbox"
                                class="big-checkbox"
                                :checked="row.selected"
                                @mousedown.stop
                                @click.stop="shiftSelect(row, index, $event)"
                              />
                            </template>

                            <!-- seq -->
                            <template v-else-if="col.key === 'seq'">
                              <span>{{ index + 1 }}</span>
                            </template>

                            <!-- Item # -->
                            <template v-else-if="col.key === 'ItemCode'">
                              <Tooltip
                                v-if="isFreeTextByRow(row, 'ItemCode', smkItemMasterItemsByRow(row), 'Item Code')"
                                icon="https://dsmapi.logistics.systems/dsm6gIcons/warning.png"
                                tooltipText="Does not match any value in SMK Item Master"
                                class="tooltip-icon smk-master-warning-icon"
                                position="left"
                              />
                              <InputQuery
                                class="smk-grid-input-query"
                                placeholder=""
                                :items="smkItemMasterItemsByRow(row)"
                                itemKey="Item Code"
                                descKey="Item Name"
                                :selectedObject.sync="row['ItemCodeObj']"
                                :search.sync="row['ItemCode']"
                                validator="text,25"
                                :allowFreeText="true"
                                :isDisabled="isSMKItemViewOnly"
                                @selected="smkItemCodeSelected(row, $event)"
                              />
                            </template>

                            <!-- Product -->
                            <template v-else-if="col.key === 'Product'">
                              <Tooltip
                                v-if="isFreeTextByRow(row, 'Product', filteredSMKProductMasterList, 'Product Code')"
                                icon="https://dsmapi.logistics.systems/dsm6gIcons/warning.png"
                                tooltipText="Does not match any value in SMK Product Master"
                                class="tooltip-icon smk-master-warning-icon"
                                position="left"
                              />
                              <InputQuery
                                class="smk-grid-input-query"
                                placeholder=""
                                :items="filteredSMKProductMasterList"
                                itemKey="Product Code"
                                descKey="Product Name"
                                :selectedObject.sync="row['ProductObj']"
                                :search.sync="row['Product']"
                                validator="text,25"
                                :allowFreeText="true"
                                :isDisabled="isSMKItemViewOnly"
                                @selected="smkProductSelected(row, $event)"
                              />
                            </template>

                            <!-- CountryOfOrigin -->
                            <template v-else-if="col.key === 'CountryOfOrigin'">
                              <InputQuery
                                class="smk-grid-input-query"
                                placeholder=""
                                :items="generalInfoData['countryList']"
                                itemKey="Code - Desc"
                                descKey="Country"
                                :selectedObject.sync="row['CountryOfOrigin']"
                                validator="text,2"
                                :isDisabled="isSMKItemViewOnly"
                              />
                            </template>

                            <!-- HSCode -->
                            <template v-else-if="col.key === 'HSCode'">
                              <Tooltip
                                v-if="isFreeTextByRow(row, 'HSCode', generalInfoData.tcList, 'Tariff Code')"
                                icon="https://dsmapi.logistics.systems/dsm6gIcons/warning.png"
                                tooltipText="Does not match any value in Tariff Code Master"
                                class="tooltip-icon smk-master-warning-icon"
                                position="left"
                              />
                              <InputQuery
                                class="smk-grid-input-query"
                                placeholder=""
                                :items="generalInfoData['tcList']"
                                itemKey="Tariff Code"
                                :selectedObject.sync="row['HSCode']"
                                validator="text,25"
                                :isDisabled="isSMKItemViewOnly"
                                :allowFreeText="true"
                                @selected="selectedHSCodeByRow(row)"
                              />
                            </template>

                            <!-- iUOM -->
                            <template v-else-if="col.key === 'InvoiceUOM'">
                              <Tooltip
                                v-if="isFreeTextByRow(row, 'InvoiceUOM', generalInfoData.uomList, 'UOM Code')"
                                icon="https://dsmapi.logistics.systems/dsm6gIcons/warning.png"
                                tooltipText="Does not match any value in UOM Master"
                                class="tooltip-icon smk-master-warning-icon"
                                position="left"
                              />
                              <InputQuery
                                class="smk-grid-input-query"
                                placeholder=""
                                :items="generalInfoData['uomList']"
                                itemKey="UOM Code"
                                :selectedObject.sync="row['InvoiceUOM']"
                                validator="text,5"
                                :allowFreeText="true"
                                :isDisabled="isSMKItemViewOnly"
                              />
                            </template>

                            <!-- iQTY -->
                            <template v-else-if="col.key === 'InvoiceQty'">
                              <Input
                                placeholder=""
                                validator="decimal,15,5"
                                :inputValue.sync="row['InvoiceQty']"
                                :isRequired="false"
                                :isDisabled="isSMKItemViewOnly"
                                @focusChanged="smkItemValueChanged(row, 'InvoiceQty', $event)"
                              />
                            </template>

                            <!-- UOQ -->
                            <template v-else-if="col.key === 'TariffUOQ'">
                              <Tooltip
                                v-if="isFreeTextByRow(row, 'TariffUOQ', generalInfoData.uomList, 'UOM Code')"
                                icon="https://dsmapi.logistics.systems/dsm6gIcons/warning.png"
                                tooltipText="Does not match any value in UOM Master"
                                class="tooltip-icon smk-master-warning-icon"
                                position="left"
                              />
                              <InputQuery
                                class="smk-grid-input-query"
                                placeholder=""
                                :items="generalInfoData['uomList']"
                                itemKey="UOM Code"
                                :selectedObject.sync="row['TariffUOQ']"
                                validator="text,5"
                                :allowFreeText="true"
                                :isDisabled="isSMKItemViewOnly"
                              />
                            </template>

                            <!-- tQty -->
                            <template v-else-if="col.key === 'TariffQty'">
                              <Input
                                placeholder=""
                                validator="decimal,15,5"
                                :inputValue.sync="row['TariffQty']"
                                :isRequired="false"
                                :isDisabled="isSMKItemViewOnly"
                                @focusChanged="smkItemValueChanged(row, 'TariffQty', $event)"
                              />
                            </template>

                            <!-- dUOM -->
                            <template v-else-if="col.key === 'DutyUOM'">
                              <Tooltip
                                v-if="
                                  showSMKItemDutyQty(row) &&
                                  isFreeTextByRow(row, 'DutyUOM', generalInfoData.uomList, 'UOM Code')
                                "
                                icon="https://dsmapi.logistics.systems/dsm6gIcons/warning.png"
                                tooltipText="Does not match any value in UOM Master"
                                class="tooltip-icon smk-master-warning-icon"
                                position="left"
                              />
                              <InputQuery
                                v-if="showSMKItemDutyQty(row)"
                                class="smk-grid-input-query"
                                placeholder=""
                                :items="generalInfoData['uomList']"
                                itemKey="UOM Code"
                                :selectedObject.sync="row['DutyUOM']"
                                validator="text,5"
                                :allowFreeText="true"
                                :isDisabled="isSMKItemViewOnly"
                              />
                            </template>

                            <!-- UnitPrice -->
                            <template v-else-if="col.key === 'UnitPrice'">
                              <Input
                                placeholder=""
                                validator="decimal,15,5"
                                :inputValue.sync="row['UnitPrice']"
                                :isRequired="false"
                                :isDisabled="isSMKItemViewOnly"
                                @focusChanged="smkItemValueChanged(row, 'UnitPrice', $event)"
                              />
                            </template>

                            <!-- ItemAmount -->
                            <template v-else-if="col.key === 'ItemAmount'">
                              <Input
                                placeholder=""
                                validator="decimal,15,4"
                                :inputValue.sync="row['ItemAmount']"
                                :isRequired="false"
                                :isDisabled="isSMKItemViewOnly"
                                @focusChanged="smkItemValueChanged(row, 'ItemAmount', $event)"
                              />
                            </template>

                            <!-- ItemDescription -->
                            <template v-else-if="col.key === 'ItemDescription'">
                              <div class="smk-item-description-cell">
                                <Input
                                  class="smk-item-description-input"
                                  placeholder=""
                                  validator="text,140"
                                  :inputValue.sync="row['ItemDescription']"
                                  :isRequired="false"
                                  :isDisabled="isSMKItemViewOnly"
                                />

                                <button
                                  type="button"
                                  class="smk-long-description-button"
                                  :class="{ active: String(row.LongDescription || '').trim() }"
                                  :title="
                                    String(row.LongDescription || '').trim() ?
                                      row.LongDescription
                                    : 'No Long Description'
                                  "
                                  @click.stop="openSMKLongDescription(row)"
                                >
                                  <img
                                    src="https://dsmlib.logistics.systems/Icons/edit-info.png"
                                    alt="Long Description"
                                  />
                                </button>
                              </div>
                            </template>

                            <!-- CEPT -->
                            <template v-else-if="col.key === 'CEPT'">
                              <Input
                                placeholder=""
                                validator="text,15"
                                :inputValue.sync="row['CEPT']"
                                :isRequired="false"
                                :isDisabled="isSMKItemViewOnly"
                              />
                            </template>

                            <!-- Alcohol -->
                            <template v-else-if="col.key === 'Alcohol'">
                              <InputQuery
                                class="smk-grid-input-query"
                                placeholder=""
                                :items="generalInfoData['alcoholList']"
                                itemKey="Name"
                                :selectedObject.sync="row['Alcohol']"
                                validator="text,3"
                                :isDisabled="isSMKItemViewOnly"
                                @selected="smkAlcoholSelected(row, $event)"
                              />
                            </template>

                            <!-- DutyQty -->
                            <template v-else-if="col.key === 'DutyQty'">
                              <Input
                                v-if="showSMKItemDutyQty(row)"
                                placeholder=""
                                validator="decimal,15,5"
                                :inputValue.sync="row['DutyQty']"
                                :isRequired="false"
                                :isDisabled="isSMKItemViewOnly"
                                @focusChanged="smkItemValueChanged(row, 'DutyQty', $event)"
                              />
                            </template>

                            <!-- TxnId / GST / Alcohol saved fields -->
                            <!-- <template v-else-if="col.key === 'TxnId'">
                              <Input
                                placeholder=""
                                validator="text,50"
                                :inputValue.sync="row['TxnId']"
                                :isRequired="false"
                                :isDisabled="true"
                              />
                            </template> -->

                            <!-- Warehouse details -->
                            <template v-else-if="['WarehouseLotNo', 'WarehouseLocation'].includes(col.key)">
                              <Input
                                placeholder=""
                                validator="text,50"
                                :inputValue.sync="row[col.key]"
                                :isRequired="false"
                                :isDisabled="isSMKItemViewOnly"
                              />
                            </template>

                            <template v-else-if="col.key === 'GSTExemptType'">
                              <Input
                                placeholder=""
                                validator="text,20"
                                :inputValue.sync="row['GSTExemptType']"
                                :isRequired="false"
                                :isDisabled="isSMKItemViewOnly"
                              />
                            </template>

                            <template v-else-if="col.key === 'GSTHSCode'">
                              <Input
                                placeholder=""
                                validator="text,25"
                                :inputValue.sync="row['GSTHSCode']"
                                :isRequired="false"
                                :isDisabled="isSMKItemViewOnly"
                              />
                            </template>

                            <template v-else-if="col.key === 'AlcoholContent'">
                              <Input
                                v-if="showSMKItemAlcohol(row)"
                                placeholder=""
                                validator="decimal,15,4"
                                :inputValue.sync="row.AlcoholContent"
                                :isRequired="false"
                                :isDisabled="isSMKItemViewOnly || !canEnterSMKAlcohol(row)"
                                @focusChanged="smkItemValueChanged(row, 'AlcoholContent', $event)"
                              />
                            </template>

                            <template v-else-if="col.key === 'AlcoholQualifier'">
                              <Input
                                v-if="showSMKItemAlcohol(row)"
                                placeholder=""
                                validator="text,3"
                                :inputValue.sync="row['AlcoholQualifier']"
                                :isRequired="false"
                                :isDisabled="true"
                              />
                            </template>

                            <!-- Vehicle details-->
                            <template v-else-if="col.key === 'Model'">
                              <Input
                                placeholder=""
                                validator="text,50"
                                :inputValue.sync="row['Model']"
                                :isRequired="false"
                                :isDisabled="isSMKItemViewOnly"
                              />
                            </template>

                            <template v-else-if="col.key === 'ChassisNo'">
                              <Input
                                placeholder=""
                                validator="text,50"
                                :inputValue.sync="row['ChassisNo']"
                                :isRequired="false"
                                :isDisabled="isSMKItemViewOnly"
                              />
                            </template>

                            <template v-else-if="col.key === 'EngineNo'">
                              <Input
                                placeholder=""
                                validator="text,50"
                                :inputValue.sync="row['EngineNo']"
                                :isRequired="false"
                                :isDisabled="isSMKItemViewOnly"
                              />
                            </template>

                            <template v-else-if="col.key === 'Brand'">
                              <Input
                                placeholder=""
                                validator="text,50"
                                :inputValue.sync="row['Brand']"
                                :isRequired="false"
                                :isDisabled="isSMKItemViewOnly"
                              />
                            </template>

                            <template v-else-if="col.key === 'EngineCapacityQlf'">
                              <Input
                                placeholder=""
                                validator="text,20"
                                :inputValue.sync="row['EngineCapacityQlf']"
                                :isRequired="false"
                                :isDisabled="isSMKItemViewOnly"
                              />
                            </template>

                            <template v-else-if="col.key === 'EngineCapacityValue'">
                              <Input
                                placeholder=""
                                validator="text,20"
                                :inputValue.sync="row['EngineCapacityValue']"
                                :isRequired="false"
                                :isDisabled="isSMKItemViewOnly"
                              />
                            </template>

                            <template v-else-if="col.key === 'ManufactureDate'">
                              <DateTimePicker
                                placeholder="Date"
                                title="Manufacture Date"
                                :value.sync="row['ManufactureDate']"
                                :showTime="false"
                                :isRequired="false"
                                :isDisabled="isSMKItemViewOnly"
                              />
                            </template>

                            <template v-else-if="['AseanCept', 'AseanPta', 'AseanAD'].includes(col.key)">
                              <div class="smk-exclusive-checkbox-cell">
                                <input
                                  type="checkbox"
                                  class="big-checkbox"
                                  :checked="!!row[col.key]"
                                  :disabled="
                                    isSMKItemViewOnly || (col.key === 'AseanCept' && !isSMKPreferentialDeclaration)
                                  "
                                  @change="smkDutyOptionChanged(row, col.key, $event.target.checked)"
                                />
                              </div>
                            </template>

                            <!-- action -->
                            <template v-else-if="col.key === 'action'">
                              <button :disabled="isSMKItemViewOnly" @click="deleteSMKItemByRow(row)">Delete</button>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div slot="Events">
                <TableBox :tableData="smkListing" title="SMK" />
              </div>
            </Tab>

            <!-- <TableBox :tableData="smkListing" title="SMK" /> -->
          </div>
        </Tab>
      </div>
    </PopupEntry>

    <SimplePopup v-if="showDocUpload" :show.sync="showDocUpload" :title="popupTitle" @close="closeClicked">
      <JobFormComponent
        ref="jobformcomponent"
        @submit="submitVerifiedInfo"
        @processorVersion="handleProcessorVersion"
        :headerInfoData="headerInfoData"
        :generalInfoData="generalInfoData"
        :shippingInfoData="shippingInfoData"
        :cargoInfoData="cargoInfoData"
        :documentInfoData="documentInfoData"
      />
    </SimplePopup>

    <SimplePopup
      v-if="showFlatFilePreview"
      :show.sync="showFlatFilePreview"
      :title="`Preview FlatFile - ${flatFilePreviewJobNo}`"
      @close="showFlatFilePreview = false"
    >
      <div class="flat-file-preview">
        <textarea class="flat-file-preview-text" :value="flatFilePreviewText" readonly></textarea>
        <textarea
          class="flat-file-preview-error"
          style="font-weight: bold"
          :value="flatFilePreviewErrors"
          readonly
        ></textarea>
      </div>
      <div class="flat-file-preview-actions">
        <button type="button" @click="downloadFlatFilePreview" :disabled="!flatFilePreviewText"> Download .Flt </button>
      </div>
    </SimplePopup>

    <!-- <Tooltip :show="showTooltip" :text="tooltipText" /> -->

    <PopupV2
      :show="showSMKLongDescriptionPopup"
      title="Item Long Description"
      type="info"
      width="700px"
      height="520px"
      :buttons="isSMKItemViewOnly ? smkLongDescriptionPopupButtonsViewOnly : smkLongDescriptionPopupButtons"
      @buttonClicked="smkLongDescriptionPopupButtonClicked"
    >
      <div class="smk-long-description-content">
        <div class="smk-long-description-details">
          <div>
            <strong>Job #:</strong>
            {{ selectedHeaderInfoData['jobNo'] || '' }}
          </div>

          <div>
            <strong>Item #:</strong>
            {{ activeSMKLongDescriptionRow ? activeSMKLongDescriptionRow.ItemCode : '' }}
          </div>
        </div>

        <textarea
          v-model="smkLongDescriptionDraft"
          class="smk-long-description-textarea"
          :disabled="isSMKItemViewOnly"
          placeholder="Enter item long description"
        ></textarea>
      </div>
    </PopupV2>

    <PopupV2
      :show="showSavePopup"
      :type="savePopupType"
      :title="savePopupTitle"
      :buttons="savePopupButtons"
      @buttonClicked="savePopupButtonClicked"
    >
      <div v-if="saveAlertType == 'required' || saveAlertType == 'requiredCantSave'">
        <div v-if="saveAlertType == 'requiredCantSave'">
          In order to save a job, the field{{ saveErrorList.length > 1 ? 's' : '' }} below
          {{ saveErrorList.length > 1 ? 'are' : 'is' }} required!
        </div>
        <div class="save-content">
          <span v-for="(e, i) in saveErrorList" :key="i">{{ i + 1 }}. {{ e }}<br /></span>
        </div>
        <div v-if="saveAlertType == 'required'">Saving will make this an unconfirm job</div>
        <div v-if="saveAlertType == 'required'" style="margin-bottom: 5px"
          >Do you want to continue to save this job?</div
        >
      </div>
      <div
        v-if="saveAlertType == 'choiceMode' || saveAlertType == 'required'"
        :style="{ textAlign: 'left', minHeight: reasonOpen ? '200px' : '' }"
      >
        <RadioButtonSet
          v-if="saveAlertType == 'choiceMode'"
          title="Save Job as"
          :buttons="saveRadioButton"
          labelKey="label"
          :selected.sync="selectedSaveBy"
          :isRequired="true"
          :isDisabled="viewMode"
          :isHorizontal="true"
          style="margin-bottom: 5px"
        />
        <div v-if="!saveAsConfirm || saveAlertType == 'required'" style="padding-left: 10px">
          <Dropdown
            :isRequired="true"
            placeholder="Reason"
            :items="reasonsList"
            :selectedObject.sync="selectedUnconfirmReason"
            itemKey="Reason"
            @focusChanged="reasonFocusChanged"
            validator="text,50"
          />
          <Input
            :isRequired="selectedUnconfirmReason ? selectedUnconfirmReason['Reason'].includes('OTHERS') : false"
            placeholder="Remarks"
            :inputValue.sync="unconfirmRemarks"
          />
          <div class="popup-error">{{ popupErrorText }}</div>
        </div>
      </div>
    </PopupV2>

    <PopupV2
      :show="showDeletePopup"
      :title="deleteTarget === 'PART' ? 'Delete Part Job' : 'Delete Job'"
      @buttonClicked="deletePopupButtonClicked"
      :buttons="deletePopupButtons"
    >
      <div>
        Are you sure you want to delete Job #{{
          deleteTarget === 'PART' ? getSelectedPartJobNo() : getSelectedMainJobNo()
        }}?
      </div>

      <div v-if="deleteTarget === 'MAIN' && selectedJob.length > 0 ? selectedJob[0]['Job Assigned'] > 0 : false">
        <br />
        Consignment under this Job has been assigned. Continue to delete?
      </div>

      <Input
        placeholder="Remarks"
        :inputValue.sync="deleteRemarks"
        :errorMessage.sync="deleteRemarksError"
        :isRequired="true"
      />
    </PopupV2>

    <PopupV2 :show="rotVerifyPopup" type="error" title="Error Creating New ROT" @buttonClicked="rotVerifyPopup = false">
      <div style="white-space: pre-wrap">{{ rotVerifyError }}</div>
    </PopupV2>

    <PopupV2
      :show="defaultPopup['show']"
      :type="defaultPopup['type']"
      :title="defaultPopup['title']"
      @buttonClicked="defaultPopupButtonClicked"
    >
      <div style="white-space: pre-wrap">{{ defaultPopup['content'] }}</div>
    </PopupV2>

    <PopupV2
      :show="excelContConfirm"
      type="info"
      title="Container List"
      @buttonClicked="excelContClicked"
      :buttons="contPreviewButtons"
      height="90%"
      width="90%"
    >
      We've detected {{ importContPreview.length }} containers from selected file.<br />Do you want to confirm these
      containers?
      <TableBox
        :style="{ height: `calc(100% - ${importHasError ? 251 : 233}px)` }"
        :tableData="importContPreview"
        :maxSelection="0"
        title="Containers"
        :loading="importContLoading"
      />
      <div v-if="importHasError"
        >There are 1 or more errors in the imported excel, please modify it in your excel first and re-upload.</div
      >
    </PopupV2>

    <PopupV2
      :show="showBatchAddPopup"
      title="Batch Add SMK Items"
      :buttons="batchAllPopupButtons"
      @buttonClicked="batchAddPopupButtonClicked"
    >
      <div style="padding: 10px">
        <span>How many SMK items do you want to add?</span>

        <Input
          placeholder="Enter number of items"
          validator="integer,3"
          :inputValue.sync="batchAddCount"
          style="margin-top: 5px; width: 100%"
        />
      </div>
    </PopupV2>

    <!-- <PopupV2
      :show="showFlatFilePreviewPopup"
      type="info"
      title="Preview FlatFile"
      :buttons="[{ text: 'Close' }]"
      @buttonClicked="showFlatFilePreviewPopup = false"
    >
      <div class="flat-file-preview">
        <div class="flat-file-preview-header">
          <div><b>Job No:</b> {{ flatFilePreview.jobno }}</div>
          <div><b>File Name:</b> {{ flatFilePreview.fileName }}</div>
        </div>

        <div v-if="flatFilePreview.errors && flatFilePreview.errors.length > 0" class="flat-file-errors">
          <div v-for="(err, index) in flatFilePreview.errors" :key="index">
            {{ err }}
          </div>
        </div>

        <textarea
          v-else
          class="flat-file-preview-text"
          readonly
          :value="flatFilePreview.text"
        ></textarea>
      </div>
    </PopupV2> -->

    <!-- #region eJob -->
    <div v-if="showEJobPopup" class="ejob-popup">
      <div class="ejob-content">
        <div class="top-section">
          <ButtonFilter
            filterPosition="right"
            buttonText="Change Filter"
            :filterWidth="300"
            :isOpen.sync="ejobFilterOpen"
          >
            <div class="filter-section">
              <Dropdown placeholder="From" />
              <BoxContainer title="eJobs">
                <CheckBoxV2
                  title="All Jobs"
                  @checkBoxClicked="ejobCheckboxClicked('allEJobChecked')"
                  :isChecked.sync="allEJobChecked"
                />
                <BoxContainer
                  title="Job Range"
                  @checkBoxClicked="ejobCheckboxClicked('rangeEJobChecked')"
                  :isChecked.sync="rangeEJobChecked"
                  :isCheckBox="true"
                >
                  <DateTimePicker
                    placeholder="From"
                    :value.sync="ejobRangeFrom"
                    :isDisabled="!rangeEJobChecked"
                    :isRequired="rangeEJobChecked"
                    :errorMessage.sync="ejobRangeFromError"
                    :maxDate="smallDateTimeMaxDate"
                    :minDate="smallDateTimeMinValue"
                  />
                  <DateTimePicker
                    placeholder="To"
                    :value.sync="ejobRangeTo"
                    :isDisabled="!rangeEJobChecked"
                    :isRequired="rangeEJobChecked"
                    :errorMessage.sync="ejobRangeToError"
                    :maxDate="smallDateTimeMaxDate"
                    :minDate="smallDateTimeMinValue"
                  />
                </BoxContainer>
              </BoxContainer>
              <button class="refresh-button" @click="refreshEJobClicked">Refresh</button>
            </div>
          </ButtonFilter>
          <div>Last Refreshed: {{ ejobLastRefreshed }}</div>
        </div>
        <div class="table-section">
          <TableBox title="eJob" :tableData="ejobListing" :selectedRow.sync="selectedeJob" />
        </div>
        <div class="bottom-section">
          <button :disabled="selectedeJob.length == 0" @click="ejobAccept">Accept</button>
          <button :disabled="selectedeJob.length == 0" @click="ejobReject">Reject</button>
          <button class="cancel-btn" @click="showEJobPopup = false">Cancel</button>
        </div>
      </div>
    </div>

    <Verification
      style="z-index: 200"
      v-if="showVerification"
      :show.sync="showVerification"
      :sections="eJobSections"
      @confirmClicked="verificationConfirm"
      title="Verify Details"
      :attachmentsList="eJobAttachments"
    >
      <!-- showAttachment :attachmentsList="eJobAttachments" title="Verify Details"> -->
      <div slot="Header Info"></div>
      <div slot="Shipping Info"></div>
      <div slot="Cargo Info"></div>
    </Verification>

    <PopupV2
      :show="showeJobReject"
      type="warning"
      title="Reject eJob"
      :buttons="eJobRejectButtons"
      @buttonClicked="eJobRejectButtonsClicked"
    >
      <div class="ejob-reject-content">
        <div
          >You're about to reject an eJob with Request No:
          {{ selectedeJob.length > 0 ? selectedeJob[0]['AutoRequestNo'] : '' }}</div
        ><br />
        <div>To reject an eJob, you'll need send a rejected eJob notice.</div><br />
        <div
          >Please enter the email addresses that the notice will be send to, the message of the email and the reason for
          the eJob rejection below.</div
        ><br />
        <EmailInput style="margin-bottom: 5px" title="To" :mails.sync="rejectToEmails" />
        <div class="collapsible-title-container" @click="showCC = !showCC">
          <img
            :style="{ transform: `scaleY(${showCC ? '-1' : '1'})` }"
            src="https://dsmlib.logistics.systems/Icons/icons8-expand-arrow-24.png"
          />
          <div>CC ({{ rejectCCEmails.length }})</div>
        </div>
        <EmailInput v-if="showCC" style="margin-bottom: 5px" title="CC" :mails.sync="rejectCCEmails" />
        <div class="collapsible-title-container" @click="showBCC = !showBCC">
          <img
            :style="{ transform: `scaleY(${showBCC ? '-1' : '1'})` }"
            src="https://dsmlib.logistics.systems/Icons/icons8-expand-arrow-24.png"
          />
          <div>BCC ({{ rejectBCCEmails.length }})</div>
        </div>
        <EmailInput v-if="showBCC" style="margin-bottom: 5px" title="BCC" :mails.sync="rejectBCCEmails" />
        <RemarksBox
          class="message-reason-container"
          title="Email Message"
          :freeText="true"
          :text.sync="eJobRejectMessage"
        />
        <RemarksBox
          class="message-reason-container"
          title="Reason for Rejection"
          :freeText="true"
          :text.sync="eJobRejectReason"
        />
      </div>
    </PopupV2>
    <!-- #endregion -->

    <!-- Print Report Popup -->
    <div v-if="reportPopup" class="report-popup-selection">
      <div class="report-popup-title"> Select a report to print </div>
      <div class="report-popup-container">
        <router-link
          :tag="reportIsCancelled ? 'button' : 'a'"
          :disabled="reportIsCancelled"
          class="report-link"
          :class="{ 'report-disabled-cancelled': reportIsCancelled }"
          :to="{
            path: `/Home/${userParam}/FreightForwarding/Booking Confirmation`,
            query: { jobtype: pageType[0], jobno: selectedJob[0]['Job No'] },
          }"
          target="_blank"
          >Booking Confirmation Letter</router-link
        >

        <router-link
          v-if="pageType[0] === 'I'"
          :tag="reportIsCancelled ? 'button' : 'a'"
          :disabled="reportIsCancelled"
          class="report-link"
          :class="{ 'report-disabled-cancelled': reportIsCancelled }"
          :to="{ path: `/Home/${userParam}/FreightForwarding/Print Notice Of Arrival`, query: { jobno: selectedJob[0]['Job No'] } }"
          target="_blank"
          >Notice of Arrival</router-link
        >

        <router-link
          :tag="reportNoContainer ? 'button' : 'a'"
          :disabled="reportNoContainer"
          class="report-link"
          :class="{ 'report-disabled-container': reportNoContainer }"
          :to="{ path: `/${userParam}/ReportsV2/Letter Of Indemnity`, query: { jobno: selectedJob[0]['Job No'] } }"
          target="_blank"
          >Letter of Indemnity</router-link
        >

        <router-link
          :tag="reportNoContainer ? 'button' : 'a'"
          :disabled="reportNoContainer"
          class="report-link"
          :class="{ 'report-disabled-container': reportNoContainer }"
          :to="{ path: `/${userParam}/ReportsV2/Container Attachment`, query: { jobNo: selectedJob[0]['Job No'] } }"
          target="_blank"
          >Container Attachment</router-link
        >

        <router-link
          :tag="reportNoContainer ? 'button' : 'a'"
          :disabled="reportNoContainer"
          class="report-link"
          :class="{ 'report-disabled-container': reportNoContainer }"
          :to="{ path: `/${userParam}/ReportsV2/Shipping Note Report`, query: { jobno: selectedJob[0]['Job No'] } }"
          target="_blank"
          >Shipping Note</router-link
        >

        <router-link
          :tag="reportNoContainer ? 'button' : 'a'"
          :disabled="reportNoContainer"
          class="report-link"
          :class="{ 'report-disabled-container': reportNoContainer }"
          :to="{ path: `/${userParam}/ReportsV2/Export Monitoring Log`, query: { jobno: selectedJob[0]['Job No'] } }"
          target="_blank"
          >Export Monitoring Log</router-link
        >

        <router-link
          :tag="reportCargoTypeF ? 'button' : 'a'"
          :disabled="reportCargoTypeF"
          class="report-link"
          :class="{ 'report-disabled-cargo-type': reportCargoTypeF }"
          :to="{ path: `/${userParam}/ReportsV2/IID IED`, query: { jobno: selectedJob[0]['Job No'] } }"
          target="_blank"
          >IID/IED</router-link
        >

        <router-link
          :tag="reportIsCancelled ? 'button' : 'a'"
          :disabled="reportIsCancelled"
          class="report-link"
          :class="{ 'report-disabled-cancelled': reportIsCancelled }"
          :to="{ path: `/${userParam}/ReportsV2/Job Summary`, query: { jobno: selectedJob[0]['Job No'] } }"
          target="_blank"
          >Job Summary</router-link
        >
      </div>
      <div class="report-popup-cancel">
        <button class="btn-alert" @click="reportPopupClose">Cancel</button>
      </div>
    </div>

    <!-- #region Container Popup -->
    <PopupV2
      :show="cargoInfoContainerData['showContainerPopup']"
      title="Add Container Details"
      @buttonClicked="addEditContainerClicked"
      :buttons="cargoInfoContainerData['popupButtonList']"
    >
      <div class="container-popup-row">
        <Dropdown
          style="margin-right: 5px; width: 50%"
          placeholder="Please select"
          :isRequired="true"
          :items="cargoInfoContainerData['containerCategoryItems']"
          itemKey="desc"
          :selectedObject.sync="cargoInfoContainerData['selectedCategory']"
          :errorMessage.sync="cargoInfoContainerData['selectedCategoryError']"
          :isDisabled="cargoInfoContainerData['containerEditIndex'] >= 0"
          validator="text,40"
        />
        <div v-if="cargoInfoContainerData['selectedCategory']" style="display: flex; align-items: center; width: 100%">
          <Input
            v-if="cargoInfoContainerData['selectedCategory']['desc'] == 'Container Required'"
            style="margin-left: 5px"
            placeholder="Cont Quantity"
            :inputValue.sync="cargoInfoContainerData['contQty']"
            :isRequired="true"
            :errorMessage.sync="cargoInfoContainerData['contQtyError']"
            validator="positiveInteger,3"
          />
          <Input
            v-if="cargoInfoContainerData['selectedCategory']['desc'] == 'Cont/Seal #'"
            style="margin-left: 5px"
            placeholder="Container #"
            validator="text,20"
            :inputValue.sync="cargoInfoContainerData['contNo']"
            :isRequired="true"
            :errorMessage.sync="cargoInfoContainerData['contNoError']"
          />
          <Input
            v-if="cargoInfoContainerData['selectedCategory']['desc'] == 'Cont/Seal #'"
            style="margin-left: 5px"
            placeholder="Seal #"
            validator="text,20"
            :inputValue.sync="cargoInfoContainerData['sealNo']"
          />
        </div>
      </div>
      <div class="container-popup-row">
        <Dropdown
          :items="cargoInfoData['contSizeList']"
          placeholder="Size"
          :isRequired="true"
          itemKey="Size"
          :selectedObject.sync="cargoInfoContainerData['contSelectedSize']"
          :errorMessage.sync="cargoInfoContainerData['contSelectedSizeError']"
          validator="text,2"
        />
        <Dropdown
          :items="cargoInfoData['contTypeList']"
          style="margin-left: 5px"
          placeholder="Type"
          :isRequired="true"
          itemKey="Code - Desc"
          :selectedObject.sync="cargoInfoContainerData['contSelectedType']"
          :errorMessage.sync="cargoInfoContainerData['contSelectedTypeError']"
          validator="text,60"
        />
      </div>
      <div class="container-popup-row">
        <Dropdown
          :items="cargoInfoData['contStatusList']"
          placeholder="Status"
          itemKey="Cont Status"
          :selectedObject.sync="cargoInfoContainerData['contSelectedStatus']"
          validator="text,10"
        />
        <Input
          style="margin-left: 5px"
          placeholder="Weight (KG)"
          :inputValue.sync="cargoInfoContainerData['contWeight']"
          validator="positiveDecimal,5,4"
        />
      </div>
      <InputQuery
        :items="cargoInfoData['contHandlingTypeList']"
        placeholder="Handling Type"
        itemKey="Handling Type"
        descKey="Description"
        :isRequired="true"
        :selectedObject.sync="cargoInfoContainerData['contSelectedHdgType']"
        :errorMessage.sync="cargoInfoContainerData['contSelectedHdgTypeError']"
        validator="text,5"
      />
      <InputQuery
        :items="cargoInfoData['contDeliveryTypeList']"
        placeholder="Delivery Type"
        itemKey="Delivery Type"
        descKey="Description"
        :isRequired="true"
        :selectedObject.sync="cargoInfoContainerData['contSelectedDelType']"
        :errorMessage.sync="cargoInfoContainerData['contSelectedDelTypeError']"
        validator="text,5"
      />
      <InputQuery
        :items="cargoInfoData['contSendToList']"
        placeholder="Send To"
        itemKey="Destination Code"
        descKey="Company"
        :selectedObject.sync="cargoInfoContainerData['contSelectedSendTo']"
        validator="text,10"
      />
      <Dropdown
        :items="cargoInfoData['soccocTypeList']"
        itemKey="SOCCOC Type"
        placeholder="SOC/COC"
        :isRequired="true"
        :selectedObject.sync="cargoInfoContainerData['contSocCoc']"
        :errorMessage.sync="cargoInfoContainerData['contSocCocError']"
        validator="text,30"
      />
      <RemarksBox :maxLength="200" style="height: 150px" :text.sync="cargoInfoContainerData['contRemarks']" />
    </PopupV2>
    <!-- #endregion -->

    <!-- #region Vessel Ammendments Pop Up - fire when user change ShipCallNo - weishen 20240513 -->
    <PopupV2
      :show="showShipCallNoChange"
      type="warning"
      title="Vessel Ammendments"
      :buttons="shipCallNoChangeButtons"
      @buttonClicked="shipCallNoChangeButtonsClicked"
    >
      <div>Please be advised of the following changes: </div><br />
      <div class="modal-content">
        <table>
          <thead>
            <tr>
              <th></th>
              <th>Previous</th>
              <th>New</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) in shipCallNoChangetableData"
              :key="index"
              :class="{ 'disabled-row': row.disabled }"
            >
              <td v-if="row.label !== 'Port Operator'"
                ><CheckBoxV2 :title="row.label" :isChecked.sync="row.checked"
              /></td>
              <td v-else></td>
              <!-- Placeholder for the checkbox -->
              <td :class="{ 'different-value': row.previous !== row.new }">{{ row.previous }}</td>
              <td :class="{ 'different-value': row.previous !== row.new }">{{ row.new }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </PopupV2>
    <!-- #endregion -->
    <!--Attachment Window-->
    <div class="attchWin-main" v-if="openPopup">
      <button class="attchWin-close" @click="closePopup()">X</button>
      <div class="attchWin-display" v-if="attachmentList.length > 0">
        <div class="left">
          <div v-if="attachmentList.length > 1" class="leftButton">
            <button class="navButton-left" @click="navAtt('prev')">&lt;</button>
          </div>

          <!-- image container and buttons -->
          <div class="attchWin-attachment">
            <iframe
              v-if="attachmentIsProjectable()"
              :src="attToView['AttImage']"
              draggable="false"
              style="width: 100%; height: 100%"
            >
            </iframe>
            <div v-else class="attachment-not-projectable-container">
              <span>
                {{ getFileTypeLabel() }} files cannot be previewed.<br />
                Please download the file and view it instead.
              </span>
              <button @click="downloadAttachment">
                <img src="https://dsmlib.logistics.systems/Icons/Download.png" alt="Download icon" />
                Download
              </button>
            </div>
          </div>

          <div v-if="attachmentList.length > 1" class="rightButton">
            <button class="navButton-right" @click="navAtt('next')">></button>
          </div>
        </div>

        <div class="right">
          <div class="count">
            <b>{{ attToView['#'] }}</b> / {{ totalAtt }} Attachments
          </div>
          <div class="attchWin-info">
            <table id="infoHeader">
              <tr>
                <th>Job No</th>
                <td>:{{ attToView['Job No'] }}</td>
              </tr>

              <tr>
                <th>Doc Code</th>
                <td>:{{ selectedViewDocumentList['Doc Code'] }}</td>
              </tr>

              <tr>
                <th>Attachment</th>
                <td>:{{ selectedViewDocumentList['Attachment'] }}</td>
              </tr>
            </table>

            <table id="tableContent">
              <tr>
                <th>ID</th>
                <td>{{ selectedViewDocumentList['ID'] }}</td>
              </tr>

              <tr>
                <th>Remarks</th>
                <td>{{ selectedViewDocumentList['Remarks'] }}</td>
              </tr>

              <tr>
                <th>Status</th>
                <td>{{ selectedViewDocumentList['Status'] }}</td>
              </tr>

              <tr>
                <th>Start Date</th>
                <td>{{ selectedViewDocumentList['Start Date'] }}</td>
              </tr>

              <tr>
                <th>Received Date</th>
                <td>{{ selectedViewDocumentList['Received Date'] }}</td>
              </tr>

              <tr>
                <th>Due Date</th>
                <td>{{ selectedViewDocumentList['Due Date'] }}</td>
              </tr>

              <tr>
                <th>Assign To</th>
                <td>{{ selectedViewDocumentList['Assign To'] }}</td>
              </tr>

              <tr>
                <th>Sets</th>
                <td>{{ selectedViewDocumentList['Sets'] }}</td>
              </tr>

              <tr>
                <th>Page</th>
                <td>{{ selectedViewDocumentList['Page'] }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <div v-else class="attchWin-display">
        <div style="margin: 0 auto">No Attachments Found</div>
      </div>
    </div>

    <!-- #region Duplicate From Other Company (DPO)  -->
    <div v-if="showDPOPopup" class="dpo-popup">
      <div class="dpo-popup-content">
        <div class="dpo-popup-header">
          <div class="header-left">
            <Dropdown
              :items="dpoCompanyList"
              placeholder="Select From"
              itemKey="Company Name"
              :isRequired="true"
              :selectedObject.sync="selectedCompanyDPO"
              :errorMessage.sync="dpoCompanyErr"
              style="max-width: 50%"
              @selected="dpoRefreshClicked"
            />
            <CheckBoxV2 title="Copy Containers" :isChecked.sync="dpoCopyContainers" style="margin: 5px" />
          </div>
          <div class="header-right">
            <div>{{ dpoFilterText }}</div>
            <ButtonFilter
              filterPosition="right"
              buttonText="Change Filter"
              :filterWidth="300"
              :isOpen.sync="dpoFilterOpen"
            >
              <div class="filter-section">
                <BoxContainer
                  class="filter-check"
                  title="Date"
                  :isChecked.sync="dpoFilterByDate"
                  :isCheckBox="true"
                  style="margin-bottom: 5px"
                >
                  <div>
                    <DateTimePicker
                      placeholder="From"
                      :showTime="false"
                      :value.sync="dpoFromDate"
                      :isRequired="dpoFilterByDate"
                      :isDisabled="!dpoFilterByDate"
                      :errorMessage.sync="dpoFromDateErr"
                    />
                    <DateTimePicker
                      placeholder="To"
                      :showTime="false"
                      :value.sync="dpoToDate"
                      :isRequired="dpoFilterByDate"
                      :isDisabled="!dpoFilterByDate"
                      :errorMessage.sync="dpoToDateErr"
                    />
                  </div>
                </BoxContainer>
                <BoxContainer
                  class="filter-check"
                  title="Search"
                  :isChecked.sync="dpoFilterBySearch"
                  :isCheckBox="true"
                  style="margin-bottom: 5px"
                >
                  <Dropdown
                    placeholder="Search By"
                    :items="searchFilterItems"
                    itemKey="Search Criteria"
                    :isDisabled="!dpoFilterBySearch"
                    :isRequired="dpoFilterBySearch"
                    :selectedObject.sync="dpoSearchBy"
                    :errorMessage.sync="dpoSearchByErr"
                    @selected="dpoSearchBySelected"
                    validator="text,40"
                  />
                  <Dropdown
                    placeholder="Search Criteria"
                    :items="searchCriteriaItems"
                    itemKey="name"
                    :isDisabled="dpoSearchCriteriaDisabled || !dpoFilterBySearch"
                    :isRequired="dpoFilterBySearch"
                    :selectedObject.sync="dpoSearchCriteria"
                    :errorMessage.sync="dpoSearchCriteriaErr"
                    validator="text,40"
                  />
                  <Input
                    placeholder="Search"
                    :inputValue.sync="dpoSearchInput"
                    :isDisabled="!dpoFilterBySearch"
                    :isRequired="dpoFilterBySearch"
                    :errorMessage.sync="dpoSearchInputErr"
                  />
                </BoxContainer>
                <button
                  class="refresh-button"
                  @click="dpoRefreshClicked"
                  :disabled="!dpoFilterByDate && !dpoFilterBySearch"
                  >Refresh
                </button>
              </div>
            </ButtonFilter>
            <div>Last Refreshed: {{ dpoLastRefreshed }}</div>
          </div>
        </div>
        <div class="dpo-popup-body">
          <TableBox
            :title="dpoPopupTitle"
            :tableData="dpoJobList"
            :dataType="{ 'Job DateTime': 'datetime' }"
            :selectedRow.sync="selectedJobDPO"
          />
        </div>
        <div class="dpo-popup-footer">
          <button @click="dpoConfirmClicked" :disabled="!selectedJobDPO">
            <img src="https://dsmlib.logistics.systems/Icons/Save.png" />
            Confirm
          </button>
          <button @click="clearDPOPopup">
            <img src="https://dsmlib.logistics.systems/Icons/Cancel.png" />
            Cancel
          </button>
        </div>
      </div>
    </div>
    <!-- #endregion -->
  </div>
</template>

<script>
import Menus from '@/components/Menus.vue';
import Tab from '@/components/Tab.vue';
import PopupEntry from '@/components/PopupEntry.vue';
import ItemListing from '@/components/ItemListing.vue';
import RemarksBox from '@/components/RemarksBox.vue';
import JobPageCargoInfoPopup from '@/components/popupComponents/JobPageCargoInfoPopup.vue';

import StatusPage from '@/pages/Home/StatusPage.vue';

import DocStatusUpdate from '@/components/DocStatusUpdate.vue';
import JobFormComponent from '@/components/formVerification/JobFormComponent.vue';
import SimplePopup from '@/components/formVerification/SimplePopup.vue';
import SMKDetails from '@/components/SMKDetails.vue';

export default {
  components: {
    Menus,
    Tab,
    PopupEntry,
    ItemListing,
    RemarksBox,
    JobPageCargoInfoPopup,

    StatusPage,
    DocStatusUpdate,
    JobFormComponent,
    SimplePopup,
    SMKDetails,
  },
  data: function () {
    return {
      menuLoading: true,
      loginDetails: null,

      pageType: '',
      tableLoading: false,

      prePopulate: false,
      preJob: '',
      preDate: '',

      createdBy: '',
      updatedBy: '',

      sasUpdateContainer: {},

      userid: '',
      updateContNoRole: '',
      userRole: '',
      saveRadioButton: [
        { label: 'Confirm Job', keyValue: '1' },
        { label: 'Unconfirm Job', keyValue: '2' },
      ],

      selectedSaveBy: {
        keyValue: '1',
        label: 'Confirm Job',
      },

      menu: [
        {
          title: 'New ',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-add-new-50.png',
          enabled: false,
          key: 'MnuNew',
        },
        {
          title: 'Edit ',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-edit-64%20(1).png',
          enabled: false,
          key: 'MnuEdit',
        },
        {
          title: 'Delete ',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-reduce-50.png',
          enabled: false,
          key: 'MnuDelete',
        },
        {
          title: 'View ',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-view-64.png',
          enabled: false,
          key: 'MnuView',
        },
        { title: 'Duplicate', icon: 'https://dsmlib.logistics.systems/Icons/DuplicateJob.png', enabled: false },
        {
          title: 'Duplicate From Other Company',
          icon: 'https://dsmlib.logistics.systems/Icons/DuplicateJob.png',
          enabled: false,
          key: 'MnuNew',
        },
        { title: 'Print Job Sheet', icon: 'https://dsmlib.logistics.systems/Icons/Print.png', enabled: true },
        { title: 'Print Import ...', icon: 'https://dsmlib.logistics.systems/Icons/Print.png', enabled: true },
        { title: 'Scan Document', icon: 'https://dsmlib.logistics.systems/Icons/ScanDocument.png', enabled: false },
        { title: 'eJob', icon: 'https://dsmlib.logistics.systems/Icons/eJob.png', enabled: false },
        { title: 'ROT', icon: 'https://dsmlib.logistics.systems/Icons/eROT.png', enabled: false },
        { title: 'Delivery Note', icon: 'https://dsmlib.logistics.systems/Icons/eROT.png', enabled: false },
        {
          title: 'Job Charges',
          icon: 'https://dsmlib.logistics.systems/Icons/money.png',
          enabled: false,
          key: 'MnuJobCharges',
        },
      ],
      smkMenu: [
        {
          title: 'New Part Job',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-add-new-50.png',
          enabled: true,
          key: 'MnuNew',
        },
        {
          title: 'Edit Part Job',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-edit-64%20(1).png',
          enabled: true,
          key: 'MnuEdit',
        },
        {
          title: 'Delete Part Job',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-reduce-50.png',
          enabled: true,
          key: 'MnuDelete',
        },
        { title: 'View Part Job', icon: 'https://dsmlib.logistics.systems/Icons/icons8-view-64.png', enabled: true },
        { title: 'Duplicate Part Job', icon: 'https://dsmlib.logistics.systems/Icons/DuplicateJob.png', enabled: true },
        { title: 'Print SMK ...', icon: 'https://dsmlib.logistics.systems/Icons/Print.png', enabled: true },
      ],
      currentTabIndex: 1,
      tabsItems: [
        { title: 'Quick Entry', disabled: false },
        { title: 'Header Info', disabled: false },
        { title: 'General Info', disabled: false },
        { title: 'Shipping Info', disabled: false },
        { title: 'Cargo Info', disabled: false },
        { title: 'Documents', disabled: false },
        { title: 'Delivery Note', disabled: true },
        { title: 'ROT', disabled: true },
        { title: 'TAS & KPI', disabled: true },
        { title: 'SMK', disabled: true },
      ],
      smkTabIndex: 0,
      smktabsItems: [
        { title: 'SMK & Invoice Details', disabled: false },
        { title: 'Exemption / Clause / Documents', disabled: false },
        { title: 'Item', disabled: false },
        { title: 'Events', disabled: false },
      ],
      statusMapping: [
        { key: 'Copy Received', mapping: 'statuscopy' },
        { key: 'Original Received', mapping: 'statusoriginal' },
        { key: 'Couriered', mapping: 'statuscouriered' },
        { key: 'Prepared', mapping: 'statusprepared' },
        { key: 'Submitted', mapping: 'statussubmitted' },
      ],

      mainFilterIsOpen: false,

      showFilterBox: false,
      dateFilterChecked: true,
      searchFilterChecked: false,
      filterText: '',
      searchFilterItems: [],
      searchCriteriaItems: [{ name: 'EQUALS' }, { name: 'STARTS WITH' }, { name: 'CONTAINS' }, { name: 'ENDS WITH' }],
      selectedCriteria: null,
      selectedSearchBy: null,
      criteriaDisabled: false,
      searchByValue: '',
      searchByError: '',
      searchByValueError: '',

      refreshStart: null,
      refreshEnd: null,
      lastRefreshed: '',

      jobsList: [],
      smkPartJobList: [],
      smkSubmissionList: [],
      tableTitle: '',
      selectedJob: [],
      selectedsmkPartJob: [],
      smkSummaryDetails: [],
      smkExemptDetails: [],
      smkDocList: [],
      jobSummaryDetails: {},

      //SMK side bar
      smkSideSummaryDetails: [],
      smkSideFormType: '',
      smkSideExemptDetails: [],
      smkSideDocList: [],
      smkSideSubmissionList: [],
      smkSideItemList: [],
      smkSideJobSummaryDetails: {},
      smkSideExempClause: [],

      //SMK Item
      smkItemDutyOriginal: null,
      smkDutyCalculationGeneration: 0,
      showSMKItemHoverTables: false,
      showSMKVehicleColumns: false,
      showSMKWarehouseColumns: false,
      showAllSMKProducts: false,
      showAllSMKItems: false,

      batchQueryObject: null,

      popupTitle: '',
      viewMode: false,
      showPopup: false,
      showDocUpload: false,

      eMessages: [],
      sMessages: [],
      rMessages: [],
      errorMessages: {
        cargotype_code: '',
        billcu_no: '',
        shipcall_no: '',
        ship_id: '',
        ag_code: '',
        voyno: '',
        imp_port: '',
        load_port: '',
        timedchgload: '',
        time_eta: '',
        gweight: '',
        measurement: '',
        nweight: '',
        packmat: '',
        no_package: '',
        package_code: '',
        consignee: '',
        shipper: '',
        fumigator: '',
        location: '',
        fumigate_on: '',
        ventilation: '',
        vesselID: '',
        voyageNo: '',
        jobtime: '',
        closing_time: '',
        requireddate: '',
        demuragetime: '',
        detention: '',
        etatime: '',
        polETD: '',
        polETA: '',
        fDestETA: '',
      },

      showSavePopup: false,
      savePopupType: 'error',
      savePopupLayout: null,
      savePopupTitle: null,
      savePopupFooter: null,
      savePopupButtons: null,

      rotVerifyPopup: false,
      rotVerifyError: '',

      defaultPopup: {
        show: false,
        type: '',
        title: '',
        content: '',
      },

      deleteLayout: null,
      deleteAllBtn: null,
      deleteSelectedBtn: null,
      deleteMessage: '',
      deleteItems: [],

      editDeleteDoc: [],
      editAddDoc: [],
      editDocumentsList: [],
      documentsToDelete: [],

      milestoneHeight: 0,
      milestonesItem: null,
      showMilestones: true,

      showTooltip: false,
      tooltipText: '',
      tooltipPos: 'top',

      saveAlertType: '', // required | option
      saveErrorList: [],

      popupError: false,
      popupErrorText: '',
      reasonsList: [],

      selectedUnconfirmReason: null,
      unconfirmRemarks: '',

      //#region Delete Popup
      showDeletePopup: false,
      deleteTarget: 'MAIN', // 'MAIN' or 'PART'
      deletePopupButtons: [
        { text: 'Delete', color: 'red', textColor: 'white' },
        { text: 'Cancel', color: 'ightgray', textColor: 'black' },
      ],
      deleteRemarks: '',
      deleteRemarksError: '',

      editDetails: null,

      showShipperAddress: false,
      showConsigneeAddress: false,
      showNPartyAddress: false,

      shipperAddress: null,
      consigneeAddress: null,
      notifyPartyAddress: null,

      detailsEditTitle: '',
      detailsEditObject: null,
      edittingDetails: false,

      addressDetails: {
        postcodeList: [],
        stateList: [],
        countryList: [],
      },

      // Header info data and details
      headerInfoData: {
        transMode: [],
        cargoType: [],
        originalCargoType: [],
        originalSMKFormType: '',
        smkFormType: [],
        shipper: [],
        consignee: [],
        notifyParty: [],

        billTo: [],
        services: [],
        quotationNo: [],
      },
      smkInfoData: {
        declarationType: [],
        shipmentType: [
          { 'Code - Desc': 'F - Full Shipment', Code: 'F', Desc: 'Full Shipment' },
          { 'Code - Desc': 'P - Partial Shipment', Code: 'P', Desc: 'Partial Shipment' },
        ],
        exemptNoList: [],
        exemptNoListTE: [],
        exemptNoListST: [],
        exemptNoListAP: [],
        exemptTypeList: [],
        exemptTypeListTE: [],
        exemptTypeListST: [],
        exemptTypeListAP: [],
        clauseList: [],

        movementType: [],
        warehouseList: [],
        warehouseTypeList: [],
        transportTypeList: [],

        docMasterList: [],
      },

      smkTransportList: [],
      selectedSMKTransportRows: [],
      smkTransportMode: '',
      smkTransportDraft: null,
      smkTransportUid: 0,
      smkTransportTableVersion: 0,
      smkTransportErrors: {
        transportType: '',
        year: '',
        form: '',
      },

      selectedHeaderInfoData: {
        selectedTransMode: null,
        selectedCargoType: null,
        selectedSmkFormType: null,
        selectedShipper: null,
        selectedConsignee: null,
        selectedNotifyParty: null,

        projectNo: null,
        custRefNo: null,
        vbkgRefNo: null,
        selectedBillTo: null,
        billToDetails: null,
        selectedQuotationNo: null,

        jobNo: null,
        jobTime: null,
        requiredDate: null,
        jobStatus: null,

        exchangeRateDate1: null,
      },
      selectedSmkInfoData: {
        selectedSmkFormType: null,
        selectedDeclarationType: null,
        selectedShipmentType: null,
        selectedCountryOfOrigin: null,
        smkNo: '',

        k3Type: null,
        k3MoveTo: null,

        k8Type: null,
        movementType: null,
        moveDate: null,
        moveFromStation: null,
        moveToStation: null,
        moveFromWarehouse: '',
        moveToWarehouse: '',

        k9Warehouse: null,
        k9WarehouseType: null,
        k9Station: null,
        k9License: '',
        k9LicenseDate: null,
        k9DepositDate: null,
        k9DepositReceipt: '',

        invoiceTypeFreight: null,
        invoiceTypeInsurance: null,
        invoiceTypeUplift: null,
        invoiceTypeBuyingComm: null,
        invoiceTypePortCharges: null,
        invoiceTypeDiscount: null,
        invoiceTypeOther: null,
        invoiceTypeAmount: null,

        amountFreight: '',
        amountInsurance: '',
        amountUplift: '',
        amountBuyingComm: '',
        amountPortCharges: '',
        amountDiscount: '',
        amountOther: '',
        amountAmount: '',

        qualifierFreight: null,
        qualifierInsurance: null,
        qualifierUplift: null,
        qualifierBuyingComm: null,
        qualifierPortCharges: null,
        qualifierDiscount: null,
        qualifierOther: null,
        qualifierAmount: null,

        currency1: null,
        exchangeRate1: '',

        exemptNoTreasury: null,
        exemptTypeTreasury: null,
        expiryDateTE: null,
        exemptNoSalesTax: null,
        exemptTypeSalesTax: null,
        registrationDateST: null,
        stationCode: '',
        expiryDateST: null,
        exemptNoSpecialTreatment: null,
        exemptTypeSpecialTreatment: null,

        claimentName: '',
        claimentCompany: '',
        claimentStatus: '',
        claimentNRIC: '',
        clauseCode: null,
        selectedDoc: [],

        freightForeignRate: '',
        freightForeignDate: null,
        freightAmountMYR: '',
      },
      smkExchangeRates: null,

      smkInvoiceQualifierList: [
        { Qualifier: 'FOB' },
        { Qualifier: 'CNI' },
        { Qualifier: 'CNF' },
        { Qualifier: 'CIF' },
        { Qualifier: 'CFR' },
      ],

      smkPortQualifierList: [
        { Qualifier: '0.33' },
        { Qualifier: 'FOB' },
        { Qualifier: 'CNI' },
        { Qualifier: 'CNF' },
        { Qualifier: 'CIF' },
        { Qualifier: 'CFR' },
      ],
      // General info data and details
      generalInfoData: {
        freightTypeList: [],
        countryList: [],
        currencyList: [],
        incoTermsList: [],
        insuranceList: [],
        branchList: [],
        servicePICList: [],
        serviceTeamList: [],
        salesPICList: [],
        salesTeamList: [],
        uomList: [],
        tcList: [],
        alcoholList: [
          { Name: 'No', Code: 0 },
          { Name: 'Yes', Code: 1 },
        ],
        smkProductList: [],
        smkItemMasterList: [],
      },
      selectedGeneralInfoData: {
        vendor: null,
        vesselBkgBy: null,
        oriBL: null,
        nonNegoBL: null,
        oriBLError: '',
        nonNegoBLError: '',
        selectedFreightType: null,
        selectedCountry: null,
        selectedCurrency: null,
        selectedIncoTerms: null,
        selectedInsurance: null,
        houseBL: null,
        selectedBranch: null,

        selectedServicePIC: null,
        selectedServiceTeam: null,
        selectedSalesPIC: null,
        selectedSalesTeam: null,
        remarks: null,

        prevJobNo: '',
      },

      // Shipping info data and details
      shippingInfoData: {
        shipCallNoList: [],
        vesselIDList: [],
        shippingAgentList: [],
        shippingLineList: [],
        frtForwarderList: [],
        fwdgAgentList: [],
        specialTreatment: [],
        station: [],
        portOperator: [],

        portOfLoading: [],
        portOfDischarge: [],
        finalDestination: [],

        fumigatorList: [],
        fumigatorLocationList: [],
      },
      selectedShippingInfoData: {
        selectedShipCall: null,
        shipCallNoValue: '',
        voyNo: null,
        selectedVesselID: null,
        vesselIDValue: '',
        selectedAgentList: null,
        selectedShippingLine: null,
        selectedFrtForwarder: null,
        selectedFwdgAgent: null,
        selectedSpecialTreatment: null,
        selectedStation: null,
        selectedPortOperator: null,
        warehouse: null,

        selectedPortLoading: null,
        selectedPortDischarge: null,
        selectedFinalDestination: null,
        demurageTime: null,
        detention: null,
        isTranshipment: null,
        selectedMVesselID: null,
        mVoyNo: null,
        selectedPortDischarge2: null,
        // ETDTime: null,
        ETATime: null,

        closingTime: null,
        polETD: null,
        polETA: null,
        fDestETA: null,
        isFumigation: null,
        selectedFumigator: null,
        selectedLocation: null,
        fumigateTime: null,
        ventilationTime: null,
        phytoMarking: null,

        goodsDescription: '',
        shippingMarks: '',

        freeStorage: '',
        storageUnit: 'D',
        freeDemurrage: '',
        demurrageUnit: 'D',
        freeDetention: '',
        detentionUnit: 'D',
      },

      // Cargo info data and details
      cargoInfoData: {
        commodityList: [],
        pMaterialList: [],
        pkgTypeList: [],
      },
      selectedCargoInfoData: {
        gWeight: this.$weightFormat('0'), // default these to 0 because if saved empty it will be 0
        volume: this.$weightFormat('0'),
        chargeable: this.$weightFormat('0'),

        selectedCommodity: null,
        selectedPMaterial: null,
        packageCount: '',
        selectedPackageType: null,

        subPkgList: [],
        selectedSubPkgs: null,
        deletedSubPkg: [],
        contDetailsList: [],
        selectedContDetails: null,
        deletedContDetails: [],
      },
      cargoInfoContainerData: {
        showContainerPopup: false,
        containerCategoryItems: [{ desc: 'Container Required' }, { desc: 'Cont/Seal #' }],
        selectedCategory: null,
        selectedCategoryError: '',

        contQty: '',
        contQtyError: '',
        contNo: '',
        contNoError: '',
        sealNo: '',

        contSelectedSize: null,
        contSelectedSizeError: '',
        contSelectedType: null,
        contSelectedTypeError: '',

        contSelectedStatus: null,
        contWeight: '',

        contSelectedHdgType: null,
        contSelectedHdgTypeError: '',
        contSelectedDelType: null,
        contSelectedDelTypeError: '',
        contSelectedSendTo: null,
        contSocCoc: null,
        contSocCocError: '',
        contRemarks: '',

        popupButtonList: [{ text: 'OK' }],
        containerEditIndex: -1,
      },
      cargoPopupDetails: {
        cargoAddType: '',
        isEdit: false,
        editIndex: -1,
        editDetails: null,
      },

      // Document info data and details
      documentInfoData: {
        updatePopup: false,
        statusList: [],
        docTypeList: [],
        docStatusList: [],
      },
      selectedDocumentInfoData: {
        docData: [],
        selectedDoc: [],
      },

      dnListing: [],
      rotListing: [],

      // Status task tab
      statusTaskData: {
        statusTaskListing: [],
        statusDocumentListing: [],

        statusJobNo: '',
      },

      smkListing: [],

      reportPopup: false,
      reportNoContainer: false,
      reportIsCancelled: false,
      reportCargoTypeF: false,

      userParam: '',

      excelContResolve: null,
      excelContConfirm: false,
      importContPreview: [],
      importContLoading: false,
      importHasError: false,

      reasonOpen: false,

      //#region Job Charges
      showJobChargesPopup: false,
      jobChargesButtons: [
        // { text: 'View Job Charges', color: 'green', textColor: 'white' },
        { text: 'Cancel', color: 'lightgray', textColor: 'black' },
      ],
      //#endregion
      //#region eJob
      showEJobPopup: false,
      ejobFilterOpen: false,

      allEJobChecked: true,
      rangeEJobChecked: false,

      ejobLastRefreshed: '',

      ejobRangeFrom: null,
      ejobRangeTo: null,
      ejobRangeFromError: '',
      ejobRangeToError: '',

      ejobListing: [],
      selectedeJob: [],

      eJobFullDetails: null,
      eJobAttachments: null,
      showVerification: false,
      eJobSections: [],

      showeJobReject: false,
      eJobRejectButtons: [
        { text: 'Reject', color: 'red', textColor: 'white' },
        { text: 'Cancel', color: 'lightgray', textColor: 'black' },
      ],

      //#region Vessel Ammendments Pop Up
      showShipCallNoChange: false,
      shipCallNoChangeButtons: [{ text: 'Apply Changes' }, { text: 'Cancel', color: 'lightgray', textColor: 'black' }],
      shipCallNoChangetableData: [],
      newVessel: [],
      previousVessel: [],
      newETDDateTime: null,
      newETADateTime: null,
      newDemurrageDate: null,
      newDetentionDate: null,
      newClosingTime: null,
      //#endregion

      rejectToEmails: [],
      rejectCCEmails: [],
      rejectBCCEmails: [],

      showCC: false,
      showBCC: false,

      eJobRejectMessage: '',
      eJobRejectReason: '',
      //#endregion

      // input fields - tab array
      inputTabs: [
        { key: 'transmode', tab: 0 },
        { key: 'cargotype_code', tab: 0 },
        { key: 'billcu_no', tab: 0 },
        { key: 'shipcall_no', tab: 0 },
        { key: 'ship_id', tab: 0 },
        { key: 'ag_code', tab: 0 },
        { key: 'voyno', tab: 0 },
        { key: 'imp_port', tab: 0 },
        { key: 'time_eta', tab: 0 },
        { key: 'packmat', tab: 0 },
        { key: 'no_package', tab: 0 },
        { key: 'package_code', tab: 0 },
        { key: 'consignee', tab: 0 },
        { key: 'jobtime', tab: 0 },
        { key: 'closing_time', tab: 0 },
        { key: 'timedchgload', tab: 0 },
        { key: 'requireddate', tab: 1 },
        { key: 'No. of Original B/L', tab: 2 },
        { key: 'No. of Non-Nego B/L', tab: 2 },
        { key: 'fumigator', tab: 3 },
        { key: 'location', tab: 3 },
        { key: 'fumigate_on', tab: 3 },
        { key: 'ventilation', tab: 3 },
        { key: 'vesselID', tab: 3 },
        { key: 'voyageNo', tab: 3 },
        { key: 'polETD', tab: 3 },
        { key: 'polETA', tab: 3 },
        { key: 'fDestETA', tab: 3 },
        { key: 'demuragetime', tab: 3 },
        { key: 'detention', tab: 3 },
        { key: 'etatime', tab: 3 },
      ],

      viewDocumentButtons: [{ text: 'View', index: 0, width: 60 }],
      attachmentList: [],
      openPopup: false,
      attToView: [],
      totalAtt: '',
      selectedViewDocumentList: '',

      tableBoxColumnOrderViewsExp: [],
      tableBoxColumnOrderViewsImp: [],
      columnOrderViewsByReportName: {},
      tableBoxColumnOrderIDExp: null,
      tableBoxColumnOrderIDImp: null,
      injectedReportName: '',

      smallDateTimeMinValue: new Date(2000, 0, 1),
      smallDateTimeMaxDate: new Date(2079, 0, 1),

      dnConsumedQtyMap: {},

      billingCheckDisabled: false,
      showSMKDetails: false,
      showSMKRightMenu: false,
      enableSMKmodule: false,
      topSectionHeight: 60,
      isDraggingVertical: false,
      disableSMKButtons: false,
      smkDetailsFulfill: false,

      //#region for SMK Item
      searchText: '',
      columnFilters: {},
      displayColumns: [],
      draggingColumnIndex: null,

      templateTypeList: [
        { label: 'GAIN', value: 'GAIN' },
        { label: 'VEHICLE', value: 'VEHICLE' },
      ],
      selectedTemplateType: { label: 'GAIN', value: 'GAIN' },

      columns: [
        { key: 'select', type: 'checkbox', width: 40 },
        { key: 'seq', label: '#', width: 30 },

        {
          key: 'ItemCode',
          label: 'Item #',
          width: 135,
          inputType: 'query',
          group: 'item',
          groupStart: true,
        },
        {
          key: 'ItemDescription',
          label: 'Item Description',
          width: 180,
          group: 'item',
        },
        {
          key: 'CountryOfOrigin',
          label: 'COO',
          width: 90,
          group: 'item',
        },
        {
          key: 'Product',
          label: 'Product #',
          width: 135,
          inputType: 'query',
          group: 'item',
          groupEnd: true,
        },

        {
          key: 'HSCode',
          label: 'Tariff Code',
          width: 150,
          inputType: 'query',
          group: 'tariff',
          groupStart: true,
          groupEnd: true,
        },

        {
          key: 'InvoiceUOM',
          label: 'Inv UOM',
          width: 86,
          inputType: 'query',
          group: 'invoice-qty',
          groupStart: true,
        },
        {
          key: 'InvoiceQty',
          label: 'Inv Qty',
          width: 110,
          group: 'invoice-qty',
          groupEnd: true,
        },

        {
          key: 'TariffUOQ',
          label: 'Tariff UOM',
          width: 91,
          inputType: 'query',
          group: 'tariff-qty',
          groupStart: true,
        },
        {
          key: 'TariffQty',
          label: 'Tariff Qty',
          width: 110,
          group: 'tariff-qty',
          groupEnd: true,
        },
        {
          key: 'DutyUOM',
          label: 'Duty UOM',
          width: 86,
          inputType: 'query',
          group: 'duty-qty',
          groupStart: true,
        },
        {
          key: 'DutyQty',
          label: 'Duty Qty',
          width: 110,
          group: 'duty-qty',
          groupEnd: true,
        },

        {
          key: 'ItemAmount',
          label: 'Amount',
          width: 110,
          group: 'price',
          groupStart: true,
        },

        {
          key: 'UnitPrice',
          label: 'Unit Price',
          width: 110,
          group: 'price',
          groupEnd: true,
        },
        {
          key: 'AlcoholContent',
          label: 'Alcohol Content',
          width: 140,
          group: 'alcohol',
          groupStart: true,
        },
        {
          key: 'AlcoholQualifier',
          label: 'Alcohol Qualifier',
          width: 150,
          group: 'alcohol',
          groupEnd: true,
        },

        {
          key: 'Model',
          label: 'Model',
          width: 130,
          vehicleOnly: true,
          group: 'vehicle',
          groupStart: true,
        },
        {
          key: 'ChassisNo',
          label: 'Chassis No',
          width: 150,
          vehicleOnly: true,
          group: 'vehicle',
        },
        {
          key: 'EngineNo',
          label: 'Engine No',
          width: 150,
          vehicleOnly: true,
          group: 'vehicle',
        },
        {
          key: 'Brand',
          label: 'Brand',
          width: 130,
          vehicleOnly: true,
          group: 'vehicle',
        },
        {
          key: 'EngineCapacityQlf',
          label: 'Engine Capacity Qlf',
          width: 170,
          vehicleOnly: true,
          group: 'vehicle',
        },
        {
          key: 'EngineCapacityValue',
          label: 'Engine Capacity Value',
          width: 170,
          vehicleOnly: true,
          group: 'vehicle',
        },
        {
          key: 'ManufactureDate',
          label: 'Manufacture Date',
          width: 170,
          vehicleOnly: true,
          group: 'vehicle',
          groupEnd: true,
        },

        {
          key: 'WarehouseLotNo',
          label: 'Lot #',
          width: 120,
          warehouseOnly: true,
          group: 'warehouse',
          groupStart: true,
        },
        {
          key: 'WarehouseLocation',
          label: 'Warehouse Location',
          width: 180,
          warehouseOnly: true,
          group: 'warehouse',
          groupEnd: true,
        },

        {
          key: 'AseanCept',
          label: 'CEPT',
          type: 'checkbox',
          width: 80,
          formTypes: ['K1', 'K8', 'K9'],
        },
        {
          key: 'AseanPta',
          label: 'Excise',
          type: 'checkbox',
          width: 80,
          formTypes: ['K1', 'K8', 'K9'],
        },
        {
          key: 'AseanAD',
          label: 'Anti Dumping',
          type: 'checkbox',
          width: 110,
          formTypes: ['K1', 'K8', 'K9'],
        },

        // { key: 'TxnId', label: 'TxnId', width: 155 },
        { key: 'action', label: 'Delete', width: 120 },
      ],

      smkItemList: [],

      showBatchAddPopup: false,
      batchAddCount: '',
      batchAllPopupButtons: [
        { text: 'Add', value: 'Add' },
        { text: 'Cancel', value: 'Cancel', color: 'lightgray' },
      ],

      selectAll: false,
      lastCheckedIndex: null,
      activeSMKItemRow: null,
      hoverSMKItemRow: null,
      hoverSMKItemPanelX: 0,
      hoverSMKItemPanelY: 0,
      batchField: '',
      batchValue: '',

      pinnedSMKItemDutyRow: null,
      smkItemDutyPanelPinned: false,
      smkItemDutyHideTimer: null,

      fieldConfig: {
        ItemCode: {
          type: 'dropdown',
          source: 'smkItemMasterList',
          itemKey: 'Item Code',
          descKey: 'Item Name',
          label: 'Item #',
        },
        Product: {
          type: 'dropdown',
          source: 'smkProductList',
          itemKey: 'Product Code',
          descKey: 'Product Name',
          label: 'Product #',
        },
        WarehouseLotNo: { type: 'text', label: 'Lot #' },
        WarehouseLocation: { type: 'text', label: 'Warehouse Location' },
        AseanCept: { type: 'checkbox', label: 'CEPT', formTypes: ['K1', 'K8', 'K9'] },
        AseanPta: { type: 'checkbox', label: 'Excise', formTypes: ['K1', 'K8', 'K9'] },
        AseanAD: { type: 'checkbox', label: 'Anti Dumping', formTypes: ['K1', 'K8', 'K9'] },

        CountryOfOrigin: {
          type: 'dropdown',
          source: 'countryList',
          itemKey: 'Country Code',
          descKey: 'Country',
          label: 'COO',
        },

        HSCode: {
          type: 'dropdown',
          source: 'tcList',
          itemKey: 'Tariff Code',
          descKey: 'Description',
          label: 'Tariff Code',
        },

        InvoiceQty: { type: 'number', label: 'Qty' },

        InvoiceUOM: {
          type: 'dropdown',
          source: 'uomList',
          itemKey: 'UOM Code',
          label: 'UOM',
        },

        TariffQty: { type: 'number', label: 'Tariff Qty' },

        TariffUOQ: {
          type: 'dropdown',
          source: 'uomList',
          itemKey: 'UOM Code',
          label: 'Tariff UOM',
        },

        DutyUOM: {
          type: 'dropdown',
          source: 'uomList',
          itemKey: 'UOM Code',
          label: 'Duty UOM',
        },

        UnitPrice: { type: 'number', label: 'Unit Price' },
        ItemAmount: { type: 'number', label: 'Amount' },
        ItemDescription: { type: 'text', label: 'Item Description' },

        DutyQty: { type: 'number', label: 'Duty Qty' },
        TxnId: { type: 'text', label: 'TxnId' },
        GSTExemptType: { type: 'text', label: 'GST Exempt Type' },
        GSTHSCode: { type: 'text', label: 'GST HS Code' },
        AlcoholContent: { type: 'number', label: 'Alcohol Content' },
        AlcoholQualifier: { type: 'text', label: 'Alcohol Qualifier' },

        Model: { type: 'text', label: 'Model' },
        ChassisNo: { type: 'text', label: 'Chassis No' },
        EngineNo: { type: 'text', label: 'Engine No' },
        Brand: { type: 'text', label: 'Brand' },
        EngineCapacityQlf: { type: 'text', label: 'Engine Capacity Qlf' },
        EngineCapacityValue: { type: 'text', label: 'Engine Capacity Value' },
        ManufactureDate: { type: 'text', label: 'Manufacture Date' },
      },
      isSMKItemExpanded: false,
      //#endregion
      actionsBoxContainer: false,
      smkBoxContainer: false,
      othersBoxContainer: false,
      clauseText: '',
      flatFilePreview: {
        jobno: '',
        fileName: '',
        text: '',
        errors: [],
      },
      showFlatFilePreviewPopup: false,
      smkDeniedControls: [],
      smkExempClause: [],

      showFlatFilePreview: false,

      // #region Duplicate From Other Company (DPO)
      dpoFlag: '',

      showDPOPopup: false,
      dpoFilterOpen: false,
      dpoFilterByDate: true,
      dpoFromDate: new Date(),
      dpoToDate: new Date(),
      dpoFromDateErr: '',
      dpoToDateErr: '',

      dpoFilterBySearch: false,
      dpoSearchBy: null,
      dpoSearchByErr: '',
      dpoSearchCriteria: null,
      dpoSearchCriteriaErr: '',
      dpoSearchInput: '',
      dpoSearchInputErr: '',
      dpoSearchCriteriaDisabled: false,

      dpoFilterText: '',
      dpoLastRefreshed: null,
      dpoCompanyList: [],
      selectedCompanyDPO: null,
      dpoCompanyErr: '',
      dpoJobList: [],
      dpoCopyContainers: false,
      selectedJobDPO: [],
      // #endregion
      flatFilePreviewText: '',
      flatFilePreviewErrors: '',
      flatFilePreviewFileName: '',
      flatFilePreviewBase64: '',
      flatFilePreviewJobNo: '',
      smkPartJobContext: {
        isPartJob: false,
        mainJobNo: '',
        smkJobNo: '',
        sourceTable: '',
      },
      showSMKLongDescriptionPopup: false,
      activeSMKLongDescriptionRow: null,
      smkLongDescriptionDraft: '',
      smkLongDescriptionPopupButtons: [
        { text: 'Update', color: '#4caf50', textColor: 'white' },
        { text: 'Delete', color: 'red', textColor: 'white' },
        { text: 'Cancel', color: 'lightgray', textColor: 'black' },
      ],

      smkLongDescriptionPopupButtonsViewOnly: [{ text: 'Close', color: 'lightgray', textColor: 'black' }],

      smkK3TypeList: [
        {
          Code: 'A',
          Description: 'Outgoing Station (Original Destination)',
          'Code - Desc': 'A - Outgoing Station (Original Destination)',
        },
        { Code: 'D', Description: 'Destination', 'Code - Desc': 'D - Destination' },
      ],

      smkK8TypeList: [
        { Code: 'D', Description: 'Outgoing Cargo', 'Code - Desc': 'D - Outgoing Cargo' },
        { Code: 'M', Description: 'Change of Conveyance', 'Code - Desc': 'M - Change of Conveyance' },
      ],

      showSMKFreightCurrencyPopup: false,
      smkFreightExchangeRates: null,
      smkFreightCurrencyPopupButtons: [
        { text: 'Update', color: '#4caf50', textColor: 'white' },
        { text: 'Cancel', color: 'lightgray', textColor: 'black' },
      ],
      smkFreightCurrencyDetails: [],
      smkItemRowKeySeed: 0,

      // SMK Documents
      smkDocMode: '',
      smkDocDraft: null,
      smkDocDeletedList: [],
      smkDocUid: 0,
      smkDocTableVersion: 0,
      smkDocErrors: {
        master: '',
        part1: '',
        invoiceDate: '',
        table: '',
        form: '',
      },

      // For vessel schedule sync
      hub: null,
      shipCallNoLoading: false,
    };
  },
  props: {},
  computed: {
    linkDisabledClass: function () {
      if (this.reportIsCancelled) {
        return 'report-disabled-cancelled';
      } else if (this.reportNoContainer) {
        return 'report-disabled-container';
      } else if (this.reportCargoTypeF) {
        return 'report-disabled-cargo-type';
      }
      return '';
    },
    linkDisabled: function () {
      if (this.reportIsCancelled || this.reportNoContainer || this.reportCargoTypeF) {
        return true;
      }
      return false;
    },

    contPreviewButtons: function () {
      return [
        { text: `Confirm Containers`, disabled: this.importHasError || this.importContPreview.length <= 0 },
        { text: 'Cancel', color: 'red', textColor: 'white' },
      ];
    },

    isFumigationRequired: function () {
      // If Fumigation is checked, set as required fields. If not, clear fields and set not required
      return this.selectedShippingInfoData['isFumigation'] == '1';
    },
    isFumigationDisabled: function () {
      // If Fumigation is checked, enable fields
      if (this.viewMode == true) {
        return true;
      } else if (this.selectedShippingInfoData['isFumigation'] == '1') {
        return false;
      }
      return true;
    },
    isTranshipmentRequired: function () {
      // If Transhipment is checked, set as required fields. If not, clear fields and set not required
      return this.selectedShippingInfoData['isTranshipment'] == '1';
    },
    isTranshipmentDisabled: function () {
      // If Transhipment is checked, enable fields
      if (this.viewMode == true) {
        return true;
      } else if (this.selectedShippingInfoData['isTranshipment'] == '1') {
        return false;
      }
      return true;
    },

    demurragePlaceholder: function () {
      if (this.pageType == 'Import') {
        if (this.selectedHeaderInfoData['selectedCargoType']) {
          return this.selectedHeaderInfoData['selectedCargoType']['Cargo Type'][0] == 'F' ?
              'Demurrage'
            : 'Free Storage';
        }
        return 'Demurrage';
      }
      return 'Demurrage';
    },

    getPOLPlaceholderAndTitle: function () {
      if (this.pageType === 'Import') {
        return 'POL ETD';
      }
      return 'POL ETA';
    },

    currencyFormattedValue: function () {
      return this.$currencyFormat(this.selectedHeaderInfoData.billToDetails.outstanding.value);
    },
    saveAsConfirm: function () {
      return this.selectedSaveBy?.keyValue === '1';
    },
    // ⚠️ Fix for "Cannot read properties of null (reading 'trim')" error:
    // This happened because the .sync binding (:search.sync="...") was used
    // directly on a value that could be null or undefined during tab switching.
    // Vue tried to call .trim() on it inside DropdownV2 before it was initialized.
    // To prevent this, wrap the bound value with a computed property that always
    // returns a safe fallback (e.g. empty string '') when null/undefined.
    shipCallNoSearch: {
      get() {
        return this.selectedShippingInfoData['shipCallNoValue'] ?? '';
      },
      set(val) {
        this.selectedShippingInfoData['shipCallNoValue'] = val;
      },
    },
    vesselIDSearch: {
      get() {
        return this.selectedShippingInfoData['vesselIDValue'] ?? '';
      },
      set(val) {
        this.selectedShippingInfoData['vesselIDValue'] = val;
      },
    },
    messageContainerStyling: function () {
      return {
        backgroundColor:
          this.rightMenuSuccess === null ? 'lightyellow'
          : this.rightMenuSuccess === true ? 'lightgreen'
          : 'lightyellow',
        color: this.rightMenuSuccess === false ? 'white' : 'black',
      };
    },
    jobSectionStyling: function () {
      if (this.showSMKDetails && this.enableSMKmodule) {
        return {
          height: `100%`,
        };
      }
      return {
        height: `calc(100% - 43px)`,
      };
    },

    selectedCount: function () {
      return this.smkItemList.filter((x) => x.selected).length;
    },

    topRightDivWidth: function () {
      return `width: 100%;`;
    },

    filteredSMKItemList: function () {
      let rows = this.smkItemList || [];

      if (this.searchText && this.searchText.trim()) {
        const keyword = this.searchText.trim().toLowerCase();

        rows = rows.filter((row) => {
          return this.displayColumns.some((col) => {
            if (['select', 'seq', 'action'].includes(col.key)) return false;

            const val = this.getSearchableCellValue(row, col.key);
            return String(val || '')
              .toLowerCase()
              .includes(keyword);
          });
        });
      }

      rows = rows.filter((row) => {
        return this.displayColumns.every((col) => {
          const filterVal = (this.columnFilters[col.key] || '').trim().toLowerCase();

          if (!filterVal) return true;
          if (['select', 'seq', 'action'].includes(col.key)) return true;

          const val = this.getSearchableCellValue(row, col.key);
          return String(val || '')
            .toLowerCase()
            .includes(filterVal);
        });
      });

      return rows;
    },

    batchFieldOptions: function () {
      const formType = this.getHeaderSMKFormType();

      return this.activeColumns
        .map((col) => col.key)
        .filter((key) => !['select', 'seq', 'action', 'TxnId'].includes(key))
        .filter((key) => this.fieldConfig[key])
        .filter((key) => {
          const config = this.fieldConfig[key];
          if (config.formTypes && !config.formTypes.includes(formType)) return false;
          return true;
        })
        .map((key) => ({
          key,
          label: this.fieldConfig[key].label,
        }));
    },

    selectedBatchFieldObj: {
      get() {
        return this.batchFieldOptions.find((x) => x.key === this.batchField) || null;
      },
      set(val) {
        this.batchField = val ? val.key : '';
      },
    },

    isVehicleTemplate: function () {
      return this.selectedTemplateType?.value === 'VEHICLE';
    },

    activeColumns: function () {
      const formType = this.getHeaderSMKFormType();

      return this.columns.filter((col) => {
        if (col.vehicleOnly && !this.showSMKVehicleColumns) return false;
        if (col.formTypes && !col.formTypes.includes(formType)) return false;
        if (col.warehouseOnly && !this.showSMKWarehouseColumns) {
          return false;
        }
        return true;
      });
    },

    visibleSMKItemColumns: function () {
      const showDuty = this.smkItemList.some((row) => this.showSMKItemDutyQty(row));
      const showAlcohol = this.smkItemList.some((row) => this.showSMKItemAlcohol(row));

      return this.displayColumns.filter((col) => {
        if (['DutyQty', 'DutyUOM'].includes(col.key)) return showDuty;
        if (['AlcoholContent', 'AlcoholQualifier'].includes(col.key)) return showAlcohol;
        return true;
      });
    },

    filteredDeclarationTypeList() {
      const formTypeObj = this.selectedSmkInfoData['selectedSmkFormType'];
      if (!formTypeObj) return [];

      const selectedFormType = String(formTypeObj['Form Type'] || '').trim();

      return (this.smkInfoData['declarationType'] || []).filter(
        (item) => String(item['JobFormType'] || '').trim() === selectedFormType,
      );
    },
    smkLegendItems() {
      return [
        {
          label: 'Released',
          sample: {
            'Request Type': 'CUSACK',
            'Status Code': '88',
          },
        },
        {
          label: 'Acknowledged',
          sample: {
            'Request Type': 'CUSACK',
            'Status Code': '00',
          },
        },
        {
          label: 'Error',
          sample: {
            'Request Type': 'CUSERR',
            'Status Code': '',
          },
        },
        {
          label: 'Submit Job',
          sample: {
            'Request Type': 'SUBMIT JOB',
            'Status Code': '',
          },
        },
      ];
    },
    smkTotalItemAmount: function () {
      const smkDetails = (this.smkSummaryDetails || [])[0] || {};
      const value = smkDetails['TtlAmt'];

      if (value === null || value === undefined || value === '') return 0;

      return Number(String(value).replaceAll(',', '')) || 0;
    },

    smkTotalItemAmountDisplay: function () {
      const total = (this.smkItemList || []).reduce((sum, item) => {
        const rawAmount = item['ItemAmount'] ?? 0;

        const amount = Number(String(rawAmount).replace(/,/g, '').trim());

        return sum + (Number.isFinite(amount) ? amount : 0);
      }, 0);

      return this.$currencyFormat ? this.$currencyFormat(total) : total.toFixed(2);
    },

    smkItemSummaryAmount: function () {
      return (this.smkItemList || []).reduce((total, item) => {
        return total + this.smkNum(item.ItemAmount);
      }, 0);
    },

    smkItemSummaryCIF: function () {
      const summary = (this.smkSummaryDetails || [])[0] || {};
      const invoiceTotal = this.smkNum(summary.TtlAmt);
      const calMOM = this.smkNum(summary.calMOM);

      if (invoiceTotal === 0) return 0;

      return (calMOM / invoiceTotal) * this.smkItemSummaryAmount;
    },

    smkItemSummaryFOB: function () {
      const summary = (this.smkSummaryDetails || [])[0] || {};
      const invoiceTotal = this.smkNum(summary.TtlAmt);
      const calFOB = this.smkNum(summary.CalFob);

      if (invoiceTotal === 0) return 0;

      return (calFOB / invoiceTotal) * this.smkItemSummaryAmount;
    },

    selectedSMKItemRowForDuty() {
      if (this.smkItemDutyPanelPinned && this.smkItemList.includes(this.pinnedSMKItemDutyRow))
        return this.pinnedSMKItemDutyRow;
      if (this.hoverSMKItemRow && this.smkItemList.includes(this.hoverSMKItemRow)) return this.hoverSMKItemRow;
      return null;
    },

    smkItemDutyRows: function () {
      return this.buildSMKItemDutyRows(this.selectedSMKItemRowForDuty || {});
    },

    isSMKItemViewOnly: function () {
      return this.viewMode;
    },

    canShowSMKItemHoverTables: function () {
      if (this.smkItemDutyPanelPinned) return true;
      if (this.viewMode || this.newMode) return true;
      return Boolean(this.showSMKItemHoverTables);
    },

    showSMKDutiesOnHover: function () {
      return ['K3', 'K8'].includes(this.getHeaderSMKFormType());
    },

    showSMKCessOnHover: function () {
      const jobType = String(this.pageType || '')
        .trim()
        .toUpperCase();
      return jobType.startsWith('E') && ['K2', 'K3', 'K8'].includes(this.getHeaderSMKFormType());
    },

    allowSMKItemAseanCheckboxes: function () {
      return ['K1', 'K8', 'K9'].includes(this.getHeaderSMKFormType());
    },

    currentSMKCustomerCode: function () {
      const text = (value) => (value == null ? '' : String(value).trim());
      const code = (obj, key) => (obj && obj[key] ? text(obj[key]) : '');

      return this.pageType[0] === 'E' ?
          code(this.selectedHeaderInfoData['selectedShipper'], 'Shipper Code')
        : code(this.selectedHeaderInfoData['selectedConsignee'], 'Consignee Code');
    },

    filteredSMKProductMasterList: function () {
      const rows = this.generalInfoData['smkProductList'] || [];
      const customerCode = this.currentSMKCustomerCode;

      if (this.showAllSMKProducts || !customerCode) return rows;
      return rows.filter((x) => String(x['Customer Code'] || '').trim() === customerCode);
    },

    smkInvoiceTypeList: function () {
      const currencies = (this.generalInfoData['currencyList'] || []).filter((item) => {
        const code = String(item['Currency Code'] || '').trim();
        return code && code !== '%';
      });

      return [
        ...currencies,
        {
          'Currency Code': '%',
          Description: 'Percentage',
        },
      ];
    },

    hasSMKAdditionalFreightCurrency: function () {
      const freightType = String(this.selectedSmkInfoData['invoiceTypeFreight']?.['Currency Code'] || '')
        .trim()
        .toUpperCase();

      const mainCurrency = String(this.selectedSmkInfoData['currency1']?.['Currency Code'] || '')
        .trim()
        .toUpperCase();

      return Boolean(freightType && freightType !== 'MYR' && freightType !== '%' && freightType !== mainCurrency);
    },

    smkInvoiceAmountTypeList: function () {
      // Total Amount cannot use percentage.
      return this.smkInvoiceTypeList.filter((item) => item['Currency Code'] !== '%');
    },
    smkItemCessRows: function () {
      return this.buildSMKItemCessRows(this.selectedSMKItemRowForDuty || {});
    },
    showSMKSideCessTable: function () {
      const summary = (this.smkSideSummaryDetails || [])[0] || {};
      const selectedPart = (this.selectedsmkPartJob || [])[0] || {};
      const selectedJob = (this.selectedJob || [])[0] || {};

      const formType = String(
        selectedPart['SMK Form Type'] || summary.JobFormType || summary.FormType || selectedJob['SMK Form Type'] || '',
      )
        .trim()
        .toUpperCase();

      const jobType = String(this.pageType || '')
        .trim()
        .toUpperCase();

      return jobType.startsWith('E') && ['K2', 'K3', 'K8'].includes(formType);
    },
    currentSMKFormType() {
      const selected = this.selectedSmkInfoData['selectedSmkFormType'];

      if (!selected) return '';

      return String(typeof selected === 'object' ? selected['Form Type'] : selected)
        .trim()
        .toUpperCase();
    },

    smkFreightCurrencyTooltip: function () {
      const smk = this.selectedSmkInfoData;
      const code = this.getSmkInvoiceCode('invoiceTypeFreight');
      const amount = smk['amountFreight'] || '0';
      const rate = smk['freightForeignRate'] || '0';
      const myr = smk['freightAmountMYR'] || '0';

      return `${code} ${amount} × ${rate} = MYR ${myr}`;
    },
    isSMKPreferentialDeclaration: function () {
      return String(this.selectedSmkInfoData.selectedDeclarationType?.['Declare Type'] || '').trim() === 'S';
    },
    availableSMKDocMasterList() {
      const jobType = this.pageType[0];

      return (this.smkInfoData.docMasterList || []).filter(
        (doc) => doc['Job Type'] === jobType || (doc['Job Type'] === 'B' && ['R', 'D'].includes(doc['Flat File'])),
      );
    },
    selectedSMKDocRow() {
      const selected = this.selectedSmkInfoData.selectedDoc;
      return Array.isArray(selected) ? selected[0] || null : selected || null;
    },
    selectedSMKTransportRow: function () {
      const selected = this.selectedSMKTransportRows;

      return Array.isArray(selected) ? selected[0] || null : selected || null;
    },
    smkSideJobDetailRows: function () {
      const details = (this.smkSideSummaryDetails || [])[0] || {};
      const trim = (value) => String(value === null || value === undefined ? '' : value).trim();

      const formType = trim(details.JobFormType || details.FormType || this.smkSideFormType).toUpperCase();

      const codeDescription = (list, code, codeKey, descriptionKey, filter) => {
        const value = trim(code);
        if (!value) return '';

        const selected = (list || []).find((item) => {
          if (filter && !filter(item)) return false;
          return trim(item[codeKey]).toUpperCase() === value.toUpperCase();
        });

        if (!selected) return value;

        const description = trim(selected[descriptionKey]);
        return description ? `${value} - ${description}` : value;
      };

      const formatDate = (value) => {
        if (!value) return '';

        const date = value instanceof Date ? value : new Date(value);
        if (Number.isNaN(date.getTime()) || date.getFullYear() <= 1900) return '';

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');

        return `${day}-${month}-${date.getFullYear()}`;
      };

      const declarationType = codeDescription(
        this.smkInfoData['declarationType'],
        details.TranType,
        'Declare Type',
        'Declare Name',
        (item) => !formType || trim(item.JobFormType).toUpperCase() === formType,
      );

      const shipmentType = codeDescription(this.smkInfoData['shipmentType'], details.ShipType, 'Code', 'Desc');

      const countryOfOrigin = codeDescription(
        this.generalInfoData['countryList'],
        details.CtryOrigin,
        'Country Code',
        'Country',
      );

      const rows = [
        { label: 'Declaration Type', value: declarationType },
        { label: 'Shipment Type', value: shipmentType },
        { label: 'Country Of Origin', value: countryOfOrigin },
      ];

      if (formType === 'K3') {
        rows.push(
          {
            label: 'K3 Type',
            value: codeDescription(this.smkK3TypeList, details.K3Type, 'Code', 'Description'),
          },
          {
            label: 'Move To',
            value: codeDescription(this.shippingInfoData['station'], details.MoveTo, 'Station Code', 'Station Name'),
          },
        );
      }

      if (formType === 'K8') {
        rows.push(
          {
            label: 'K8 Type',
            value: codeDescription(this.smkK8TypeList, details.K3Type, 'Code', 'Description'),
          },
          {
            label: 'Move Type',
            value: codeDescription(this.smkInfoData['movementType'], details.MoveType, 'Move Type', 'Move Desc'),
          },
          {
            label: 'Date',
            value: formatDate(details.MoveDate),
          },
          {
            label: 'From Station',
            value: codeDescription(
              this.shippingInfoData['station'],
              details.MoveFrStation,
              'Station Code',
              'Station Name',
            ),
          },
          {
            label: 'To Station',
            value: codeDescription(
              this.shippingInfoData['station'],
              details.MoveToStation,
              'Station Code',
              'Station Name',
            ),
          },
          {
            label: 'From Whse',
            value: trim(details.MoveFrWhse),
          },
          {
            label: 'To Whse',
            value: trim(details.MoveToWhse),
          },
        );
      }

      if (formType === 'K9') {
        const warehouseCode = details.K9WhseCode || details.WhseCode;
        const warehouseType = details.K9WhseType || details.WhseType;
        const stationCode = details.K9Stt || details.Stt;

        rows.push(
          {
            label: 'Whse Code',
            value: codeDescription(
              this.smkInfoData['warehouseList'],
              warehouseCode,
              'Warehouse Code',
              'Warehouse Name',
            ),
          },
          {
            label: 'Whse Type',
            value: codeDescription(
              this.smkInfoData['warehouseTypeList'],
              warehouseType,
              'Warehouse Type',
              'Warehouse Desc',
            ),
          },
          {
            label: 'Station Code',
            value: codeDescription(this.shippingInfoData['station'], stationCode, 'Station Code', 'Station Name'),
          },
          {
            label: 'License #',
            value: trim(details.K9License || details.License),
          },
          {
            label: 'License Date',
            value: formatDate(details.K9LicenseDate || details.LicenseDate),
          },
          {
            label: 'Deposit Date',
            value: formatDate(details.K9DepDate || details.DepDate),
          },
          {
            label: 'Deposit Receipt #',
            value: trim(details.K9DepRecpt || details.DepRecpt),
          },
        );
      }

      return rows;
    },
  },
  methods: {
    menuClicked: async function (item) {
      this.viewMode = false;
      this.billingCheckDisabled = false;
      this.mainFilterIsOpen = false;

      if (!item.enabled) {
        // this.$alert.showAlert('Access Denied', `You have no permission for '${item['title']}'`, 'error');
        this.$showAlert('error', 'Access Denied', `You have no permission for '${item['title']}'`);
        return;
      }

      switch (item.title) {
        case 'New Import Job':
        case 'New Export Job': {
          this.resetSMKFormData(false);
          this.setNewSmkInvoiceDefaults();
          this.originalSMKFormType = '';
          this.clearSMKPartJobContext && this.clearSMKPartJobContext();

          this.$fullscreenLoading('Getting defaults');
          const defaults = await this.$apiCallV2(`/FreightForwarding/GetJobDefaults?jobType=${this.pageType[0]}`);
          this.$fullscreenLoading();

          this.selectedHeaderInfoData['jobNo'] = '**********';
          this.selectedHeaderInfoData['jobStatus'] = 'New';
          this.selectedHeaderInfoData['jobTime'] = new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate(),
            new Date().getHours(),
            new Date().getMinutes(),
            0,
            0,
            0,
          );
          const userBranch = this.loginDetails['Branch']['BrName'];
          this.selectedGeneralInfoData['selectedBranch'] = this.generalInfoData['branchList'].filter((b) => {
            return b['Branch Name'].trim() == userBranch.trim();
          })[0];
          this.popupTitle = `New ${this.pageType} Job`;
          this.createdBy = '';
          this.updatedBy = '';

          if (defaults['DefaultTransMode']) {
            const selectedTransMode = this.headerInfoData['transMode'].find(
              (item) => item.Description.toLowerCase() === defaults['DefaultTransMode'].toLowerCase(),
            );
            if (selectedTransMode) {
              this.selectedHeaderInfoData['selectedTransMode'] = selectedTransMode;
            }
          }

          if (defaults['DefaultCargoType']) {
            this.selectedHeaderInfoData['selectedCargoType'] = this.headerInfoData['cargoType'].getSelected(
              defaults['DefaultCargoType'],
              'Cargo Type',
            );
          }

          if (defaults['DefaultCommodity']) {
            this.selectedCargoInfoData['selectedCommodity'] = this.cargoInfoData['commodityList'].getSelected(
              defaults['DefaultCommodity'],
              'Commodity Code',
            );
          }

          // if (defaults['ForwardingAgent'] && (item.title == 'New Import Job' || item.title == 'New Export Job')) { //no need to check the part after and?
          if (defaults['ForwardingAgent']) {
            this.selectedShippingInfoData['selectedFwdgAgent'] = this.shippingInfoData['fwdgAgentList'].filter((a) => {
              return a['FA Code'].trim() == defaults['ForwardingAgent'].trim();
            })[0];
          }

          if (defaults['DefaultPort']) {
            if (this.pageType == 'Import') {
              this.selectedShippingInfoData['selectedPortDischarge'] = this.shippingInfoData[
                'portOfDischarge'
              ].getSelected(defaults['DefaultPort'], 'Port Code');
            } else {
              this.selectedShippingInfoData['selectedPortLoading'] = this.shippingInfoData['portOfLoading'].getSelected(
                defaults['DefaultPort'],
                'Port Code',
              );
            }
          }

          this.milestoneHeight = 0;
          this.showPopup = true;
          break;
        }
        case 'Edit Import Job':
        case 'Edit Export Job': {
          if (this.selectedJob.length == 0) {
            this.$showAlert('error', 'No Job Selected', 'Please select a record to edit');
            return;
          }
          if (this.selectedJob[0]['Job State'] == 'Cancelled') {
            this.$showAlert('error', 'Cancelled Job', 'Cancelled Job cannot be edited');
            return;
          }
          const tempUpdateContNoRole = await this.$apiCallV2(
            '/Master/GetSettingsSystem?settingsitem=SASUpdContNoRoleId',
          );
          if (tempUpdateContNoRole) {
            this.updateContNoRole = tempUpdateContNoRole[0]['SettingsValue'];
          }

          this.popupTitle = `Edit ${this.pageType} Job`;

          const hasSMKAccess = this.hasSMKFormTypeAccess(this.getSelectedSMKFormType('JOB'));
          if (hasSMKAccess) {
            await this.loadSMKDetailsForSelection('JOB');
          } else {
            this.clearSMKDetails(false);
          }

          await this.viewEditClicked('e');
          this.originalSMKFormType = this.getHeaderSMKFormType();
          await this.loadDnConsumedQty();
          this.showPopup = true;
          await this.filterSMKlist();

          this.applySMKViewTabAccess(hasSMKAccess);

          break;
        }
        case 'Delete Import Job':
        case 'Delete Export Job':
          if (this.selectedJob.length == 0) {
            this.$showAlert('error', 'No Job Selected', `Please select a record to delete`);
          } else {
            if (this.selectedJob[0]['Job State'] == 'Cancelled') {
              this.$showAlert('error', 'Cancelled Job', 'You cannot delete a job that is already cancelled.');
              return;
            }
            // var reason = await Swal.fire({
            //   title: `You want to delete ${this.selectedJob[0]['Job No']}`,
            //   input: 'text',
            //   showCancelButton: true,
            //   inputPlaceholder: 'Enter your reason',
            //   inputValidator: (v) => {
            //     if (!v) {
            //       return 'You need to state your reason to delete the job';
            //     }
            //   },
            //   confirmButtonText: 'Delete',
            //   confirmButtonColor: 'red'
            // });
            this.showDeletePopup = true;

            // var confirmDelete = await this.$alert.questionAlert('Delete Job', `Are you sure you want to delete ${this.selectedJob[0]['Job No']}?`, 'Delete', 'No', 'warning', 'red', '');
            // var confirmDelete = await this.$showAlert('warning', 'Delete Job',  `Are you sure you want to delete ${this.selectedJob[0]['Job No']}?`, [{"text" : "Delete"}, {"text" : "No"}] )
            // if (confirmDelete === "Delete") {
            //   var job = await this.$apiCallV2(`/FreightForwarding/DeleteFrtFwdJob?reason=${reason['value']}&jobno=${this.selectedJob[0]['Job No']}`);
            //   if (job[0]['Results'] == 0) {
            //     this.refreshClicked(true);
            //     // this.$alert.showAlert('Deleted!', `Job ${this.selectedJob[0]['Job No']} was successfully deleted.`, 'success');
            //     this.$showAlert('success', 'Deleted!', `Job ${this.selectedJob[0]['Job No']} was successfully deleted.`);
            //   } else {
            //     // this.$alert.showAlert('Not Deleted', `There was an error occurred while deleting your job. Please try again.`, 'error');
            //     this.$showAlert('error', 'Not Deleted', `There was an error occurred while deleting your job. Please try again.`);
            //   }
            // }
          }
          break;
        case 'View Import Job':
        case 'View Export Job': {
          if (this.selectedJob.length == 0) {
            //this.$alert.showAlert('No Job Selected', `Please select a record to view`, 'error');
            this.$showAlert('error', 'No Job Selected', 'Please select a record to view');
            return;
          }
          const hasSMKAccess = this.hasSMKFormTypeAccess(this.getSelectedSMKFormType('JOB'));

          this.tabsItems[6]['disabled'] = false;
          this.tabsItems[7]['disabled'] = false;
          this.tabsItems[8]['disabled'] = false;

          this.applySMKViewTabAccess(hasSMKAccess);

          this.viewMode = true;
          this.popupTitle = `View ${this.pageType} Job`;

          if (hasSMKAccess) {
            await this.loadSMKDetailsForSelection('JOB');
          } else {
            this.clearSMKDetails(true);
            this.showSMKDetails = false;
            this.showSMKRightMenu = false;
          }
          await this.viewEditClicked('v');
          this.showPopup = true;
          break;
        }
        case 'New Part Job': {
          const selectedMainJob = (this.selectedJob || [])[0] || {};
          const mainJobNo = this.getSelectedMainJobNo();

          if (!mainJobNo) {
            this.$showAlert('error', 'No Job Selected', 'Please select a main job first.');
            return;
          }

          if (selectedMainJob['Job State'] == 'Cancelled') {
            this.$showAlert('error', 'Cancelled Job', 'Cancelled Job cannot be edited');
            return;
          }

          const formType = this.getSelectedSMKFormType('JOB');
          const hasSMKAccess = this.hasSMKFormTypeAccess(formType);

          if (!formType) {
            this.$showAlert('error', 'SMK Form Type', 'SMK Form Type for this Job is empty.');
            return;
          }

          if (!this.enableSMKmodule || !formType || !hasSMKAccess) {
            this.$showAlert('error', 'Access Denied', 'You have no permission for this SMK Form Type.');
            return;
          }

          this.$fullscreenLoading('Preparing Part Job');
          await this.loadSMKDetailsForSelection('JOB');
          const partJobNo = await this.getNextSMKPartJobNo(mainJobNo);
          this.$fullscreenLoading();

          if (!partJobNo) return;

          this.clearSMKPartJobContext();
          this.setSMKPartJobContext(mainJobNo, partJobNo);
          this.setPartJobPopupTabs(hasSMKAccess);

          this.viewMode = false;
          this.popupTitle = 'New Part Job';
          this.createdBy = '';
          this.updatedBy = '';

          await this.viewEditClicked('e', true, false, {
            jobno: mainJobNo,
            mainjobno: mainJobNo,
          });

          // New Part Job copies job-level data, but not the main job's
          // invoice, items, documents, exemption, or clause.
          this.smkSummaryDetails = [];
          this.smkExemptDetails = [];
          this.smkDocList = [];
          this.smkItemList = [];
          this.smkExempClause = [];
          this.smkSubmissionList = [];
          this.clauseText = '';

          Object.assign(this.selectedSmkInfoData, {
            selectedDeclarationType: null,
            selectedShipmentType: null,
            selectedCountryOfOrigin: null,

            exemptNoTreasury: null,
            exemptTypeTreasury: null,
            expiryDateTE: null,
            exemptNoSalesTax: null,
            exemptTypeSalesTax: null,
            registrationDateST: null,
            stationCode: '',
            expiryDateST: null,
            exemptNoSpecialTreatment: null,
            exemptTypeSpecialTreatment: null,
            claimentName: '',
            claimentCompany: '',
            claimentStatus: '',
            claimentNRIC: '',
            clauseCode: null,
            selectedDoc: [],
          });

          this.setNewSmkInvoiceDefaults();

          this.selectedHeaderInfoData['jobNo'] = partJobNo;
          this.selectedHeaderInfoData['jobStatus'] = 'New';
          this.originalSMKFormType = this.getHeaderSMKFormType();

          this.showPopup = true;
          await this.filterSMKlist();
          break;
        }

        case 'Edit Part Job': {
          const mainJobNo = this.getSelectedMainJobNo();
          const partJobNo = this.getSelectedPartJobNo();

          if (!mainJobNo) {
            this.$showAlert('error', 'No Job Selected', 'Please select a main job first.');
            return;
          }

          if (!partJobNo) {
            this.$showAlert('error', 'No Part Job Selected', 'Please select a record to edit');
            return;
          }

          const selectedPartJob = (this.selectedsmkPartJob || [])[0] || {};
          if (
            String(selectedPartJob['Job State'] || '')
              .trim()
              .toUpperCase() === 'CANCELLED'
          ) {
            this.$showAlert('error', 'Cancelled Part Job', 'Cancelled Part Job cannot be edited.');
            return;
          }

          const formType = this.getSelectedSMKFormType('PART');
          const hasSMKAccess = this.hasSMKFormTypeAccess(formType);

          if (!this.enableSMKmodule || !formType || !hasSMKAccess) {
            this.$showAlert('error', 'Access Denied', 'You have no permission for this SMK Form Type.');
            return;
          }

          this.clearSMKPartJobContext();
          this.setSMKPartJobContext(mainJobNo, partJobNo);
          this.setPartJobPopupTabs(hasSMKAccess);

          await this.loadSMKDetailsForSelection('PART');

          this.viewMode = false;
          this.popupTitle = 'Edit Part Job';

          await this.viewEditClicked('e', false, false, {
            jobno: partJobNo,
            mainjobno: mainJobNo,
            sourcetable: 'SMKJOB',
          });

          this.originalSMKFormType = this.getHeaderSMKFormType();
          this.showPopup = true;
          await this.filterSMKlist();
          break;
        }
        case 'Delete Part Job': {
          const mainJobNo = this.getSelectedMainJobNo();
          const partJobNo = this.getSelectedPartJobNo();

          if (!mainJobNo || !partJobNo) {
            this.$showAlert('error', 'No Part Job Selected', 'Please select a main job and Part Job to delete.');
            return;
          }

          this.deleteTarget = 'PART';
          this.deleteRemarks = '';
          this.deleteRemarksError = '';
          this.showDeletePopup = true;
          break;
        }
        case 'Duplicate Part Job': {
          const mainJobNo = this.getSelectedMainJobNo();
          const selectedPartJobNo = this.getSelectedPartJobNo();
          const sourceJobNo = selectedPartJobNo || mainJobNo;
          const sourceIsPartJob = Boolean(selectedPartJobNo);

          if (!mainJobNo) {
            this.$showAlert('error', 'No Job Selected', 'Please select a main job first.');
            return;
          }

          if (!this.enableSMKmodule) {
            this.$showAlert('error', 'Access Denied', 'SMK is not enabled.');
            return;
          }

          const formType = this.getSelectedSMKFormType(sourceIsPartJob ? 'PART' : 'JOB');
          const hasSMKAccess = this.hasSMKFormTypeAccess(formType);

          if (!formType || !hasSMKAccess) {
            this.$showAlert('error', 'Access Denied', 'You have no permission for this SMK Form Type.');
            return;
          }

          const choice = await this.$showAlert('info', 'Duplicate Part Job', `Duplicate ${sourceJobNo}?`, [
            { text: 'Copy Invoice Items' },
            { text: 'Without Invoice Items' },
            { text: 'Cancel', color: 'gray', textColor: 'white' },
          ]);

          if (choice !== 'Copy Invoice Items' && choice !== 'Without Invoice Items') {
            return;
          }

          this.$fullscreenLoading('Preparing Duplicate Part Job');

          try {
            // Refresh the part-job list before generating the next suffix.
            await this.loadSMKDetailsForSelection('JOB');

            const newPartJobNo = await this.getNextSMKPartJobNo(mainJobNo);
            if (!newPartJobNo) return;

            // Load the selected source, not always the main job.
            if (sourceIsPartJob) {
              await this.loadSMKDetailsForSelection('PART');
            }

            this.clearSMKPartJobContext();
            this.setSMKPartJobContext(mainJobNo, newPartJobNo);
            this.setPartJobPopupTabs(hasSMKAccess);

            this.viewMode = false;
            this.popupTitle = 'Duplicate Part Job';
            this.createdBy = '';
            this.updatedBy = '';

            await this.viewEditClicked('e', true, true, {
              jobno: sourceJobNo,
              mainjobno: mainJobNo,
              sourcetable: sourceIsPartJob ? 'SMKJOB' : '',
            });

            // The source documents are new documents for the duplicate.
            this.smkDocDeletedList = [];
            this.smkDocList = this.smkDocList.map((doc) => ({
              ...doc,
              _smkDocUid: ++this.smkDocUid,
              _smkSaved: false,
              _smkOriginalCategory: '',
              _smkOriginalRef: '',
            }));

            if (choice === 'Copy Invoice Items') {
              this.smkItemList = this.smkItemList.map((row, index) => ({
                ...row,
                selected: false,
                SeqNo: String(index + 1),
                TxnId: '',
                _rowKey: this.nextSMKItemRowKey(),
              }));
            } else {
              this.smkItemList = [];
            }

            this.selectedHeaderInfoData['jobNo'] = newPartJobNo;
            this.selectedHeaderInfoData['jobStatus'] = 'New';
            this.originalSMKFormType = this.getHeaderSMKFormType();

            this.showPopup = true;
            await this.filterSMKlist();
          } finally {
            this.$fullscreenLoading();
          }

          break;
        }
        case 'View Part Job': {
          const partJobNo =
            this.selectedsmkPartJob.length > 0 ? (this.selectedsmkPartJob[0]['SMK Job No'] || '').trim() : '';

          if (!partJobNo) {
            this.$showAlert('error', 'No Part Job Selected', 'Please select a record to view');
            return;
          }
          const hasSMKAccess = this.hasSMKFormTypeAccess(this.getSelectedSMKFormType('PART'));

          this.tabsItems[5]['disabled'] = true;
          this.tabsItems[6]['disabled'] = true;
          this.tabsItems[7]['disabled'] = true;
          this.tabsItems[8]['disabled'] = true;

          this.applySMKViewTabAccess(hasSMKAccess);

          if (hasSMKAccess) {
            await this.loadSMKDetailsForSelection('PART');
          } else {
            this.clearSMKDetails(false);
            this.showSMKRightMenu = false;
          }

          this.viewMode = true;
          this.popupTitle = `View Part Job`;

          await this.viewEditClicked('v', false, false, {
            jobno: partJobNo,
            mainjobno: this.selectedJob[0]['Job No'].trim(),
            sourcetable: 'SMKJOB',
          });
          this.showPopup = true;
          break;
        }
        case 'Duplicate':
          if (this.selectedJob.length == 0) {
            this.$showAlert('error', 'No Job Selected', 'Please select a record to duplicate');
          } else {
            const tempUpdateContNoRole = await this.$apiCallV2(
              '/Master/GetSettingsSystem?settingsitem=SASUpdContNoRoleId',
            );
            if (tempUpdateContNoRole) {
              this.updateContNoRole = tempUpdateContNoRole[0]['SettingsValue'];
            }

            const duplicateCont = await this.$showAlert(
              'info',
              'Duplicate Containers',
              'Do you want to duplicate the container details as well?',
              [
                { text: 'Duplicate Containers' },
                { text: 'Do not Duplicate Containers', color: 'gray', textColor: 'white' },
              ],
            );

            this.showPopup = true;
            this.popupTitle = `New ${this.pageType} Job`;

            this.createdBy = '';
            this.updatedBy = '';

            this.viewEditClicked('e', true, duplicateCont == 'Duplicate Containers');
          }
          break;
        case 'Duplicate From Other Company':
          this.dpoRefreshClicked();
          this.showDPOPopup = true;
          break;
        case 'Print Job Sheet':
          if (this.selectedJob.length == 0) {
            //this.$alert.showAlert('No Job Selected', `Please select a record to view`, 'error');
            this.$showAlert('error', 'No Job Selected', `Please select a record to Print Job Sheet`);
          } else {
            window.open(`/${this.userParam}/ReportsV2/Job Sheet?jobNo=${this.selectedJob[0]['Job No']}`, '_blank');
          }
          break;
        case 'Print Import ...':
        case 'Print Export ...':
          if (this.selectedJob.length == 0) {
            this.$showAlert('error', 'No Job Selected', `Please select a record to print`);
          } else {
            this.reportNoContainer =
              parseInt(this.selectedJob[0]['Total 20']) + parseInt(this.selectedJob[0]['Total 40']) <= 0;
            this.reportIsCancelled = this.selectedJob[0]['Job State'].trim() == 'Cancelled';
            this.reportCargoTypeF = this.selectedJob[0]['Cargo Type'].trim().startsWith('F');
            this.reportPopup = !this.reportPopup;
          }
          break;
        case 'Scan Document':
          this.showDocUpload = true;
          this.popupTitle = `Document AI - Creating ${this.pageType} Job`;
          break;
        case 'eJob':
          this.showEJobPopup = true;
          break;
        case 'Job Charges':
          if (this.selectedJob.length == 0) {
            this.$showAlert('error', 'No Job Selected', 'Please select a record to view Job Charges');
          } else {
            const route = this.$router.resolve(
              `/Home/${this.$route.params['user']}/FINAR/Job%20Charges?jobNo=${this.selectedJob[0]['Job No']}`,
            );
            window.open(route.href, '_blank');
          }
          break;
        case 'ROT':
          if (this.selectedJob.length == 0) {
            this.$showAlert('error', 'No Job Selected', 'Please select a record to load ROT');
          } else if (this.selectedJob[0]['Job State'].trim() == 'Cancelled') {
            this.$showAlert('error', 'Error Creating New ROT', 'Job is cancelled');
          } else {
            const validate = await this.$apiCallV2(
              `/ROT/ValidateJobsForROT?jobno=${this.selectedJob[0]['Job No'].trim()}`,
            );
            if (validate[0]['Results'] == 1) {
              this.rotVerifyPopup = true;
              this.rotVerifyError = validate[0]['ErrMsg'];
            } else {
              const route = this.$router.resolve(
                `/Home/${this.$route.params['user']}/FreightForwarding/ROT?jobNo=${this.selectedJob[0]['Job No']}`,
              );
              window.open(route.href, '_blank');
            }
          }
          break;
        case 'Delivery Note':
          if (this.selectedJob.length == 0) {
            this.$showAlert('error', 'No Job Selected', 'Please select a record to load Delivery Note');
          } else {
            const route = this.$router.resolve(
              `/Home/${this.$route.params['user']}/FreightForwarding/Delivery%20Notes?jobNo=${this.selectedJob[0]['Job No']}`,
            );
            window.open(route.href, '_blank');
          }
          break;
      }
    },
    filterChecked: function () {
      if (this.searchFilterChecked) {
        if (!this.selectedSearchBy) {
          this.selectedSearchBy = this.searchFilterItems[0];
        }

        if (!this.selectedCriteria) {
          this.selectedCriteria = this.searchCriteriaItems[2];
        }
      }
    },
    refreshClicked: async function () {
      this.jobsList = [];
      this.searchByError = '';
      this.searchByValueError = '';
      this.showDocUpload = false;
      this.showEJobPopup = false;

      this.tableBoxColumnOrderViewsExp = [];
      this.tableBoxColumnOrderViewsImp = [];
      this.tableBoxColumnOrderIDExp = null;
      this.tableBoxColumnOrderIDImp = null;

      if (this.searchFilterChecked && (!this.selectedSearchBy || !this.searchByValue)) {
        this.searchByError = !this.selectedSearchBy ? 'Please select your search criteria' : '';
        this.searchByValueError = !this.searchByValue ? 'Please enter your search value' : '';
        return;
      }

      const dataToPost = {
        stjobdate: this.dateFilterChecked ? new Date(this.refreshStart).formatString('yyyy-MM-dd') : '',
        edjobdate: this.dateFilterChecked ? new Date(this.refreshEnd).formatString('yyyy-MM-dd') : '',
        jobtype: this.pageType[0],
        searchfield: this.searchFilterChecked ? this.selectedSearchBy['Search Criteria'] : '',
        searchcriteria: this.searchFilterChecked ? this.selectedCriteria['name'] : '',
        searchvalue: this.searchFilterChecked ? this.searchByValue : '',
      };

      if (this.dateFilterChecked && this.searchFilterChecked) {
        this.filterText = `Filter by ${this.selectedSearchBy['Search Criteria']} ${this.selectedCriteria['name']} ${this.searchByValue}, from ${new Date(this.refreshStart).formatString('yyyy-MM-dd')} to ${new Date(this.refreshEnd).formatString('yyyy-MM-dd')}`;
      } else if (this.dateFilterChecked && !this.searchFilterChecked) {
        this.filterText = `Filter by date from ${new Date(this.refreshStart).formatString('yyyy-MM-dd')} to ${new Date(this.refreshEnd).formatString('yyyy-MM-dd')}`;
      } else if (!this.dateFilterChecked && this.searchFilterChecked) {
        this.filterText = `Filter by ${this.selectedSearchBy['Search Criteria']} ${this.selectedCriteria['name']} ${this.searchByValue}`;
      }
      this.showFilterBox = false;

      this.$fullscreenLoading('');
      this.tableLoading = true;
      this.jobsList = await this.$apiCallV2(`/FreightForwarding/GetListJobTracking`, dataToPost);
      if (this.pageType == 'Export') {
        this.injectedReportName = 'Export Jobs';
        const columnOrderIDExp = {
          formname: 'FMS_ExportJob',
          formctrlname: this.injectedReportName,
        };
        if (!this.columnOrderViewsByReportName[this.injectedReportName]) {
          this.columnOrderViewsByReportName[this.injectedReportName] = await this.$apiCallV2(
            '/TableBox/GetColumnOrder',
            columnOrderIDExp,
          );
        }
        this.tableBoxColumnOrderViewsExp = this.columnOrderViewsByReportName[this.injectedReportName];
        this.tableBoxColumnOrderIDExp = columnOrderIDExp;
      } else {
        this.injectedReportName = 'Import Jobs';
        const columnOrderIDImp = {
          formname: 'FMS_ImportJob',
          formctrlname: this.injectedReportName,
        };
        if (!this.columnOrderViewsByReportName[this.injectedReportName]) {
          this.columnOrderViewsByReportName[this.injectedReportName] = await this.$apiCallV2(
            '/TableBox/GetColumnOrder',
            columnOrderIDImp,
          );
        }
        this.tableBoxColumnOrderViewsImp = this.columnOrderViewsByReportName[this.injectedReportName];
        this.tableBoxColumnOrderIDImp = columnOrderIDImp;
      }
      this.tableLoading = false;
      this.$fullscreenLoading();

      this.lastRefreshed = new Date().formatString('yyyy-MM-dd HH:mm');
      this.mainFilterIsOpen = false;

      if (this.prePopulate) {
        const preJobData = this.jobsList.filter((j) => j['Job No'].trim() == this.preJob.trim());
        this.selectedJob = preJobData;
      }
    },
    transportMethodPlaceholders: function (key) {
      if (this.selectedHeaderInfoData['selectedTransMode']) {
        // if selectedObject is NOT null
        const placeholder = this.selectedHeaderInfoData['selectedTransMode'][key];
        if (placeholder) {
          return placeholder;
        }
      }

      switch (
        key // defaults
      ) {
        case 'ShipCallNo':
          return 'Ship Call #';
        case 'VesselID':
          return 'Vessel ID';
        case 'VesselName':
          return 'Vessel Name';
        case 'ShippingAgent':
          return 'Shipping Agent';
        case 'ShipLineCode':
          return 'Shipping Line';
        case 'DemurrageDate':
          return 'Demurrage';
        case 'DetentionDate':
          return 'Detention';
      }
    },
    searchBySelected: function (e) {
      if (e) {
        if (e['Search Criteria'] == 'Required Date') {
          this.selectedCriteria = this.searchCriteriaItems[0];
          this.criteriaDisabled = true;
        } else {
          this.criteriaDisabled = false;
        }
      }
    },

    pageChanges: async function (to) {
      this.showPopup = false;
      this.menuLoading = true;
      this.showDocUpload = false;

      let pageRoute;
      if (to) {
        pageRoute = to.path.split('/');
      } else {
        pageRoute = this.$route.path.split('/');
      }

      //this.pageType = pageRoute[pageRoute.length - 1].split(' ')[0];
      const newPageType = pageRoute[pageRoute.length - 1].split(' ')[0];
      const isChangingJobType = newPageType !== this.pageType;

      this.pageType = newPageType;

      if (isChangingJobType) {
        // if page change import to export or vise versa
        this.jobsList = []; // clear all job list, close right menu, reset all button containers
        this.smkPartJobList = [];
        this.showSMKRightMenu = false;
        this.showSMKDetails = false;
        this.selectedsmkPartJob = [];
        this.clearSMKSideDetails();
      }

      if (isChangingJobType) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.refreshClicked(true); // refresh the job listing
          }, 500);
        });
      }

      this.menu.forEach((m, i) => {
        if (i <= 3) {
          m.title = `${m.title.split(' ')[0]} ${this.pageType} Job`;
        } else if (i == 6) {
          m.title = `Print ${this.pageType} ...`;
        }
      });
      this.tableTitle = `${this.pageType} Jobs`;

      if (to) {
        this.jobsList = [];
        this.smkPartJobList = [];
        this.$nextTick(() => {
          setTimeout(() => {
            this.refreshClicked(true);
          }, 500);
        });
      }

      this.$fullscreenLoading('Checking Security Access');
      const tempsasUpdateContainer = await this.$apiCallV2(
        '/SASControl/GetSASControlAccess?system=FMS&page=Update Container %23',
      ); //%23 = #
      this.sasUpdateContainer = tempsasUpdateContainer.find((f) => (f['Control'] = 'lblAllowEditAfterBilling'));

      let sasControl = [];
      sasControl = await this.$apiCallV2(`/SASControl/GetSASControlAccess?system=FMS&page=${this.pageType} Job`);

      this.menu = this.menu.map((menu) => ({
        ...menu,
        enabled: true,
      }));

      sasControl.forEach((s) => {
        const menu = this.menu.find((m) => m['key'] == s['Control']);
        if (menu) {
          menu[s['Properties'].toLowerCase()] = s['PropertiesValue'] !== 'False';
          menu['message'] = 'Access Denied';
        }
      });

      //SMK SAS Control
      let sasControlSMK = [];
      sasControlSMK = await this.$apiCallV2(`/SASControl/GetSASControlAccess?system=SMK&page=HOME`);
      this.enableSMKmodule = !sasControlSMK.some((x) => x.Control === 'SMK');
      this.setSMKMenuEnabled(true);

      const smkMnuAccess = await this.$apiCallV2(`/SASControl/GetSASControlAccess?system=SMK&page=ROLEMANAGEMENT`);
      this.smkDeniedControls = smkMnuAccess.map((x) =>
        String(x.Control || '')
          .trim()
          .toUpperCase(),
      );

      await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'smkformtype', jobtype: this.pageType[0] }).then(
        (result) => {
          this.headerInfoData['smkFormType'] = result;
        },
      ),
        (this.menuLoading = false);

      this.$fullscreenLoading();
    },
    viewEditClicked: async function (_type, duplicate, duplicateCont, options = {}) {
      const defaultJobNo =
        (
          this.selectedJob.length > 0 // main job no
        ) ?
          (this.selectedJob[0]['Job No'] || '').trim()
        : '';

      const jobno = (options.jobno || defaultJobNo || '').trim(); // if options.jobno is provided, use it (smk part job no); otherwise, use the selected job no
      const duplicatecocode = options.duplicatecocode || '';
      const sourcetable = options.sourcetable || '';
      const isPartJob = sourcetable.toUpperCase() === 'SMKJOB';
      const mainjobno = (options.mainjobno || defaultJobNo || '').trim();
      const mainJobQuery = isPartJob ? `&mainjobno=${encodeURIComponent(mainjobno)}` : '';

      if (!jobno) return;
      if (!duplicate) {
        this.popupTitle += ` ${jobno}`;
      }

      if (!duplicatecocode) {
        this.dpoFlag = '';
      }

      const sourceQuery = sourcetable ? `&sourcetable=${encodeURIComponent(sourcetable)}` : '';

      const dpoQuery = duplicatecocode ? `&duplicatecocode=${encodeURIComponent(duplicatecocode)}` : '';

      this.$fullscreenLoading('Getting Job Details');
      const getJobDetails = await this.$apiCallV2(
        `/FreightForwarding/JobDetails?jobno=${encodeURIComponent(jobno)}${sourceQuery}${mainJobQuery}${dpoQuery}`,
      );
      // const getJobDetails = await this.$apiCallV2(
      //   `/FreightForwarding/JobDetails?jobno=${this.selectedJob[0]['Job No'].trim()}`,
      // );
      //console.log(getJobDetails)
      const details = getJobDetails['JobDetails']['Job'];
      this.editDetails = details;

      if (!duplicate) {
        this.createdBy = `${this.editDetails['Created By'] ? this.editDetails['Created By'].trim() : ''} ${this.editDetails['Created Date'] ? new Date(new Date(this.editDetails['Created Date'])).formatString('dd/MM/yyyy HH:mm') : ''}`;
        this.updatedBy = `${this.editDetails['Updated By'] ? this.editDetails['Updated By'].trim() : ''} ${this.editDetails['Last Update'] ? new Date(new Date(this.editDetails['Last Update'])).formatString('dd/MM/yyyy HH:mm') : ''}`;

        if (!isPartJob) {
          this.$fullscreenLoading('Getting Job Milestones');
          const jobMileStones = await this.$apiCallV2(`/FreightForwarding/JobMilestones?jobno=${jobno}`);
          const milestones = jobMileStones['JobMilestones']['Job']['TAS'];
          const legend = jobMileStones['Legend'];
          this.milestonesItem = {
            milestones: milestones,
            legend: legend,
          };

          this.$fullscreenLoading('Getting Documents');
          const jobDocuments = await this.$apiCallV2(`/FreightForwarding/GetJobDocuments?jobno=${jobno}`);
          this.statusTaskData['statusDocumentListing'] = jobDocuments;
          jobDocuments.forEach((d, index) => {
            // let due = d['Due DateTime'] ? `${d['Due DateTime'].substring(0, 13)}${d['Due DateTime'].substring(13, 15)}` : '';
            const due = d['Due DateTime'] ? d['Due DateTime'] : '';
            // let received = d['Received DateTime'] ? `${d['Received DateTime'].substring(0, 13)}${d['Received DateTime'].substring(13, 15)}` : '';
            const received = d['Received DateTime'] ? d['Received DateTime'] : '';
            const start = d['Start DateTime'] ? d['Start DateTime'] : '';

            this.selectedDocumentInfoData['docData'].push({
              'Doc Code': d['Doc Code'],
              'Doc Ref #': d['Reference No'],
              Attachment: d['AttImageName'],
              Remarks: d['Remarks'],
              Status: d['Status Count'] > 0 ? d['Status Code'] : 'N/A',
              'Start Date': d['Status Count'] > 0 ? start : 'N/A',
              'Received Date': d['Status Count'] > 0 ? received : 'N/A',
              'Due Date': d['Status Count'] > 0 ? due : 'N/A',
              'Assign To': d['Status Count'] > 0 ? d['Assign To'] : 'N/A',
              Sets: d['Status Count'] > 0 ? d['Sets'] : 'N/A',
              Page: d['Status Count'] > 0 ? d['Pages'] : 'N/A',

              documentguid: d['DocumentGUID'],
              statusseqno: '',
              ID: `${d['Doc Code']}-${d['Reference No']}`,
              fileAtt: d['AttImage'],
              filetype: d['AttImageType'],
              Action: '',
              'Row #': index, //id for image viewing
            });
          });

          this.$fullscreenLoading('Getting Delivery Notes');
          this.dnListing = await this.$apiCallV2(`/FreightForwarding/GetDeliveryNoteListing?jobno=${jobno}`);
          this.dnListing = this.dnListing.map((item) => {
            if (item.Remarks && typeof item.Remarks === 'string') {
              // replace all newline characters with <br> only in the Remarks field
              item.Remarks = item.Remarks.replace(/\n/g, '<br>');
            }
            if (item['Goods Description'] && typeof item['Goods Description'] === 'string') {
              item['Goods Description'] = item['Goods Description'].replace(/\n/g, '<br>');
            }
            if (item['Shipping Marks'] && typeof item['Shipping Marks'] === 'string') {
              item['Shipping Marks'] = item['Shipping Marks'].replace(/\n/g, '<br>');
            }
            return item;
          });

          this.dnListing = this.dnListing.map((item) => {
            if (item.Remarks && typeof item.Remarks === 'string') {
              // weishen 20240426 - replace all newline characters with <br> only in the Remarks field
              item.Remarks = item.Remarks.replace(/\n/g, '<br>');
            }
            return item;
          });

          this.$fullscreenLoading('Getting ROTs');
          this.rotListing = await this.$apiCallV2(`/FreightForwarding/GetROTListing?jobno=${jobno}`);

          this.$fullscreenLoading('Getting Status Task');
          // original code:
          // const statusTaskList = await this.$apiCallV2(
          //   `/FreightForwarding/GetStatusTaskList?jobno=${this.selectedJob[0]['Job No'].trim()}`,
          // );
          const statusTaskList = (await this.$apiCallV2(`/FreightForwarding/GetStatusTaskList?jobno=${jobno}`)).filter(
            (s) => s['#'] != '0',
          );
          // unsure why status listing always missing the latest record if we dont filter out the '#' = 0 record
          // hence added .filter((s) => s['#'] != '0');
          // refer StausPage.vue -> statusTask = statusTask.filter(s => s['#'] != '0');

          this.statusTaskData['statusTaskListing'] = this.appendStatusIcon(statusTaskList);
          this.statusTaskData['statusJobNo'] = jobno;

          this.$fullscreenLoading('Getting SMK Jobs');
          this.smkListing = await this.$apiCallV2(`/FreightForwarding/GetSMKJobs?jobno=${jobno}`);
          //console.log(this.smkListing)
          //console.log(details)

          this.$fullscreenLoading('Checking Job');
          const billingCheck = await this.$apiCallV2(`/FreightForwarding/BillingCheckJobNo?jobno=${jobno}`);

          billingCheck.forEach((j) => {
            switch (j['JobNo'].toUpperCase().trim()) {
              case 'INV':
              case 'TMS':
                this.billingCheckDisabled = true;
                break;
            }
          });
        }
      }

      //#region Header Info
      this.selectedHeaderInfoData['selectedTransMode'] =
        details['Trans Mode Desc'] ?
          this.headerInfoData['transMode'].filter((t) => {
            return t['Description'].trim() == details['Trans Mode Desc'].trim();
          })[0]
        : null;
      this.selectedHeaderInfoData['selectedCargoType'] =
        details['Cargo Type'] ?
          this.headerInfoData['cargoType'].filter((t) => {
            return t['Cargo Type'].trim() == details['Cargo Type'].trim();
          })[0]
        : null;
      this.originalCargoType =
        details['Cargo Type'] ?
          this.headerInfoData['cargoType'].filter((t) => {
            return t['Cargo Type'].trim() == details['Cargo Type'].trim();
          })[0]
        : null;
      this.selectedHeaderInfoData['selectedSmkFormType'] =
        details['Form Type'] ?
          this.headerInfoData['smkFormType'].filter((t) => {
            return t['Form Type'].trim() == details['Form Type'].trim();
          })[0]
        : null;
      this.selectedHeaderInfoData['selectedShipper'] =
        details['Shipper'] ?
          this.headerInfoData['shipper'].filter((t) => {
            return t['Shipper Code'].trim() == details['Shipper'].trim();
          })[0]
        : null;
      this.selectedHeaderInfoData['selectedConsignee'] =
        details['Consignee'] ?
          this.headerInfoData['consignee'].filter((t) => {
            return t['Consignee Code'].trim() == details['Consignee'].trim();
          })[0]
        : null;
      this.selectedHeaderInfoData['selectedNotifyParty'] =
        details['Notify Party'] ?
          this.headerInfoData['notifyParty'].filter((t) => {
            return t['Notify Party Code'].trim() == details['Notify Party'].trim();
          })[0]
        : null;

      this.selectedHeaderInfoData['projectNo'] = details['Project No'] ? details['Project No'].trim() : '';
      this.selectedHeaderInfoData['custRefNo'] = details['Cust Ref No'] ? details['Cust Ref No'].trim() : '';
      this.selectedHeaderInfoData['vbkgRefNo'] =
        this.pageType[0] == 'E' ?
          details['Booking Ref No'] ?
            details['Booking Ref No'].trim()
          : ''
        : details['BL No'] ? details['BL No'].trim()
        : '';
      this.selectedHeaderInfoData['selectedBillTo'] =
        details['Bill To'] ?
          this.headerInfoData['billTo'].filter((t) => {
            return t['Customer Code'].trim() == details['Bill To'].trim();
          })[0]
        : null;

      this.selectedHeaderInfoData['selectedQuotationNo'] =
        details['Quotation No'] ?
          this.headerInfoData['quotationNo'].filter((t) => {
            return (
              t['Quotation No'] && details['Quotation No'] && t['Quotation No'].trim() == details['Quotation No'].trim()
            );
          })[0]
        : null;

      this.selectedHeaderInfoData['jobNo'] =
        duplicate && !duplicatecocode ? '**********'
        : details['Job No'] ? details['Job No'].trim()
        : '';
      this.selectedHeaderInfoData['jobTime'] =
        duplicate && !duplicatecocode ? new Date()
        : details['Job Time'] ? new Date(details['Job Time'])
        : null;
      this.selectedHeaderInfoData['requiredDate'] =
        duplicate ? null
        : details['Required Date'] ? new Date(details['Required Date'])
        : null;
      this.selectedHeaderInfoData['jobStatus'] =
        duplicate ? 'New'
        : details['Job State'] ? details['Job State'].trim()
        : '';
      if (this.selectedHeaderInfoData['selectedBillTo']) {
        this.billToSelected(this.selectedHeaderInfoData['selectedBillTo']);
      }

      if (details['Services']) {
        // API returns an object if one service is selected.
        // API returns an array of objects if more than one services is selected
        const servicesArray = Array.isArray(details['Services']) ? details['Services'] : [details['Services']];

        servicesArray.forEach((incomingService) => {
          const extractedService = {
            selected: true,
            item: incomingService['Description'],
            remarks: incomingService['Remarks'],
            data: { Status: incomingService['Status'] },
          };
          this.headerInfoData['services'].forEach((service, index) => {
            if (incomingService.Description === service.item) {
              this.headerInfoData['services'][index] = extractedService;
            }
          });
        });
      }
      const allServices = this.headerInfoData['services'];
      allServices.forEach((s) => {
        s['originalSelected'] = s['selected']; // Set 'originalSelected' to the initial 'selected' state
      });

      // hInfo['milestonesData'] = milestones;
      // hInfo['legendData'] = legend;
      //#endregion

      //#region General Info
      this.selectedGeneralInfoData['vendor'] = details['Vendor'] ? details['Vendor'].trim() : '';
      this.selectedGeneralInfoData['vesselBkgBy'] = details['Vessel Bkg By'] ? details['Vessel Bkg By'].trim() : '';
      this.selectedGeneralInfoData['oriBL'] = details['Original BLs'] ? details['Original BLs'].trim() : '';
      this.selectedGeneralInfoData['nonNegoBL'] = details['Non-Nego BLs'] ? details['Non-Nego BLs'].trim() : '';
      this.selectedGeneralInfoData['selectedFreightType'] =
        details['Freight Type Desc'] ?
          this.generalInfoData['freightTypeList'].filter((t) => {
            return t['Freight Type Desc'].trim() == details['Freight Type Desc'].trim();
          })[0]
        : null;
      this.selectedGeneralInfoData['selectedCountry'] =
        details['Pay Country'] ?
          this.generalInfoData['countryList'].filter((t) => {
            return t['Country Code'].trim() == details['Pay Country'].trim();
          })[0]
        : null;
      this.selectedGeneralInfoData['selectedCurrency'] =
        details['Currency'] ?
          this.generalInfoData['currencyList'].filter((t) => {
            return t['Currency Code'].trim() == details['Currency'].trim();
          })[0]
        : null;
      this.selectedGeneralInfoData['selectedIncoTerms'] =
        details['INCOTerm'] ?
          this.generalInfoData['incoTermsList'].filter((t) => {
            return t['Incoterm'].trim() == details['INCOTerm'].trim();
          })[0]
        : null;
      this.selectedGeneralInfoData['selectedInsurance'] =
        details['Insurance'] ?
          this.generalInfoData['insuranceList'].filter((t) => {
            return t['Insurance'].trim() == details['Insurance'].trim();
          })[0]
        : null;
      this.selectedGeneralInfoData['houseBL'] = details['HBL No'] ? details['HBL No'].trim() : '';
      this.selectedGeneralInfoData['selectedBranch'] =
        details['Branch'] ?
          this.generalInfoData['branchList'].filter((t) => {
            return t['Branch Name'].trim() == details['Branch'].trim();
          })[0]
        : null;
      this.selectedGeneralInfoData['remarks'] = details['Remarks'] ? details['Remarks'].trim() : '';
      this.selectedGeneralInfoData['prevJobNo'] = details['Prev Job No'] ? details['Prev Job No'].trim() : '';

      this.selectedGeneralInfoData['selectedServicePIC'] =
        details['Service PIC'] ?
          this.generalInfoData['servicePICList'].filter((t) => {
            return t['Service Person Code'].trim() == details['Service PIC'].trim();
          })[0]
        : null;
      this.selectedGeneralInfoData['selectedServiceTeam'] =
        details['Service Team'] ?
          this.generalInfoData['serviceTeamList'].filter((t) => {
            return t['Service Team Code'].trim() == details['Service Team'].trim();
          })[0]
        : null;
      this.selectedGeneralInfoData['selectedSalesPIC'] =
        details['Sales PIC'] ?
          this.generalInfoData['salesPICList'].filter((t) => {
            return t['Sales Person Code'].trim() == details['Sales PIC'].trim();
          })[0]
        : null;
      this.selectedGeneralInfoData['selectedSalesTeam'] =
        details['Sales Team'] ?
          this.generalInfoData['salesTeamList'].filter((t) => {
            return t['Sales Team Code'].trim() == details['Sales Team'].trim();
          })[0]
        : null;
      //#endregion

      //#region Shipping Info
      this.selectedShippingInfoData['selectedShipCall'] =
        details['Ship Call No'] ?
          this.shippingInfoData['shipCallNoList'].getSelected(details['Ship Call No'], 'Ship Call No')
        : null;
      if (details['Ship Call No'] && !this.selectedShippingInfoData['selectedShipCall']) {
        this.selectedShippingInfoData['shipCallNoValue'] = details['Ship Call No'];
      }
      this.selectedShippingInfoData['selectedVesselID'] =
        details['Vessel ID'] ?
          this.shippingInfoData['vesselIDList'].filter((t) => {
            return t['Vessel ID'].trim() == details['Vessel ID'].trim();
          })[0]
        : null;
      if (!this.selectedShippingInfoData['selectedVesselID']) {
        this.selectedShippingInfoData['vesselIDValue'] =
          details['Vessel ID'] ? details['Vessel ID'] : details['Vessel Name'] || '';
      }
      this.selectedShippingInfoData['selectedAgentList'] =
        details['Shipping Agt'] ?
          this.shippingInfoData['shippingAgentList'].filter((t) => {
            return t['Agent Code'].trim() == details['Shipping Agt'].trim();
          })[0]
        : null;
      this.selectedShippingInfoData['selectedShippingLine'] =
        details['Shipping Line'] ?
          this.shippingInfoData['shippingLineList'].filter((t) => {
            return t['Agent Code'].trim() == details['Shipping Line'].trim();
          })[0]
        : null;
      this.selectedShippingInfoData['selectedFrtForwarder'] =
        details['Frt Forwarder'] ?
          this.shippingInfoData['frtForwarderList'].getSelected(details['Frt Forwarder'], 'Agent Code')
        : null;
      this.selectedShippingInfoData['selectedFwdgAgent'] =
        details['Forwarding Agent'] ?
          this.shippingInfoData['fwdgAgentList'].getSelected(details['Forwarding Agent'], 'FA Code')
        : null;
      this.selectedShippingInfoData['selectedSpecialTreatment'] =
        details['Special Treatment'] ?
          this.shippingInfoData['specialTreatment'].filter((t) => {
            return t['ST Code'].trim() == details['Special Treatment'].trim();
          })[0]
        : null;
      this.selectedShippingInfoData['selectedStation'] =
        details['Station Code'] ?
          this.shippingInfoData['station'].filter((t) => {
            return t['Station Code'].trim() == details['Station Code'].trim();
          })[0]
        : null;
      this.selectedShippingInfoData['selectedPortOperator'] =
        details['Port Operator'] ?
          this.shippingInfoData['portOperator'].filter((t) => {
            return t['Operator Code'].trim() == details['Port Operator'].trim();
          })[0]
        : null;
      this.selectedShippingInfoData['warehouse'] = details['Warehouse'] ? details['Warehouse'].trim() : null;

      this.selectedShippingInfoData['voyNo'] = details['Voy No'] ? details['Voy No'] : null;
      this.selectedShippingInfoData['selectedPortLoading'] =
        details['Port of Loading'] ?
          this.shippingInfoData['portOfLoading'].filter((t) => {
            return t['Port Code'].trim() == details['Port of Loading'].trim();
          })[0]
        : null;
      this.selectedShippingInfoData['selectedPortDischarge'] =
        details['Port of Discharge'] ?
          this.shippingInfoData['portOfDischarge'].filter((t) => {
            return t['Port Code'].trim() == details['Port of Discharge'].trim();
          })[0]
        : null;
      // this.selectedShippingInfoData['selectedPortDischarge2'] = details['Port of Discharge'] ? this.shippingInfoData['portOfDischarge'].filter((t) => { return t['Port Code'].trim() == details['Port of Discharge'].trim() })[0] : '';
      this.selectedShippingInfoData['selectedFinalDestination'] =
        details['Final Dest'] ?
          this.shippingInfoData['finalDestination'].filter((t) => {
            return t['Port Code'].trim() == details['Final Dest'].trim();
          })[0]
        : null;
      // this.selectedShippingInfoData['demurageTime'] =
      //   details['Demurrage Date'] ? new Date(details['Demurrage Date']) : new Date(details['Free Storage']); // if Demurrage Date is null, take from Free Storage
      this.selectedShippingInfoData['isTranshipment'] = details['Transshipment'] == '1';
      this.selectedShippingInfoData['selectedMVesselID'] =
        details['Mother Vessel Name'] ?
          this.shippingInfoData['vesselIDList'].filter((t) => {
            return t['Vessel ID'].trim() == details['Mother Vessel Name'].trim();
          })[0]
        : null;
      this.selectedShippingInfoData['mVoyNo'] = details['Mother Voy No'] ?? null;
      this.selectedShippingInfoData['selectedPortDischarge2'] =
        details['Transhipment Port'] ?
          this.shippingInfoData['portOfDischarge'].filter((t) => {
            return t['Port Code'].trim() == details['Transhipment Port'].trim();
          })[0]
        : null;
      this.selectedShippingInfoData['ETATime'] = details['POT ETD'] ? new Date(details['POT ETD']) : null;
      // this.selectedShippingInfoData['selectedMVesselID'] = details['Port of Discharge'] ? this.shippingInfoData['portOfDischarge'].filter((t) => { return t['Port Code'].trim() == details['Port of Discharge'].trim() })[0] : '';
      // this.selectedShippingInfoData['mVoyNo'] = details['Port of Discharge'] ? this.shippingInfoData['portOfDischarge'].filter((t) => { return t['Port Code'].trim() == details['Port of Discharge'].trim() })[0] : '';
      // this.selectedShippingInfoData['ETDTime'] = details['Port of Discharge'] ? this.shippingInfoData['portOfDischarge'].filter((t) => { return t['Port Code'].trim() == details['Port of Discharge'].trim() })[0] : '';

      this.selectedShippingInfoData['closingTime'] = details['Closing Time'] ? new Date(details['Closing Time']) : null;
      this.selectedShippingInfoData['polETD'] =
        this.pageType == 'Import' ?
          details['POL ETD'] ?
            new Date(details['POL ETD'])
          : null
        : details['POL ETA'] ? new Date(details['POL ETA'])
        : null;
      this.selectedShippingInfoData['polETA'] = details['POD ETA'] ? new Date(details['POD ETA']) : null;
      this.selectedShippingInfoData['fDestETA'] =
        details['Final Dest ETA Time'] ? new Date(details['Final Dest ETA Time']) : null;
      // this.selectedShippingInfoData['detention'] =
      //   details['Detention Date'] ? new Date(details['Detention Date']) : null;
      this.selectedShippingInfoData['isFumigation'] = details['Fumigation'] == '1';
      this.selectedShippingInfoData['selectedFumigator'] =
        details['JobFumigation'] ?
          this.shippingInfoData['fumigatorList'].getSelected(details['JobFumigation']['Fumigator'], 'Supplier Code')
        : null;
      this.selectedShippingInfoData['selectedLocation'] =
        details['JobFumigation'] ?
          this.shippingInfoData['fumigatorLocationList'].getSelected(
            details['JobFumigation']['Fumigate At'],
            'Destination Code',
          )
        : null;

      if (details['JobFumigation']) {
        const [year1, month1, day1] = details['JobFumigation']['Fumigation Time']
          .split('-')
          .map((datePart) => parseInt(datePart));
        this.selectedShippingInfoData['fumigateTime'] = new Date(year1, month1 - 1, day1);
        const [year2, month2, day2] = details['JobFumigation']['Ventilation Time']
          .split('-')
          .map((datePart) => parseInt(datePart));
        this.selectedShippingInfoData['ventilationTime'] = new Date(year2, month2 - 1, day2);
        this.selectedShippingInfoData['phytoMarking'] =
          details['JobFumigation'] ? details['JobFumigation']['Phytomarking'] : '';
      } else {
        this.selectedShippingInfoData['fumigateTime'] = null;
        this.selectedShippingInfoData['ventilationTime'] = null;
      }

      this.selectedShippingInfoData['goodsDescription'] =
        details['GoodsDesc'] ? details['GoodsDesc'].map((g) => g['GoodsDescription']).join('\n') : '';
      this.selectedShippingInfoData['shippingMarks'] =
        details['ShipMarks'] ? details['ShipMarks'].map((g) => g['ShipMark']).join('\n') : '';

      this.selectedShippingInfoData['freeStorage'] = details['Free Storage Days'];
      this.selectedShippingInfoData['storageUnit'] = details['Storage Unit'] ?? 'D';
      this.selectedShippingInfoData['freeDemurrage'] = details['Free Demurrage Days'];
      this.selectedShippingInfoData['demurrageUnit'] = details['Demurrage Unit'] ?? 'D';
      this.selectedShippingInfoData['freeDetention'] = details['Free Detention Days'];
      this.selectedShippingInfoData['detentionUnit'] = details['Detention Unit'] ?? 'D';
      //#endregion

      //#region Cargo Info
      this.selectedCargoInfoData['gWeight'] =
        details['Gross Weight'] ? this.formatWeightValue(details['Gross Weight']) : this.$weightFormat('0');
      this.selectedCargoInfoData['volume'] =
        details['Volume'] ? this.formatWeightValue(details['Volume']) : this.$weightFormat('0');
      this.selectedCargoInfoData['chargeable'] =
        details['Chargeable'] ? this.formatWeightValue(details['Chargeable']) : this.$weightFormat('0');
      this.selectedCargoInfoData['selectedCommodity'] =
        details['Commodity Code'] ?
          this.cargoInfoData['commodityList'].filter((t) => {
            return t['Commodity Code'].trim() == details['Commodity Code'].trim();
          })[0]
        : null;
      this.selectedCargoInfoData['selectedPMaterial'] =
        details['Packing Material'] ?
          this.cargoInfoData['pMaterialList'].filter((t) => {
            return t['Packing Material Code'].trim() == details['Packing Material'].trim();
          })[0]
        : null;
      this.selectedCargoInfoData['packageCount'] = details['Total Packages'] ? details['Total Packages'] : '';
      this.selectedCargoInfoData['selectedPackageType'] =
        details['Package Code'] ?
          this.cargoInfoData['pkgTypeList'].filter((t) => {
            return t['Package Code'].trim() == details['Package Code'].trim();
          })[0]
        : null;

      if (!duplicate || duplicateCont) {
        if (details['ContDetail']) {
          details['ContDetail'].forEach((c) => {
            this.selectedCargoInfoData['contDetailsList'].push({
              'Cont #': c['Container No'] ? c['Container No'] : '',
              'Old Cont #': c['Container No'] ? c['Container No'] : '',
              'Seal No': c['Seal No'] ? c['Seal No'] : '',
              'Cont Size': c['Size'] ? c['Size'] : '',
              'Old Cont Size': c['Size'] ? c['Size'] : '',
              'Cont Type': c['Cont Type'] ? c['Cont Type'] : '',
              'Old Cont Type': c['Cont Type'] ? c['Cont Type'] : '',
              'Cont Weight': c['Cont Weight'] ? this.$weightFormat(c['Cont Weight']) : '',
              Status:
                c['Cont Status'] ?
                  (this.cargoInfoData['contStatusList'].getSelected(c['Cont Status'], '#')?.['Cont Status'] ?? '')
                : '',
              'Handling Type': c['Handling Type'] ? c['Handling Type'] : '',
              'Old Handling Type': c['Handling Type'] ? c['Handling Type'] : '',
              'Delivery Type': c['Delivery Type'] ? c['Delivery Type'] : '',
              'Old Delivery Type': c['Delivery Type'] ? c['Delivery Type'] : '',
              'SOC/COC': c['Cont Soc Coc'] ? c['Cont Soc Coc'] : '',
              'Send To': c['Send To'] ? c['Send To'] : '',
              Remarks: c['Remarks'] ? c['Remarks'] : '',
              'ROT No': c['ROT No'] ? c['ROT No'] : '',
              ContCharges: c['ContCharges'] ? c['ContCharges'] : '',
              Invoices: c['Invoices'] ? c['Invoices'] : '',
              item_action: duplicateCont ? 'N' : '',
              'Discharge Date': c['Discharge Date'] ?? '',
              'Demurrage Date': c['Demurrage Date'] ?? '',
              'Detention Date': c['Detention Date'] ?? '',
            });
          });
        }
      }
      if (!duplicate) {
        if (details['PackingList']) {
          let packages = [];
          if (Array.isArray(details['PackingList'])) {
            // Has multiple sub package
            packages = details['PackingList'];
          } else {
            // Has one sub package
            packages = [details['PackingList']];
          }

          packages.forEach((p) => {
            const TotalGrossKG =
              p['Total Gross KG'] ? this.$weightFormat(p['Total Gross KG']) : this.$weightFormat('0');
            const PerPkgKG = p['Per Pkg KG'] ? this.$weightFormat(p['Per Pkg KG']) : this.$weightFormat('0');
            const TotalNettKG = p['Total Nett KG'] ? this.$weightFormat(p['Total Nett KG']) : this.$weightFormat('0');
            const PerPkgNettKG =
              p['Per Pkg Nett KG'] ? this.$weightFormat(p['Per Pkg Nett KG']) : this.$weightFormat('0');
            const TotalVolM3 = p['Total Vol M3'] ? this.$weightFormat(p['Total Vol M3']) : this.$weightFormat('0');
            const PerPkgM3 = p['Per Pkg M3'] ? this.$weightFormat(p['Per Pkg M3']) : this.$weightFormat('0');

            const Length = p['Length'] ? this.$weightFormat(p['Length']) : this.$weightFormat('0');
            const Width = p['Width'] ? this.$weightFormat(p['Width']) : this.$weightFormat('0');
            const Height = p['Height'] ? this.$weightFormat(p['Height']) : this.$weightFormat('0');

            this.selectedCargoInfoData['subPkgList'].push({
              'Package Quantity': p['SubPackages Qty'],
              'Package Type': p['SubPackage Code'] ? p['SubPackage Code'] : '',
              Dimensions: `${Length}m X ${Width}m X ${Height}m`,
              'Gross Weight': `${TotalGrossKG}KG (${PerPkgKG}KG)`,
              'Net Weight': `${TotalNettKG}KG (${PerPkgNettKG}KG)`,
              Volume: `${TotalVolM3}M³ (${PerPkgM3}M³)`,
              'Item Code': p['Item Code'] ? p['Item Code'] : '',
              'Packing List #': p['Packing List No'] || '',
              'Invoice #': p['Invoice No'] || '',
              'Container #': p['Container No'] || '',
              Remarks: p['Remarks'] || '',
              item_action: '',
              seq_no: p['SeqNo'] || '',
            });
          });
        }
      }

      if (details['Shipper'] || details['Shipper Name1']) {
        this.shipperAddress = {};
        this.shipperAddress['name'] = details['Shipper Name1'];
        this.shipperAddress['add1'] = details['Shipper Add1'];
        this.shipperAddress['add2'] = details['Shipper Add2'];
        this.shipperAddress['add3'] = details['Shipper Add3'];
        this.shipperAddress['add4'] = details['Shipper Add4'];
        this.shipperAddress['postcode'] = details['Shipper PostCode'];
        this.shipperAddress['city'] = details['Shipper City'];
        this.shipperAddress['state'] = details['Shipper State'];
        this.shipperAddress['country'] = details['Shipper Country'];
        this.shipperAddress['attn'] = details['Shipper Attn'];
        this.shipperAddress['tel'] = details['Shipper Tel'];
        this.shipperAddress['fax'] = details['Shipper Fax'];
        this.shipperAddress['gst'] = details['Shipper GSTNo'];
        this.showShipperAddress = true;
      } else {
        this.shipperAddress = null;
      }

      if (details['Consignee'] || details['Consignee Name1']) {
        this.consigneeAddress = {};
        this.consigneeAddress['name'] = details['Consignee Name1'];
        this.consigneeAddress['add1'] = details['Consignee Add1'];
        this.consigneeAddress['add2'] = details['Consignee Add2'];
        this.consigneeAddress['add3'] = details['Consignee Add3'];
        this.consigneeAddress['add4'] = details['Consignee Add4'];
        this.consigneeAddress['postcode'] = details['Consignee PostCode'];
        this.consigneeAddress['city'] = details['Consignee City'];
        this.consigneeAddress['state'] = details['Consignee State'];
        this.consigneeAddress['country'] = details['Consignee Country'];
        this.consigneeAddress['attn'] = details['Consignee Attn'];
        this.consigneeAddress['tel'] = details['Consignee Tel'];
        this.consigneeAddress['fax'] = details['Consignee Fax'];
        this.consigneeAddress['gst'] = details['Consignee GSTNo'];
        this.showConsigneeAddress = true;
      } else {
        this.consigneeAddress = null;
      }

      if (details['Notify Party'] || details['NParty Name1']) {
        this.notifyPartyAddress = {};
        this.notifyPartyAddress['name'] = details['NParty Name1'];
        this.notifyPartyAddress['add1'] = details['NParty Add1'];
        this.notifyPartyAddress['add2'] = details['NParty Add2'];
        this.notifyPartyAddress['add3'] = details['NParty Add3'];
        this.notifyPartyAddress['add4'] = details['NParty Add4'];
        this.notifyPartyAddress['postcode'] = details['NParty PostCode'];
        this.notifyPartyAddress['city'] = details['NParty City'];
        this.notifyPartyAddress['state'] = details['NParty State'];
        this.notifyPartyAddress['country'] = details['NParty Country'];
        this.notifyPartyAddress['attn'] = details['NParty Attn'];
        this.notifyPartyAddress['tel'] = details['NParty Tel'];
        this.notifyPartyAddress['fax'] = details['NParty Fax'];
        this.notifyPartyAddress['gst'] = details['NParty GSTNo'];
        this.showNPartyAddress = true;
      } else {
        this.notifyPartyAddress = null;
      }
      //#endregion

      this.$fullscreenLoading();

      if (!duplicate) {
        this.$nextTick(() => {
          this.updateMilestoneHeight();
        });
      }

      //smk details
      if (this.enableSMKmodule) {
        await this.populateSMKDetails(details);
      }
    },
    populateSMKDetails: async function (details) {
      const text = (value) => String(value || '').trim();
      const toDate = (value) => (value ? new Date(value) : null);

      const findBy = (list, key, value) => {
        const target = text(value);
        if (!target) return null;

        return (
          (list || []).find((item) => {
            return text(item[key]) === target;
          }) || null
        );
      };
      const getSelectedOrFreeText = ({ list, value, key }) => {
        const savedValue = text(value);

        if (!savedValue) return null;

        const match = (list || []).getSelected ? list.getSelected(savedValue, key) : findBy(list, key, savedValue);

        return match || { [key]: savedValue };
      };
      // #region SMK Job Detail
      const hasSmkInvoice = (this.smkSummaryDetails || []).length > 0;
      const smkDetails = hasSmkInvoice ? this.smkSummaryDetails[0] : {};
      const smkExempt = (this.smkExemptDetails || []).length > 0 ? this.smkExemptDetails[0] : {};
      //console.log(smkExempt);

      this.selectedSmkInfoData['selectedSmkFormType'] = findBy(
        this.headerInfoData['smkFormType'],
        'Form Type',
        details['Form Type'],
      );

      await this.$nextTick();

      const latestSmk = (this.smkSubmissionList || [])
        .filter((s) => text(s['SMK #']))
        .sort((a, b) => {
          const dateA = new Date(a['DateUpdate'] || a['Submit Date Time'] || 0).getTime();
          const dateB = new Date(b['DateUpdate'] || b['Submit Date Time'] || 0).getTime();

          if (dateA !== dateB) return dateB - dateA;

          return Number(text(b['Status Code'])) - Number(text(a['Status Code']));
        })[0];

      this.selectedSmkInfoData['smkNo'] = latestSmk ? text(latestSmk['SMK #']) : '';

      const savedDeclareType = `${smkDetails['TranTypeHasLeadingSpace'] ? ' ' : ''}${String(smkDetails['TranType'] || '').trim()}`;
      this.selectedSmkInfoData['selectedDeclarationType'] =
        (this.filteredDeclarationTypeList || []).find(
          (item) => String(item['Declare Type'] || '').replace(/\s+$/, '') === savedDeclareType,
        ) || null;

      this.selectedSmkInfoData['selectedShipmentType'] = findBy(
        this.smkInfoData['shipmentType'],
        'Code',
        smkDetails['ShipType'],
      );

      this.selectedSmkInfoData['selectedCountryOfOrigin'] = findBy(
        this.generalInfoData['countryList'],
        'Country Code',
        smkDetails['CtryOrigin'],
      );

      this.selectedSmkInfoData['k3Type'] = this.smkK3TypeList.getSelected(smkDetails['K3Type'], 'Code');

      this.selectedSmkInfoData['k3MoveTo'] = this.shippingInfoData['station'].getSelected(
        smkDetails['MoveTo'],
        'Station Code',
      );

      this.selectedSmkInfoData['k8Type'] = this.smkK8TypeList.getSelected(smkDetails['K3Type'], 'Code');

      this.selectedSmkInfoData['movementType'] = this.smkInfoData['movementType'].getSelected(
        smkDetails['MoveType'],
        'Move Type',
      );

      this.selectedSmkInfoData['moveDate'] = toDate(smkDetails['MoveDate']);

      this.selectedSmkInfoData['moveFromStation'] = this.shippingInfoData['station'].getSelected(
        smkDetails['MoveFrStation'],
        'Station Code',
      );

      this.selectedSmkInfoData['moveToStation'] = this.shippingInfoData['station'].getSelected(
        smkDetails['MoveToStation'],
        'Station Code',
      );

      this.selectedSmkInfoData['moveFromWarehouse'] = text(smkDetails['MoveFrWhse']);

      this.selectedSmkInfoData['moveToWarehouse'] = text(smkDetails['MoveToWhse']);

      this.selectedSmkInfoData['k9Warehouse'] = this.smkInfoData['warehouseList'].getSelected(
        smkDetails['K9WhseCode'] || smkDetails['WhseCode'],
        'Warehouse Code',
      );

      this.selectedSmkInfoData['k9WarehouseType'] = this.smkInfoData['warehouseTypeList'].getSelected(
        smkDetails['K9WhseType'] || smkDetails['WhseType'],
        'Warehouse Type',
      );

      this.selectedSmkInfoData['k9Station'] = this.shippingInfoData['station'].getSelected(
        smkDetails['K9Stt'] || smkDetails['Stt'],
        'Station Code',
      );

      this.selectedSmkInfoData['k9License'] = text(smkDetails['K9License'] || smkDetails['License']);

      this.selectedSmkInfoData['k9LicenseDate'] = toDate(smkDetails['K9LicenseDate'] || smkDetails['LicenseDate']);

      this.selectedSmkInfoData['k9DepositDate'] = toDate(smkDetails['K9DepDate'] || smkDetails['DepDate']);

      this.selectedSmkInfoData['k9DepositReceipt'] = text(smkDetails['K9DepRecpt'] || smkDetails['DepRecpt']);

      // #endregion
      // #region Exemption / Clause / Documents
      this.filterSMKlist();

      this.selectedSmkInfoData['exemptNoTreasury'] = getSelectedOrFreeText({
        list: this.smkInfoData['exemptNoListTE'],
        value: smkExempt['TERefNo'],
        key: 'Exemption No',
      });
      this.selectedSmkInfoData['exemptTypeTreasury'] = findBy(
        this.smkInfoData['exemptTypeListTE'],
        'Type',
        smkExempt['TEType'],
      );
      this.selectedSmkInfoData['expiryDateTE'] = toDate(smkExempt['TEExpiryDate']);

      this.selectedSmkInfoData['exemptNoSalesTax'] = getSelectedOrFreeText({
        list: this.smkInfoData['exemptNoListST'],
        value: smkExempt['STRefNo'],
        key: 'Exemption No',
      });
      this.selectedSmkInfoData['exemptTypeSalesTax'] = findBy(
        this.smkInfoData['exemptTypeListST'],
        'Type',
        smkExempt['STType'],
      );
      this.selectedSmkInfoData['registrationDateST'] = toDate(smkExempt['STRegDate']);
      this.selectedSmkInfoData['stationCode'] = text(smkExempt['STStationCode']);
      this.selectedSmkInfoData['expiryDateST'] = toDate(smkExempt['STExpiryDate']);

      this.selectedSmkInfoData['exemptNoSpecialTreatment'] = getSelectedOrFreeText({
        list: this.smkInfoData['exemptNoListAP'],
        value: smkExempt['APRefNo'],
        key: 'Exemption No',
      });
      this.selectedSmkInfoData['exemptTypeSpecialTreatment'] = findBy(
        this.smkInfoData['exemptTypeListAP'],
        'Type',
        smkExempt['APType'],
      );

      this.selectedSmkInfoData['claimentName'] = smkExempt['CMName'] || '';
      this.selectedSmkInfoData['claimentCompany'] = smkExempt['CMCompany'] || '';
      this.selectedSmkInfoData['claimentStatus'] = smkExempt['CMStatus'] || '';
      this.selectedSmkInfoData['claimentNRIC'] = smkExempt['CMNRIC'] || '';

      const smkClause = (this.smkExempClause || []).length > 0 ? this.smkExempClause[0] : {};
      this.selectedSmkInfoData['clauseCode'] = findBy(
        this.smkInfoData['clauseList'],
        'Clause Code',
        smkClause['ClauseCode'],
      );

      await this.$nextTick();
      this.clauseCodeSelected();

      //#endregion
      //#region Invoice Details

      const findQualifier = (value, port = false) => {
        const qualifier = inputText(value);
        const list = port ? this.smkPortQualifierList : this.smkInvoiceQualifierList;

        return list.find((x) => x.Qualifier === qualifier) || null;
      };

      const findCurrency = (value) => {
        const currency = inputText(value);

        return (
          (this.generalInfoData['currencyList'] || []).find((x) => inputText(x['Currency Code']) === currency) || null
        );
      };

      const findInvoiceType = (type, allowPercentage = true) => {
        const savedType = text(type);

        if (!savedType) return null;
        if (savedType === '%' && !allowPercentage) return null;

        // Old 4G records stored "$".
        // In 6G, display the actual selected currency code.
        const displayType = savedType === '$' ? text(smkDetails['ExCode']) : savedType;

        return (
          this.smkInvoiceTypeList.find((item) => {
            return text(item['Currency Code']) === displayType;
          }) || null
        );
      };

      const inputText = (value, fallback = '') => {
        // turn number to string
        if (value === null || value === undefined || value === '') return fallback;
        return String(value);
      };

      const amountText = (value) => inputText(value, '0.00'); // 0 if empty

      this.selectedSmkInfoData['invoiceTypeFreight'] = findInvoiceType(smkDetails['FrtType']);
      this.selectedSmkInfoData['invoiceTypeInsurance'] = findInvoiceType(smkDetails['InsType']);
      this.selectedSmkInfoData['invoiceTypeUplift'] = findInvoiceType(smkDetails['UplType']);
      this.selectedSmkInfoData['invoiceTypeBuyingComm'] = findInvoiceType(smkDetails['BCType']);
      this.selectedSmkInfoData['invoiceTypePortCharges'] = findInvoiceType(smkDetails['PCType']);
      this.selectedSmkInfoData['invoiceTypeDiscount'] = findInvoiceType(smkDetails['DCType']);
      this.selectedSmkInfoData['invoiceTypeOther'] = findInvoiceType(smkDetails['OthType']);
      this.selectedSmkInfoData['invoiceTypeAmount'] = findInvoiceType(smkDetails['TtlType']);

      this.selectedSmkInfoData['amountFreight'] = amountText(smkDetails['FrtAmt']);
      this.selectedSmkInfoData['qualifierFreight'] = findQualifier(smkDetails['FrtQlf']);

      this.selectedSmkInfoData['amountInsurance'] = amountText(smkDetails['InsAmt']);
      this.selectedSmkInfoData['qualifierInsurance'] = findQualifier(smkDetails['InsQlf']);

      this.selectedSmkInfoData['amountUplift'] = amountText(smkDetails['UplAmt']);
      this.selectedSmkInfoData['qualifierUplift'] = findQualifier(smkDetails['UplQlf']);

      this.selectedSmkInfoData['amountBuyingComm'] = amountText(smkDetails['BCAmt']);
      this.selectedSmkInfoData['qualifierBuyingComm'] = findQualifier(smkDetails['BCQlf']);

      this.selectedSmkInfoData['amountPortCharges'] = amountText(smkDetails['PCAmt']);
      this.selectedSmkInfoData['qualifierPortCharges'] = findQualifier(smkDetails['PCQlf'], true);

      this.selectedSmkInfoData['amountDiscount'] = amountText(smkDetails['DCAmt']);
      this.selectedSmkInfoData['qualifierDiscount'] = findQualifier(smkDetails['DCQlf']);

      this.selectedSmkInfoData['amountOther'] = amountText(smkDetails['OthAmt']);
      this.selectedSmkInfoData['qualifierOther'] = findQualifier(smkDetails['OthQlf']);

      this.selectedSmkInfoData['amountAmount'] = amountText(smkDetails['TtlAmt']);
      this.selectedSmkInfoData['qualifierAmount'] = findQualifier(smkDetails['TtlQlf']);

      this.selectedSmkInfoData['currency1'] = findCurrency(smkDetails['ExCode']);
      this.selectedSmkInfoData['exchangeRate1'] = inputText(smkDetails['ExRate']);
      this.selectedHeaderInfoData['exchangeRateDate1'] = toDate(smkDetails['EXDate']);

      const freightCurrencyRow = (this.smkFreightCurrencyDetails || [])[0];

      if (freightCurrencyRow && freightCurrencyRow.Remarks) {
        const parts = String(freightCurrencyRow.Remarks)
          .split('*')
          .map((value) => value.trim());

        if (parts.length >= 5 && parts[0] && Number(parts[2]) > 0) {
          this.selectedSmkInfoData['invoiceTypeFreight'] = findInvoiceType(parts[0]);

          this.selectedSmkInfoData['amountFreight'] = inputText(parts[1], '0.00');

          this.selectedSmkInfoData['freightForeignRate'] = inputText(parts[2]);

          const dateParts = parts[3].split('/');

          this.selectedSmkInfoData['freightForeignDate'] =
            dateParts.length === 3 ?
              new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0]))
            : null;

          this.selectedSmkInfoData['freightAmountMYR'] = inputText(parts[4], '0.00');
        }
      } else {
        this.selectedSmkInfoData['freightForeignRate'] = '';
        this.selectedSmkInfoData['freightForeignDate'] = null;
        this.selectedSmkInfoData['freightAmountMYR'] = '';
      }

      if (!hasSmkInvoice) {
        this.setNewSmkInvoiceDefaults(); // set Invoice Details default
      }

      //#endregion
    },
    formatWeightValue: function (value) {
      // to format value to weight format with decimals and remove the separator to avoid issues
      if (value) {
        if (typeof value === 'number') {
          value = value.toString();
        }
        value = value.replaceAll(',', '');
        return this.$weightFormat(value).replaceAll(',', '');
      }
      return this.$weightFormat('0');
    },
    //#region delete popup
    deletePopupButtonClicked: async function (buttonText) {
      if (buttonText === 'Cancel') {
        this.deleteRemarks = '';
        this.deleteRemarksError = '';
        this.showDeletePopup = false;
        return;
      }

      if (buttonText !== 'Delete') return;

      const reason = String(this.deleteRemarks || '').trim();
      if (!reason) {
        this.deleteRemarksError = 'Please enter your reason to delete';
        return;
      }

      const isPartJob = this.deleteTarget === 'PART';
      const mainJobNo = this.getSelectedMainJobNo();
      const partJobNo = this.getSelectedPartJobNo();
      const jobNo = isPartJob ? partJobNo : mainJobNo;

      if (!mainJobNo || (isPartJob && !partJobNo)) {
        this.$showAlert('error', 'No Job Selected', 'Please select a job to delete.');
        return;
      }

      const confirmed = await this.$showAlert(
        'warning',
        isPartJob ? 'Delete Part Job' : 'Delete Job',
        `Are you sure you want to delete ${jobNo}?`,
        [{ text: 'Delete' }, { text: 'No' }],
      );

      if (confirmed !== 'Delete') return;

      try {
        this.$fullscreenLoading('Deleting Job');

        const result =
          isPartJob ?
            await this.$apiCallV2('/FreightForwarding/DeleteSMKPartJob', {
              mainjobno: mainJobNo,
              smkjobno: partJobNo,
              userid: this.userid,
              reason,
              // Add cocode here if $apiCallV2 does not inject it.
            })
          : await this.$apiCallV2(
              `/FreightForwarding/DeleteFrtFwdJob` +
                `?reason=${encodeURIComponent(reason)}` +
                `&jobno=${encodeURIComponent(mainJobNo)}`,
            );

        const row = Array.isArray(result) ? result[0] : result;

        if (!row || Number(row.Results) !== 0) {
          this.$showAlert('error', 'Not Deleted', row?.ErrMsg || 'Unable to delete the job.');
          return;
        }

        this.showDeletePopup = false;
        this.deleteRemarks = '';
        this.deleteRemarksError = '';

        if (isPartJob) {
          this.selectedsmkPartJob = [];
          this.clearSMKSideDetails();
          await this.loadSMKDetailsForSelection('JOB');
          await this.tableBoxRowSelected(this.selectedJob[0], true, 'JOB');
        } else {
          await this.refreshClicked(true);
        }

        this.$showAlert('success', 'Deleted!', `Job ${jobNo} was successfully deleted.`);
      } catch (error) {
        this.$showAlert('error', 'Not Deleted', error?.message || 'Unable to delete the job.');
      } finally {
        this.$fullscreenLoading();
      }
    },

    clearPopupData: function () {
      this.viewMode = false;
      this.billingCheckDisabled = false;

      Object.keys(this.selectedHeaderInfoData).forEach((k) => {
        this.selectedHeaderInfoData[k] = null;
      });
      Object.keys(this.selectedGeneralInfoData).forEach((k) => {
        this.selectedGeneralInfoData[k] = null;
      });
      Object.keys(this.selectedShippingInfoData).forEach((k) => {
        this.selectedShippingInfoData[k] = null;
      });
      //#region Selected Cargo Info Data
      this.selectedCargoInfoData['gWeight'] = this.$weightFormat('0'); // default these to 0 because if saved empty it will be 0
      this.selectedCargoInfoData['volume'] = this.$weightFormat('0');
      this.selectedCargoInfoData['chargeable'] = this.$weightFormat('0');

      this.selectedCargoInfoData['selectedCommodity'] = null;
      this.selectedCargoInfoData['selectedPMaterial'] = null;
      this.selectedCargoInfoData['packageCount'] = null;
      this.selectedCargoInfoData['selectedPackageType'] = null;

      this.selectedCargoInfoData['subPkgList'] = [];
      this.selectedCargoInfoData['selectedSubPkgs'] = null;
      this.selectedCargoInfoData['deletedSubPkg'] = [];
      this.selectedCargoInfoData['contDetailsList'] = [];
      this.selectedCargoInfoData['selectedContDetails'] = null;
      this.selectedCargoInfoData['deletedContDetails'] = [];
      //#endregion

      this.selectedDocumentInfoData['docData'] = [];
      this.selectedDocumentInfoData['selectedDoc'] = [];
      if (this.headerInfoData['services']) {
        this.headerInfoData['services'].forEach((s) => {
          s['selected'] = false;
          s['remarks'] = '';
        });
      }

      Object.keys(this.errorMessages).forEach((k) => {
        this.errorMessages[k] = '';
      });

      this.sMessages = [];
      this.eMessages = [];
      this.rMessages = [];

      this.documentsToDelete = [];
      this.editDeleteDoc = [];
      this.editAddDoc = [];

      this.milestonesItem = null;
      this.showMilestones = true;

      this.tabsItems[6]['disabled'] = true;
      this.tabsItems[7]['disabled'] = true;
      this.tabsItems[8]['disabled'] = true;

      this.dnListing = [];
      this.rotListing = [];
      this.statusTaskListing = [];
      this.smkListing = [];
      this.originalCargoType = [];
      this.originalSMKFormType = '';
      const keepSMKPartJobTable =
        this.enableSMKmodule && (this.selectedJob || []).length > 0 && (this.smkPartJobList || []).length > 0;

      this.resetSMKFormData(!keepSMKPartJobTable);

      if (keepSMKPartJobTable) {
        this.showSMKDetails = true;
      } else {
        this.showSMKDetails = false;
        this.selectedsmkPartJob = [];
      }

      this.smkPartJobContext = {
        isPartJob: false,
        mainJobNo: '',
        smkJobNo: '',
        sourceTable: '',
      };

      this.editDetails = null;

      this.currentTabIndex = 1;

      this.showShipperAddress = false;
      this.showConsigneeAddress = false;
      this.showNPartyAddress = false;

      this.shipperAddress = null;
      this.consigneeAddress = null;
      this.notifyPartyAddress = null;

      this.selectedShippingInfoData['freeStorage'] = '';
      this.selectedShippingInfoData['storageUnit'] = 'D';
      this.selectedShippingInfoData['freeDemurrage'] = '';
      this.selectedShippingInfoData['demurrageUnit'] = 'D';
      this.selectedShippingInfoData['freeDetention'] = '';
      this.selectedShippingInfoData['detentionUnit'] = 'D';

      this.edittingDetails = false;

      this.documentInfoData['updatePopup'] = false;

      this.$apiCallV2('/FreightForwarding/GetQuotationListing', {}).then((result) => {
        this.headerInfoData['quotationNo'] = result; // reset the listing
      });
    },

    billToSelected: async function (e) {
      if (!e) {
        this.$fullscreenLoading('Loading');

        this.selectedHeaderInfoData['billToDetails'] = null;
        await this.$apiCallV2('/FreightForwarding/GetQuotationListing', {}).then((result) => {
          this.headerInfoData['quotationNo'] = result; // reset the listing

          this.$fullscreenLoading();
        });
        return;
      }
      this.$fullscreenLoading('Loading');

      const getOutstanding = await this.$apiCallV2(
        `/FreightForwarding/GetAROutstanding?cust=${encodeURIComponent(e['Customer Code'].trim())}&jobdate=${this.selectedHeaderInfoData['jobTime']?.formatString('yyyy-MM-dd') ?? ''}`,
      );
      const details = getOutstanding[0];

      this.selectedHeaderInfoData['billToDetails'] = {};
      this.selectedHeaderInfoData['billToDetails']['creditLimit'] = details['CreditLimit'];
      this.selectedHeaderInfoData['billToDetails']['creditTerms'] =
        `${details['CreditTerm']} ${details['CreditTypeDesc'] ? details['CreditTypeDesc'].trim() : ''}`;
      this.selectedHeaderInfoData['billToDetails']['status'] = {
        text: details['CusStatus'],
        color: details['CusStatusColor'],
      };
      this.selectedHeaderInfoData['billToDetails']['outstanding'] = {
        perc: details['PerOutstanding'],
        color: details['PerOutstandingColor'],
        value: details['Outstanding'],
      };
      this.selectedHeaderInfoData['billToDetails']['currency'] = details['Currency'] ? details['Currency'].trim() : '';

      if (details['errMsg']) {
        await this.$showAlert(
          'error',
          'Credit Outstanding',
          `<div style="text-align: left">${details['errMsg']}</div>`,
        );
        this.selectedHeaderInfoData['selectedBillTo'] = null;
        this.selectedHeaderInfoData['billToDetails'] = null;
        this.$refs['billToInput'].setFocus();
      }
      await this.$apiCallV2('/FreightForwarding/GetQuotationListing', {
        billingcustno: e['Customer Code'],
        custno:
          this.pageType == 'Import' ?
            this.selectedHeaderInfoData['selectedConsignee']?.['Consignee Code'] || null
          : this.selectedHeaderInfoData['selectedShipper']?.['Shipper Code'] || null,
      }).then((result) => {
        this.headerInfoData['quotationNo'] = result; // get listing based on billing cust no
      });

      this.$fullscreenLoading();
    },

    //#region Cargo Info Tab Methods
    addContainerClicked: function () {
      this.clearContainerPopupData();
      this.clearContainerPopupError();
      this.cargoInfoContainerData['containerEditIndex'] = -1;

      this.cargoInfoContainerData['popupButtonList'] = [
        { text: 'Add Container' },
        { text: 'Cancel', textColor: 'white', color: 'gray' },
      ];
      this.cargoInfoContainerData['showContainerPopup'] = true;
      this.$nextTick(() => {
        if (this.pageType == 'Import') {
          this.cargoInfoContainerData['selectedCategory'] = { desc: 'Cont/Seal #' };
        } else {
          this.cargoInfoContainerData['selectedCategory'] = { desc: 'Container Required' };
        }
      });
    },
    editContainerClicked: function () {
      if (this.selectedCargoInfoData['selectedContDetails'].length == 0) {
        this.$showAlert('error', 'No Container Selected', 'Please select at least 1 container to edit');
      } else {
        this.clearContainerPopupData();
        this.clearContainerPopupError();

        const selected = JSON.parse(JSON.stringify(this.selectedCargoInfoData['selectedContDetails'][0]));
        //delete selected['_rowid']; //object have rowid which need to be deleted for comparing below
        // console.log(selected) // weishen 25/10/2024 - removed above code because its causing error. contDetailsList have '_rowid' as well. no need to delete selected['_rowid'].
        // console.log(this.selectedCargoInfoData['contDetailsList'])
        this.cargoInfoContainerData['containerEditIndex'] = this.selectedCargoInfoData['contDetailsList'].findIndex(
          (cd) => JSON.stringify(cd) == JSON.stringify(selected),
        );
        // console.log(this.cargoInfoContainerData['containerEditIndex'])
        this.cargoInfoContainerData['popupButtonList'] = [
          { text: 'Edit Container' },
          { text: 'Cancel', textColor: 'white', color: 'gray' },
        ];
        this.cargoInfoContainerData['showContainerPopup'] = true;

        this.cargoInfoContainerData['selectedCategory'] = { desc: 'Cont/Seal #' };
        this.cargoInfoContainerData['contQty'] = '';
        this.cargoInfoContainerData['contNo'] = this.selectedCargoInfoData['selectedContDetails'][0]['Cont #'] || '';
        this.cargoInfoContainerData['oldcontNo'] =
          this.selectedCargoInfoData['selectedContDetails'][0]['Old Cont #'] || '';
        this.cargoInfoContainerData['sealNo'] = this.selectedCargoInfoData['selectedContDetails'][0]['Seal No'] || '';
        this.cargoInfoContainerData['oldsealNo'] =
          this.selectedCargoInfoData['selectedContDetails'][0]['Old Seal No'] || '';
        this.cargoInfoContainerData['contSelectedSize'] = this.cargoInfoData['contSizeList'].getSelected(
          this.selectedCargoInfoData['selectedContDetails'][0]['Cont Size'],
          'Size',
        );
        this.cargoInfoContainerData['contoldSelectedSize'] = this.cargoInfoData['contSizeList'].getSelected(
          this.selectedCargoInfoData['selectedContDetails'][0]['Old Cont Size'],
          'Size',
        );
        this.cargoInfoContainerData['contSelectedType'] = this.cargoInfoData['contTypeList'].getSelected(
          this.selectedCargoInfoData['selectedContDetails'][0]['Cont Type'],
          'Cont Type',
        );
        this.cargoInfoContainerData['contoldSelectedType'] = this.cargoInfoData['contTypeList'].getSelected(
          this.selectedCargoInfoData['selectedContDetails'][0]['Old Cont Type'],
          'Cont Type',
        );
        this.cargoInfoContainerData['contSelectedStatus'] = this.cargoInfoData['contStatusList'].getSelected(
          this.selectedCargoInfoData['selectedContDetails'][0]['Status'],
          'Cont Status',
        );
        this.cargoInfoContainerData['contWeight'] =
          this.selectedCargoInfoData['selectedContDetails'][0]['Cont Weight'] ?
            this.selectedCargoInfoData['selectedContDetails'][0]['Cont Weight'].replaceAll(',', '')
          : this.$weightFormat('0');
        this.cargoInfoContainerData['contSelectedHdgType'] = this.cargoInfoData['contHandlingTypeList'].getSelected(
          this.selectedCargoInfoData['selectedContDetails'][0]['Handling Type'],
          'Handling Type',
        );
        this.cargoInfoContainerData['contoldSelectedHdgType'] = this.cargoInfoData['contHandlingTypeList'].getSelected(
          this.selectedCargoInfoData['selectedContDetails'][0]['Old Handling Type'],
          'Handling Type',
        );
        this.cargoInfoContainerData['contSelectedDelType'] = this.cargoInfoData['contDeliveryTypeList'].getSelected(
          this.selectedCargoInfoData['selectedContDetails'][0]['Delivery Type'],
          'Delivery Type',
        );
        this.cargoInfoContainerData['contoldSelectedDelType'] = this.cargoInfoData['contDeliveryTypeList'].getSelected(
          this.selectedCargoInfoData['selectedContDetails'][0]['Old Delivery Type'],
          'Delivery Type',
        );
        this.cargoInfoContainerData['contSelectedSendTo'] = this.cargoInfoData['contSendToList'].getSelected(
          this.selectedCargoInfoData['selectedContDetails'][0]['Send To'],
          'Destination Code',
        );
        this.cargoInfoContainerData['contSocCoc'] = this.cargoInfoData['soccocTypeList'].getSelected(
          this.selectedCargoInfoData['selectedContDetails'][0]['SOC/COC'],
          'SOCCOC Type',
        );
        this.cargoInfoContainerData['contRemarks'] = this.selectedCargoInfoData['selectedContDetails'][0]['Remarks'];
        this.cargoInfoContainerData['rotno'] = this.selectedCargoInfoData['selectedContDetails'][0]['ROT No'];
        this.cargoInfoContainerData['contcharges'] =
          this.selectedCargoInfoData['selectedContDetails'][0]['ContCharges'];
        this.cargoInfoContainerData['invoices'] = this.selectedCargoInfoData['selectedContDetails'][0]['Invoices'];
        this.cargoInfoContainerData['updateType'] = this.selectedCargoInfoData['selectedContDetails'][0]['UpdateType'];
      }
    },
    addEditContainerClicked: async function (e) {
      if (e == 'Cancel') {
        this.cargoInfoContainerData['showContainerPopup'] = false;
        return;
      }

      //#region Compulsory field check
      let errorCount = 0;
      if (!this.cargoInfoContainerData['selectedCategory']) {
        this.cargoInfoContainerData['selectedCategoryError'] = 'Cateogry is required!';
        errorCount++;
      }
      if (
        !this.cargoInfoContainerData['contQty'] && this.cargoInfoContainerData['selectedCategory'] ?
          this.cargoInfoContainerData['selectedCategory']['desc'] == 'Container Required'
        : false
      ) {
        this.cargoInfoContainerData['contQtyError'] = 'Container Quantity is required!';
        errorCount++;
      }
      if (
        !this.cargoInfoContainerData['contNo'] && this.cargoInfoContainerData['selectedCategory'] ?
          this.cargoInfoContainerData['selectedCategory']['desc'] == 'Cont/Seal #'
        : false
      ) {
        this.cargoInfoContainerData['contNoError'] = 'Container No is required!';
        errorCount++;
      }
      if (!this.cargoInfoContainerData['contSelectedSize']) {
        this.cargoInfoContainerData['contSelectedSizeError'] = 'Container Size is required!';
        errorCount++;
      }
      if (!this.cargoInfoContainerData['contSelectedType']) {
        this.cargoInfoContainerData['contSelectedTypeError'] = 'Container Type is required!';
        errorCount++;
      }
      if (!this.cargoInfoContainerData['contSelectedHdgType']) {
        this.cargoInfoContainerData['contSelectedHdgTypeError'] = 'Handling Type is required!';
        errorCount++;
      }
      if (!this.cargoInfoContainerData['contSelectedDelType']) {
        this.cargoInfoContainerData['contSelectedDelTypeError'] = 'Delivery Type is required!';
        errorCount++;
      }
      if (!this.cargoInfoContainerData['contSocCoc']) {
        this.cargoInfoContainerData['contSocCocError'] = 'SOC/COC is required!';
        errorCount++;
      }
      //#endregion

      if (errorCount > 0) {
        return;
      }

      const newDataList = [];
      const newData = {
        'Cont #': this.cargoInfoContainerData['contNo'] || '',
        'Old Cont #': e == 'Add Container' ? '' : this.cargoInfoContainerData['oldcontNo'] || '',
        'Seal No': this.cargoInfoContainerData['sealNo'] || '',
        'Old Seal No': e == 'Add Container' ? '' : this.cargoInfoContainerData['oldsealNo'] || '',
        'Cont Size':
          this.cargoInfoContainerData['contSelectedSize'] ?
            this.cargoInfoContainerData['contSelectedSize']['Size']
          : '',
        'Old Cont Size':
          e == 'Add Container' ? ''
          : this.cargoInfoContainerData['contoldSelectedSize'] ?
            this.cargoInfoContainerData['contoldSelectedSize']['Size']
          : '',
        'Cont Type':
          this.cargoInfoContainerData['contSelectedType'] ?
            this.cargoInfoContainerData['contSelectedType']['Cont Type']
          : '',
        'Old Cont Type':
          e == 'Add Container' ? ''
          : this.cargoInfoContainerData['contoldSelectedType'] ?
            this.cargoInfoContainerData['contoldSelectedType']['Cont Type']
          : '',
        'Cont Weight':
          this.cargoInfoContainerData['contWeight'] ?
            this.$weightFormat(this.cargoInfoContainerData['contWeight'])
          : this.$weightFormat('0'),
        Status:
          this.cargoInfoContainerData['contSelectedStatus'] ?
            this.cargoInfoContainerData['contSelectedStatus']['Cont Status']
          : '',
        'Handling Type':
          this.cargoInfoContainerData['contSelectedHdgType'] ?
            this.cargoInfoContainerData['contSelectedHdgType']['Handling Type']
          : '',
        'Old Handling Type':
          this.cargoInfoContainerData['contoldSelectedHdgType'] ?
            this.cargoInfoContainerData['contoldSelectedHdgType']['Handling Type']
          : '',
        'Delivery Type':
          this.cargoInfoContainerData['contSelectedDelType'] ?
            this.cargoInfoContainerData['contSelectedDelType']['Delivery Type']
          : '',
        'Old Delivery Type':
          this.cargoInfoContainerData['contoldSelectedDelType'] ?
            this.cargoInfoContainerData['contoldSelectedDelType']['Delivery Type']
          : '',
        'Send To':
          this.cargoInfoContainerData['contSelectedSendTo'] ?
            this.cargoInfoContainerData['contSelectedSendTo']['Destination Code']
          : '',
        'SOC/COC':
          this.cargoInfoContainerData['contSocCoc'] ? this.cargoInfoContainerData['contSocCoc']['SOCCOC Type'] : '',
        Remarks: this.cargoInfoContainerData['contRemarks'] || '',
        'ROT No': this.cargoInfoContainerData['rotno'] || '',
        ContCharges: this.cargoInfoContainerData['contcharges'] || '',
        Invoices: this.cargoInfoContainerData['Invoices'] || '',
        UpdateType: '',
      };

      const temp = this.selectedCargoInfoData['contDetailsList'];

      if (e == 'Add Container') {
        const loopCount =
          this.cargoInfoContainerData['selectedCategory']['desc'] == 'Container Required' ?
            Number(this.cargoInfoContainerData['contQty'])
          : 1;
        for (let x = 0; x < loopCount; x++) {
          newDataList.push(JSON.parse(JSON.stringify(newData)));
        }
        newDataList.forEach((d) => (d['item_action'] = 'N'));
      } else if (e == 'Edit Container') {
        //check for container #, size, seal # (FMS Update Container only check container #, seal #, size)

        //#region UpdateType
        //checking on if updatetype is 1 or 2 or 3.
        //1 = update container #, seal #, size only.
        //2 = update size, type, delivery, handling only. Charges involved
        //3 = update all. Charges Invloved.
        let containerUpdateType = 0; //no cont update
        if (this.cargoInfoContainerData['contNo'] != this.cargoInfoContainerData['oldcontNo']) containerUpdateType = 1;
        if (this.cargoInfoContainerData['sealNo'] != this.cargoInfoContainerData['oldsealNo']) containerUpdateType = 1;
        const sizeDiff = newData['Cont Size'] != newData['Old Cont Size'];
        if (sizeDiff)
          //check if true or false
          containerUpdateType = 1;
        const typeDiff = newData['Cont Type'] != newData['Old Cont Type'];
        if (typeDiff)
          //check if true or false
          containerUpdateType = containerUpdateType == 1 ? 3 : 2;
        const deliveryDiff = newData['Delivery Type'] != newData['Old Delivery Type'];
        if (deliveryDiff)
          //check if true or false
          containerUpdateType = containerUpdateType == 1 ? 3 : 2;
        const handlingDiff = newData['Handling Type'] != newData['Old Handling Type'];
        if (handlingDiff)
          //check if true or false
          containerUpdateType = containerUpdateType == 1 ? 3 : 2;
        //#endregion

        if (containerUpdateType != 0) {
          if (this.cargoInfoContainerData['rotno']) {
            const confirmEdit = await this.$showAlert(
              'warning',
              'Edit Container',
              `Container No already associated with a CMR NO(${this.cargoInfoContainerData['rotno']}). Do you want to continue edit?`,
              [
                { text: 'Edit', color: 'green', textColor: 'white' },
                { text: 'Cancel', color: 'gray', textColor: 'white' },
              ],
            );

            if (confirmEdit == 'Cancel') {
              return;
            }
          }

          if (this.cargoInfoContainerData['contcharges'] > 0) {
            if (
              this.userRole['Role ID'].trim().toLowerCase() == this.updateContNoRole.trim().toLowerCase() ||
              (!this.sasUpdateContainer && containerUpdateType == 1)
            ) {
              // if (updateContNoRole == 'yes') { //temporary. need to change to if (currentuserroleid == updatecontnorole)
              const confirmEdit = await this.$showAlert(
                'warning',
                'Edit Container',
                `There are charges already invoiced for container(${this.cargoInfoContainerData['oldcontNo']}). Do you want to change this container # ?`,
                [
                  { text: 'Edit', color: 'green', textColor: 'white' },
                  { text: 'Cancel', color: 'gray', textColor: 'white' },
                ],
              );

              if (confirmEdit == 'Cancel') {
                return;
              }
            } else {
              //this.$alert.showAlert('warning', `Update not allowed. There are charges already invoice for container(${this.cargoInfoContainerData['oldcontNo']}). `, 'error');
              this.$showAlert(
                'error',
                'warning',
                `Update not allowed. There are charges already invoice for container(${this.cargoInfoContainerData['oldcontNo']}). `,
              );
              return;
            }
          }

          if (this.cargoInfoContainerData['invoices'] > 0) {
            if (
              this.userRole['Role ID'].trim().toLowerCase() != this.updateContNoRole.trim().toLowerCase() ||
              this.sasUpdateContainer
            ) {
              //this.$alert.showAlert('warning', `Update not allowed. There are already ${this.cargoInfoContainerData['invoices']} invoiced items for container ${this.cargoInfoContainerData['oldcontNo']}.`);
              this.$showAlert(
                'warning',
                'warning',
                `Update not allowed. There are already ${this.cargoInfoContainerData['invoices']} invoiced items for container ${this.cargoInfoContainerData['oldcontNo']}.`,
              );
              return;
            }
          }

          newData['UpdateType'] = containerUpdateType.toString();
        }
        // console.log(this.cargoInfoContainerData['containerEditIndex']);
        // console.log(temp)
        const itemAction = temp[this.cargoInfoContainerData['containerEditIndex']].item_action;
        if (!itemAction) {
          newData['item_action'] = 'E';
        } else if (itemAction == 'N') {
          newData['item_action'] = 'N';
        }

        this.selectedCargoInfoData['contDetailsList'] = [];
        this.selectedCargoInfoData['selectedContDetails'] = [];
        temp.splice(this.cargoInfoContainerData['containerEditIndex'], 1, newData);
      }

      this.cargoInfoContainerData['showContainerPopup'] = false;
      this.selectedCargoInfoData['contDetailsList'] = [];
      this.$nextTick(() => (this.selectedCargoInfoData['contDetailsList'] = temp.concat(newDataList)));
    },
    clearContainerPopupData: function () {
      this.cargoInfoContainerData['selectedCategory'] = null;
      this.cargoInfoContainerData['contQty'] = '';
      this.cargoInfoContainerData['contNo'] = '';
      this.cargoInfoContainerData['sealNo'] = '';
      this.cargoInfoContainerData['contSelectedSize'] = null;
      this.cargoInfoContainerData['contSelectedType'] = null;
      this.cargoInfoContainerData['contSelectedStatus'] = null;
      this.cargoInfoContainerData['contWeight'] = this.$weightFormat('0');
      this.cargoInfoContainerData['contSelectedHdgType'] = null;
      this.cargoInfoContainerData['contSelectedDelType'] = null;
      this.cargoInfoContainerData['contSelectedSendTo'] = null;
      this.cargoInfoContainerData['contSocCoc'] = null;
      this.cargoInfoContainerData['contRemarks'] = '';
    },
    clearContainerPopupError: function () {
      this.cargoInfoContainerData['selectedCategoryError'] = '';
      this.cargoInfoContainerData['contQtyError'] = '';
      this.cargoInfoContainerData['contNoError'] = '';
      this.cargoInfoContainerData['contSelectedSizeError'] = '';
      this.cargoInfoContainerData['contSelectedTypeError'] = '';
      this.cargoInfoContainerData['contSelectedHdgTypeError'] = '';
      this.cargoInfoContainerData['contSelectedDelTypeError'] = '';
      this.cargoInfoContainerData['contSocCocError'] = '';
    },
    deleteContainerClicked: async function () {
      if (this.selectedCargoInfoData['selectedContDetails'].length == 0) {
        this.$showAlert('error', 'No Container Selected', 'Please select at least 1 container to delete');
        return;
      }

      const confirmDelete = await this.$showAlert(
        'warning',
        'Delete Container',
        'Are you sure you want to delete the selected container?',
        [
          { text: 'Delete', color: 'red', textColor: 'white' },
          { text: 'Cancel', color: 'gray', textColor: 'white' },
        ],
      );
      if (confirmDelete == 'Delete') {
        const temp = this.selectedCargoInfoData['contDetailsList'];
        this.selectedCargoInfoData['contDetailsList'] = [];

        this.selectedCargoInfoData['selectedContDetails'].forEach((s) => {
          const selected = JSON.parse(JSON.stringify(s));
          //delete selected['_rowid'];

          const index = temp.findIndex((t) => JSON.stringify(t) == JSON.stringify(selected));
          //console.log(index)
          const itemAction = temp[index]['item_action'];
          if (itemAction != 'N') {
            this.selectedCargoInfoData['deletedContDetails'].push(temp[index]);
          }

          temp.splice(index, 1);
        });

        this.$nextTick(() => {
          this.selectedCargoInfoData['contDetailsList'] = temp;
          this.selectedCargoInfoData['selectedContDetails'] = [];
        });
      }
    },
    //#endregion

    showHideDetailsPopup: function (type, edit) {
      if (edit && type == 'sub') {
        if (this.selectedCargoInfoData['selectedSubPkgs'].length == 0) {
          this.$showAlert(
            'error',
            'No Details Selected',
            `No ${type == 'sub' ? 'Package' : 'Container'} details selected to edit`,
          );
          return;
        } else if (this.selectedCargoInfoData['selectedSubPkgs'].length > 1) {
          this.$showAlert(
            'error',
            'Multiple Details Selected',
            `Please select only 1 ${type == 'sub' ? 'Package' : 'Container'} details to edit`,
          );
          return;
        }
      } else if (edit && type == 'cont') {
        if (this.selectedCargoInfoData['selectedContDetails'].length == 0) {
          this.$showAlert(
            'error',
            'No Details Selected',
            `No ${type == 'sub' ? 'Package' : 'Container'} details selected to edit`,
          );
          return;
        } else if (this.selectedCargoInfoData['selectedContDetails'].length > 1) {
          this.$showAlert(
            'error',
            'Multiple Details Selected',
            `Please select only 1 ${type == 'sub' ? 'Package' : 'Container'} details to edit`,
          );
          return;
        }
      }

      this.cargoPopupDetails['cargoAddType'] = type;
      this.cargoPopupDetails['isEdit'] = Boolean(edit);
      this.cargoPopupDetails['editIndex'] = -1;
      this.cargoPopupDetails['editDetails'] =
        edit ?
          type == 'sub' ?
            this.selectedCargoInfoData['selectedSubPkgs'][0]
          : this.selectedCargoInfoData['selectedContDetails'][0]
        : null;
      if (edit && type == 'sub') {
        const selectedSubPkg = this.selectedCargoInfoData['selectedSubPkgs'][0];
        const compareColumns = ['Package Quantity', 'Package Type', 'Gross Weight'];

        this.cargoPopupDetails['editIndex'] = this.selectedCargoInfoData['subPkgList'].findIndex((s) =>
          compareColumns.every((column) => s[column] === selectedSubPkg[column]),
        );
      }
      if (type == 'cont' && edit) {
        this.cargoPopupDetails['editIndex'] = this.selectedCargoInfoData['contDetailsList'].findIndex(
          (s) => JSON.stringify(s) == JSON.stringify(this.selectedCargoInfoData['selectedContDetails'][0]),
        );
      }
    },
    convertNumber: function (value) {
      if (value) {
        const converted = Number(value);
        const formatted = value ? this.$weightFormat(converted) : this.$weightFormat('0');
        return formatted;
      }
    },
    cargoInfoPopupAddDetails: function (sub, details) {
      this.cargoPopupDetails['cargoAddType'] = '';

      if (sub == 'sub') {
        const temp = this.selectedCargoInfoData['subPkgList'];
        this.selectedCargoInfoData['subPkgList'] = [];

        // DN QTY VALIDATION
        if (this.cargoPopupDetails['editIndex'] >= 0) {
          const existing = temp[this.cargoPopupDetails['editIndex']];
          const seqNo = existing.seq_no;
          const dnInfo = this.getDnConsumedInfo(seqNo);
          const dnUsedQty = dnInfo.qty;
          const newQty = Number(details.pkgQty || 0);

          if (newQty < dnUsedQty) {
            this.$showAlert(
              'error',
              'Invalid Quantity',
              `Package quantity cannot be less than ${dnUsedQty}. Used in Delivery Note(s): ${dnInfo.dns.join(', ')}`,
            );
            this.selectedCargoInfoData['subPkgList'] = temp;
            return;
          }
        }
        // END ADD

        const grossWeight = `${this.convertNumber(details.totalGross)}KG (${this.convertNumber(details.grossPerPkg)}KG)`;
        const netWeight = `${this.convertNumber(details.totalNet)}KG (${this.convertNumber(details.netPerPkg)}KG)`;
        const volume = `${this.convertNumber(details.totalVol)}M³ (${this.convertNumber(details.volPerPkg)}M³)`;

        const Length = details.dimLength ? this.convertNumber(details.dimLength) : this.$weightFormat('0');
        const Width = details.dimWidth ? this.convertNumber(details.dimWidth) : this.$weightFormat('0');
        const Height = details.dimHeight ? this.convertNumber(details.dimHeight) : this.$weightFormat('0');

        const addEditDetails = {
          'Package Quantity': details.pkgQty,
          'Package Type': details.selectedPackageType ? details.selectedPackageType['Package Code'] : '',
          Dimensions: `${Length}m X ${Width}m X ${Height}m`,
          'Gross Weight': grossWeight,
          'Net Weight': netWeight,
          Volume: volume,
          'Item Code': details.selectedItemCode ? details.selectedItemCode['Product Code'] : '',
          'Packing List #': details.packingListNo,
          'Invoice #': details.invoiceNo,
          'Container #': details.containerNo,
          Remarks: details.remarks,
          seq_no: '',
        };

        if (this.cargoPopupDetails['editIndex'] >= 0) {
          const itemAction = temp[this.cargoPopupDetails['editIndex']]['item_action'];
          if (!itemAction) {
            addEditDetails['item_action'] = 'E';
          } else if (itemAction == 'N') {
            addEditDetails['item_action'] = 'N';
          }

          addEditDetails['seq_no'] = temp[this.cargoPopupDetails['editIndex']]['seq_no'];

          temp.splice(this.cargoPopupDetails['editIndex'], 1, addEditDetails);
          this.selectedCargoInfoData['selectedSubPkgs'] = [];
        } else {
          addEditDetails['item_action'] = 'N';
          temp.push(addEditDetails);
        }

        this.$nextTick(() => (this.selectedCargoInfoData['subPkgList'] = temp));
      } else {
        const detailsToUse = Array.isArray(details) ? details : [details];
        const data = detailsToUse.map((d) => {
          return {
            'Cont #': d.contNo || '',
            'Old Cont #': d.oldcontNo || '',
            'Seal No': d.sealNo || '',
            'Old Seal No': d.oldsealNo || '',
            'Cont Size':
              d.contSelectedSize ?
                d.contSelectedSize['Size'] ?
                  d.contSelectedSize['Size'].trim()
                : ''
              : '',
            'Old Cont Size':
              d.contoldSelectedSize ?
                d.contoldSelectedSize['Size'] ?
                  d.contoldSelectedSize['Size'].trim()
                : ''
              : '',
            'Cont Type':
              d.contSelectedType ?
                d.contSelectedType['Cont Type'] ?
                  d.contSelectedType['Cont Type'].trim()
                : ''
              : '',
            'Old Cont Type':
              d.contoldSelectedType ?
                d.contoldSelectedType['Cont Type'] ?
                  d.contoldSelectedType['Cont Type'].trim()
                : ''
              : '',
            'Cont Weight': d.contWeight ? this.$weightFormat(d.contWeight) : this.$weightFormat('0'),
            Status:
              d.contSelectedStatus ?
                d.contSelectedStatus['Cont Status'] ?
                  d.contSelectedStatus['Cont Status'].trim()
                : ''
              : '',
            'Handling Type':
              d.contSelectedHdgType ?
                d.contSelectedHdgType['Handling Type'] ?
                  d.contSelectedHdgType['Handling Type'].trim()
                : ''
              : '',
            'Old Handling Type':
              d.contoldSelectedHdgType ?
                d.contoldSelectedHdgType['Handling Type'] ?
                  d.contoldSelectedHdgType['Handling Type'].trim()
                : ''
              : '',
            'Delivery Type':
              d.contSelectedDelType ?
                d.contSelectedDelType['Delivery Type'] ?
                  d.contSelectedDelType['Delivery Type'].trim()
                : ''
              : '',
            'Old Delivery Type':
              d.contoldSelectedDelType ?
                d.contoldSelectedDelType['Delivery Type'] ?
                  d.contoldSelectedDelType['Delivery Type'].trim()
                : ''
              : '',
            'Send To':
              d.contSelectedSendTo ?
                d.contSelectedSendTo['Destination Code'] ?
                  d.contSelectedSendTo['Destination Code'].trim()
                : ''
              : '',
            'SOC/COC': d.contSocCoc['SOCCOC Type'],
            Remarks: d.contRemarks || '',
            'ROT No': d.rotno || '',
            'Cont Charges': d.contcharges || '',
          };
        });

        let temp = this.selectedCargoInfoData['contDetailsList'];
        this.selectedCargoInfoData['contDetailsList'] = [];

        if (this.cargoPopupDetails['editIndex'] >= 0) {
          const itemAction = temp[this.cargoPopupDetails['editIndex']]['item_action'];
          if (!itemAction) {
            data[0]['item_action'] = 'E';
          } else if (itemAction == 'N') {
            data[0]['item_action'] = 'N';
          }

          temp.splice(this.cargoPopupDetails['editIndex'], 1, data[0]);
          this.selectedCargoInfoData['selectedContDetails'] = [];
        } else {
          data.forEach((d) => (d['item_action'] = 'N'));
          temp = temp.concat(data);
        }

        this.$nextTick(() => (this.selectedCargoInfoData['contDetailsList'] = temp));
      }
    },
    cargoPopupCancel: function () {
      this.cargoPopupDetails['cargoAddType'] = '';
      this.cargoPopupDetails['isEdit'] = false;
    },
    cargoInfoPopupDeleteDetails: function (type) {
      const listKey = type == 'sub' ? 'subPkgList' : 'contDetailsList';
      const selectedKey = type == 'sub' ? 'selectedSubPkgs' : 'selectedContDetails';
      const deleteKey = type == 'sub' ? 'deletedSubPkg' : 'deletedContDetails';

      if (!this.selectedCargoInfoData[selectedKey]) {
        //this.$alert.showAlert('Error', `Please select at least 1 ${type == 'sub' ? 'sub package' : 'container detail'} below to remove`, 'error');
        this.$showAlert(
          'error',
          'Error',
          `Please select at least 1 ${type == 'sub' ? 'sub package' : 'container detail'} below to remove`,
        );
        return;
      }

      // DN DELETE Validation
      if (type === 'sub') {
        for (const s of this.selectedCargoInfoData[selectedKey]) {
          const dnInfo = this.getDnConsumedInfo(s.seq_no);
          if (dnInfo.qty > 0) {
            this.$showAlert(
              'error',
              'Cannot Delete Package',
              `This package is used in Delivery Note(s): ${dnInfo.dns.join(', ')}. Please remove it from Delivery Note first.`,
            );
            return;
          }
        }
      }
      // END DELETE

      if (this.selectedCargoInfoData[selectedKey].length == 0) {
        //this.$alert.showAlert('Error', `Please select at least 1 ${type == 'sub' ? 'sub package' : 'container detail'} below to remove`, 'error');
        this.$showAlert(
          'error',
          'Error',
          `Please select at least 1 ${type == 'sub' ? 'sub package' : 'container detail'} below to remove`,
        );
        return;
      }

      const temp = this.selectedCargoInfoData[listKey];
      this.selectedCargoInfoData[listKey] = [];

      // this.selectedCargoInfoData[selectedKey].forEach((s) => {
      //   let index = temp.findIndex(t => JSON.stringify(t) == JSON.stringify(s));

      //   let itemAction = temp[index]['item_action'];
      //   if (itemAction != 'N') { this.selectedCargoInfoData[deleteKey].push(temp[index]) }

      //   temp.splice(index, 1);
      // });

      this.selectedCargoInfoData[selectedKey].forEach((s) => {
        const compareColumns = ['Package Quantity', 'Package Type', 'Gross Weight'];
        const index = temp.findIndex((t) => {
          return compareColumns.every((column) => t[column] === s[column]);
        });
        if (index !== -1) {
          const itemAction = temp[index]['item_action'];
          if (itemAction != 'N') {
            this.selectedCargoInfoData[deleteKey].push(temp[index]);
          }
          temp.splice(index, 1);
        }
      });

      this.$nextTick(() => {
        this.selectedCargoInfoData[listKey] = temp;
        this.selectedCargoInfoData[selectedKey] = [];
      });
    },
    importFromExcel: async function () {
      this.importContPreview = [];
      this.importHasError = false;
      this.$refs['excelCont'].value = '';
      this.$refs['excelCont'].click();
      const excelFile = await new Promise((r) => (this.excelContResolve = r)); // returns the selected file

      if (typeof excelFile == 'object') {
        // If the file picker is not dismissed by pressing cancel
        this.excelContConfirm = true;

        const converted = await this.$excelToJson(excelFile);
        this.importContLoading = true;
        setTimeout(async () => {
          this.importContLoading = false;
          if (converted['success']) {
            // Successfully converted the excel to JSON
            const excelContent = converted['data'];

            const allSheet = excelContent.map((c) => c['sheet']);
            if (allSheet.includes('Containers')) {
              // Excel has the 'Containers' sheet
              const warn =
                '<img src="https://dsmlib.logistics.systems/Icons/warning.png" height="20" title="Value does not exist within the list">';
              const error =
                '<img src="https://dsmlib.logistics.systems/Icons/error.png" height="20" title="Value is required">';

              let duplicate = false;
              const currentContainers = this.selectedCargoInfoData['contDetailsList'].map((c) => c['Cont #']);
              const excelData = this.$deepTrimJsonV2(excelContent.find((c) => c['sheet'] == 'Containers')['data']);
              excelData.forEach((d) => {
                if (!d['Container No']) {
                  d['Container No'] = error;
                  this.importHasError = true;
                } else if (currentContainers.includes(d['Container No'])) {
                  duplicate = true;
                }

                if (!d['Size']) {
                  d['Size'] = error;
                  this.importHasError = true;
                } else if (
                  !this.cargoInfoData['contSizeList'].find(
                    (c) => c['Size'].toString().toLowerCase() == d['Size'].toString().toLowerCase(),
                  )
                ) {
                  d['Size'] += warn;
                  this.importHasError = true;
                }
                if (!d['Type']) {
                  d['Type'] = error;
                  this.importHasError = true;
                } else if (
                  !this.cargoInfoData['contTypeList'].find(
                    (c) => c['Cont Type'].toString().toLowerCase() == d['Type'].toString().toLowerCase(),
                  )
                ) {
                  d['Type'] += warn;
                  this.importHasError = true;
                }
                if (!d['Handling Type']) {
                  d['Handling Type'] = error;
                  this.importHasError = true;
                } else if (
                  !this.cargoInfoData['contHandlingTypeList'].find(
                    (c) => c['Handling Type'].toString().toLowerCase() == d['Handling Type'].toString().toLowerCase(),
                  )
                ) {
                  d['Handling Type'] += warn;
                  this.importHasError = true;
                }
                if (!d['Delivery Type']) {
                  d['Delivery Type'] = error;
                  this.importHasError = true;
                } else if (
                  !this.cargoInfoData['contDeliveryTypeList'].find(
                    (c) => c['Delivery Type'].toString().toLowerCase() == d['Delivery Type'].toString().toLowerCase(),
                  )
                ) {
                  d['Delivery Type'] += warn;
                  this.importHasError = true;
                }
              });

              if (duplicate) {
                // Got duplicate
                this.$showAlert(
                  'error',
                  'Container Has Duplicates',
                  `The excel file you've chosen might already been uploaded or there are 1 or more container number is duplicated.<br>Please fix the duplicate container in your excel and re-upload.`,
                );
                this.excelContConfirm = false;
              } else {
                // No duplications
                this.importContPreview = excelData;

                const confirmCont = await new Promise((r) => (this.excelContResolve = r));
                this.excelContConfirm = false;

                if (confirmCont.includes('Confirm')) {
                  // User confirm the container list
                  const fromExcel = this.importContPreview.map((c) => {
                    return {
                      'Cont #': c['Container No'] ? c['Container No'] : '',
                      'Seal No': c['Seal No'] ? c['Seal No'] : '',
                      'Cont Size': c['Size'] ? c['Size'] : '',
                      'Cont Type': c['Type'] ? c['Type'] : '',
                      'Cont Weight': c['Weight (KG)'] ? c['Weight (KG)'] : '',
                      Status: '',
                      'Handling Type': c['Handling Type'] ? c['Handling Type'] : '',
                      'Delivery Type': c['Delivery Type'] ? c['Delivery Type'] : '',
                      Remarks: c['Remarks'] ? c['Remarks'] : '',
                      'SOC/COC': c['SOC/COC'] ? c['SOC/COC'] : '',
                      'From API': false,
                      item_action: 'N',
                    };
                  });

                  const temp = this.selectedCargoInfoData['contDetailsList'];
                  this.selectedCargoInfoData['contDetailsList'] = [];
                  this.$nextTick(() => {
                    this.selectedCargoInfoData['contDetailsList'] = temp.concat(fromExcel);
                    this.importContPreview = [];
                  });
                }
              }
            } else {
              // Excel has no 'Containers' sheet
              this.$showAlert(
                'error',
                'Wrong Excel Format',
                `Please make sure that you're using the correct Excel format to import the list of containers.<br><br>If you don't have one, you may download it from <a href="https://dsmlib.logistics.systems/Files/Template/DataTemplate_Containers.xlsx">here</a>.`,
              );
              this.excelContConfirm = false;
            }
          } else {
            // Error converting the Excel to JSON
            this.$showAlert('error', 'Error Reading File', converted['data']);
            this.excelContConfirm = false;
          }
        }, 1000);
      }
    },
    excelContClicked: function (btn) {
      this.excelContResolve(btn);
    },
    excelContChange: function (e) {
      const files = e.target.files;
      if (files.length > 0) {
        this.excelContResolve(e.target.files[0]);
      } else {
        this.excelContResolve('cancel');
      }
    },

    //#region API Calls
    getHeaderInfoTabDetails: function () {
      const headerInfoTabDetailsPromises = [];

      headerInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'transmode' }).then((result) => {
          this.headerInfoData['transMode'] = result;
        }),
      );

      headerInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'cargotype' }).then((result) => {
          this.headerInfoData['cargoType'] = result;
        }),
      );

      headerInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'smkformtype', jobtype: this.pageType[0] }).then(
          (result) => {
            this.headerInfoData['smkFormType'] = result;
          },
        ),
      );

      headerInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'shipper' }).then((result) => {
          this.headerInfoData['shipper'] = result.map((shipper) => ({
            ...shipper,
            'Code - Name': `${shipper['Shipper Code']} - ${shipper['Shipper Name']}`,
          }));
        }),
      );

      headerInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'consignee' }).then((result) => {
          this.headerInfoData['consignee'] = result.map((consignee) => ({
            ...consignee,
            'Code - Name': `${consignee['Consignee Code']} - ${consignee['Consignee Name']}`,
          }));
        }),
      );

      headerInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'notifyparty' }).then((result) => {
          this.headerInfoData['notifyParty'] = result.map((notifyParty) => ({
            ...notifyParty,
            'Code - Name': `${notifyParty['Notify Party Code']} - ${notifyParty['Notify Party Name']}`,
          }));
        }),
      );

      headerInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'billcust' }).then((result) => {
          this.headerInfoData['billTo'] = result.map((billTo) => ({
            ...billTo,
            'Code - Name': `${billTo['Customer Code']} - ${billTo['Customer Name']}`,
          }));
        }),
      );

      headerInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'job_servicelist', module: 'FMS' }).then((services) => {
          services.forEach((s) => {
            this.headerInfoData['services'].push({
              selected: false,
              item: s['Description'],
              remarks: '',
              data: s,
            });
          });
        }),
      );

      headerInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'job_unconfirm_reason' }).then((result) => {
          this.reasonsList = result;
        }),
      );

      headerInfoTabDetailsPromises.push(
        this.$apiCallV2('/FreightForwarding/GetQuotationListing', {}).then((result) => {
          this.headerInfoData['quotationNo'] = result;
        }),
      );

      return headerInfoTabDetailsPromises;
    },
    getGeneralInfoTabDetails: function () {
      const generalInfoTabDetailsPromises = [];
      generalInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'freighttype' }).then((result) => {
          this.generalInfoData['freightTypeList'] = result;
        }),
      );

      generalInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'COUNTRY' }).then((result) => {
          this.generalInfoData['countryList'] = result.map((countryList) => ({
            ...countryList,
            'Code - Desc': `${countryList['Country Code']} - ${countryList['Country']}`,
          }));

          this.addressDetails['countryList'] = result;
        }),
      );

      generalInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'POSTCODE' }).then((result) => {
          this.addressDetails['postcodeList'] = result;
        }),
      );

      generalInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'STATE' }).then((result) => {
          this.addressDetails['stateList'] = result;
        }),
      );

      generalInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'CURRENCY' }).then((result) => {
          this.generalInfoData['currencyList'] = result;
        }),
      );

      generalInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'incoterms', module: 'FMS' }).then((result) => {
          this.generalInfoData['incoTermsList'] = result;
        }),
      );

      generalInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'insurance', module: 'FMS' }).then((result) => {
          this.generalInfoData['insuranceList'] = result;
        }),
      );

      generalInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'branch' }).then((result) => {
          this.generalInfoData['branchList'] = result;
        }),
      );

      generalInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', {
          masterfile: 'SERVICEPERSON',
          module: 'FMS',
          jobtype: this.pageType[0],
        }).then((result) => {
          this.generalInfoData['servicePICList'] = result;
        }),
      );

      generalInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', {
          masterfile: 'SERVICETEAM',
          module: 'FMS',
          jobtype: this.pageType[0],
        }).then((result) => {
          this.generalInfoData['serviceTeamList'] = result;
        }),
      );

      generalInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', {
          masterfile: 'SALESPERSON',
          module: 'FMS',
          jobtype: this.pageType[0],
        }).then((result) => {
          this.generalInfoData['salesPICList'] = result;
        }),
      );

      generalInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', {
          masterfile: 'SALESTEAM',
          module: 'FMS',
          jobtype: this.pageType[0],
        }).then((result) => {
          this.generalInfoData['salesTeamList'] = result;
        }),
      );

      return generalInfoTabDetailsPromises;
    },
    getShippingInfoTabDetails: function () {
      const shippingInfoTabDetailsPromises = [];

      shippingInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'vesselid' }).then((result) => {
          this.shippingInfoData['vesselIDList'] = result.map((vesselid) => ({
            ...vesselid,
            'ID - Name': `${vesselid['Vessel ID']} - ${vesselid['Vessel Name']}`,
          }));
        }),
      );

      shippingInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'specialtreatment' }).then((result) => {
          this.shippingInfoData['specialTreatment'] = result.map((specialtreatment) => ({
            ...specialtreatment,
            'Code - Desc': `${specialtreatment['ST Code']} - ${specialtreatment['ST Desc']}`,
          }));
        }),
      );

      shippingInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'station' }).then((result) => {
          this.shippingInfoData['station'] = result.map((station) => ({
            ...station,
            'Code - Name': `${station['Station Code']} - ${station['Station Name']}`,
          }));
        }),
      );

      shippingInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'portoperator' }).then((result) => {
          this.shippingInfoData['portOperator'] = result.map((portOperator) => ({
            ...portOperator,
            'Code - Name': `${portOperator['Operator Code']} - ${portOperator['Operator Name']}`,
          }));
        }),
      );

      shippingInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'fumigator' }).then((result) => {
          this.shippingInfoData['fumigatorList'] = result;
        }),
      );

      return shippingInfoTabDetailsPromises;
    },
    getShippingInfoTabDetailsByTransMode: function () {
      const shippingInfoTabDetailsByTransModePromises = [];

      shippingInfoTabDetailsByTransModePromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'shippingagent' }).then((result) => {
          this.shippingInfoData['shippingAgentList'] = result.map((shippingagent) => ({
            ...shippingagent,
            'Code - Name': `${shippingagent['Agent Code']} - ${shippingagent['Agent Name']}`,
          }));
        }),
      );

      shippingInfoTabDetailsByTransModePromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'shippingline' }).then((result) => {
          this.shippingInfoData['shippingLineList'] = result.map((shippingline) => ({
            ...shippingline,
            'Code - Name': `${shippingline['Agent Code']} - ${shippingline['Agent Name']}`,
          }));
        }),
      );

      shippingInfoTabDetailsByTransModePromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'frtforwarder' }).then((result) => {
          this.shippingInfoData['frtForwarderList'] = result.map((frtforwarder) => ({
            ...frtforwarder,
            'Code - Name': `${frtforwarder['Agent Code']} - ${frtforwarder['Agent Name']}`,
          }));
        }),
      );

      shippingInfoTabDetailsByTransModePromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'FORWARDINGAGENT' }).then((result) => {
          this.shippingInfoData['fwdgAgentList'] = result;
        }),
      );

      return shippingInfoTabDetailsByTransModePromises;
    },
    getCargoInfoTabDetails: function () {
      const shippingInfoTabDetailsPromises = [];
      shippingInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'commodity' }).then((result) => {
          this.cargoInfoData['commodityList'] = result;
        }),
      );

      shippingInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'packmat' }).then((result) => {
          this.cargoInfoData['pMaterialList'] = result.map((packmat) => ({
            ...packmat,
            'Code - Desc': `${packmat['Packing Material Code']} - ${packmat['Material Description']}`,
          }));
        }),
      );

      shippingInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'packagecode' }).then((result) => {
          this.cargoInfoData['pkgTypeList'] = result.map((pkgType) => ({
            ...pkgType,
            'Code - Desc': `${pkgType['Package Code']} - ${pkgType['Description']}`,
          }));
        }),
      );

      shippingInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'CONTSIZE', module: 'FMS' }).then((result) => {
          this.cargoInfoData['contSizeList'] = result;
        }),
      );

      shippingInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'CONTTYPE', module: 'FMS' }).then((result) => {
          this.cargoInfoData['contTypeList'] = result.map((pkgType) => ({
            ...pkgType,
            'Code - Desc': `${pkgType['Cont Type']} - ${pkgType['Description']}`,
          }));
        }),
      );

      shippingInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'CONTHANDLINGTYPE', module: 'FMS' }).then((result) => {
          this.cargoInfoData['contHandlingTypeList'] = result;
        }),
      );

      shippingInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'CONTDELIVERYTYPE', module: 'FMS' }).then((result) => {
          this.cargoInfoData['contDeliveryTypeList'] = result;
        }),
      );

      shippingInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SOCCOC' }).then((result) => {
          this.cargoInfoData['soccocTypeList'] = result;
        }),
      );

      shippingInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'CONTSTATUS', module: 'FMS' }).then((result) => {
          this.cargoInfoData['contStatusList'] = result;
        }),
      );

      shippingInfoTabDetailsPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'whproduct', module: 'FMS' }).then((result) => {
          this.cargoInfoData['itemCode'] = result;
        }),
      );

      return shippingInfoTabDetailsPromises;
    },
    getLargeData: function () {
      const largeDataPromises = [];
      largeDataPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'port' }).then((result) => {
          const portList = result.map((item) => {
            return {
              ...item,
              'Code - Desc': `${item['Port Code']} - ${item['Port Location']}`,
            };
          });
          this.shippingInfoData['portOfLoading'] = portList;
          this.shippingInfoData['portOfDischarge'] = portList;
          this.shippingInfoData['finalDestination'] = portList;
        }),
      );

      largeDataPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'destination', module: 'FMS' }).then((result) => {
          this.shippingInfoData['fumigatorLocationList'] = result;
          this.cargoInfoData['contSendToList'] = result;
        }),
      );

      largeDataPromises.push(
        this.$apiCallV2('/Master/GetListMaster?save=true', { masterfile: 'shipcallno' }).then((result) => {
          this.shippingInfoData['shipCallNoList'] = result;
        }),
      );

      return largeDataPromises;
    },
    getSMKItemDetails: function () {
      // smk dropdown list here
      const smkItemPromises = [];
      smkItemPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'UOM' }).then((result) => {
          this.generalInfoData['uomList'] = result;
        }),
      );

      smkItemPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SMKTC' }).then((result) => {
          this.generalInfoData['tcList'] = result;
        }),
      );

      smkItemPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SMKDECLARETYPE' }).then((result) => {
          this.smkInfoData['declarationType'] = result.map((item) => {
            const declareType = `${item['Has Leading Space'] == 1 ? ' ' : ''}${item['Declare Type']}`;
            return { ...item, 'Declare Type': declareType, 'Code - Name': `${declareType} - ${item['Declare Name']}` };
          });
        }),
      );
      smkItemPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SMKEXEMPTNO' }).then((result) => {
          this.smkInfoData['exemptNoList'] = result;
        }),
      );

      smkItemPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SMKEXEMPTYPE' }).then((result) => {
          this.smkInfoData['exemptTypeList'] = result;
        }),
      );

      smkItemPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SMKCLAUSENEW' }).then((result) => {
          this.smkInfoData['clauseList'] = result;
        }),
      );

      smkItemPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SMKPRODUCT' }).then((result) => {
          this.generalInfoData['smkProductList'] = result || [];
        }),
      );

      smkItemPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SMKEXEMPTITEM' }).then((result) => {
          this.generalInfoData['smkItemMasterList'] = result || [];
        }),
      );

      smkItemPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SMKMOVEMENTTYPE' }).then((result) => {
          this.smkInfoData['movementType'] = result.map((movementType) => ({
            ...movementType,
            'Code - Name': `${movementType['Move Type']} - ${movementType['Move Desc']}`,
          }));
        }),
      );

      smkItemPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SMKWHSE' }).then((result) => {
          this.smkInfoData['warehouseList'] = result.map((warehouse) => ({
            ...warehouse,
            'Code - Name': `${warehouse['Warehouse Code']} - ${warehouse['Warehouse Name']}`,
          }));
        }),
      );

      smkItemPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SMKWHSETYPE' }).then((result) => {
          this.smkInfoData['warehouseTypeList'] = result.map((warehouseType) => ({
            ...warehouseType,
            'Code - Name': `${warehouseType['Warehouse Type']} - ${warehouseType['Warehouse Desc']}`,
          }));
        }),
      );

      smkItemPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SMKTRANSTYPE' }).then((result) => {
          this.smkInfoData['transportTypeList'] = (result || []).map((item) => ({
            ...item,
            'Code - Desc': `${item['Transport Type']} - ${item['Transport Description']}`,
          }));
        }),
      );

      smkItemPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SMKDOCCAT' }).then((result) => {
          this.smkInfoData.docMasterList = result || [];
        }),
      );

      return smkItemPromises;
    },
    //#endregion

    //#region InputQuery Refresh Clicked Handlers
    consigneeInputQueryRefreshClicked: async function (placeholder) {
      this.headerInfoData['consignee'] = [];
      this.$fullscreenLoading(`Getting Latest ${placeholder} List`);
      this.headerInfoData['consignee'] = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'consignee' });
      this.$fullscreenLoading();
      // <InputQuery placeholder="Consignee" v-if="pageType == 'Import'" :items.sync="headerInfoData['consignee']" itemKey="Consignee Code" descKey="Consignee Name" :errorMessage.sync="errorMessages['consignee']"
      //             :selectedObject.sync="selectedHeaderInfoData['selectedConsignee']" :isRequired="true" :isDisabled="viewMode" ref="consignee" @selected="consigneeSelected"
      //             addLink="/Home/MasterFiles/ProfileMaster/ShipperConsignee" :refreshData="{ masterfile: 'consignee' }" :allowFreeText="false" />

      // <InputQuery placeholder="Consignee" :items.sync="headerInfoData['consignee']" itemKey="Consignee Code" descKey="Consignee Name" :isDisabled="viewMode"
      //             :selectedObject.sync="selectedHeaderInfoData['selectedConsignee']" :isRequired="pageType == 'Import'" @selected="consigneeSelected"
      //             addLink="/Home/MasterFiles/ProfileMaster/ShipperConsignee?new=1" :refreshData="{ masterfile: 'consignee' }" :allowFreeText="false" />
    },
    billToInputQueryRefreshClicked: async function (placeholder) {
      this.headerInfoData['billTo'] = [];
      this.$fullscreenLoading(`Getting Latest ${placeholder} List`);
      this.headerInfoData['billTo'] = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'billcust' });
      this.$fullscreenLoading();
      // <InputQuery placeholder="Bill To" :items.sync="headerInfoData['billTo']" itemKey="Customer Code" descKey="Customer Name" ref="billcu_no" :errorMessage.sync="errorMessages['billcu_no']"
      //             :selectedObject.sync="selectedHeaderInfoData['selectedBillTo']" :isRequired="true" :isDisabled="viewMode"
      //             addLink="/Home/MasterFiles/ProfileMaster/Customer?new=1" :refreshData="{ masterfile: 'billcust' }" />

      // <InputQuery placeholder="Bill To" :items.sync="headerInfoData['billTo']" itemKey="Customer Code" descKey="Customer Name" :isDisabled="viewMode"
      //             :selectedObject.sync="selectedHeaderInfoData['selectedBillTo']" @selected="billToSelected" :isRequired="true" ref="billToInput"
      //             addLink="/Home/MasterFiles/ProfileMaster/Customer?new=1" :refreshData="{ masterfile: 'billcust' }" />
    },
    vesselIDInputQueryRefreshClicked: async function (placeholder) {
      this.shippingInfoData['vesselIDList'] = [];
      this.$fullscreenLoading(`Getting Latest ${placeholder} List`);
      this.shippingInfoData['vesselIDList'] = await this.$apiCallV2('/Master/GetListMaster', {
        masterfile: 'vesselid',
      });
      this.$fullscreenLoading();
      // <InputQuery :placeholder="transportMethodPlaceholders('VesselID')" :items="shippingInfoData['vesselIDList']" itemKey="Vessel ID" descKey="Vessel Name" :isRequired="true" :isDisabled="viewMode"
      //             :selectedObject.sync="selectedShippingInfoData['selectedVesselID']" ref="ship_id" :errorMessage.sync="errorMessages['ship_id']" :search.sync="selectedShippingInfoData['vesselIDValue']" :refreshData="{ masterfile: 'vesselid' }" />

      // <InputQuery :placeholder="transportMethodPlaceholders('VesselID')" :items="shippingInfoData['vesselIDList']" itemKey="Vessel ID" descKey="Vessel Name" :isDisabled="viewMode"
      //             :selectedObject.sync="selectedShippingInfoData['selectedVesselID']" :isRequired="true" :search.sync="selectedShippingInfoData['vesselIDValue']" :refreshData="{ masterfile: 'vesselid' }" />

      // <InputQuery placeholder="M. Vessel ID" :items="shippingInfoData['vesselIDList']" itemKey="Vessel ID" descKey="Vessel Name" :isDisabled="viewMode"
      //               :selectedObject.sync="selectedShippingInfoData['selectedMVesselID']" :refreshData="{ masterfile: 'vesselid' }" />
    },
    portOfLoadingInputQueryRefreshClicked: async function (placeholder) {
      this.shippingInfoData['portOfLoading'] = [];
      this.$fullscreenLoading(`Getting Latest ${placeholder} List`);
      this.shippingInfoData['portOfLoading'] = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'port' });
      this.$fullscreenLoading();
      // <InputQuery placeholder="Port of Loading" :items.sync="shippingInfoData['portOfLoading']" itemKey="Port Code" descKey="Port Location" :isRequired="true" :isDisabled="viewMode"
      //             :selectedObject.sync="selectedShippingInfoData['selectedPortLoading']" ref="imp_port" :errorMessage.sync="errorMessages['imp_port']"
      //             addLink="/Home/MasterFiles/OperationMaster/Port?new=1" :refreshData="{ masterfile: 'port' }" :saveDataToJson="true" />

      // <InputQuery placeholder="Port of Loading" :items.sync="shippingInfoData['portOfLoading']" itemKey="Port Code" descKey="Port Location" :isDisabled="viewMode"
      //             :selectedObject.sync="selectedShippingInfoData['selectedPortLoading']" :isRequired="true"
      //             addLink="/Home/MasterFiles/OperationMaster/Port?new=1" :refreshData="{ masterfile: 'port' }" :saveDataToJson="true" />
    },
    portOfDischargeInputQueryRefreshClicked: async function (placeholder) {
      this.shippingInfoData['portOfDischarge'] = [];
      this.$fullscreenLoading(`Getting Latest ${placeholder} List`);
      this.shippingInfoData['portOfDischarge'] = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'port' });
      this.$fullscreenLoading();
      // <InputQuery placeholder="Port of Discharge" :items.sync="shippingInfoData['portOfDischarge']" itemKey="Port Code" descKey="Port Location" :isRequired="true" :isDisabled="viewMode"
      //             :selectedObject.sync="selectedShippingInfoData['selectedPortDischarge']" ref="load_port" :errorMessage.sync="errorMessages['load_port']"
      //             addLink="/Home/MasterFiles/OperationMaster/Port?new=1" :refreshData="{ masterfile: 'port' }" :saveDataToJson="true" />

      // <InputQuery placeholder="Port of Discharge" :items.sync="shippingInfoData['portOfDischarge']" itemKey="Port Code" descKey="Port Location" :isDisabled="viewMode"
      //             :selectedObject.sync="selectedShippingInfoData['selectedPortDischarge']" :isRequired="true"
      //             addLink="/Home/MasterFiles/OperationMaster/Port?new=1" :refreshData="{ masterfile: 'port' }" :saveDataToJson="true" />
    },
    finalDestinationInputQueryRefreshClicked: async function (placeholder) {
      this.shippingInfoData['finalDestination'] = [];
      this.$fullscreenLoading(`Getting Latest ${placeholder} List`);
      this.shippingInfoData['finalDestination'] = await this.$apiCallV2('/Master/GetListMaster', {
        masterfile: 'port',
      });
      this.$fullscreenLoading();
      // <InputQuery placeholder="Final Destination" :items.sync="shippingInfoData['finalDestination']" itemKey="Port Code" descKey="Port Location" :isDisabled="viewMode"
      //             :selectedObject.sync="selectedShippingInfoData['selectedFinalDestination']"
      //             addLink="/Home/MasterFiles/OperationMaster/Port?new=1" :refreshData="{ masterfile: 'port' }" :saveDataToJson="true" />
    },
    shipperInputQueryRefreshClicked: async function (placeholder) {
      this.headerInfoData['shipper'] = [];
      this.$fullscreenLoading(`Getting Latest ${placeholder} List`);
      this.headerInfoData['shipper'] = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'shipper' });
      this.$fullscreenLoading();
      // <InputQuery placeholder="Shipper" :items.sync="headerInfoData['shipper']" itemKey="Shipper Code" descKey="Shipper Name" :isDisabled="viewMode"
      //             :selectedObject.sync="selectedHeaderInfoData['selectedShipper']" :isRequired="pageType == 'Export'" @selected="shipperSelected"
      //             addLink="/Home/MasterFiles/ProfileMaster/ShipperConsignee?new=1" :refreshData="{ masterfile: 'shipper' }" :allowFreeText="false" />
    },
    shippingAgentInputQueryRefreshClicked: async function (placeholder) {
      this.shippingInfoData['shippingAgentList'] = [];
      this.$fullscreenLoading(`Getting Latest ${placeholder} List`);

      this.shippingInfoData['shippingAgentList'] = await this.$apiCallV2('/Master/GetListMaster', {
        masterfile: 'shippingagent',
      });
      this.$fullscreenLoading();
    },
    //#endregion

    formatCargoPkgList: function () {
      if (this.selectedCargoInfoData['subPkgList']?.length < 1) {
        return [];
      }
      let toSend = this.selectedCargoInfoData['subPkgList'].filter((s) => s['item_action']);
      toSend = toSend.concat(this.selectedCargoInfoData['deletedSubPkg'] ?? []);
      const formatted = toSend.map((p) => {
        const dim = p['Dimensions'].split('X');
        const gWeight = p['Gross Weight'].replaceAll(',', '').split('KG');
        const nWeight = p['Net Weight'].replaceAll(',', '').split('KG');
        const uom = p['Volume'].replaceAll(',', '').split('M³');
        return {
          seq_no: p['seq_no'],
          packageqty: p['Package Quantity'],
          packageheight: dim[2].replaceAll('m', '').replaceAll(',', '').trim(),
          packagewidth: dim[1].replaceAll('m', '').replaceAll(',', '').trim(),
          packagelength: dim[0].replaceAll('m', '').replaceAll(',', '').trim(),
          packageweight: gWeight[1].replace('(', '').trim(),
          packageuom: uom[1].replace('(', '').trim(),
          remarks: p['Remarks'],
          actionflag: p['item_action'] || 'D',
          prod_code: p['Item Code'],
          balquantity: '',
          balweight: '',
          baluom: '',
          packagenweight: nWeight[1].replace('(', '').trim(),
          totalweight: gWeight[0].trim(),
          totaluom: uom[0].trim(),
          totalnweight: nWeight[0].trim(),
          itemvalue: '',
          packinglistno: p['Packing List #'],
          invoiceno: p['Invoice #'],
          cont_no: p['Container #'],
          package_code: p['Package Type'],
        };
      });

      return formatted;
    },
    formatCargoContList: function () {
      if (this.selectedCargoInfoData['contDetailsList']?.length < 1) {
        return [];
      }
      // if no action, set as 'E' to update demurragedate & dententiondate to each containerdetails records
      this.selectedCargoInfoData['contDetailsList'].forEach((item) => {
        if (!item['item_action']) {
          item['item_action'] = 'E';
        }
      });
      let toSend = this.selectedCargoInfoData['contDetailsList'].filter((s) => s['item_action']);
      toSend = toSend.concat(this.selectedCargoInfoData['deletedContDetails'] ?? []);
      const formatted = toSend.map((c) => {
        return {
          cont_no: c['Cont #'],
          oldcont_no: c['Old Cont #'],
          seal_no: c['Seal No'],
          size: c['Cont Size'],
          oldsize: c['Old Cont Size'],
          cont_type: c['Cont Type'],
          oldcont_type: c['Old Cont Type'],
          deliverytype: c['Delivery Type'],
          olddeliverytype: c['Old Delivery Type'],
          handlingtype: c['Handling Type'],
          oldhandlingtype: c['Old Handling Type'],
          remarks: c['Remarks'],
          shipmentstatus:
            c['Status'] ? this.cargoInfoData['contStatusList'].getSelected(c['Status'], 'Cont Status')['#'] : '0', //use number value instead of text
          sendto: c['Send To'],
          weight: c['Cont Weight'].replaceAll(',', ''),
          description: c['SOC/COC'],
          // demurragedate:
          //   this.selectedShippingInfoData['demurageTime'] ?
          //     new Date(this.selectedShippingInfoData['demurageTime']).formatString('yyyy-MM-dd HH:mm:ss')
          //   : '',
          // dententiondate:
          //   this.selectedShippingInfoData['detention'] ?
          //     new Date(this.selectedShippingInfoData['detention']).formatString('yyyy-MM-dd HH:mm:ss')
          //   : '',
          // 'demurragedate': '',
          // 'detentiondate': '',
          updatetype: c['UpdateType'],
          actionflag: c['item_action'] || 'D',
          docno: '',
          rotno: c['ROT No'],
        };
      });

      return formatted;
    },
    formatServicesList: function () {
      const formatted = [];
      if (this.popupTitle[0] == 'E') {
        // 20240419 weishen
        const services = this.headerInfoData['services'];
        services.forEach((s) => {
          if (s['selected'] !== s['originalSelected']) {
            // get services that changed
            formatted.push({
              serviceaction: s['selected'] ? 'N' : 'D', // 'D' if unselected
              status: s['data']['Status'],
              seqno: '',
              remarks: s['remarks'],
            });
          } else if (s['selected']) {
            formatted.push({
              serviceaction: 'E', // remaining set as 'E'
              status: s['data']['Status'],
              seqno: '',
              remarks: s['remarks'],
            });
          }
        });
      } else if (this.popupTitle[0] == 'N') {
        const selected = this.headerInfoData['services'].filter((s) => {
          return s['selected'];
        }); // get selected services only
        selected.forEach((s) => {
          formatted.push({
            serviceaction: this.popupTitle[0],
            status: s['data']['Status'],
            seqno: '',
            remarks: s['remarks'],
          });
        });
      }
      return formatted;
    },
    formatDocuments: function () {
      const adding = this.selectedDocumentInfoData['docData'].filter((d) => d['Action']);
      const deleting = this.documentsToDelete;

      let addingStr = JSON.stringify(adding.concat(deleting));
      addingStr = addingStr.replace(/"N\/A"/g, '""'); //replace all key values that is "N/A" to empty string instead of below code which replace any N/A
      // addingStr = addingStr.split('N/A').join('');

      const formatted = JSON.parse(addingStr);
      formatted.forEach((f) => {
        f['Start Date'] = f['Start Date'].split(':').join('');
        f['Received Date'] = f['Received Date'].split(':').join('');
        f['Due Date'] = f['Due Date'].split(':').join('');
      });
      return formatted;
    },
    formatDeleteDocuments: function () {
      // this.deleteItems
    },
    saveClicked: async function (noload, bypassCompulsory, save) {
      this.sMessages = [];
      this.eMessages = [];
      this.rMessages = [];

      this.selectedUnconfirmReason = null;
      this.unconfirmRemarks = '';

      this.popupError = false;
      this.popupErrorText = '';

      const action = this.popupTitle[0] == 'D' ? 'N' : this.popupTitle[0];
      const isSMKPartJob = this.isSMKPartJobPopup();

      if (!(await this.checkPopupEntryFields())) {
        return;
      }
      if (!(await this.validateDates())) {
        return;
      }

      if (!(await this.validateDates())) {
        return;
      }

      const smkFormType = this.getHeaderSMKFormType && this.getHeaderSMKFormType();

      if (this.enableSMKmodule && !this.isSMKPreferentialDeclaration && this.smkItemList.some((row) => row.AseanCept)) {
        await this.$showAlert(
          'error',
          'CEPT cannot be saved',
          'CEPT requires Declaration Type S - Import With Preferential Tariffs. Select S or untick CEPT on the items.',
          [{ text: 'OK' }],
        );
        return;
      }

      const isNewPartJob = isSMKPartJob && action == 'N' && this.popupTitle === 'New Part Job';

      if (this.enableSMKmodule && smkFormType && !isNewPartJob && !this.validateSmkInvoiceDetails()) {
        return;
      }

      const postData = {
        action: action,
        lastupdate: '',
        // 'job_status': this.popupTitle[0] == 'N' ? '' : this.selectedHeaderInfoData['jobStatus'],
        job_status: '',
        job_type: this.pageType[0],
        //job_no: action == 'N' && this.dpoFlag != 'CPO' ? '' : this.selectedHeaderInfoData['jobNo'],
        job_no: action == 'N' && this.dpoFlag != 'CPO' && !isSMKPartJob ? '' : this.selectedHeaderInfoData['jobNo'],
        urgent: '',
        job_date:
          this.selectedHeaderInfoData['jobTime'] ?
            new Date(this.selectedHeaderInfoData['jobTime']).formatString('yyyy-MM-dd')
          : '',
        jobtime:
          this.selectedHeaderInfoData['jobTime'] ?
            new Date(this.selectedHeaderInfoData['jobTime']).formatString('HHmm')
          : '',
        orderno: this.selectedHeaderInfoData['projectNo'],
        targetdate:
          this.selectedHeaderInfoData['requiredDate'] ?
            this.selectedHeaderInfoData['requiredDate'].formatString('yyyy-MM-dd')
          : '',
        cargotype_code:
          this.selectedHeaderInfoData['selectedCargoType'] ?
            this.selectedHeaderInfoData['selectedCargoType']['Cargo Type']
          : '',
        billcu_no:
          this.selectedHeaderInfoData['selectedBillTo'] ?
            this.selectedHeaderInfoData['selectedBillTo']['Customer Code']
          : '',
        brcode:
          this.selectedGeneralInfoData['selectedBranch'] ?
            this.selectedGeneralInfoData['selectedBranch']['Branch Code']
          : '',
        vendor: this.selectedGeneralInfoData['vendor'],
        custref: this.selectedHeaderInfoData['custRefNo'],
        custreftag: this.selectedeJob[0] ? this.selectedeJob[0]['AutoRequestNo'] : '',
        bookingrefno: '',
        bookbyshipper: this.selectedGeneralInfoData['vesselBkgBy'],
        remarks: this.selectedGeneralInfoData['remarks'],
        noofbl: this.selectedGeneralInfoData['oriBL'],
        noofnonnegobl: this.selectedGeneralInfoData['nonNegoBL'],
        pay_country:
          this.selectedGeneralInfoData['selectedCountry'] ?
            this.selectedGeneralInfoData['selectedCountry']['Country Code']
          : '',
        currency:
          this.selectedGeneralInfoData['selectedCurrency'] ?
            this.selectedGeneralInfoData['selectedCurrency']['Currency Code']
          : '',
        salesteam_code:
          this.selectedGeneralInfoData['selectedSalesTeam'] ?
            this.selectedGeneralInfoData['selectedSalesTeam']['Sales Team Code']
          : '',
        salesperson:
          this.selectedGeneralInfoData['selectedSalesPIC'] ?
            this.selectedGeneralInfoData['selectedSalesPIC']['Sales Person Code']
          : '',
        serviceteam_code:
          this.selectedGeneralInfoData['selectedServiceTeam'] ?
            this.selectedGeneralInfoData['selectedServiceTeam']['Service Team Code']
          : '',
        serviceperson:
          this.selectedGeneralInfoData['selectedServicePIC'] ?
            this.selectedGeneralInfoData['selectedServicePIC']['Service Person Code']
          : '',
        system: 'FMS',
        dateupdate: '',
        nextstatusno: '',
        currentstatus: '',
        jobconfirm: '',
        actfinishdate: '',
        actfinishtime: '',
        freightpayable:
          this.selectedGeneralInfoData['selectedFreightType'] ?
            this.selectedGeneralInfoData['selectedFreightType']['Freight Type']
          : '',
        // 'prev_refjobno': '',
        prev_refjobno:
          this.selectedeJob[0] ? this.selectedeJob[0]['AutoRequestNo']
          : this.dpoFlag == 'CPO' ? this.selectedHeaderInfoData['jobNo']
          : this.selectedGeneralInfoData['prevJobNo'],
        fumigation: this.selectedShippingInfoData['isFumigation'] ? '1' : '0',
        fdestetadate:
          this.selectedShippingInfoData['fDestETA'] ?
            new Date(this.selectedShippingInfoData['fDestETA']).formatString('yyyy-MM-dd')
          : '',
        fdestetatime:
          this.selectedShippingInfoData['fDestETA'] ?
            new Date(this.selectedShippingInfoData['fDestETA']).formatString('HHmm')
          : '',
        // dententiondate:
        //   this.selectedShippingInfoData['detention'] ?
        //     new Date(this.selectedShippingInfoData['detention']).formatString('yyyy-MM-dd HH:mm:ss')
        //   : '',
        jobformtype:
          this.selectedHeaderInfoData['selectedSmkFormType'] ?
            this.selectedHeaderInfoData['selectedSmkFormType']['Form Type']
          : '',
        packmat:
          this.selectedCargoInfoData['selectedPMaterial'] ?
            this.selectedCargoInfoData['selectedPMaterial']['Packing Material Code']
          : '',
        origincode:
          this.selectedGeneralInfoData['selectedIncoTerms'] ?
            this.selectedGeneralInfoData['selectedIncoTerms']['Incoterm']
          : '',
        trans_mode:
          this.selectedGeneralInfoData['selectedInsurance'] ?
            this.selectedGeneralInfoData['selectedInsurance']['Insurance'] == 'Yes' ?
              1
            : 0
          : '',
        station_code:
          this.selectedShippingInfoData['selectedStation'] ?
            this.selectedShippingInfoData['selectedStation']['Station Code']
          : '',
        voyno: this.selectedShippingInfoData['voyNo'],
        ship_id:
          this.selectedShippingInfoData['selectedVesselID'] ?
            this.selectedShippingInfoData['selectedVesselID']['Vessel ID']
          : '',
        shipcall_no:
          this.selectedShippingInfoData['selectedShipCall'] ?
            this.selectedShippingInfoData['selectedShipCall']['Ship Call No']
          : this.selectedShippingInfoData['shipCallNoValue'],
        vessel_name:
          this.selectedShippingInfoData['selectedVesselID'] ?
            this.selectedShippingInfoData['selectedVesselID']['Vessel Name']
          : this.selectedShippingInfoData['vesselIDValue'],
        ag_code:
          this.selectedShippingInfoData['selectedAgentList'] ?
            this.selectedShippingInfoData['selectedAgentList']['Agent Code']
          : '',
        shiplinecode:
          this.selectedShippingInfoData['selectedShippingLine'] ?
            this.selectedShippingInfoData['selectedShippingLine']['Agent Code']
          : '',
        shipline:
          this.selectedShippingInfoData['selectedShippingLine'] ?
            this.selectedShippingInfoData['selectedShippingLine']['Agent Name']
          : '',
        ffagt:
          this.selectedShippingInfoData['selectedFrtForwarder'] ?
            this.selectedShippingInfoData['selectedFrtForwarder']['Agent Code']
          : '',
        frt_no:
          this.selectedShippingInfoData['selectedFwdgAgent'] ?
            this.selectedShippingInfoData['selectedFwdgAgent']['FA Code']
          : '',
        spc_treatmnt:
          this.selectedShippingInfoData['selectedSpecialTreatment'] ?
            this.selectedShippingInfoData['selectedSpecialTreatment']['ST Code']
          : '',
        operator_code:
          this.selectedShippingInfoData['selectedPortOperator'] ?
            this.selectedShippingInfoData['selectedPortOperator']['Operator Code']
          : '',
        finaldest:
          this.selectedShippingInfoData['selectedFinalDestination'] ?
            this.selectedShippingInfoData['selectedFinalDestination']['Port Code']
          : '',
        closedate:
          this.selectedShippingInfoData['closingTime'] ?
            new Date(this.selectedShippingInfoData['closingTime']).formatString('yyyy-MM-dd')
          : '',
        closetime:
          this.selectedShippingInfoData['closingTime'] ?
            new Date(this.selectedShippingInfoData['closingTime']).formatString('HHmm')
          : '',
        manifest_no: '',
        bl_no: '',
        hbl_no: this.selectedGeneralInfoData['houseBL'],
        date_etd: '',
        time_etd: '',
        trans: this.selectedShippingInfoData['isTranshipment'] ? '1' : '0',
        mothervname:
          this.selectedShippingInfoData['selectedMVesselID'] ?
            this.selectedShippingInfoData['selectedMVesselID']['Vessel ID']
          : '',
        mothervno: this.selectedShippingInfoData['mVoyNo'],
        trans_port:
          this.selectedShippingInfoData['selectedPortDischarge2'] ?
            this.selectedShippingInfoData['selectedPortDischarge2']['Port Code']
          : '',
        datetranship:
          this.selectedShippingInfoData['ETATime'] ?
            new Date(this.selectedShippingInfoData['ETATime']).formatString('yyyy-MM-dd')
          : '',
        timetranship:
          this.selectedShippingInfoData['ETATime'] ?
            new Date(this.selectedShippingInfoData['ETATime']).formatString('HHmm')
          : '',
        bladdnotifyparty:
          this.selectedHeaderInfoData['selectedNotifyParty'] ?
            this.selectedHeaderInfoData['selectedNotifyParty']['Notify Party Code']
          : '',
        gweight: this.selectedCargoInfoData['gWeight'],
        measurement: this.selectedCargoInfoData['volume'],
        nweight: this.selectedCargoInfoData['chargeable'],
        package_code:
          this.selectedCargoInfoData['selectedPackageType'] ?
            this.selectedCargoInfoData['selectedPackageType']['Package Code']
          : '',
        no_package: this.selectedCargoInfoData['packageCount'],
        goodcollplace: this.selectedShippingInfoData['warehouse'],
        commoditycode:
          this.selectedCargoInfoData['selectedCommodity'] ?
            this.selectedCargoInfoData['selectedCommodity']['Commodity Code']
          : '',
        indicator: '', // reason if not confirm
        jobnoconfirmremarks: '', // remarks if not confirm
        cocode: '',
        transmode:
          this.selectedHeaderInfoData['selectedTransMode'] ?
            this.selectedHeaderInfoData['selectedTransMode']['Trans Mode']
          : '',
        // freestorage:
        //   this.selectedShippingInfoData['demurageTime'] ?
        //     new Date(this.selectedShippingInfoData['demurageTime']).formatString('yyyy-MM-dd HH:mm:ss')
        //   : '',
        // demurragedate:
        //   this.selectedShippingInfoData['demurageTime'] ?
        //     new Date(this.selectedShippingInfoData['demurageTime']).formatString('yyyy-MM-dd HH:mm:ss')
        //   : '',
        mvshipcallno: '',
        copyfr: this.dpoFlag || '',
        imp_name: this.consigneeAddress ? this.consigneeAddress['name'] : '', // consignee
        imp_attnto: this.consigneeAddress ? this.consigneeAddress['attn'] : '',
        imp_addr1: this.consigneeAddress ? this.consigneeAddress['add1'] : '',
        imp_addr2: this.consigneeAddress ? this.consigneeAddress['add2'] : '',
        imp_addr3: this.consigneeAddress ? this.consigneeAddress['add3'] : '',
        imp_addr4: this.consigneeAddress ? this.consigneeAddress['add4'] : '',
        imp_postcode: this.consigneeAddress ? this.consigneeAddress['postcode'] : '',
        imp_city: this.consigneeAddress ? this.consigneeAddress['city'] : '',
        imp_state: this.consigneeAddress ? this.consigneeAddress['state'] : '',
        imp_country: this.consigneeAddress ? this.consigneeAddress['country'] : '',
        imp_phoneno: this.consigneeAddress ? this.consigneeAddress['tel'] : '',
        imp_faxno: this.consigneeAddress ? this.consigneeAddress['fax'] : '',
        exp_name: this.shipperAddress ? this.shipperAddress['name'] : '', // shipper
        exp_attnto: this.shipperAddress ? this.shipperAddress['attn'] : '',
        exp_addr1: this.shipperAddress ? this.shipperAddress['add1'] : '',
        exp_addr2: this.shipperAddress ? this.shipperAddress['add2'] : '',
        exp_addr3: this.shipperAddress ? this.shipperAddress['add3'] : '',
        exp_addr4: this.shipperAddress ? this.shipperAddress['add4'] : '',
        exp_postcode: this.shipperAddress ? this.shipperAddress['postcode'] : '',
        exp_city: this.shipperAddress ? this.shipperAddress['city'] : '',
        exp_state: this.shipperAddress ? this.shipperAddress['state'] : '',
        exp_country: this.shipperAddress ? this.shipperAddress['country'] : '',
        exp_phoneno: this.shipperAddress ? this.shipperAddress['tel'] : '',
        exp_faxno: this.shipperAddress ? this.shipperAddress['fax'] : '',
        nparty_code:
          this.selectedHeaderInfoData['selectedNotifyParty'] ?
            this.selectedHeaderInfoData['selectedNotifyParty']['Notify Party Code']
          : '',
        nparty_name: this.notifyPartyAddress ? this.notifyPartyAddress['name'] : '',
        nparty_attnto: this.notifyPartyAddress ? this.notifyPartyAddress['attn'] : '',
        nparty_addr1: this.notifyPartyAddress ? this.notifyPartyAddress['add1'] : '',
        nparty_addr2: this.notifyPartyAddress ? this.notifyPartyAddress['add2'] : '',
        nparty_addr3: this.notifyPartyAddress ? this.notifyPartyAddress['add3'] : '',
        nparty_addr4: this.notifyPartyAddress ? this.notifyPartyAddress['add4'] : '',
        nparty_postcode: this.notifyPartyAddress ? this.notifyPartyAddress['postcode'] : '',
        nparty_city: this.notifyPartyAddress ? this.notifyPartyAddress['city'] : '',
        nparty_state: this.notifyPartyAddress ? this.notifyPartyAddress['state'] : '',
        nparty_country: this.notifyPartyAddress ? this.notifyPartyAddress['country'] : '',
        nparty_phoneno: this.notifyPartyAddress ? this.notifyPartyAddress['tel'] : '',
        nparty_faxno: this.notifyPartyAddress ? this.notifyPartyAddress['fax'] : '',
        imp_gst2license: this.consigneeAddress ? this.consigneeAddress['gst'] : '',
        exp_gst2license: this.shipperAddress ? this.shipperAddress['gst'] : '',
        actionflag: '',
        fumigatorcode:
          this.selectedShippingInfoData['selectedFumigator'] ?
            this.selectedShippingInfoData['selectedFumigator']['Supplier Code']
          : '',
        fumigationdate:
          this.selectedShippingInfoData['fumigateTime'] ?
            new Date(this.selectedShippingInfoData['fumigateTime']).formatString('yyyy-MM-dd')
          : '',
        fumigationtime:
          this.selectedShippingInfoData['fumigateTime'] ?
            new Date(this.selectedShippingInfoData['fumigateTime']).formatString('HHmm')
          : '',
        ventilationdate:
          this.selectedShippingInfoData['ventilationTime'] ?
            new Date(this.selectedShippingInfoData['ventilationTime']).formatString('yyyy-MM-dd')
          : '',
        ventilationtime:
          this.selectedShippingInfoData['ventilationTime'] ?
            new Date(this.selectedShippingInfoData['ventilationTime']).formatString('HHmm')
          : '',
        phytomarking: this.selectedShippingInfoData['phytoMarking'],
        fumigateat:
          this.selectedShippingInfoData['selectedLocation'] ?
            this.selectedShippingInfoData['selectedLocation']['Destination Code']
          : '',
        status: '',
        // new
        cu_number: '',
        imp_port: '',
        load_port:
          this.selectedShippingInfoData['selectedPortLoading'] ?
            this.selectedShippingInfoData['selectedPortLoading']['Port Code']
          : '',
        discharge_port: '',
        date_eta: '',
        datedchgload: '',
        timedchgload: '',
        time_eta: '',
        bladdimporter: '',
        bladdexporter: '',
        reason: '',
        imp_code: '',
        exp_code: '',
        type: '',
        // new
        goodsdescription: this.selectedShippingInfoData['goodsDescription'],
        shipmark: this.selectedShippingInfoData['shippingMarks'],
        packinglist: [],
        containerdetail: [],
        services: [],
        quotation_no:
          this.selectedHeaderInfoData['selectedQuotationNo'] ?
            this.selectedHeaderInfoData['selectedQuotationNo']['Quotation No']
          : null,

        freestorageval: this.selectedShippingInfoData['freeStorage'],
        freedemurrage: this.selectedShippingInfoData['freeDemurrage'],
        freedetention: this.selectedShippingInfoData['freeDetention'],
        storageunit: this.selectedShippingInfoData['storageUnit'],
        demurrageunit: this.selectedShippingInfoData['demurrageUnit'],
        detentionunit: this.selectedShippingInfoData['detentionUnit'],
      };
      postData['packinglist'] = this.formatCargoPkgList();
      postData['containerdetail'] = this.formatCargoContList();
      postData['services'] = this.formatServicesList();
      postData['documents'] = await this.formatDocuments();

      if (this.pageType[0] == 'E') {
        // Export Page
        postData['cu_number'] =
          this.selectedHeaderInfoData['selectedShipper'] ?
            this.selectedHeaderInfoData['selectedShipper']['Shipper Code']
          : '';
        postData['bladdimporter'] =
          this.selectedHeaderInfoData['selectedShipper'] ?
            this.selectedHeaderInfoData['selectedShipper']['Shipper Code']
          : '';
        postData['imp_code'] =
          this.selectedHeaderInfoData['selectedShipper'] ?
            this.selectedHeaderInfoData['selectedShipper']['Shipper Code']
          : '';

        postData['bookingrefno'] = this.selectedHeaderInfoData['vbkgRefNo'];

        postData['bladdexporter'] =
          this.selectedHeaderInfoData['selectedConsignee'] ?
            this.selectedHeaderInfoData['selectedConsignee']['Consignee Code']
          : '';
        postData['exp_code'] =
          this.selectedHeaderInfoData['selectedConsignee'] ?
            this.selectedHeaderInfoData['selectedConsignee']['Consignee Code']
          : '';

        postData['discharge_port'] =
          this.selectedShippingInfoData['selectedPortDischarge'] ?
            this.selectedShippingInfoData['selectedPortDischarge']['Port Code']
          : '';

        postData['date_eta'] =
          this.selectedShippingInfoData['polETD'] ?
            new Date(this.selectedShippingInfoData['polETD']).formatString('yyyy-MM-dd')
          : '';
        postData['time_eta'] =
          this.selectedShippingInfoData['polETD'] ?
            new Date(this.selectedShippingInfoData['polETD']).formatString('HHmm')
          : '';

        postData['datedchgload'] =
          this.selectedShippingInfoData['polETA'] ?
            new Date(this.selectedShippingInfoData['polETA']).formatString('yyyy-MM-dd')
          : '';
        postData['timedchgload'] =
          this.selectedShippingInfoData['polETA'] ?
            new Date(this.selectedShippingInfoData['polETA']).formatString('HHmm')
          : '';
      } else {
        // Import Page
        postData['bladdexporter'] =
          this.selectedHeaderInfoData['selectedShipper'] ?
            this.selectedHeaderInfoData['selectedShipper']['Shipper Code']
          : '';
        postData['exp_code'] =
          this.selectedHeaderInfoData['selectedShipper'] ?
            this.selectedHeaderInfoData['selectedShipper']['Shipper Code']
          : '';

        postData['cu_number'] =
          this.selectedHeaderInfoData['selectedConsignee'] ?
            this.selectedHeaderInfoData['selectedConsignee']['Consignee Code']
          : '';
        postData['bladdimporter'] =
          this.selectedHeaderInfoData['selectedConsignee'] ?
            this.selectedHeaderInfoData['selectedConsignee']['Consignee Code']
          : '';
        postData['imp_code'] =
          this.selectedHeaderInfoData['selectedConsignee'] ?
            this.selectedHeaderInfoData['selectedConsignee']['Consignee Code']
          : '';

        postData['bl_no'] = this.selectedHeaderInfoData['vbkgRefNo'];

        postData['imp_port'] =
          this.selectedShippingInfoData['selectedPortDischarge'] ?
            this.selectedShippingInfoData['selectedPortDischarge']['Port Code']
          : '';

        postData['datedchgload'] =
          this.selectedShippingInfoData['polETD'] ?
            new Date(this.selectedShippingInfoData['polETD']).formatString('yyyy-MM-dd')
          : '';
        postData['timedchgload'] =
          this.selectedShippingInfoData['polETD'] ?
            new Date(this.selectedShippingInfoData['polETD']).formatString('HHmm')
          : '';

        postData['date_eta'] =
          this.selectedShippingInfoData['polETA'] ?
            new Date(this.selectedShippingInfoData['polETA']).formatString('yyyy-MM-dd')
          : '';
        postData['time_eta'] =
          this.selectedShippingInfoData['polETA'] ?
            new Date(this.selectedShippingInfoData['polETA']).formatString('HHmm')
          : '';
      }

      if (!noload) {
        // Only show the loading if noload is null or undefined
        this.$fullscreenLoading('Check Compulsory Fields');
      }

      let compulsoryError = await this.$apiCallV2('/FreightForwarding/CheckSaveJSON', postData); //check FreightForwardingModel.cs for compulsory fields
      this.$fullscreenLoading();

      if (this.selectedGeneralInfoData['oriBL'] > 255) {
        this.selectedGeneralInfoData['oriBLError'] = 'No. of Original B/L cannot exceed the value of 255';
        this.rMessages.push({
          Key: 'No. of Original B/L',
          Value: 'No. of Original B/L cannot exceed the value of 255',
        });
      }

      if (this.selectedGeneralInfoData['nonNegoBL'] > 255) {
        this.selectedGeneralInfoData['nonNegoBLError'] = 'No. of Non-Nego B/L cannot exceed the value of 255';
        this.rMessages.push({
          Key: 'No. of Non-Nego B/L',
          Value: 'No. of Non-Nego B/L cannot exceed the value of 255',
        });
      }

      if (this.pageType == 'Import' && !this.selectedHeaderInfoData['selectedConsignee']) {
        this.rMessages.push({ Key: 'consignee', Value: 'Consignee is Required' });
      } else if (this.pageType == 'Export' && !this.selectedHeaderInfoData['selectedShipper']) {
        this.rMessages.push({ Key: 'shipper', Value: 'Shipper is Required' });
      }

      // if (this.pageType == 'Export' && !this.selectedShippingInfoData['polETD']) { // removed due to double error message
      //   this.rMessages.push({ 'Key': 'timedchgload', 'Value': 'ETD Date and Time is Required' });
      // }

      if (this.pageType == 'Export' && !this.selectedHeaderInfoData['vbkgRefNo']) {
        if (this.selectedHeaderInfoData['selectedTransMode']) {
          if (this.selectedHeaderInfoData['selectedTransMode']['Trans Mode'] == 'S') {
            this.rMessages.push({ Key: 'vbkgRefNo', Value: 'VBkg Ref # is Required' });
          }
        }
      }
      if (this.selectedShippingInfoData['isFumigation'] == '1') {
        if (!this.selectedShippingInfoData['selectedFumigator']) {
          this.rMessages.push({ Key: 'fumigator', Value: 'Fumigator is Required' });
        }
        if (!this.selectedShippingInfoData['selectedLocation']) {
          this.rMessages.push({ Key: 'location', Value: 'Location is Required' });
        }
        if (!this.selectedShippingInfoData['fumigateTime']) {
          this.rMessages.push({ Key: 'fumigate_on', Value: 'Fumigator on is Required' });
        }
        if (!this.selectedShippingInfoData['ventilationTime']) {
          this.rMessages.push({ Key: 'ventilation', Value: 'Ventilation on is Required' });
        }
      }
      if (this.selectedShippingInfoData['isTranshipment'] == '1') {
        if (!this.selectedShippingInfoData['selectedMVesselID']) {
          this.rMessages.push({ Key: 'vesselID', Value: 'M. Vessel ID is Required' });
        }
        if (!this.selectedShippingInfoData['mVoyNo']) {
          this.rMessages.push({ Key: 'voyageNo', Value: 'M. Voyage # is Required' });
        }
      }

      if (this.pageType == 'Export' && !this.selectedShippingInfoData['closingTime']) {
        this.rMessages.push({ Key: 'closing_time', Value: 'Closing Date and Time is Required' });
      }

      if (compulsoryError) {
        if (this.pageType == 'Export') {
          const polEmpty = compulsoryError['error'].find((c) => c['Key'] == 'imp_port');
          const index = compulsoryError['error'].indexOf(polEmpty);
          compulsoryError['error'].splice(index, 1);

          if (compulsoryError['error'].length == 0) {
            compulsoryError = null;
          }
        }
      }

      if (this.pageType == 'Export' && !this.selectedShippingInfoData['polETA']) {
        this.rMessages.push({ Key: 'time_eta', Value: 'POD ETA Date and Time is Required' });
      }

      if (this.selectedHeaderInfoData['selectedTransMode']) {
        if (compulsoryError) {
          for (const error of compulsoryError['error']) {
            switch (error['Key']) {
              case 'shipcall_no':
                error['Value'] = `${this.selectedHeaderInfoData['selectedTransMode']['ShipCallNo']} is Required`;
                break;
              case 'ship_id':
                error['Value'] = `${this.selectedHeaderInfoData['selectedTransMode']['VesselID']} is Required`;
                break;
              case 'ag_code':
                error['Value'] = `${this.selectedHeaderInfoData['selectedTransMode']['ShippingAgent']} is Required`;
                break;
            }
          }
        }
      }

      if (this.selectedHeaderInfoData['selectedCargoType']) {
        if (
          this.selectedHeaderInfoData['selectedCargoType']['Cargo Type'][0] != 'F' &&
          !this.selectedCargoInfoData['gWeight']
        ) {
          this.rMessages.push({ Key: 'gWeightInput', Value: 'Gross Weight is Required' });
        }
      }

      if ((compulsoryError || this.rMessages.length > 0) && !bypassCompulsory) {
        // Not all compulsory fields filled in
        this.currentTabIndex = 0;
        if (compulsoryError) {
          this.rMessages = compulsoryError['error']
            .filter((e) => {
              return e['Key'] != 'datedchgload' && e['Key'] != 'date_eta';
            })
            .concat(this.rMessages);
        } //appending the words to the error message should be happening here YENKHAI
        this.saveErrorList = this.rMessages.map((r) => {
          return `${r['Value'].replace(' is Required', '').trim()}`;
        });

        const requiredError = this.rMessages.filter((r) => {
          return (
            r['Key'] == 'cargotype_code' ||
            r['Key'] == 'billcu_no' ||
            r['Key'] == 'consignee' ||
            r['Key'] == 'shipper' ||
            r['Key'] == 'No. of Original B/L' ||
            r['Key'] == 'No. of Non-Nego B/L'
          );
        });
        if (requiredError.length > 0) {
          // If bill to, cargo type and consignee/shipper is empty
          requiredError.forEach((r) => {
            this.errorMessages[r['Key']] = r['Value'];
          });
          this.saveErrorList = requiredError.map((r) => {
            return `${r['Value'].replace(' is Required', '').trim()}`;
          });

          this.saveAlertType = 'requiredCantSave';
          this.savePopupType = 'error';
          this.savePopupTitle = 'Error Saving Job';
          this.savePopupButtons = [];
          this.showSavePopup = true;

          return;
        } // Required fields has empty or invalid but save as unconfirm job
        this.popupError = true;
        this.saveAlertType = 'required';
        this.savePopupType = 'warning';
        this.savePopupTitle = 'The below fields are required but is empty or invalid';
        this.savePopupButtons = [{ text: 'Yes' }, { text: 'No', color: 'lightgray' }];
        this.showSavePopup = true;

        // Uncomment the lines below to show red error box in each compulsory fields
        this.rMessages.forEach((r) => {
          this.errorMessages[r['Key']] = r['Value'];
        });
      } else if (!bypassCompulsory) {
        // All compulsory fields filled in
        this.popupError = false;
        this.saveAlertType = 'choiceMode';
        this.savePopupType = 'warning';
        this.savePopupTitle = 'Saving Job';
        this.savePopupButtons = [{ text: 'Save' }, { text: 'Cancel', color: 'lightgray' }];
        this.showSavePopup = true;
      }

      if (this.eJobFullDetails) {
        postData['efms'] = '1';
      }

      if (save) {
        // If user choose to save the job
        if (this.saveAlertType == 'requiredCantSave' || this.saveAlertType == 'required') {
          postData['jobconfirm'] = false;
        } else {
          postData['jobconfirm'] = this.saveAsConfirm;
        }

        postData['indicator'] = this.selectedUnconfirmReason ? this.selectedUnconfirmReason['Reason'] : '';
        postData['jobnoconfirmremarks'] = this.unconfirmRemarks;

        if (isSMKPartJob) {
          const mainJobNo = this.smkPartJobContext.mainJobNo || this.getSelectedMainJobNo();
          const partJobNo = this.smkPartJobContext.smkJobNo || this.selectedHeaderInfoData['jobNo'];

          if (!mainJobNo || !partJobNo) {
            this.eMessages.push('Unable to save SMK Part Job. Main Job No or SMK Job No is missing.');
            return;
          }

          let smkSaveResult = null;

          if (postData['action'] == 'E' || postData['action'] == 'N') {
            this.$fullscreenLoading('Saving SMK Part Job');
            smkSaveResult = await this.saveSMKDetails(partJobNo, postData['action'], {
              sourceTable: 'SMKJOB',
              mainJobNo,
              smkJobNo: partJobNo,
              forwarding: postData,
              partJobMode: this.popupTitle === 'Duplicate Part Job' ? 'DUPLICATE' : 'NEW',
            });
            this.$fullscreenLoading();
          }

          this.sMessages = [];
          this.eMessages = [];
          this.rMessages = [];

          if (smkSaveResult && smkSaveResult[0] && smkSaveResult[0]['Results'] == 0) {
            if (postData['action'] == 'N') {
              this.sMessages.push('Successfully saved SMK Part Job!');
              this.sMessages.push(`Your SMK part job number is ${partJobNo}`);
            } else {
              this.sMessages.push(`Successfully edited SMK Part Job ${partJobNo}!`);
            }

            this.popupTitle = `View Part Job ${partJobNo}`;
            this.viewMode = true;

            // Leave the saved job unselected until the user clicks the main job again.
            this.showSMKRightMenu = false;
            this.clearSMKSideDetails();
            this.showSMKDetails = false;
            this.smkPartJobList = [];
            this.selectedsmkPartJob = [];
            this.selectedJob = [];

            this.refreshClicked(false);
            return;
          }

          this.eMessages.push(
            smkSaveResult && smkSaveResult[0] && smkSaveResult[0]['ErrMsg'] ?
              smkSaveResult[0]['ErrMsg']
            : 'Save SMK Part Job failed.',
          );
          return;
        }

        if (postData['action'] == 'E' && !(await this.confirmSMKFormTypeChange())) {
          return;
        }

        this.$fullscreenLoading('Saving Job');
        const saveResult = await this.$apiCallV2('/FreightForwarding/SaveFrtFwdJob', postData);
        this.$fullscreenLoading();

        this.sMessages = [];
        this.eMessages = [];
        this.rMessages = [];

        if (saveResult[0]['Results'] == 0) {
          const savedJobNo = saveResult[0]['Job_No'] || this.selectedHeaderInfoData['jobNo'];

          if (postData['action'] == 'E' || postData['action'] == 'N') {
            const smkSaveResult = await this.saveSMKDetails(savedJobNo, postData['action']);

            if (smkSaveResult && smkSaveResult[0] && smkSaveResult[0]['Results'] != 0) {
              this.eMessages.push(`Job saved but SMK details failed. ${smkSaveResult[0]['ErrMsg'] || ''}`.trim());
              return;
            }
          }

          if (postData['action'] == 'N') {
            this.sMessages.push('Successfully saved job!');
            this.sMessages.push(`Your job number is ${saveResult[0]['Job_No']}`);
            // this.sMessages.push(`${window.location.origin}/Reports/Job%20Sheet/${saveResult[0]['Job_No']}`);
            this.sMessages.push(
              `<a href="${window.location.origin}/${this.userParam}/ReportsV2/Job%20Sheet?jobNo=${saveResult[0]['Job_No']}" target="_blank">View Job Sheet</a>`,
            );

            this.selectedHeaderInfoData['jobNo'] = saveResult[0]['Job_No'];
            this.selectedHeaderInfoData['jobStatus'] = !postData['jobconfirm'] ? 'Unconfirmed' : 'Confirmed';
          } else {
            this.sMessages.push(`Successfully edited job for Job No ${this.selectedHeaderInfoData['jobNo']}!`);
          }

          this.popupTitle = `View ${this.pageType} Job`;
          this.viewMode = true;

          this.documentsToDelete = [];

          this.eJobFullDetails = null;
          this.eJobAttachments = null;
          this.selectedeJob = [];
          this.showEJobPopup = false;

          this.$nextTick(async () => {
            this.selectedCargoInfoData['subPkgList'] = [];
            this.selectedCargoInfoData['contDetailsList'] = [];
            this.selectedDocumentInfoData['docData'] = [];
            this.selectedJob = [{ 'Job No': savedJobNo }];

            await this.loadSMKDetailsForSelection('JOB');
            await this.viewEditClicked('v');

            this.showSMKRightMenu = false;
            this.clearSMKSideDetails();
          });

          this.refreshClicked(false);
        } else {
          this.eMessages.push(saveResult[0]['ErrMsg']);
        }
      }
    },
    validateDateOrder: async function (dateField1, dateField2, alertMessage, focusField) {
      if (
        this.selectedShippingInfoData[dateField1] &&
        this.selectedShippingInfoData[dateField2] &&
        this.selectedShippingInfoData[dateField1] > this.selectedShippingInfoData[dateField2]
      ) {
        const invalidDate = await this.$showAlert('warning', 'Invalid Date selection', alertMessage, [{ text: 'OK' }]);
        if (invalidDate === 'OK') {
          this.requiredClicked(focusField);
          return false;
        }
      }
      return true;
    },
    validateDates: async function () {
      if (this.pageType === 'Export') {
        return (
          (await this.validateDateOrder('polETD', 'polETA', 'POD ETA cannot be earlier than POL ETA!', 'polETD')) &&
          (await this.validateDateOrder(
            'polETD',
            'fDestETA',
            'Final Dest. ETA cannot be earlier than POL ETA!',
            'fDestETA',
          )) &&
          (await this.validateDateOrder(
            'polETA',
            'fDestETA',
            'Final Dest. ETA cannot be earlier than POD ETA!',
            'fDestETA',
          ))
        );
      } else if (this.pageType === 'Import') {
        return (
          (await this.validateDateOrder('polETD', 'polETA', 'POD ETA cannot be earlier than POL ETD!', 'polETD')) &&
          (await this.validateDateOrder(
            'polETD',
            'fDestETA',
            'Final Dest. ETA cannot be earlier than POL ETD!',
            'fDestETA',
          )) &&
          (await this.validateDateOrder(
            'polETA',
            'fDestETA',
            'Final Dest. ETA cannot be earlier than POD ETA!',
            'fDestETA',
          ))
        );
      }

      return true;
    },
    checkDateTime: function (field, date, isSaving) {
      //console.log('Checking date for field:', field, 'with date:', date, 'during:', isSaving);
      if (!date) return;

      if (date > this.smallDateTimeMaxDate) {
        this.errorMessages[field] =
          `Please select date earlier than ${this.smallDateTimeMaxDate.formatString('yyyy-MM-dd')}`;
        return true;
      }

      if (date < this.smallDateTimeMinValue) {
        this.errorMessages[field] =
          `Please select date later than ${this.smallDateTimeMinValue.formatString('yyyy-MM-dd')}`;
        return true;
      }

      if ((field == 'time_eta' || field == 'polETA') && isSaving != 'save') {
        this.calculateDefaultDates('ETA', date);
      }
    },
    checkPopupEntryFields: function () {
      this.rMessages = []; // Reset

      const fieldsToCheck = [
        { data: this.selectedHeaderInfoData, dataKey: 'jobTime', errorKey: 'jobtime' },
        { data: this.selectedShippingInfoData, dataKey: 'closingTime', errorKey: 'closing_time' },
        { data: this.selectedShippingInfoData, dataKey: 'polETD', errorKey: 'timedchgload' },
        { data: this.selectedShippingInfoData, dataKey: 'polETA', errorKey: 'time_eta' },
        { data: this.selectedHeaderInfoData, dataKey: 'requiredDate', errorKey: 'requireddate' },
        { data: this.selectedShippingInfoData, dataKey: 'demurageTime', errorKey: 'demuragetime' },
        { data: this.selectedShippingInfoData, dataKey: 'detention', errorKey: 'detention' },
        { data: this.selectedShippingInfoData, dataKey: 'ETATime', errorKey: 'etatime' },
        { data: this.selectedShippingInfoData, dataKey: 'polETD', errorKey: 'polETD' },
        { data: this.selectedShippingInfoData, dataKey: 'polETA', errorKey: 'polETA' },
        { data: this.selectedShippingInfoData, dataKey: 'fDestETA', errorKey: 'fDestETA' },
        { data: this.selectedShippingInfoData, dataKey: 'fumigateTime', errorKey: 'fumigate_on' },
        { data: this.selectedShippingInfoData, dataKey: 'ventilationTime', errorKey: 'ventilation' },
      ];

      fieldsToCheck.forEach(({ data, dataKey, errorKey }) => {
        const value = data[dataKey];
        if (value) {
          if (this.checkDateTime(errorKey, value, 'save')) {
            this.rMessages.push({ Key: errorKey, Value: this.errorMessages[errorKey] });
          }
        }
      });

      if (this.rMessages.length > 0) {
        this.rMessages.forEach((r) => {
          this.errorMessages[r.Key] = r.Value;
        });
        return false; //stop saving, there are date errors
      }
      return true; // continue save
      // simplified the logic below to above code
      //if (this.selectedShippingInfoData['closingTime'] != null && this.selectedShippingInfoData['closingTime'] != '') {
      //   if (this.checkDateTime('closing_time', this.selectedShippingInfoData['closingTime'])) {
      //     this.rMessages.push({ Key: 'closing_time', Value: this.errorMessages['closing_time'] });
      //   }
      // }
    },
    savePopupButtonClicked: function (e) {
      switch (e) {
        case 'Yes':
          if (!this.selectedUnconfirmReason) {
            this.popupErrorText = 'Please select your reason';
          } else if (
            this.selectedUnconfirmReason['Reason'].includes('OTHERS') &&
            (!this.unconfirmRemarks || !this.unconfirmRemarks.trim())
          ) {
            this.popupErrorText = 'Please state your remarks';
          } else {
            this.saveClicked(true, true, true);
            this.showSavePopup = false;
          }
          break;
        case 'Save':
          if (!this.saveAsConfirm) {
            if (!this.selectedUnconfirmReason) {
              this.popupErrorText = 'Please select your reason';
            } else if (this.selectedUnconfirmReason['Reason'].includes('OTHERS') && !this.unconfirmRemarks) {
              this.popupErrorText = 'Please state your remarks';
            } else {
              this.saveClicked(true, true, true);
              this.showSavePopup = false;
            }
          } else {
            this.saveClicked(true, true, true);
            this.showSavePopup = false;
          }
          break;
        default:
          this.showSavePopup = false;
          this.selectedSaveBy = { keyValue: '1', label: 'Confirm Job' };
          break;
      }
    },
    requiredClicked: function (e) {
      this.inputTabs.forEach((inputField) => {
        if (inputField.key === e) {
          this.currentTabIndex = inputField.tab;
          this.$nextTick(() => {
            this.$refs[e].setFocus();
          });
        }
      });
    },
    closeClicked: function () {
      this.showDocUpload = false;

      Object.keys(this.selectedHeaderInfoData).forEach((k) => {
        this.selectedHeaderInfoData[k] = null;
      });
      Object.keys(this.selectedGeneralInfoData).forEach((k) => {
        this.selectedGeneralInfoData[k] = null;
      });
      Object.keys(this.selectedShippingInfoData).forEach((k) => {
        this.selectedShippingInfoData[k] = null;
      });
      Object.keys(this.selectedCargoInfoData).forEach((k) => {
        if (k == 'subPkgList' || k == 'contDetailsList') {
          this.selectedCargoInfoData[k] = [];
        } else {
          this.selectedCargoInfoData[k] = null;
        }
      });

      this.selectedDocumentInfoData['docData'] = [];
      this.selectedDocumentInfoData['selectedDoc'] = null;

      this.editDeleteDoc = [];
      this.editAddDoc = [];

      this.dnListing = [];
      this.rotListing = [];
      this.statusTaskListing = [];
      this.smkListing = [];

      this.currentTabIndex = 1;
      this.$refs.jobformcomponent.resetFile();
    },
    submitVerifiedInfo: function ({
      selectedHeaderInfoData,
      selectedGeneralInfoData,
      selectedShippingInfoData,
      selectedCargoInfoData,
      subPackageList,
      containerList,
    }) {
      this.showDocUpload = false;
      this.selectedHeaderInfoData = selectedHeaderInfoData;
      const selectedBillTo = selectedHeaderInfoData['selectedBillTo'];
      this.selectedGeneralInfoData = selectedGeneralInfoData;
      this.selectedShippingInfoData = selectedShippingInfoData;
      this.selectedCargoInfoData = selectedCargoInfoData;
      this.selectedHeaderInfoData['jobNo'] = '**********';
      this.selectedHeaderInfoData['jobStatus'] = 'New';
      this.selectedHeaderInfoData['jobTime'] = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate(),
        new Date().getHours(),
        new Date().getMinutes(),
        0,
        0,
        0,
      );

      // console.log(this.selectedHeaderInfoData)
      if (this.selectedHeaderInfoData['selectedConsignee']) {
        this.$nextTick(() => this.consigneeSelected(this.selectedHeaderInfoData['selectedConsignee']));
      }
      if (this.selectedHeaderInfoData['selectedShipper']) {
        this.$nextTick(() => this.shipperSelected(this.selectedHeaderInfoData['selectedShipper']));
      }
      this.$nextTick(() => (this.selectedHeaderInfoData['selectedBillTo'] = selectedBillTo)); // set back to what the user have chosen in doc ai

      const docAIShipperAddress = selectedHeaderInfoData.shipperAddress;
      const docAIConsigneeAddress = selectedHeaderInfoData.consigneeAddress;
      const docAINotifyPartyAddress = selectedHeaderInfoData.notifyPartyAddress;

      this.$nextTick(() => {
        // set back to what the address details of user have chosen in doc ai
        if (docAIShipperAddress) {
          this.shipperAddress = docAIShipperAddress;
        }

        if (docAIConsigneeAddress) {
          this.consigneeAddress = docAIConsigneeAddress;
        }

        if (docAINotifyPartyAddress) {
          this.notifyPartyAddress = docAINotifyPartyAddress;
        }
      });

      //console.log(containerList)
      if (containerList) {
        this.$nextTick(() => {
          containerList.forEach((element) => {
            this.selectedCargoInfoData['contDetailsList'].push({
              'Cont #': element.contNo,
              'Seal No': element.sealNo,
              'Cont Size': element.contSize ? element.contSize : null,
              'Cont Type': element.contType ? element.contType.trim() : null,
              'Cont Weight': element.contWeight ? this.$weightFormat(element.contWeight) : this.$weightFormat('0'),
              Status: element.status ? element.status.trim() : null,
              'Handling Type': element.handlingType ? element.handlingType.trim() : null,
              'Delivery Type': element.deliveryType ? element.deliveryType.trim() : null,
              'Send To': element.sendTo ? element.sendTo.trim() : null,
              'SOC/COC': element.contSocCoc,
              Remarks: element.remarks,
              //'From API': element.fromAPI, - weishen unsure if this is needed, will leave it out for now
              item_action: 'N',
            });
          });
        });
      }
      if (subPackageList) {
        this.$nextTick(() => {
          subPackageList.forEach((element) => {
            const grossWeight = `${this.convertNumber(element.grossWeight)}KG (${this.convertNumber(element.grossPerPkg)}KG)`;
            const netWeight = `${this.convertNumber(element.netWeight)}KG (${this.convertNumber(element.netPerPkg)}KG)`;
            const volume = `${this.convertNumber(element.totalVol)}M³ (${this.convertNumber(element.volPerPkg)}M³)`;
            const dimensions = `${element.dimensions.pkgLength ? this.convertNumber(element.dimensions.pkgLength) : this.$weightFormat('0')}m X 
                          ${element.dimensions.pkgWidth ? this.convertNumber(element.dimensions.pkgWidth) : this.$weightFormat('0')}m X 
                          ${element.dimensions.pkgHeight ? this.convertNumber(element.dimensions.pkgHeight) : this.$weightFormat('0')}m`;

            this.selectedCargoInfoData['subPkgList'].push({
              'Package Quantity': element.pkgQty,
              'Package Type': element.pkgType ? element.pkgType.trim() : null,
              Dimensions: dimensions,
              'Gross Weight': grossWeight,
              'Net Weight': netWeight,
              Volume: volume,
              'Item Code': element.itemCode ? element.itemCode.trim() : null,
              'Packing List #': element.packingListNumber,
              'Invoice #': element.invoiceNumber,
              'Container #': element.containerNumber,
              Remarks: element.pkgRemarks,
              seq_no: '',
              item_action: 'N',
            });
          });
        });
      }

      this.$refs.jobformcomponent.resetFile();
      this.showPopup = true;
    },

    addDoc: function () {
      this.documentInfoData['updatePopup'] = true;
    },

    documentUpdate: async function (e) {
      const editDetails = this.editDocumentsList;
      const details = e['details'];
      const hasStatus = details['statuses'];

      const allData = [];

      if (hasStatus == 'N/A') {
        // Doc without status
        const att = Array.from(details['attachment']);

        if (editDetails.length > 0) {
          // For edit
          if (details['docRef'] != editDetails[0]['Doc Ref #']) {
            // Changes in docref#
            editDetails.forEach((ed) => {
              // let index = this.selectedDocumentInfoData['docData'].indexOf(ed);
              const index = this.selectedDocumentInfoData['docData'].findIndex(
                (d) => JSON.stringify(d) == JSON.stringify(ed),
              );
              ed['Action'] = ed['Action'] == 'N' ? ed['Action'] : 'E';
              ed['Doc Ref #'] = details['docRef'];
              ed['ID'] = `${details['docCode']}-${details['docRef']}`;

              this.selectedDocumentInfoData['docData'].splice(index, 1, ed);
            });
          }
        }

        const fixedData = {
          'Doc Code': details['docCode'],
          'Doc Ref #': details['docRef'],
          Attachment: '',
          Remarks: '',
          Status: 'N/A',
          'Start Date': 'N/A',
          'Received Date': 'N/A',
          'Due Date': 'N/A',
          'Assign To': 'N/A',
          Sets: 'N/A',
          Page: 'N/A',

          documentguid: '',
          statusseqno: '',
          ID: `${details['docCode']}-${details['docRef']}`,
          fileAtt: '',
          filetype: '',
          Action: 'N',
        };

        if (att.length > 0) {
          // if has attachment
          for (const a of att) {
            const attBase64 = await this.$convertFile.toBase64(a);
            allData.push({
              'Doc Code': details['docCode'],
              'Doc Ref #': details['docRef'],
              Attachment: a.name,
              Remarks: '',
              Status: 'N/A',
              'Start Date': 'N/A',
              'Received Date': 'N/A',
              'Due Date': 'N/A',
              'Assign To': 'N/A',
              Sets: 'N/A',
              Page: 'N/A',

              documentguid: '',
              statusseqno: '',
              ID: `${details['docCode']}-${details['docRef']}`,
              fileAtt: attBase64,
              filetype: a.type,
              Action: 'N',
            });
          }
        } else if (editDetails.length == 0 && details) {
          // without attachment and not edit ?? !editDetails
          allData.push(fixedData);
        }

        const temp = this.selectedDocumentInfoData['docData'];
        this.selectedDocumentInfoData['docData'] = [];
        this.$nextTick(() => {
          this.selectedDocumentInfoData['docData'] = temp.concat(allData);
        });
      } else {
        // Doc with status
        const statusChecked = hasStatus.filter((s) => s['checked']);
        for (const s of statusChecked) {
          allData.push({
            'Doc Code': details['docCode'],
            'Doc Ref #': details['docRef'],
            Attachment: s['attachment'] ? s['attachment'][0].name : '',
            Remarks: s['remarks'],
            Status: s['docStatus'],
            'Start Date': s['start'] ? new Date(s['start']).formatString('yyyy-MM-dd HH:mm') : '',
            'Received Date': s['received'] ? new Date(s['received']).formatString('yyyy-MM-dd HH:mm') : '',
            'Due Date': s['due'] ? new Date(s['due']).formatString('yyyy-MM-dd HH:mm') : '',
            'Assign To': s['assignTo'],
            Sets: s['sets'],
            Page: s['page'],

            documentguid: '',
            statusseqno: '',
            ID: `${details['docCode']}-${details['docRef']}`,
            fileAtt: s['attachment'] ? await this.$convertFile.toBase64(s['attachment'][0]) : '',
            filetype: s['attachment'] ? s['attachment'][0].type : '',
            Action: 'N',
          });
        }

        if (editDetails.length == 0) {
          // For new
          const temp = this.selectedDocumentInfoData['docData'];
          this.selectedDocumentInfoData['docData'] = [];
          //if no status check then add a blank record to allData.
          if (allData.length == 0) {
            const fixedData = {
              'Doc Code': details['docCode'],
              'Doc Ref #': details['docRef'],
              Attachment: '',
              Remarks: '',
              Status: '',
              'Start Date': '',
              'Received Date': '',
              'Due Date': '',
              'Assign To': '',
              Sets: '',
              Page: '0',

              documentguid: '',
              statusseqno: '',
              ID: `${details['docCode']}-${details['docRef']}`,
              fileAtt: '',
              filetype: '',
              Action: 'N',
            };
            allData.push(fixedData);
          }

          this.$nextTick(() => {
            this.selectedDocumentInfoData['docData'] = temp.concat(allData);
          });
        } else {
          // For edit
          //find if there is any records that have empty status. If yes then add that record into allData
          const emptyStatus = editDetails.find((f) => f['Status'] === '');
          if (emptyStatus) {
            const fixedData = {
              'Doc Code': emptyStatus['docCode'],
              'Doc Ref #': emptyStatus['docRef'],
              Attachment: '',
              Remarks: '',
              Status: '',
              'Start Date': '',
              'Received Date': '',
              'Due Date': '',
              'Assign To': '',
              Sets: '',
              Page: '0',

              documentguid: '',
              statusseqno: '',
              ID: `${emptyStatus['docCode']}-${emptyStatus['docRef']}`,
              fileAtt: '',
              filetype: '',
              Action: 'N',
            };
            allData.push(fixedData);
          }

          const oldStatus = editDetails.map((ed) => ed['Status']);
          const newStatus = allData.map((ad) => ad['Status']);

          const toDelete = oldStatus.filter((o) => !newStatus.includes(o));
          const toAdd = newStatus.filter((n) => !oldStatus.includes(n));
          const toCheck = newStatus.filter((n) => oldStatus.includes(n));

          toDelete.forEach((d) => {
            const deleting = editDetails.find((ed) => ed['Status'] == d);
            // let index = this.selectedDocumentInfoData['docData'].indexOf(deleting);
            const index = this.selectedDocumentInfoData['docData'].findIndex(
              (d) => JSON.stringify(d) == JSON.stringify(deleting),
            );

            this.selectedDocumentInfoData['docData'].splice(index, 1);
            deleting['Action'] = 'D';
            this.documentsToDelete.push(deleting);
          });
          toAdd.forEach((a) => {
            const adding = allData.find((ad) => ad['Status'] == a);
            this.selectedDocumentInfoData['docData'].push(adding);
          });
          toCheck.forEach((c) => {
            const oldData = editDetails.find((ed) => ed['Status'] == c);
            const newData = allData.find((ed) => ed['Status'] == c);
            // let index = this.selectedDocumentInfoData['docData'].indexOf(oldData);
            const index = this.selectedDocumentInfoData['docData'].findIndex(
              (d) => JSON.stringify(d) == JSON.stringify(oldData),
            );

            Object.keys(oldData).forEach((k) => {
              if (oldData[k] == null) {
                oldData[k] = '';
              }
            });

            if (oldData['Sets'] == 0) {
              oldData['Sets'] = '';
            }
            if (oldData['Page'] == 0) {
              oldData['Page'] = '';
            }

            let hasChanges = false;

            if (newData['Attachment']) {
              hasChanges = true;
            }

            if (
              newData['Start Date'] != oldData['Start Date'] ||
              newData['Received Date'] != oldData['Received Date'] ||
              newData['Due Date'] != oldData['Due Date'] ||
              newData['Remarks'] != oldData['Remarks'] ||
              newData['Assign To'] != oldData['Assign To'] ||
              newData['Sets'] != oldData['Sets'] ||
              newData['Page'] != oldData['Page']
            ) {
              oldData['Start Date'] = newData['Start Date'];
              oldData['Received Date'] = newData['Received Date'];
              oldData['Due Date'] = newData['Due Date'];
              oldData['Remarks'] = newData['Remarks'];
              oldData['Assign To'] = newData['Assign To'];
              oldData['Sets'] = newData['Sets'];
              oldData['Page'] = newData['Page'];

              hasChanges = true;
            }

            if (hasChanges) {
              oldData['Action'] = oldData['Action'] == 'N' ? oldData['Action'] : 'E';
              this.selectedDocumentInfoData['docData'].splice(index, 1, oldData);
            }

            if (details['docRef'] != editDetails[0]['Doc Ref #']) {
              // Changes in docref#
              editDetails.forEach((ed) => {
                // let index = this.selectedDocumentInfoData['docData'].indexOf(ed);
                const index = this.selectedDocumentInfoData['docData'].findIndex(
                  (d) => JSON.stringify(d) == JSON.stringify(ed),
                );
                ed['Action'] = ed['Action'] == 'N' ? ed['Action'] : 'E';
                ed['Doc Ref #'] = details['docRef'];
                ed['ID'] = `${details['docCode']}-${details['docRef']}`;

                this.selectedDocumentInfoData['docData'].splice(index, 1, ed);
              });
            }

            oldData['Attachment'] = newData['Attachment'];
            oldData['fileAtt'] = newData['fileAtt'];
            oldData['filetype'] = newData['filetype'];
          });

          const temp = this.selectedDocumentInfoData['docData'];
          this.selectedDocumentInfoData['docData'] = [];
          this.$nextTick(() => {
            this.selectedDocumentInfoData['docData'] = temp;
          });
        }
      }

      this.selectedDocumentInfoData['selectedDoc'] = [];
    },
    deleteDoc: async function () {
      const deleteAll = [];
      const uniqueSelected = [
        ...new Set(
          this.selectedDocumentInfoData['selectedDoc'].map((s) => {
            return s['ID'];
          }),
        ),
      ];

      if (uniqueSelected.length == 0) {
        this.showDefaultPopup('error', 'No document selected', 'Please select at least one document to delete');
        return;
      }

      uniqueSelected.forEach((u) => {
        const selectedCount = this.selectedDocumentInfoData['selectedDoc'].filter((s) => {
          return s['ID'] == u;
        });
        const allCount = this.selectedDocumentInfoData['docData'].filter((s) => {
          return s['ID'] == u;
        });

        const deleteData = {
          docCode: selectedCount[0]['Doc Code'],
          refNo: selectedCount[0]['Doc Ref #'],
          allItems: allCount,
          selectedItems: selectedCount,
          allSelected: selectedCount.length == allCount.length,
        };
        deleteAll.push(deleteData);
      });

      if (deleteAll.length > 0) {
        for (const d of deleteAll) {
          this.deleteItems = d;
          this.deleteSelectedBtn.style.display = 'unset';

          if (d['allSelected']) {
            this.deleteMessage.innerHTML = `You are about to delete ${d['allItems'].length} of ${d['allItems'].length} attachments for<br />Doc Code ${d['docCode']}<br />(Doc Ref #: ${d['refNo']})`;
            this.deleteAllBtn.innerHTML = `Delete All Attachments for<br />Doc Code ${d['docCode']}<br />(Doc Ref #: ${d['refNo']})`;
            this.deleteSelectedBtn.style.display = 'none';
          } else {
            const selectedNames = d['selectedItems']
              .map((s) => {
                return s['Attachment'];
              })
              .join(`<br />`);
            this.deleteMessage.innerHTML = `You are about to delete ${d['selectedItems'].length} of ${d['allItems'].length} attachments for
              <br />Doc Code ${d['docCode']}
              <br />(Doc Ref #: ${d['refNo']})
              <br /><br />Selected Files:
              <br />${selectedNames}`;
            this.deleteAllBtn.innerHTML = `Delete All Attachments for<br />Doc Code ${d['docCode']}<br />(Doc Ref #: ${d['refNo']})`;
            this.deleteSelectedBtn.innerHTML = `Delete ${d['selectedItems'].length} of ${d['allItems'].length} Attachments for<br />Doc Code ${d['docCode']}<br />(Doc Ref #: ${d['refNo']})`;
          }
          // eslint-disable-next-line no-undef -- Sweet Alert should should be replaced with <PopupV2> in the future
          await Swal.fire({
            type: 'warning',
            title: 'Deleting Doc Code',
            html: this.deleteLayout,
            showConfirmButton: false,
            showCancelButton: false,
          });
        }
      }
    },
    deleteButtonClicked: function (e) {
      const btn = e.target.innerHTML;
      // eslint-disable-next-line no-undef -- Sweet Alert should should be replaced with <PopupV2> in the future
      Swal.close();

      if (btn.includes('Delete All')) {
        this.deleteItems['allItems'].forEach((d) => {
          // var index = this.selectedDocumentInfoData['docData'].indexOf(d);
          const index = this.selectedDocumentInfoData['docData'].findIndex(
            (dd) => JSON.stringify(dd) == JSON.stringify(d),
          );

          if (d['documentguid']) {
            // To send to API for delete
            d['Action'] = 'D';
            this.documentsToDelete.push(d);
          }

          this.selectedDocumentInfoData['docData'].splice(index, 1);
        });
      } else {
        this.deleteItems['selectedItems'].forEach((d) => {
          // var index = this.selectedDocumentInfoData['docData'].indexOf(d);
          const index = this.selectedDocumentInfoData['docData'].findIndex(
            (dd) => JSON.stringify(dd) == JSON.stringify(d),
          );

          if (d['documentguid']) {
            // To send to API for delete
            d['Action'] = 'D';
            this.documentsToDelete.push(d);
          }

          this.selectedDocumentInfoData['docData'].splice(index, 1);
        });
      }

      const temp = this.selectedDocumentInfoData['docData'];
      this.selectedDocumentInfoData['docData'] = [];
      this.$nextTick(() => {
        this.selectedDocumentInfoData['docData'] = temp;
      });

      this.selectedDocumentInfoData['selectedDoc'] = [];
    },
    documentsDoubleClicked: function (e) {
      window.open(e['oriObj']['AttImage'], '_blank');
      // if (e['Attachment']) {
      //   var base64 = e['oriObj']['AttImage'];
      //   var byteChar = atob(base64);
      //   var byteArray = new Array(byteChar.length);
      //   for (var i = 0; i < byteChar.length; i++) {
      //     byteArray[i] = byteChar.charCodeAt(i);
      //   }
      //   var u8Array = new Uint8Array(byteArray);

      //   var blob = new Blob([ u8Array ], { type: e['oriObj']['AttImageType'].includes('/') ? e['oriObj']['AttImageType'] : '' });
      //   console.log(blob);

      //   var url = window.URL.createObjectURL(blob, { oneTimeOnly: false });
      //   console.log(url);
      //   var link = document.createElement('a');
      //   link.target = '_blank';
      //   if (e['oriObj']['AttImageType'].includes('/')) {
      //     link.href = url;
      //   } else {
      //     link.download = `myfile${e['oriObj']['AttImageType'].includes('.') ? '' : '.'}${e['oriObj']['AttImageType']}`;
      //   }
      //   // console.log(link);
      //   link.click();
      // } else {
      //   this.$alert.showAlert('No attachment', 'No attachment for the selected document', 'error');
      // }
    },

    editDoc: function () {
      if (this.selectedDocumentInfoData['selectedDoc'].length == 0) {
        this.showDefaultPopup('error', 'No document selected', 'Please select at least one document to edit');
      } else {
        const uniqueID = [...new Set(this.selectedDocumentInfoData['selectedDoc'].map((s) => s['ID']))];
        if (uniqueID.length > 1) {
          this.showDefaultPopup(
            'error',
            'Multiple Document Selected',
            'Please select at most one unique document to edit',
          );
        } else {
          this.editDocumentsList = this.selectedDocumentInfoData['docData'].filter((d) => d['ID'] == uniqueID[0]);
          this.documentInfoData['updatePopup'] = true;
        }
      }
    },

    tooltip: function (show, text) {
      this.showTooltip = show;
      this.tooltipText = text;
    },

    validation: function (btn) {
      if (btn == 'No' || btn == 'Cancel') {
        // eslint-disable-next-line no-undef -- Sweet Alert should should be replaced with <PopupV2> in the future
        popup.hide();
      } else if (btn == 'Yes' || btn == 'Save') {
        if (!this.selectedUnconfirmReason) {
          this.popupErrorText = 'Please select your reason';
        } else if (this.selectedUnconfirmReason['Reason'].split('-')[0].trim() == 'OTHERS' && !this.unconfirmRemarks) {
          this.popupErrorText = 'Please enter your remarks';
        } else {
          this.popupErrorText = '';
        }
      }
    },
    popupValidation: function () {
      if (!this.selectedUnconfirmReason) {
        this.popupError = true;
      } else if (this.selectedUnconfirmReason['Reason'].split('-')[0].trim() == 'OTHERS' && !this.unconfirmRemarks) {
        this.popupError = true;
      } else {
        this.popupError = false;
      }
    },
    getDateFormat: function (dateString) {
      const dateParts = dateString.split(' ');

      const date = dateParts[0].split('-');
      const year = parseInt(date[0]);
      const month = parseInt(date[1]) - 1;
      const day = parseInt(date[2]);

      const timeStr = dateParts[1];
      const hour = parseInt(timeStr.substring(0, 2));
      const minute = parseInt(timeStr.substring(2));

      const datetime = new Date(year, month, day, hour, minute);

      return datetime;
    },

    // shipCallNoSelected: async function (e, p) {
    //   if (!e) return;
    //   const vessel = this.shippingInfoData['vesselIDList'].filter((v) => {
    //     return v['Vessel ID'].trim() == e['Vessel ID'].trim();
    //   });
    //   if (vessel.length == 0) {
    //     // if no macth (table dbo.Vessel)
    //     return;
    //   }
    //   this.newVessel = vessel[0];
    //   this.previousVessel = p;
    //   const previousVesselID = p ? p['Ship Call No'] + ' (' + p['Terminal'] + ')' : '';
    //   const newVesselID = e ? e['Ship Call No'] + ' (' + e['Terminal'] + ')' : '';

    //   if (this.pageType == 'Import') {
    //     this.newETADateTime = this.getDateFormat(e['ETA']); //this.selectedShippingInfoData['polETA']
    //   } else if (e['ETD']) {
    //     this.newETDDateTime = this.getDateFormat(e['ETD']); //this.selectedShippingInfoData['polETD']
    //   } else {
    //     this.newETDDateTime = this.getDateFormat(e['ETA']); //this.selectedShippingInfoData['polETD']
    //   }
    //   if (this.pageType == 'Export') {
    //     if (
    //       this.selectedHeaderInfoData['selectedTransMode'] &&
    //       this.selectedHeaderInfoData['selectedCargoType'] &&
    //       (this.selectedShippingInfoData['polETD'] || this.newETDDateTime)
    //     ) {
    //       let settingsKey = `CLOSINGDATE_`;
    //       settingsKey += this.selectedHeaderInfoData['selectedCargoType']['Cargo Type'][0] == 'F' ? 'FCL_' : 'LCL_';
    //       settingsKey += this.selectedHeaderInfoData['selectedTransMode']['Description'] == 'by Air' ? 'AIR' : 'HRS';
    //       this.$fullscreenLoading('Calculating Closing Time');
    //       const hours = await this.$apiCallV2(`/FreightForwarding/GetSettingsSystem?settingsItem=${settingsKey}`);
    //       this.$fullscreenLoading();
    //       const closingDate =
    //         this.selectedShippingInfoData?.['polETD'] ?
    //           new Date(this.selectedShippingInfoData['polETD'])
    //         : this.newETDDateTime;
    //       closingDate.setHours(closingDate.getHours() - Number(hours[0]['SettingsValue']));
    //       this.newClosingTime = new Date(closingDate);
    //     }
    //   }
    //   await this.calculateDefaultDatesForPopup();
    //   // Populate the data for the popup table
    //   this.shipCallNoChangetableData = [
    //     {
    //       label: this.transportMethodPlaceholders('ShipCallNo') + ' (Port Operator)',
    //       previous: previousVesselID,
    //       new: newVesselID,
    //       checked: true,
    //       disabled: true,
    //     },
    //     {
    //       label: 'Voyage #',
    //       previous: this.selectedShippingInfoData['voyNo'],
    //       new: e['Voy No'],
    //       checked: true,
    //       disabled: true,
    //     },
    //     {
    //       label: this.transportMethodPlaceholders('VesselID'),
    //       previous:
    //         this.selectedShippingInfoData['selectedVesselID'] ?
    //           this.selectedShippingInfoData['selectedVesselID']['Vessel ID']
    //         : '',
    //       new: this.newVessel['Vessel ID'] ? this.newVessel['Vessel ID'] : '',
    //       checked: true,
    //     },
    //   ];
    //   if (this.pageType == 'Export') {
    //     if (this.selectedShippingInfoData['polETD'] || this.newETDDateTime) {
    //       this.shipCallNoChangetableData.push({
    //         label: this.getPOLPlaceholderAndTitle,
    //         previous:
    //           this.selectedShippingInfoData['polETD'] ?
    //             new Date(this.selectedShippingInfoData['polETD']).formatString('yyyy-MM-dd HH:mm')
    //           : '',
    //         new: this.newETDDateTime ? new Date(this.newETDDateTime).formatString('yyyy-MM-dd HH:mm') : '',
    //         checked: true,
    //       });
    //     }
    //   }
    //   if (this.pageType == 'Import') {
    //     if (this.selectedShippingInfoData['polETA'] || this.newETADateTime) {
    //       this.shipCallNoChangetableData.push({
    //         label: 'POD ETA',
    //         previous:
    //           this.selectedShippingInfoData['polETA'] ?
    //             new Date(this.selectedShippingInfoData['polETA']).formatString('yyyy-MM-dd HH:mm')
    //           : '',
    //         new: this.newETADateTime ? new Date(this.newETADateTime).formatString('yyyy-MM-dd HH:mm') : '',
    //         checked: true,
    //       });
    //     }
    //   }
    //   // if (this.selectedShippingInfoData['demurageTime'] || this.newDemurrageDate) {
    //   //   this.shipCallNoChangetableData.push({
    //   //     label: 'Demurrage',
    //   //     previous:
    //   //       this.selectedShippingInfoData['demurageTime'] ?
    //   //         new Date(this.selectedShippingInfoData['demurageTime']).formatString('yyyy-MM-dd HH:mm')
    //   //       : '',
    //   //     new: this.newDemurrageDate ? new Date(this.newDemurrageDate).formatString('yyyy-MM-dd HH:mm') : '',
    //   //     checked: true,
    //   //   });
    //   // }
    //   // if (this.selectedShippingInfoData['detention'] || this.newDetentionDate) {
    //   //   this.shipCallNoChangetableData.push({
    //   //     label: 'Detention',
    //   //     previous:
    //   //       this.selectedShippingInfoData['detention'] ?
    //   //         new Date(this.selectedShippingInfoData['detention']).formatString('yyyy-MM-dd HH:mm')
    //   //       : '',
    //   //     new: this.newDetentionDate ? new Date(this.newDetentionDate).formatString('yyyy-MM-dd HH:mm') : '',
    //   //     checked: true,
    //   //   });
    //   // }
    //   if (this.selectedShippingInfoData['closingTime'] || this.newClosingTime) {
    //     this.shipCallNoChangetableData.push({
    //       label: 'Closing Time',
    //       previous:
    //         this.selectedShippingInfoData['closingTime'] ?
    //           new Date(this.selectedShippingInfoData['closingTime']).formatString('yyyy-MM-dd HH:mm')
    //         : '',
    //       new: this.newClosingTime ? new Date(this.newClosingTime).formatString('yyyy-MM-dd HH:mm') : '',
    //       checked: true,
    //     });
    //   }
    //   this.showShipCallNoChange = true;
    // },
    shipCallNoSelected: async function (e, p) {
      if (!e) return;

      const vessel = this.shippingInfoData['vesselIDList'].find((v) => {
        return v['Vessel ID']?.trim() === e['Vessel ID']?.trim();
      });

      if (!vessel) return;

      const getShipCallDate = (value) => {
        if (!value) return null;
        if (value instanceof Date) return new Date(value);

        return this.getDateFormat(value);
      };

      const formatDisplayDate = (value) => {
        return value ? new Date(value).formatString('yyyy-MM-dd HH:mm') : '';
      };

      const getShipCallDisplay = (shipCall) => {
        if (!shipCall) return '';
        return `${shipCall['Ship Call No'] || ''} (${shipCall['Terminal'] || ''})`;
      };

      const clearNewShipCallValues = () => {
        this.newVessel = [];
        this.previousVessel = [];
        this.newETDDateTime = null;
        this.newETADateTime = null;
        this.newClosingTime = null;
      };

      const shipCallETA = getShipCallDate(e['ETA']);

      this.newVessel = vessel;
      this.previousVessel = p;

      this.newETADateTime = this.pageType === 'Import' ? shipCallETA : null;
      this.newETDDateTime = this.pageType === 'Export' ? shipCallETA : null;
      this.newClosingTime = null;

      if (this.pageType === 'Export' && shipCallETA && this.selectedHeaderInfoData['selectedCargoType']) {
        const cargoType = this.selectedHeaderInfoData['selectedCargoType']['Cargo Type'] || '';
        const settingsKey = cargoType[0] === 'F' ? 'CLOSINGDATE_FCL_HRS' : 'CLOSINGDATE_LCL_HRS';

        try {
          this.$fullscreenLoading('Calculating Closing Time');

          const settings = await this.$apiCallV2(
            `/FreightForwarding/GetSettingsSystem?settingsItem=${encodeURIComponent(settingsKey)}`,
          );

          const closingHours = Number(settings?.[0]?.['SettingsValue']);

          if (Number.isFinite(closingHours)) {
            const closingDate = new Date(shipCallETA);
            closingDate.setHours(closingDate.getHours() - closingHours);
            this.newClosingTime = closingDate;
          }
        } finally {
          this.$fullscreenLoading();
        }
      }

      if (!p || !p['Ship Call No']) {
        this.selectedShippingInfoData['selectedVesselID'] = this.newVessel;
        this.selectedShippingInfoData['voyNo'] = e['Voy No'] || '';

        if (this.pageType === 'Import') {
          this.selectedShippingInfoData['polETA'] = this.newETADateTime;
        } else {
          this.selectedShippingInfoData['polETD'] = this.newETDDateTime;
          this.selectedShippingInfoData['closingTime'] = this.newClosingTime;
        }

        clearNewShipCallValues();
        return;
      }

      await this.calculateDefaultDatesForPopup();

      this.shipCallNoChangetableData = [
        {
          label: this.transportMethodPlaceholders('ShipCallNo') + ' (Port Operator)',
          previous: getShipCallDisplay(p),
          new: getShipCallDisplay(e),
          checked: true,
          disabled: true,
        },
        {
          label: 'Voyage #',
          previous: this.selectedShippingInfoData['voyNo'] || '',
          new: e['Voy No'] || '',
          checked: true,
          disabled: true,
        },
        {
          label: this.transportMethodPlaceholders('VesselID'),
          previous: this.selectedShippingInfoData['selectedVesselID']?.['Vessel ID'] || '',
          new: this.newVessel['Vessel ID'] || '',
          checked: true,
        },
      ];

      if (this.pageType === 'Export' && (this.selectedShippingInfoData['polETD'] || this.newETDDateTime)) {
        this.shipCallNoChangetableData.push({
          label: this.getPOLPlaceholderAndTitle,
          previous: formatDisplayDate(this.selectedShippingInfoData['polETD']),
          new: formatDisplayDate(this.newETDDateTime),
          checked: true,
        });
      }

      if (this.pageType === 'Import' && (this.selectedShippingInfoData['polETA'] || this.newETADateTime)) {
        this.shipCallNoChangetableData.push({
          label: 'POD ETA',
          previous: formatDisplayDate(this.selectedShippingInfoData['polETA']),
          new: formatDisplayDate(this.newETADateTime),
          checked: true,
        });
      }

      if (this.pageType === 'Export' && (this.selectedShippingInfoData['closingTime'] || this.newClosingTime)) {
        this.shipCallNoChangetableData.push({
          label: 'Closing Time',
          previous: formatDisplayDate(this.selectedShippingInfoData['closingTime']),
          new: formatDisplayDate(this.newClosingTime),
          checked: true,
        });
      }

      this.showShipCallNoChange = true;
    },
    applyChanges: function () {
      // Apply changes based on user selection
      this.shipCallNoChangetableData.forEach((row) => {
        if (row.checked) {
          switch (row.label) {
            case 'Voyage #':
              this.selectedShippingInfoData['voyNo'] = row.new;
              break;
            case this.transportMethodPlaceholders('VesselID'):
              this.selectedShippingInfoData['selectedVesselID'] = this.newVessel;
              break;
            case this.getPOLPlaceholderAndTitle:
              this.selectedShippingInfoData['polETD'] = this.newETDDateTime;
              break;
            case 'POD ETA':
              this.selectedShippingInfoData['polETA'] = this.newETADateTime;
              break;
            // case 'Demurrage':
            //   this.selectedShippingInfoData['demurageTime'] = this.newDemurrageDate;
            //   break;
            // case 'Detention':
            //   this.selectedShippingInfoData['detention'] = this.newDetentionDate;
            //   break;
            case 'Closing Time':
              this.selectedShippingInfoData['closingTime'] = this.newClosingTime;
              break;
            default:
          }
        }
      });
      this.showShipCallNoChange = false;
    },
    shipCallNoChangeButtonsClicked: function (buttonText) {
      switch (buttonText) {
        case 'Apply Changes':
          this.applyChanges();

          this.newVessel = [];
          this.previousVessel = [];
          this.newETDDateTime = null;
          this.newETADateTime = null;
          this.newDemurrageDate = null;
          this.newDetentionDate = null;
          this.newClosingTime = null;
          break;
        case 'Cancel':
          this.selectedShippingInfoData['selectedShipCall'] = this.previousVessel;
          this.showShipCallNoChange = false;

          this.newVessel = [];
          this.previousVessel = [];
          this.newETDDateTime = null;
          this.newETADateTime = null;
          this.newDemurrageDate = null;
          this.newDetentionDate = null;
          this.newClosingTime = null;
          break;
      }
    },
    // set default dates for demurrage and detention
    calculateDefaultDates: async function (a, selectedAgent) {
      try {
        let agentList = null;
        // if called from ETA field, take data from ShippingAgent field
        // if called from ShippingAgent field, take data from newly selected
        if (a == 'ETA') {
          agentList = this.selectedShippingInfoData['selectedAgentList'];
        } else if (a == 'Agent') {
          agentList = selectedAgent;
        }

        if (agentList) {
          this.$fullscreenLoading('Loading');

          // api call to retrieve freeStorageDays and detention days by matching shipping agent code
          const agentInfoData = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SHIPPINGAGENT' });
          const match = agentInfoData.find((v) => v['Agent Code'].trim() === agentList['Agent Code']);

          if (match) {
            if (match.FreeStorageDays) this.selectedShippingInfoData['freeDemurrage'] = match.FreeStorageDays;
            if (match.DetentionDays) this.selectedShippingInfoData['freeDetention'] = match.DetentionDays;
          }
          this.$fullscreenLoading();
        }
      } catch (error) {
        // eslint-disable-next-line no-console -- Unsure if this fuction needs to ignore erros
        console.error('Error processing dates:', error.message);
      }
    },
    calculateDefaultDatesForPopup: async function () {
      // set default dates for demurrage and detention
      try {
        if (
          this.selectedShippingInfoData['selectedAgentList'] != null &&
          this.selectedShippingInfoData['selectedAgentList'] != ''
        ) {
          this.$fullscreenLoading('Loading');
          // api call to retrieve freeStorageDays and detention days by matching shipping agent code
          const agentInfoData = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SHIPPINGAGENT' });
          const filteredlist = agentInfoData.filter((v) => {
            return v['Agent Code'].trim() == this.selectedShippingInfoData['selectedAgentList']['Agent Code'];
          });

          if (filteredlist.length == 1) {
            const freeStorageDays = filteredlist[0].FreeStorageDays;
            const detentionDays = filteredlist[0].DetentionDays;

            // skip if no POD ETA dates
            if (this.selectedShippingInfoData['polETA'] || this.newETADateTime) {
              // skip if its Export Job and empty ETA
              if (this.pageType != 'Export' && this.newETADateTime != null) {
                // prior to use ETA date that matches the newly selected shipcallno
                let polETADate;
                if (this.newETADateTime != null) {
                  polETADate = new Date(this.newETADateTime);
                } else if (this.selectedShippingInfoData['polETA'] != null) {
                  polETADate = new Date(this.selectedShippingInfoData['polETA']);
                } else {
                  throw new Error('Both newETADateTime and polETA are null');
                }

                // turn string value into int
                const freeStorageDaysInt = parseInt(freeStorageDays, 10);
                const detentionDaysInt = parseInt(detentionDays, 10);

                if (freeStorageDaysInt != 0) {
                  // calculate the default date by adding free storage days and subtracting one
                  const adjustedDays = freeStorageDaysInt - 1;
                  const DefaultDemurrageDate = new Date(polETADate.getTime());
                  DefaultDemurrageDate.setDate(polETADate.getDate() + adjustedDays);

                  // set calculated value into the field
                  this.newDemurrageDate = DefaultDemurrageDate;
                }

                if (detentionDaysInt != 0) {
                  // calculate the default date by adding free storage days and subtracting one
                  const adjustedDetentionDays = detentionDaysInt - 1;
                  const DefaultDetentionDate = new Date(polETADate.getTime());
                  DefaultDetentionDate.setDate(polETADate.getDate() + adjustedDetentionDays);

                  // set calculated value into the field
                  this.newDetentionDate = DefaultDetentionDate;
                }
              }
            }
          }
          this.$fullscreenLoading();
        }
      } catch (error) {
        // eslint-disable-next-line no-console -- Unsure if this fuction needs to ignore erros
        console.error('Error processing dates:', error.message);
      }
    },

    appendStatusIcon: function (list) {
      const allStatus = list.sort((a, b) => {
        return a['#'] < b['#'] ? 1 : -1;
      });
      const statusWithIcons = allStatus.map((s) => {
        switch (s['Progress']) {
          case 'Completed':
            return Object.assign({ '': 'https://dsmlib.logistics.systems/Icons/StatusComplete.png' }, s);
          case 'Due':
            return Object.assign({ '': 'https://dsmlib.logistics.systems/Icons/StatusDue.png' }, s);
          case 'Due In 2 days':
            return Object.assign({ '': 'https://dsmlib.logistics.systems/Icons/StatusDueIn2Days.png' }, s);
          case 'Pending':
            return Object.assign({ '': 'https://dsmlib.logistics.systems/Icons/StatusPending.png' }, s);
          case 'Cancelled':
            return Object.assign({ '': 'https://dsmlib.logistics.systems/Icons/StatusCancelled.png' }, s);
          default:
            return Object.assign({ '': '' }, s);
        }
      });

      return statusWithIcons;
    },

    addDeliveryNote: function () {
      const route = this.$router.resolve(
        `/Home/${this.$route.params['user']}/FreightForwarding/Delivery%20Notes?jobNo=${this.selectedJob[0]['Job No'].trim()}&action=N&jobDate=${this.selectedJob[0]['Job DateTime'].trim()}`,
      );
      window.open(route.href, '_blank');
    },
    addROT: async function () {
      this.$fullscreenLoading('Verifying');

      const validate = await this.$apiCallV2(`/ROT/ValidateJobsForROT?jobno=${this.selectedJob[0]['Job No'].trim()}`);
      this.$fullscreenLoading();
      if (validate[0]['Results'] == 1) {
        this.rotVerifyPopup = true;
        this.rotVerifyError = validate[0]['ErrMsg'];
      } else {
        const route = this.$router.resolve(
          `/Home/${this.$route.params['user']}/FreightForwarding/ROT?jobNo=${this.selectedJob[0]['Job No'].trim()}`,
        );
        window.open(route.href, '_blank');
      }
    },

    showDefaultPopup: function (type, title, content) {
      this.defaultPopup['show'] = true;
      this.defaultPopup['type'] = type;
      this.defaultPopup['title'] = title;
      this.defaultPopup['content'] = content;
    },
    defaultPopupButtonClicked: function (e) {
      if (e == 'OK') {
        this.defaultPopup['show'] = false;
      }
    },
    reportPopupClose: function () {
      this.reportPopup = !this.reportPopup;
    },
    reportPageLink: function (reportTitle) {
      switch (reportTitle) {
        case 'Booking Confirmation':
          window.open(`/Reports/Booking Confirmation/${this.selectedJob[0]['Job No']}`, '_blank');
          this.reportPopup = !this.reportPopup;
          break;

        case 'Container Attachment':
          window.open(`/ReportsV2/Container Attachment?jobNo=${this.selectedJob[0]['Job No']}`, '_blank');
          this.reportPopup = !this.reportPopup;
          break;
      }
    },

    showHideAddress: function (type) {
      switch (type) {
        case 'shipper':
          this.showShipperAddress = !this.showShipperAddress;
          break;
        case 'consignee':
          this.showConsigneeAddress = !this.showConsigneeAddress;
          break;
        case 'nparty':
          this.showNPartyAddress = !this.showNPartyAddress;
          break;
      }
    },
    getSafeAddress: function (address) {
      const addr = address || {};

      return {
        name: addr.name || '',
        add1: addr.add1 || '',
        add2: addr.add2 || '',
        add3: addr.add3 || '',
        add4: addr.add4 || '',
        postcode: addr.postcode || '',
        city: addr.city || '',
        state: addr.state || '',
        country: addr.country || '',
        attn: addr.attn || '',
        tel: addr.tel || '',
        fax: addr.fax || '',
        gst: addr.gst || '',
      };
    },
    buildEditObject: function (address, title) {
      const addr = this.getSafeAddress(address);

      return {
        name: addr.name,
        addressLine1: addr.add1,
        addressLine2: addr.add2,
        addressLine3: addr.add3,
        addressLine4: addr.add4,

        postcodeSearch: '',
        postcodeKey: 'PostCode',

        city: addr.city,

        stateSearch: '',
        stateKey: 'State',

        countrySearch: '',
        countryKey: 'Country',

        attn: addr.attn,
        tel: addr.tel,
        fax: addr.fax,
        gst: addr.gst,

        postcode: addr.postcode,
        state: addr.state,
        country: addr.country,

        title,
      };
    },
    editDetailsPopup(type) {
      this.edittingDetails = true;

      const map = {
        shipper: {
          title: 'Shipper',
          data: this.shipperAddress,
        },
        consignee: {
          title: 'Consignee',
          data: this.consigneeAddress,
        },
        nparty: {
          title: 'Notify Party',
          data: this.notifyPartyAddress,
        },
      };

      const selected = map[type];

      this.detailsEditTitle = selected.title;
      this.detailsEditObject = this.buildEditObject(selected.data, selected.title);

      const postcode = this.detailsEditObject.postcode;
      const state = this.detailsEditObject.state;
      const country = this.detailsEditObject.country;

      this.detailsEditObject.postcodeItems = this.addressDetails['postcodeList'];
      this.detailsEditObject.stateItems = this.addressDetails['stateList'];
      this.detailsEditObject.countryItems = this.addressDetails['countryList'];

      this.$nextTick(() => {
        this.detailsEditObject.postcodeSearch = postcode;
        this.detailsEditObject.stateSearch = state;
        this.detailsEditObject.countrySearch = country;
      });
    },
    detailsEditSave: function (type) {
      if (type == 'save') {
        switch (this.detailsEditTitle) {
          case 'Shipper':
            if (!this.shipperAddress) this.shipperAddress = {};
            this.shipperAddress['name'] = this.detailsEditObject['name'];
            this.shipperAddress['add1'] = this.detailsEditObject['addressLine1'];
            this.shipperAddress['add2'] = this.detailsEditObject['addressLine2'];
            this.shipperAddress['add3'] = this.detailsEditObject['addressLine3'];
            this.shipperAddress['add4'] = this.detailsEditObject['addressLine4'];
            this.shipperAddress['postcode'] =
              this.detailsEditObject['postcodeSearch'] ? this.detailsEditObject['postcodeSearch'].trim() : '';
            this.shipperAddress['city'] = this.detailsEditObject['city'];
            this.shipperAddress['state'] =
              this.detailsEditObject['stateSearch'] ? this.detailsEditObject['stateSearch'].trim() : '';
            this.shipperAddress['country'] =
              this.detailsEditObject['countrySearch'] ? this.detailsEditObject['countrySearch'].trim() : '';
            this.shipperAddress['attn'] = this.detailsEditObject['attn'];
            this.shipperAddress['tel'] = this.detailsEditObject['tel'];
            this.shipperAddress['fax'] = this.detailsEditObject['fax'];
            this.shipperAddress['gst'] = this.detailsEditObject['gst'];
            this.showShipperAddress = true;
            break;
          case 'Consignee':
            if (!this.consigneeAddress) this.consigneeAddress = {};
            this.consigneeAddress['name'] = this.detailsEditObject['name'];
            this.consigneeAddress['add1'] = this.detailsEditObject['addressLine1'];
            this.consigneeAddress['add2'] = this.detailsEditObject['addressLine2'];
            this.consigneeAddress['add3'] = this.detailsEditObject['addressLine3'];
            this.consigneeAddress['add4'] = this.detailsEditObject['addressLine4'];
            this.consigneeAddress['postcode'] =
              this.detailsEditObject['postcodeSearch'] ? this.detailsEditObject['postcodeSearch'].trim() : '';
            this.consigneeAddress['city'] = this.detailsEditObject['city'];
            this.consigneeAddress['state'] =
              this.detailsEditObject['stateSearch'] ? this.detailsEditObject['stateSearch'].trim() : '';
            this.consigneeAddress['country'] =
              this.detailsEditObject['countrySearch'] ? this.detailsEditObject['countrySearch'].trim() : '';
            this.consigneeAddress['attn'] = this.detailsEditObject['attn'];
            this.consigneeAddress['tel'] = this.detailsEditObject['tel'];
            this.consigneeAddress['fax'] = this.detailsEditObject['fax'];
            this.consigneeAddress['gst'] = this.detailsEditObject['gst'];
            this.showConsigneeAddress = true;
            break;
          case 'Notify Party':
            if (!this.notifyPartyAddress) this.notifyPartyAddress = {};
            this.notifyPartyAddress['name'] = this.detailsEditObject['name'];
            this.notifyPartyAddress['add1'] = this.detailsEditObject['addressLine1'];
            this.notifyPartyAddress['add2'] = this.detailsEditObject['addressLine2'];
            this.notifyPartyAddress['add3'] = this.detailsEditObject['addressLine3'];
            this.notifyPartyAddress['add4'] = this.detailsEditObject['addressLine4'];
            this.notifyPartyAddress['postcode'] =
              this.detailsEditObject['postcodeSearch'] ? this.detailsEditObject['postcodeSearch'].trim() : '';
            this.notifyPartyAddress['city'] = this.detailsEditObject['city'];
            this.notifyPartyAddress['state'] =
              this.detailsEditObject['stateSearch'] ? this.detailsEditObject['stateSearch'].trim() : '';
            this.notifyPartyAddress['country'] =
              this.detailsEditObject['countrySearch'] ? this.detailsEditObject['countrySearch'].trim() : '';
            this.notifyPartyAddress['attn'] = this.detailsEditObject['attn'];
            this.notifyPartyAddress['tel'] = this.detailsEditObject['tel'];
            this.notifyPartyAddress['fax'] = this.detailsEditObject['fax'];
            this.notifyPartyAddress['gst'] = this.detailsEditObject['gst'];
            this.showNPartyAddress = true;
            break;
        }
      }

      this.edittingDetails = false;
      this.detailsEditObject = null;
    },

    shipperSelected: function (e) {
      if (e) {
        this.shipperAddress = {};
        this.shipperAddress['name'] = e['Shipper Name'];
        this.shipperAddress['add1'] = e['Shipper Add1'];
        this.shipperAddress['add2'] = e['Shipper Add2'];
        this.shipperAddress['add3'] = e['Shipper Add3'];
        this.shipperAddress['add4'] = e['Shipper Add4'];
        this.shipperAddress['postcode'] = e['Shipper PostCode'];
        this.shipperAddress['city'] = e['Shipper City'];
        this.shipperAddress['state'] = e['Shipper State'];
        this.shipperAddress['country'] = e['Shipper Country'];
        this.shipperAddress['attn'] = e['Shipper Attn'];
        this.shipperAddress['tel'] = e['Shipper Tel'];
        this.shipperAddress['fax'] = e['Shipper Fax'];
        this.shipperAddress['gst'] = e['Shipper GSTNo'];

        this.showShipperAddress = true;

        if (this.pageType == 'Export') {
          this.selectedHeaderInfoData['selectedBillTo'] = this.headerInfoData['billTo'].find(
            (b) => b['Customer Code'] == e['Bill To'],
          );
          this.billToSelected(this.selectedHeaderInfoData['selectedBillTo']);
          this.populateDefaultSalesService(e);
        }
      } else {
        this.shipperAddress = null;
        this.showShipperAddress = false;
      }
    },
    populateDefaultSalesService: async function (cust) {
      // populate default sales service based on customer code

      if (
        (this.selectedGeneralInfoData['selectedSalesTeam'] == null &&
          this.selectedGeneralInfoData['selectedSalesPIC'] == null &&
          this.selectedGeneralInfoData['selectedServiceTeam'] == null &&
          this.selectedGeneralInfoData['selectedServicePIC'] == null) ||
        this.selectedHeaderInfoData['jobStatus'] == 'New'
      ) {
        let defaultCustomerSalesService = [];
        this.$fullscreenLoading('Loading');
        defaultCustomerSalesService = await this.$apiCallV2('/FreightForwarding/GetCustomerSalesService', {
          custno: cust['Shipper Code'] ? cust['Shipper Code'] : cust['Consignee Code'],
          jobtype: this.pageType === 'Export' ? 'E' : 'I',
          module: 'FMS',
        });
        if (defaultCustomerSalesService.length > 0) {
          this.selectedGeneralInfoData['selectedSalesTeam'] =
            defaultCustomerSalesService[0]['SalesTeam_Code'] ?
              this.generalInfoData['salesTeamList'].find(
                (s) => s['Sales Team Code'] == defaultCustomerSalesService[0]['SalesTeam_Code'],
              )
            : null;

          this.selectedGeneralInfoData['selectedSalesPIC'] =
            defaultCustomerSalesService[0]['SalesPerson_Code'] ?
              this.generalInfoData['salesPICList'].find(
                (s) => s['Sales Person Code'] == defaultCustomerSalesService[0]['SalesPerson_Code'],
              )
            : null;

          this.selectedGeneralInfoData['selectedServiceTeam'] =
            defaultCustomerSalesService[0]['ServiceTeam_Code'] ?
              this.generalInfoData['serviceTeamList'].find(
                (s) => s['Service Team Code'] == defaultCustomerSalesService[0]['ServiceTeam_Code'],
              )
            : null;

          this.selectedGeneralInfoData['selectedServicePIC'] =
            defaultCustomerSalesService[0]['ServicePerson_Code'] ?
              this.generalInfoData['servicePICList'].find(
                (s) => s['Service Person Code'] == defaultCustomerSalesService[0]['ServicePerson_Code'],
              )
            : null;
        } else {
          this.selectedGeneralInfoData['selectedSalesTeam'] = null;
          this.selectedGeneralInfoData['selectedSalesPIC'] = null;
          this.selectedGeneralInfoData['selectedServiceTeam'] = null;
          this.selectedGeneralInfoData['selectedServicePIC'] = null;
        }
        this.$fullscreenLoading();
      }
    },
    consigneeSelected: function (e) {
      if (e) {
        this.consigneeAddress = {};
        this.consigneeAddress['name'] = e['Consignee Name'];
        this.consigneeAddress['add1'] = e['Consignee Add1'];
        this.consigneeAddress['add2'] = e['Consignee Add2'];
        this.consigneeAddress['add3'] = e['Consignee Add3'];
        this.consigneeAddress['add4'] = e['Consignee Add4'];
        this.consigneeAddress['postcode'] = e['Consignee PostCode'];
        this.consigneeAddress['city'] = e['Consignee City'];
        this.consigneeAddress['state'] = e['Consignee State'];
        this.consigneeAddress['country'] = e['Consignee Country'];
        this.consigneeAddress['attn'] = e['Consignee Attn'];
        this.consigneeAddress['tel'] = e['Consignee Tel'];
        this.consigneeAddress['fax'] = e['Consignee Fax'];
        this.consigneeAddress['gst'] = e['Consignee GSTNo'];

        this.showConsigneeAddress = true;

        if (this.pageType == 'Import') {
          this.selectedHeaderInfoData['selectedBillTo'] = this.headerInfoData['billTo'].find(
            (b) => b['Customer Code'] == e['Bill To'],
          );
          this.billToSelected(this.selectedHeaderInfoData['selectedBillTo']);
          this.populateDefaultSalesService(e);
        }
      } else {
        this.consigneeAddress = null;
        this.showConsigneeAddress = false;
      }
    },
    cargoTypeSelected: async function (newVal, oldVal) {
      const newCargoType =
        newVal['Cargo Type'] ? newVal['Cargo Type'] : this.selectedHeaderInfoData['selectedCargoType']['Cargo Type'];
      const oldCargoType = this.originalCargoType['Cargo Type']; // from API - original cargo type of the job

      if (newVal != oldCargoType && oldCargoType != null) {
        if (oldCargoType.startsWith('FC') && !newCargoType.startsWith('FC') && this.rotListing.length > 0) {
          // fire if user switch from FC% types to other types, and rot listing is not empty
          let alertContent = `There are existing ROT record(s) for Job <b>${this.selectedJob[0]['Job No'].trim()}</b>.`;
          alertContent += '<br> Are you sure you want to change the Cargo Type?';

          const confirmChange = await this.$showAlert('warning', 'Cargo Type Change', alertContent, [
            { text: 'Change Cargo Type' },
            { text: 'Cancel', color: 'lightgray' },
          ]);

          if (confirmChange != 'Change Cargo Type') {
            this.$nextTick(() => (this.selectedHeaderInfoData['selectedCargoType'] = oldVal));
          }
        }
      }
    },
    npartySelected: function (e) {
      if (e) {
        this.notifyPartyAddress = {};
        this.notifyPartyAddress['name'] = e['Notify Party Name'];
        this.notifyPartyAddress['add1'] = e['Notify Party Add1'];
        this.notifyPartyAddress['add2'] = e['Notify Party Add2'];
        this.notifyPartyAddress['add3'] = e['Notify Party Add3'];
        this.notifyPartyAddress['add4'] = e['Notify Party Add4'];
        this.notifyPartyAddress['postcode'] = e['Notify Party PostCode'];
        this.notifyPartyAddress['city'] = e['Notify Party City'];
        this.notifyPartyAddress['state'] = e['Notify Party State'];
        this.notifyPartyAddress['country'] = e['Notify Party Country'];
        this.notifyPartyAddress['attn'] = e['Notify Party Attn'];
        this.notifyPartyAddress['tel'] = e['Notify Party Tel'];
        this.notifyPartyAddress['fax'] = e['Notify Party Fax'];
        this.notifyPartyAddress['gst'] = e['Notify Party GSTNo'];

        this.showNPartyAddress = true;
      } else {
        this.notifyPartyAddress = null;
        this.showNPartyAddress = false;
      }
    },

    reasonFocusChanged: function (e) {
      this.reasonOpen = e;
    },
    //#region eJob
    ejobCheckboxClicked: function (checkbox) {
      this.allEJobChecked = false;
      this.rangeEJobChecked = false;

      this.ejobRangeToError = '';
      this.ejobRangeFromError = '';

      this.$nextTick(() => (this[checkbox] = true));
    },
    refreshEJobClicked: async function () {
      if (this.rangeEJobChecked && (!this.ejobRangeFrom || !this.ejobRangeTo)) {
        this.ejobRangeFromError = this.ejobRangeFrom ? '' : 'From date time is required';
        this.ejobRangeToError = this.ejobRangeTo ? '' : 'To date time is required';
        return;
      }

      this.ejobListing = [];
      let jobListing = [];
      this.$fullscreenLoading('Getting eJobs');
      if (this.rangeEJobChecked) {
        jobListing = await this.$apiCallV2(
          `/FreightForwarding/GetComBookingList?start=${this.ejobRangeFrom.formatString('yyyy-MM-dd')}&end=${this.ejobRangeTo.formatString('yyyy-MM-dd')}&jobtype=${this.pageType}`,
        );
      } else {
        jobListing = await this.$apiCallV2(`/FreightForwarding/GetComBookingList?jobtype=${this.pageType}`);
      }
      this.$fullscreenLoading();

      if (!jobListing[0]['ErrMsg']) {
        this.ejobListing = jobListing;
      }

      this.ejobFilterOpen = false;
      this.ejobLastRefreshed = new Date().formatString('yyyy-MM-dd HH:mm');
    },
    getJobRequestJson: async function () {
      this.$fullscreenLoading('Getting Details');
      const details = await this.$apiCallV2(
        `/FMSEJob/geteJobRequestJSON?requestNo=${this.selectedeJob[0]['AutoRequestNo']}`,
      );
      this.$fullscreenLoading();
      return details;
    },
    geteJobRequestAttachment: async function () {
      this.$fullscreenLoading('Getting Attachments');
      const attachment = await this.$apiCallV2(
        `/FMSEJob/GeteJobDocuments?jobno=${this.selectedeJob[0]['AutoRequestNo']}`,
      );
      const attachmentMap = [];
      if (attachment) {
        attachment.forEach((a) =>
          attachmentMap.push({
            link: a['AttImage'],
            filename: a['AttImageName'],
            remarks: a['Remarks'],
          }),
        );
      }
      this.$fullscreenLoading();
      return attachmentMap;
    },
    ejobAccept: async function () {
      this.eJobFullDetails = await this.getJobRequestJson();
      this.eJobAttachments = await this.geteJobRequestAttachment();
      this.eJobSections = [
        {
          name: 'Header Info',
          verifyData: [
            {
              column: this.pageType == 'Import' ? 'Consignee' : 'Shipper',
              detected: `${this.eJobFullDetails['cu_number'] || ''}`,
              submittedList: this.headerInfoData[this.pageType == 'Import' ? 'consignee' : 'shipper'],
              submittedKey: `${this.pageType == 'Import' ? 'Consignee' : 'Shipper'} Code`,
              submittedDesc: `${this.pageType == 'Import' ? 'Consignee' : 'Shipper'} Name`,
              displayKey: 'Code - Name',
              historyKey: 'shipperConsignee',
              isRequired: true,
              compareIndex: 0,
              compareByKey: true,
            },
            {
              column: 'Bill To',
              detected: `${this.eJobFullDetails['billto'] || ''}`,
              submittedList: this.headerInfoData['billTo'],
              submittedKey: 'Customer Code',
              submittedDesc: 'Customer Name',
              displayKey: 'Code - Name',
              historyKey: 'billTo',
              isRequired: true,
              compareIndex: 0,
              compareByKey: true,
            },
          ],
        },
        {
          name: 'Shipping Info',
          verifyData: [
            {
              column: 'Vessel',
              detected: `${this.eJobFullDetails['vessel_no'] || ''}
${this.eJobFullDetails['vessel_name'] || ''}`,
              submittedList: this.shippingInfoData['vesselIDList'],
              submittedKey: 'Vessel ID',
              submittedDesc: 'Vessel Name',
              displayKey: 'ID - Name',
              historyKey: 'vesselId',
              isRequired: true,
              compareIndex: 1,
            },
            {
              column: 'Port of Loading',
              detected: `${this.eJobFullDetails['load_port'] || ''}
${this.eJobFullDetails['load_portname'] || ''}`,
              submittedList: this.shippingInfoData['portOfLoading'],
              submittedKey: 'Port Code',
              submittedDesc: 'Port Location',
              displayKey: 'Code - Desc',
              historyKey: 'portofloading',
              isRequired: true,
              compareIndex: 1,
            },
            {
              column: 'Port of Discharge',
              detected: `${this.eJobFullDetails['discharge_port'] || ''}
${this.eJobFullDetails['discharge_portname'] || ''}`,
              submittedList: this.shippingInfoData['portOfDischarge'],
              submittedKey: 'Port Code',
              submittedDesc: 'Port Location',
              displayKey: 'Code - Desc',
              historyKey: 'portofdischarge',
              isRequired: true,
              compareIndex: 1,
            },
            {
              column: 'Ship Line',
              detected: `${this.eJobFullDetails['shipline'] || ''}`,
              submittedList: this.shippingInfoData['shippingLineList'],
              submittedKey: 'Agent Code',
              submittedDesc: 'Agent Name',
              displayKey: 'Code - Name',
              historyKey: 'shipline',
              isRequired: true,
              compareIndex: 0,
              compareByKey: true,
            },
            {
              column: 'Shipping Agent',
              detected: `${this.eJobFullDetails['ag_code'] || ''}
${this.eJobFullDetails['ag_name'] || ''}`,
              submittedList: this.shippingInfoData['shippingAgentList'],
              submittedKey: 'Agent Code',
              submittedDesc: 'Agent Name',
              displayKey: 'Code - Name',
              historyKey: 'shippingagent',
              isRequired: true,
              compareIndex: 1,
            },
          ],
        },
        {
          name: 'Cargo Info',
          verifyData: [
            {
              column: 'Package Code',
              detected: `${
                Array.isArray(this.eJobFullDetails['consignments']) ?
                  this.eJobFullDetails['consignments'][0] ?
                    this.eJobFullDetails['consignments'][0]['package_code'] || ''
                  : ''
                : ''
              }`,
              submittedList: this.cargoInfoData['pkgTypeList'],
              submittedKey: 'Package Code',
              submittedDesc: 'Description',
              displayKey: 'Code - Desc',
              historyKey: 'packagecode',
              isRequired: true,
              compareIndex: 0,
              compareByKey: true,
            },
          ],
        },
      ];

      this.showVerification = true;
    },
    ejobReject: async function () {
      const fullDetails = await this.getJobRequestJson();

      if (Array.isArray(fullDetails)) {
        this.eJobFullDetails = null;
        this.$showAlert('error', 'No details', `${fullDetails[0]['ErrMsg']}`);
      } else {
        this.showeJobReject = true;
        this.eJobFullDetails = fullDetails;
      }
    },
    eJobRejectButtonsClicked: async function (buttonText) {
      switch (buttonText) {
        case 'Reject': {
          const errorMessage = [];

          //#region Validation
          const errorToEmails = this.rejectToEmails.filter((e) => !e['valid']);
          const errorCCEmails = this.rejectCCEmails.filter((e) => !e['valid']);
          const errorBCCEmails = this.rejectBCCEmails.filter((e) => !e['valid']);

          if (this.rejectToEmails.length == 0) {
            errorMessage.push('Please enter at least 1 email address to send to rejection notice to.');
          } else if (errorToEmails.length > 0 || errorCCEmails.length > 0 || errorBCCEmails.length > 0) {
            errorMessage.push('Please make sure that all your email address are in correct format.');
          }

          if (!this.eJobRejectReason) {
            errorMessage.push('Please enter the reason for the rejection.');
          }
          //#endregion

          //#region Reason validation
          if (errorMessage.length > 0) {
            this.$showAlert('error', 'eJob Reject Error', errorMessage.join('\n'));
            return;
          }
          this.$fullscreenLoading('Rejecting an eJob');
          const rejectResult = await this.$apiCallV2('/FreightForwarding/RejecteJob', {
            emailto: this.rejectToEmails.map((e) => e['email']).join(';'),
            rejectreason: this.eJobRejectReason,
            rejectnotice: '',
            autorequestno: this.selectedeJob[0]['AutoRequestNo'],
            emailmessage: this.eJobRejectMessage,
          });

          const rot = JSON.parse(JSON.stringify(this.selectedeJob[0]));

          if (rejectResult[0]['Results'] == 0) {
            // Reject success
            //#region Send Reject Email
            this.$fullscreenLoading('Sending Rejection Email');
            const attachmentsToAdd = [];
            // if (this.eJobFullDetails['attachments']) {
            //   let report = this.eJobFullDetails['attachments'].find(a => a['doc_remark'].toLowerCase() == 'auto generated report');
            //   if (report) {
            //     attachmentsToAdd.push({
            //       Content: `${report['doc_image']}`,
            //       FileName: report['doc_refno'],
            //       ContentType: report['doc_imagetype']
            //     });
            //   }
            // }

            let body = 'Your Job Request has been rejected.<br><br>';
            body += `Request #: ${this.selectedeJob[0]['AutoRequestNo']}<br>`;
            body += `Your Ref. #: ${this.eJobFullDetails['job_no']}<br>`;
            body += `Date/Time Received: ${new Date(this.selectedeJob[0]['Received Time']).formatString('dd/MM/yyyy HHmm')}<br>`;
            body += `Date/Time Processed: ${new Date().formatString('dd/MM/yyyy HHmm')}<br>`;
            body += `Reason: ${this.eJobRejectReason}<br><br>`;

            if (this.eJobRejectMessage) {
              body += `<br><br>${this.eJobRejectMessage}`;
            }

            const disclaimer = await this.$apiCallV2(`/FreightForwarding/GetSettingsSystem?settingsItem=Disclaimer`);
            body += `<br><br><i>${disclaimer[0]['SettingsValue']}</i><br><br>`;

            body += `Thank you.<br>`;
            body += `Regards,<br>`;
            body += `${this.loginDetails['LoginUserId']}<br>`;

            const dataForEmailing = {
              ToEmails: this.rejectToEmails.map((e) => e['email']),
              CCEmails: this.rejectCCEmails.map((e) => e['email']),
              BCCEmails: this.rejectBCCEmails.map((e) => e['email']),
              Subject: `Job Request Rejected - ${this.selectedeJob[0]['AutoRequestNo']}`,
              Body: body,
              Attachments: attachmentsToAdd,
            };

            await this.$apiCallV2('/FreightForwarding/SendRejectEmail', dataForEmailing);
            this.$fullscreenLoading();
            //#endregion

            this.$showAlert(
              'success',
              'eJob Rejected',
              `eJob with Request No ${rot['AutoRequestNo']} has been rejected.`,
            );

            this.selectedeJob = [];
            await this.refreshEJobClicked();
          } else {
            // Reject error
            this.$showAlert(
              'error',
              'eJob Reject Error',
              `There was an error while rejecting eJob with Request No ${rot['AutoRequestNo']}. Please try again.`,
            );
            return;
          }

          //#endregion
          break;
        }
        case 'Cancel':
          break;
      }

      this.showeJobReject = false;
      this.rejectToEmails = [];
      this.rejectCCEmails = [];
      this.rejectBCCEmails = [];
      this.eJobRejectMessage = '';
      this.eJobRejectReason = '';
      this.showCC = false;
      this.showBCC = false;
    },
    verificationConfirm: function (_detectedData, selectedData) {
      this.eJobFullDetails['cu_number'] = selectedData['shipperConsignee'];
      this.eJobFullDetails['billto'] = selectedData['billTo'];
      this.eJobFullDetails['vessel_no'] = selectedData['vesselId'];
      this.eJobFullDetails['load_port'] = selectedData['portofloading'];
      this.eJobFullDetails['discharge_port'] = selectedData['portofdischarge'];
      this.eJobFullDetails['shipline'] = selectedData['shipline'];
      this.eJobFullDetails['ag_code'] = selectedData['shippingagent'];
      this.eJobFullDetails['pkgCode'] = selectedData['packagecode'];

      this.showVerification = false;

      this.menuClicked({ title: `New ${this.pageType} Job`, enabled: true });
      this.$nextTick(() => {
        //#region Header Info
        // this.selectedHeaderInfoData['selectedTransMode'] = this.eJobFullDetails['trans'] ? this.headerInfoData['transMode'].getSelected(this.eJobFullDetails['trans'], 'Description') : null;
        this.selectedHeaderInfoData['selectedCargoType'] =
          this.eJobFullDetails['cargotype_code'] ?
            this.headerInfoData['cargoType'].getSelected(this.eJobFullDetails['cargotype_code'], 'Cargo Type')
          : null;
        this.selectedHeaderInfoData['selectedSmkFormType'] =
          this.eJobFullDetails['jobformtype'] ?
            this.headerInfoData['smkFormType'].getSelected(this.eJobFullDetails['jobformtype'], 'Form Type')
          : null;
        if (this.pageType == 'Import') {
          this.selectedHeaderInfoData['selectedConsignee'] =
            this.eJobFullDetails['cu_number'] ?
              this.headerInfoData['consignee'].getSelected(this.eJobFullDetails['cu_number'], 'Consignee Code')
            : null;
          this.$nextTick(() => this.consigneeSelected(this.selectedHeaderInfoData['selectedConsignee']));
        } else {
          this.selectedHeaderInfoData['selectedShipper'] =
            this.eJobFullDetails['cu_number'] ?
              this.headerInfoData['shipper'].getSelected(this.eJobFullDetails['cu_number'], 'Shipper Code')
            : null;
          this.$nextTick(() => this.shipperSelected(this.selectedHeaderInfoData['selectedShipper']));
        }
        // this.selectedHeaderInfoData['selectedNotifyParty'] = this.eJobFullDetails['Notify Party'] ? this.headerInfoData['notifyParty'].filter((t) => { return t['Notify Party Code'].trim() == this.eJobFullDetails['Notify Party'].trim() })[0] : null;

        // this.selectedHeaderInfoData['projectNo'] = this.eJobFullDetails['Project No'] ? this.eJobFullDetails['Project No'].trim() : '';
        this.selectedHeaderInfoData['custRefNo'] = this.eJobFullDetails['curefno'];
        this.selectedHeaderInfoData['vbkgRefNo'] = this.eJobFullDetails['bookingrefno'];
        this.selectedHeaderInfoData['selectedBillTo'] =
          this.eJobFullDetails['billto'] ?
            this.headerInfoData['billTo'].getSelected(this.eJobFullDetails['billto'], 'Customer Code')
          : null;
        this.$nextTick(() => this.billToSelected(this.selectedHeaderInfoData['selectedBillTo']));

        // this.selectedHeaderInfoData['jobNo'] = this.eJobFullDetails['Job No'] ? this.eJobFullDetails['Job No'].trim() : '';
        // this.selectedHeaderInfoData['jobTime'] = this.eJobFullDetails['Job Time'] ? new Date(this.eJobFullDetails['Job Time']) : null;
        // this.selectedHeaderInfoData['jobStatus'] = this.eJobFullDetails['Job State'] ? this.eJobFullDetails['Job State'].trim() : '';

        // hInfo['milestonesData'] = milestones;
        // hInfo['legendData'] = legend;
        //#endregion

        //#region General Info
        // this.selectedGeneralInfoData['vendor'] = this.eJobFullDetails['Vendor'] ? this.eJobFullDetails['Vendor'].trim() : '';
        // this.selectedGeneralInfoData['vesselBkgBy'] = this.eJobFullDetails['Vessel Bkg By'] ? this.eJobFullDetails['Vessel Bkg By'].trim() : '';
        // this.selectedGeneralInfoData['oriBL'] = this.eJobFullDetails['Original BLs'] ? this.eJobFullDetails['Original BLs'].trim() : '';
        // this.selectedGeneralInfoData['nonNegoBL'] = this.eJobFullDetails['Non-Nego BLs'] ? this.eJobFullDetails['Non-Nego BLs'].trim() : '';
        // this.selectedGeneralInfoData['selectedFreightType'] = this.eJobFullDetails['Freight Type Desc'] ? this.generalInfoData['freightTypeList'].filter((t) => { return t['Freight Type Desc'].trim() == this.eJobFullDetails['Freight Type Desc'].trim() })[0] : '';
        // this.selectedGeneralInfoData['selectedCountry'] = this.eJobFullDetails['Pay Country'] ? this.generalInfoData['countryList'].filter((t) => { return t['Country Code'].trim() == this.eJobFullDetails['Pay Country'].trim() })[0] : '';
        // this.selectedGeneralInfoData['selectedCurrency'] = this.eJobFullDetails['Currency'] ? this.generalInfoData['currencyList'].filter((t) => { return t['Currency Code'].trim() == this.eJobFullDetails['Currency'].trim() })[0] : '';
        // this.selectedGeneralInfoData['selectedIncoTerms'] = this.eJobFullDetails['INCOTerm'] ? this.generalInfoData['incoTermsList'].filter((t) => { return t['Incoterm'].trim() == this.eJobFullDetails['INCOTerm'].trim() })[0] : '';
        // this.selectedGeneralInfoData['selectedInsurance'] = this.eJobFullDetails['Insurance'] ? this.generalInfoData['insuranceList'].filter((t) => { return t['Insurance'].trim() == this.eJobFullDetails['Insurance'].trim() })[0] : '';
        // this.selectedGeneralInfoData['houseBL'] = this.eJobFullDetails['HBL No'] ? this.eJobFullDetails['HBL No'].trim() : '';
        // this.selectedGeneralInfoData['selectedBranch'] = this.eJobFullDetails['Branch'] ? this.generalInfoData['branchList'].filter((t) => { return t['Branch Name'].trim() == this.eJobFullDetails['Branch'].trim() })[0] : '';
        // this.selectedGeneralInfoData['remarks'] = this.eJobFullDetails['Remarks'] ? this.eJobFullDetails['Remarks'].trim() : '';

        // this.selectedGeneralInfoData['selectedServicePIC'] = this.eJobFullDetails['Service PIC'] ? this.generalInfoData['servicePICList'].filter((t) => { return t['Service Person Code'].trim() == this.eJobFullDetails['Service PIC'].trim() })[0] : '';
        // this.selectedGeneralInfoData['selectedServiceTeam'] = this.eJobFullDetails['Service Team'] ? this.generalInfoData['serviceTeamList'].filter((t) => { return t['Service Team Code'].trim() == this.eJobFullDetails['Service Team'].trim() })[0] : '';
        // this.selectedGeneralInfoData['selectedSalesPIC'] = this.eJobFullDetails['Sales PIC'] ? this.generalInfoData['salesPICList'].filter((t) => { return t['Sales Person Code'].trim() == this.eJobFullDetails['Sales PIC'].trim() })[0] : '';
        // this.selectedGeneralInfoData['selectedSalesTeam'] = this.eJobFullDetails['Sales Team'] ? this.generalInfoData['salesTeamList'].filter((t) => { return t['Sales Team Code'].trim() == this.eJobFullDetails['Sales Team'].trim() })[0] : '';
        //#endregion

        //#region Shipping Info
        this.selectedShippingInfoData['selectedShipCall'] =
          this.eJobFullDetails['shipcall_no'] ?
            this.shippingInfoData['shipCallNoList'].getSelected(this.eJobFullDetails['shipcall_no'], 'Ship Call No')
          : null;
        this.selectedShippingInfoData['voyNo'] = this.eJobFullDetails['voyno'];
        this.selectedShippingInfoData['selectedVesselID'] =
          this.eJobFullDetails['vessel_no'] ?
            this.shippingInfoData['vesselIDList'].getSelected(this.eJobFullDetails['vessel_no'], 'Vessel ID')
          : null;
        this.selectedShippingInfoData['selectedAgentList'] =
          this.eJobFullDetails['ag_code'] ?
            this.shippingInfoData['shippingAgentList'].getSelected(this.eJobFullDetails['ag_code'], 'Agent Code')
          : null;
        this.selectedShippingInfoData['selectedShippingLine'] =
          this.eJobFullDetails['shipline'] ?
            this.shippingInfoData['shippingLineList'].getSelected(this.eJobFullDetails['shipline'], 'Agent Code')
          : null;
        // this.selectedShippingInfoData['selectedFrtForwarder'] = this.eJobFullDetails['Frt Forwarder'] ? this.shippingInfoData['frtForwarderList'].getSelected(this.eJobFullDetails['vessel_no'], 'Vessel ID') : null; // filter((t) => { return t['Agent Code'].trim() == this.eJobFullDetails['Frt Forwarder'].trim() })[0] : '';
        this.selectedShippingInfoData['selectedSpecialTreatment'] =
          this.eJobFullDetails['spc_treatment'] ?
            this.shippingInfoData['specialTreatment'].getSelected(this.eJobFullDetails['spc_treatment'], 'ST Code')
          : null;
        // this.selectedShippingInfoData['selectedStation'] = this.eJobFullDetails['Station Code'] ? this.shippingInfoData['station'].getSelected(this.eJobFullDetails['vessel_no'], 'Vessel ID') : null; // filter((t) => { return t['Station Code'].trim() == this.eJobFullDetails['Station Code'].trim() })[0] : '';
        this.selectedShippingInfoData['selectedPortOperator'] =
          this.eJobFullDetails['operator_code'] ?
            this.shippingInfoData['portOperator'].getSelected(this.eJobFullDetails['operator_code'], 'Operator Code')
          : null;
        // this.selectedShippingInfoData['warehouse'] = this.eJobFullDetails['Warehouse'] ? this.eJobFullDetails['Warehouse'].trim() : '';

        this.selectedShippingInfoData['selectedPortLoading'] =
          this.eJobFullDetails['load_port'] ?
            this.shippingInfoData['portOfLoading'].getSelected(this.eJobFullDetails['load_port'], 'Port Code')
          : null; // filter((t) => { return t['Port Code'].trim() == this.eJobFullDetails['Port of Loading'].trim() })[0] : '';
        this.selectedShippingInfoData['selectedPortDischarge'] =
          this.eJobFullDetails['discharge_port'] ?
            this.shippingInfoData['portOfDischarge'].getSelected(this.eJobFullDetails['discharge_port'], 'Port Code')
          : null; // filter((t) => { return t['Port Code'].trim() == this.eJobFullDetails['Port of Discharge'].trim() })[0] : '';
        // this.selectedShippingInfoData['selectedPortDischarge2'] = this.eJobFullDetails['Port of Discharge'] ? this.shippingInfoData['portOfDischarge'].getSelected(this.eJobFullDetails['operator_code'], 'Operator Code') : null; // filter((t) => { return t['Port Code'].trim() == this.eJobFullDetails['Port of Discharge'].trim() })[0] : '';
        this.selectedShippingInfoData['selectedFinalDestination'] =
          this.eJobFullDetails['finaldest'] ?
            this.shippingInfoData['finalDestination'].getSelected(this.eJobFullDetails['finaldest'], 'Port Code')
          : null; // filter((t) => { return t['Port Code'].trim() == this.eJobFullDetails['Final Dest'].trim() })[0] : '';
        // this.selectedShippingInfoData['demurageTime'] =
        //   this.eJobFullDetails['datedemurage'] ? new Date(this.eJobFullDetails['datedemurage']) : null;
        // this.selectedShippingInfoData['isTranshipment'] = this.eJobFullDetails['Transshipment'] == '1';
        // this.selectedShippingInfoData['selectedMVesselID'] = this.eJobFullDetails['Port of Discharge'] ? this.shippingInfoData['portOfDischarge'].getSelected(this.eJobFullDetails['operator_code'], 'Operator Code') : null; // filter((t) => { return t['Port Code'].trim() == this.eJobFullDetails['Port of Discharge'].trim() })[0] : '';
        // this.selectedShippingInfoData['mVoyNo'] = this.eJobFullDetails['Port of Discharge'] ? this.shippingInfoData['portOfDischarge'].getSelected(this.eJobFullDetails['operator_code'], 'Operator Code') : null; // filter((t) => { return t['Port Code'].trim() == this.eJobFullDetails['Port of Discharge'].trim() })[0] : '';
        // this.selectedShippingInfoData['ETDTime'] = this.eJobFullDetails['Port of Discharge'] ? this.shippingInfoData['portOfDischarge'].getSelected(this.eJobFullDetails['operator_code'], 'Operator Code') : null; // filter((t) => { return t['Port Code'].trim() == this.eJobFullDetails['Port of Discharge'].trim() })[0] : '';

        this.selectedShippingInfoData['closingTime'] =
          this.eJobFullDetails['closingtime'] ? new Date(this.eJobFullDetails['closingtime']) : null;
        this.selectedShippingInfoData['polETD'] =
          this.eJobFullDetails['date_etd'] ? new Date(this.eJobFullDetails['date_etd']) : null;
        this.selectedShippingInfoData['polETA'] =
          this.eJobFullDetails['date_eta'] ? new Date(this.eJobFullDetails['date_eta']) : null;
        // this.selectedShippingInfoData['fDestETA'] = this.eJobFullDetails['Final Dest ETA Time'] ? new Date(this.eJobFullDetails['Final Dest ETA Time']) : '';
        // this.selectedShippingInfoData['detention'] = this.eJobFullDetails['Detention Date'] ? new Date(this.eJobFullDetails['Detention Date']) : null;
        // this.selectedShippingInfoData['isFumigation'] = this.eJobFullDetails['Fumigation'] == '1';
        this.selectedShippingInfoData['selectedFumigator'] = null;
        this.selectedShippingInfoData['selectedLocation'] = null;
        this.selectedShippingInfoData['fumigateTime'] = null;
        this.selectedShippingInfoData['ventilationTime'] = null;
        this.selectedShippingInfoData['phytoMarking'] = '';

        this.selectedShippingInfoData['goodsDescription'] =
          Array.isArray(this.eJobFullDetails['GoodsDescription']) ?
            this.eJobFullDetails['GoodsDescription'].map((g) => g['GD']).join('\n')
          : '';
        this.selectedShippingInfoData['shippingMarks'] =
          Array.isArray(this.eJobFullDetails['ShipMark']) ?
            this.eJobFullDetails['ShipMark'].map((g) => g['SM']).join('\n')
          : '';
        //#endregion

        //#region Cargo Info
        this.selectedCargoInfoData['gWeight'] = this.eJobFullDetails['gweight'];
        // this.selectedCargoInfoData['volume'] = this.eJobFullDetails['Volume'] ? this.eJobFullDetails['Volume']: '';
        // this.selectedCargoInfoData['chargeable'] = this.eJobFullDetails['Chargeable'] ? this.eJobFullDetails['Chargeable'] : '';
        this.selectedCargoInfoData['selectedCommodity'] =
          this.eJobFullDetails['commodity'] ?
            this.cargoInfoData['commodityList'].getSelected(this.eJobFullDetails['commodity'], 'Commodity Code')
          : null; // filter((t) => { return t['Commodity Code'].trim() == this.eJobFullDetails['Commodity Code'].trim() })[0] : null;
        // this.selectedCargoInfoData['selectedPMaterial'] = this.eJobFullDetails['Packing Material'] ? this.cargoInfoData['pMaterialList'].getSelected(this.eJobFullDetails['finaldest'], 'Port Code') : null; // filter((t) => { return t['Packing Material Code'].trim() == this.eJobFullDetails['Packing Material'].trim() })[0] : '';
        // this.selectedCargoInfoData['packageCount'] = this.eJobFullDetails['Total Packages'] ? this.eJobFullDetails['Total Packages'] : '';
        this.selectedCargoInfoData['selectedPackageType'] =
          this.eJobFullDetails['pkgCode'] ?
            this.cargoInfoData['pkgTypeList'].getSelected(this.eJobFullDetails['pkgCode'], 'Package Code')
          : null; // filter((t) => { return t['Package Code'].trim() == this.eJobFullDetails['Package Code'].trim() })[0] : '';

        if (Array.isArray(this.eJobFullDetails['Cont_Detail'])) {
          // Adding Container Details
          this.selectedCargoInfoData['contDetailsList'] = this.eJobFullDetails['Cont_Detail'].map((c) => {
            return {
              'Cont #': c['Cont_No'],
              'Seal No': c['Seal_No'],
              'Cont Size': c['Size'],
              'Cont Type': c['Cont_Type'],
              'Cont Weight': c['weight'],
              Status: '',
              'Handling Type': c['HandlingType'],
              'Delivery Type': c['DeliveryType'],
              'Send To': '',
              'SOC/COC': '',
              Remarks: c['remarks'],
              item_action: 'N',
            };
          });
        }

        // if (Array.isArray(this.eJobFullDetails['consignments'])) { // Adding Sub Package Details
        //   this.selectedCargoInfoData['subPkgList'] = this.eJobFullDetails['consignments'].map(p => {
        //     return {
        //       'Package Quantity': p['packageqty'],
        //       'Package Type': p['package_code'],
        //       'Dimensions': `${p['Length'] ? p['Length'] : '0'}m X ${p['Width'] ? p['Width'] : '0'}m X ${p['Height'] ? p['Height'] : '0'}m`,
        //       'Gross Weight': `${p['Total Gross KG']}KG (${p['Per Pkg KG']}KG)`,
        //       'Net Weight': `${p['Total Nett KG'] ? p['Total Nett KG'] : '0'}KG (${p['Per Pkg Nett KG']}KG)`,
        //       'Volume': `${p['Total Vol M3'] ? p['Total Vol M3'] : ''}M3 (${p['Per Pkg M3']}M3)`,
        //       'Item Code': p['Item Code'] ? p['Item Code'] : '',
        //       'Packing List #': p['Packing List No'] || '',
        //       'Invoice #': p['Invoice No'] || '',
        //       'Container #': p['Container No'] || '',
        //       'Remarks': p['Remarks'] || '',
        //       'item_action': '',
        //       'seq_no': p['SeqNo'] || '',
        //     }
        //   })
        // }
        //#endregion
      });
    },
    //#endregion
    viewDocumentClicked: async function (_a, row) {
      this.$fullscreenLoading('Getting Attachments');
      this.attachmentList = [];
      this.attachmentList = await this.$apiCallV2(
        `/FreightForwarding/GetJobDocuments?jobno=${this.selectedJob[0]['Job No']}`,
      );
      this.selectedViewDocumentList = [];
      this.selectedViewDocumentList = row;
      //if no attachments, show "no attachments"
      if (this.attachmentList?.length) {
        this.convertImage(this.attachmentList);
        this.attToView = this.attachmentList[row['Row #']];
        //console.log(this.attToView) // selected attachment to view
        this.totalAtt = this.attachmentList.length;

        for (let i = 0; i < this.attachmentList.length; i++) {
          this.attachmentList[i]['AttImageType'] = this.attachmentList[i]['AttImageType'].trim();

          for (const key in this.attachmentList[i]) {
            // if (this.attachmentList[i].hasOwnProperty(key)) {
            if (Object.prototype.hasOwnProperty.call(this.attachmentList[i], key)) {
              if (
                this.attachmentList[i][key] === '' ||
                this.attachmentList[i][key] == null ||
                !this.attachmentList[i][key]
              ) {
                this.attachmentList[i][key] = 'null';
              }
            }
          }
        }
      }
      this.$fullscreenLoading();
      if (this.attToView == undefined || this.attToView.length == 0) {
        this.$showAlert('warning', 'Unsaved Document', 'Please save the job before viewing the document.');
        return;
      }
      this.openPopup = true;
      this.loading = false;
    },
    convertImage: function (data) {
      //loop to get and convert all attImg
      for (let j = 0; j < data.length; j++) {
        let type = '';
        if (data[j]['AttImageType'] == null) {
          data[j]['AttImageType'] = 'n/a';
        } else {
          type = data[j]['AttImageType'].trim();
        }

        //if empty
        if (data[j]['AttImage'] == null || data[j]['AttImage'].length == 0) {
          data[j]['AttImage'] = 'https://i.ibb.co/kyZfpjx/no-image.png';

          //if value = pdf file
        } else if (type === '.pdf' || type === 'application/pdf') {
          //qyvoon 20210520
          const b64Data = data[j]['AttImage'];
          const byteCharacters = atob(b64Data);
          const byteArrays = [];
          const sliceSize = 512;
          for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
          }
          const blob = new Blob(byteArrays, { type: 'application/pdf' });
          const fileurl = URL.createObjectURL(blob);
          data[j]['AttImage'] = fileurl;
        } else if (type === '.xlsx') {
          data[j]['AttImage'] =
            'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' +
            data[j]['AttImage'] +
            '==';
        } else if (type === '.ogg') {
          data[j]['AttImage'] = 'data:audio/ogg;base64,' + data[j]['AttImage'];
        } else if (type === '.pptx') {
          data[j]['AttImage'] =
            'data:application/vnd.openxmlformats-officedocument.presentationml.presentation;base64,' +
            data[j]['AttImage'].substring(0, data[j]['AttImage'].length - 4);
        } else if (type === '.docx') {
          data[j]['AttImage'] =
            'data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,' +
            data[j]['AttImage'];
        } else if (type === '.msg') {
          data[j]['AttImage'] = 'data:application/vnd.msoutlook;base64,' + data[j]['AttImage'];
        } else if (
          type === '.jpeg' ||
          type === '.jpg' ||
          type === 'image/Jpeg' ||
          type === '.jpeg' ||
          type === 'image/jpeg' ||
          type === '.png' ||
          type === '.gif'
        ) {
          data[j]['AttImage'] = 'data:image/png;base64,' + data[j]['AttImage'];
        } else if (type === '.webm' || type === 'video/webm') {
          data[j]['AttImage'] = 'data:video/webm;base64,' + data[j]['AttImage'];
        } else {
          data[j]['AttImage'] = 'data:application/octet-stream;base64,' + data[j]['AttImage'];
        }
      }
    },
    closePopup: function () {
      this.attachmentList = '';
      this.openPopup = false;
    },
    navAtt: function (clicked) {
      const getIndex = this.attToView;
      const inArray = this.attachmentList.indexOf(getIndex);

      // const curr = getIndex["#"] - 1;
      let next;
      const length = this.attachmentList.length;
      const end = length - 1;

      if (clicked == 'prev') {
        if (inArray == 0) {
          next = end;
        } else {
          next = inArray - 1;
        }
      } else if (inArray == end) {
        next = 0;
      } else {
        next = inArray + 1;
      }
      this.selectedViewDocumentList = this.selectedDocumentInfoData['docData'][next];
      this.attToView = this.attachmentList[next];
    },
    attachmentIsProjectable: function () {
      if (!this.attToView?.AttImageName || !this.attToView?.AttImageType) {
        return false;
      }
      const filenameSplit = this.attToView.AttImageName.trim().split('.');
      const fileExtension = filenameSplit[filenameSplit.length - 1].toLowerCase();
      const projectableExtensions = ['pdf', 'txt', 'json', 'mp3', 'wav', 'mp4', 'webm', 'ogg'];
      return this.attToView.AttImageType.startsWith('image/') || projectableExtensions.includes(fileExtension);
    },
    getFileTypeLabel() {
      if (this.attToView.AttImageName) {
        const split = this.attToView.AttImageName.split('.');
        return split[split.length - 1].toUpperCase();
      }
      return '';
    },
    downloadAttachment: function () {
      const anchor = document.createElement('a');
      anchor['href'] = this.attToView['AttImage'];
      anchor['download'] = this.attToView?.AttImageName || 'download';
      anchor.click();
    },
    loadDnConsumedQty: async function () {
      const map = {};

      const resp = await this.$apiCallV2(
        `/DeliveryNotes/GetTransportRequestDetailsByJob?jobno=${this.selectedJob[0]['Job No'].trim()}`,
      );
      //console.log('DN Consumed Qty Response:', resp);

      resp.forEach((r) => {
        const seqNo = r.SeqNo;
        if (!seqNo) return;

        if (!map[seqNo]) {
          map[seqNo] = { qty: 0, dns: [] };
        }

        map[seqNo].qty += Number(r['SubPackages Qty'] || 0);

        const dnNo = r['ROT No'];
        if (dnNo && !map[seqNo].dns.includes(dnNo)) {
          map[seqNo].dns.push(dnNo);
        }
      });

      this.dnConsumedQtyMap = map;
      //console.log('DN Consumed Qty Map:', this.dnConsumedQtyMap);
    },
    getDnConsumedInfo(seqNo) {
      return this.dnConsumedQtyMap?.[seqNo] || { qty: 0, dns: [] };
    },
    setUnit(field, value) {
      this.selectedShippingInfoData[field] = value;
    },
    handleProcessorVersion: function (version) {
      this.popupTitle = `Document AI - Processor Version: ${version}`;
    },

    async openFromParams() {
      const params = new URLSearchParams(window.location.search);

      const newValue = params.get('New');
      if (newValue != null) this.menuClicked(this.menu.find((item) => item.title == `New ${this.pageType} Job`));

      const View = params.get('View');
      const Edit = params.get('Edit');

      if (View || Edit) {
        this.searchFilterChecked = true;
        this.dateFilterChecked = false;
        this.searchByValue = View || Edit;
        this.selectedSearchBy = this.searchFilterItems.find((item) => item['Search Criteria'] == 'Job #');
        await this.refreshClicked();
        const objectCleaned = Object.fromEntries(Object.entries(this.jobsList[0]).map(([k, v]) => [k, v ?? '']));

        this.selectedJob = [{ ...objectCleaned, _rowid: 'row0' }];
        if (View) this.menuClicked(this.menu.find((item) => item.title == `View ${this.pageType} Job`));
        if (Edit) this.menuClicked(this.menu.find((item) => item.title == `Edit ${this.pageType} Job`));
      }
    },
    tableBoxRowSelected: async function (_selectedRow, selected, from) {
      if (!this.enableSMKmodule) return;

      const isPartJob = from === 'PART';

      this.showSMKRightMenu = false;

      if (!selected) {
        this.clearSMKDetails(!isPartJob);
        this.clearSMKSideDetails();

        if (!isPartJob) {
          this.showSMKDetails = false;
          this.selectedsmkPartJob = [];
        }

        return;
      }

      this.clearSMKDetails(!isPartJob);

      if (!isPartJob) {
        this.selectedsmkPartJob = [];
      }

      const formType = this.getSelectedSMKFormType(isPartJob ? 'PART' : 'JOB');

      if (!this.hasSMKFormTypeAccess(formType)) {
        this.clearSMKSideDetails();
        this.showSMKDetails = false;
        this.showSMKRightMenu = false;
        return;
      }

      await this.loadSMKDetailsForSelection(isPartJob ? 'PART' : 'JOB');
    },
    mapSMKItemList: function (items) {
      const text = (value, fallback = '') => {
        if (value === null || value === undefined || value === '') return fallback;
        return String(value).trim();
      };

      const dateValue = (value) => {
        if (!value) return null;
        if (value instanceof Date) return value;

        const date = new Date(value);
        return Number.isNaN(date.getTime()) ? null : date;
      };

      const findBy = (list, key, value) => {
        const target = text(value).toUpperCase();
        if (!target) return null;

        const found = (list || []).find((item) => {
          return text(item[key]).toUpperCase() === target;
        });

        return found || null;
      };

      const findCountry = (value) => findBy(this.generalInfoData['countryList'], 'Country Code', value);

      const findTariff = (value) => findBy(this.generalInfoData['tcList'], 'Tariff Code', value);

      const findUom = (value) => {
        const code = text(value);
        if (!code) return null;

        const found = findBy(this.generalInfoData['uomList'], 'UOM Code', code);
        return found || { 'UOM Code': code };
      };

      return (items || []).map((row, _index) => ({
        selected: false,
        _raw: row,
        _rowKey: text(row.TxnId) ? `db-${text(row.TxnId)}` : this.nextSMKItemRowKey(),

        SeqNo: text(row.SeqNo),
        TxnId: text(row.TxnId),

        ItemCode: text(row.ItemCode),
        ItemCodeObj: null,
        CountryOfOrigin: findCountry(row.CountryOfOrigin),
        HSCode: findTariff(row.HSCode),

        InvoiceQty: this.smkDecimalText(row.StatisticalQty, 5),
        InvoiceUOM: findUom(row.StatisticalUOM),

        TariffQty: this.smkDecimalText(row.DeclaredQty, 5),
        TariffUOQ: findUom(row.DeclaredUOM),

        UnitPrice: this.smkDecimalText(row.UnitPrice, 5),
        ItemAmount: this.smkDecimalText(row.ItemAmount, 4),
        ItemDescription: text(row.ItemDescription),
        LongDescription: text(row.LongDescription),
        LongDescriptionTouched: false,

        DutyQty: this.smkDecimalText(row.DutyQty, 5),
        DutyUOM: findUom(row.DutyUOM),
        GSTExemptType: text(row.GST2ExemptType),
        GSTHSCode: text(row.GST2HSCode),
        Alcohol: this.smkAlcoholObject(row.AlcoholContent),
        AlcoholContent: text(row.AlcoholContent, '0'),
        AlcoholQualifier: text(row.AlcoholQualifier),

        Duty: text(row.Duty),
        Duty2: text(row.Duty2),
        SalesTax: text(row.SalesTax),
        DutyTypeX1: text(row.DutyTypeX1),
        DutyTypeX2: text(row.DutyTypeX2),
        TaxTypeX: text(row.TaxTypeX),
        ExemptedDuty: text(row.ExemptedDuty),
        ExemptedDuty2: text(row.ExemptedDuty2),
        ExemptedTax: text(row.ExemptedTax),
        DutyCategory: text(row.DutyCategory),
        CalDuty: text(row.CalDuty),
        CalDuty2: text(row.CalDuty2),
        TaxCategory: text(row.TaxCategory),
        CalTax: text(row.CalTax),
        Excise: text(row.Excise),
        Excise2: text(row.Excise2),
        calExcise: text(row.calExcise),
        CalExcise2: text(row.CalExcise2),
        ExciseTypeX: text(row.ExciseTypeX),
        ExciseTypeX2: text(row.ExciseTypeX2),
        ExemptedExcise: text(row.ExemptedExcise),
        ExemptedExcise2: text(row.ExemptedExcise2),
        ExciseCategory: text(row.ExciseCategory),
        AntiDumping: text(row.AntiDumping),
        AntiDumping2: text(row.AntiDumping2),
        calAntiDumping: text(row.calAntiDumping),
        calAntiDumping2: text(row.calAntiDumping2),
        AntiDumpingTypeX: text(row.AntiDumpingTypeX),
        AntiDumpingTypeX2: text(row.AntiDumpingTypeX2),
        ExemptedAntiDumping: text(row.ExemptedAntiDumping),
        ExemptedAntiDumping2: text(row.ExemptedAntiDumping2),
        AntiDumpingCategory: text(row.AntiDumpingCategory),

        StatisticalQty: text(row.StatisticalQty),
        StatisticalUOM: findUom(row.StatisticalUOM),
        DeclaredQty: text(row.DeclaredQty),
        DeclaredUOM: findUom(row.DeclaredUOM),
        CEPT: text(row.GST2ExemptType),

        Model: text(row.Model),
        ChassisNo: text(row.ChassisNo),
        EngineNo: text(row.EngineNo),
        Brand: text(row.Brand),
        EngineCapacityQlf: text(row.EngineCapacityQlf),
        EngineCapacityValue: text(row.EngineCapacityValue),
        ManufactureDate: dateValue(row.ManufactureDate),

        Product: text(row.Product || row.ProdCode),
        ProductObj: null,
        WarehouseLotNo: text(row.WarehouseLotNo),
        WarehouseLocation: text(row.WarehouseLocation),
        AseanCept: ['Y', '1', 'TRUE'].includes(text(row.AseanCept).toUpperCase()),
        AseanPta: ['Y', '1', 'TRUE'].includes(text(row.AseanPta).toUpperCase()),
        AseanAD: ['Y', '1', 'TRUE'].includes(text(row.AseanAD).toUpperCase()),
        CessRate: text(row.CessRate, '0'),
        CessReplantRate: text(row.CessReplantRate, '0'),
        CessResearchRate: text(row.CessResearchRate, '0'),
        CessFlatDuty: text(row.CessFlatDuty, '0'),
        CessReplantDuty: text(row.CessReplantDuty, '0'),
        CessResearchDuty: text(row.CessResearchDuty, '0'),
      }));
    },
    verticalResizerMousedown() {
      this.isDraggingVertical = true;

      document.addEventListener('mousemove', this.verticalResizerMousemove);
      document.addEventListener('mouseup', this.verticalResizerMouseup);
    },

    verticalResizerMousemove(e) {
      if (!this.isDraggingVertical) return;

      const container = this.$el.querySelector('.page-layout');
      const rect = container.getBoundingClientRect();

      let percentage = ((e.clientY - rect.top) / rect.height) * 100;

      // limit resize range
      percentage = Math.max(20, Math.min(85, percentage));

      this.topSectionHeight = percentage;
    },

    verticalResizerMouseup() {
      this.isDraggingVertical = false;

      document.removeEventListener('mousemove', this.verticalResizerMousemove);
      document.removeEventListener('mouseup', this.verticalResizerMouseup);
    },
    // updateMenuTitles(type) {
    //   this.menu = this.menu.map((m) => {
    //     const action = m.title.split(' ')[0];

    //     if (['Edit', 'Delete', 'View'].includes(action)) {
    //       return {
    //         ...m,
    //         title: `${action} ${type}`,
    //       };
    //     }

    //     return m;
    //   });
    // },
    setSMKMenuEnabled(isEnabled) {
      this.disableSMKButtons = isEnabled;
    },
    approvalResendClicked: function () {
      // not done yet
      const selectedJob = (this.selectedJob || [])[0] || {};
      const jobNo = selectedJob['Job No'] || '';
      if (!jobNo) {
        this.showDefaultPopup('error', 'Approval To Resend', 'Please select a job first.');
      }
    },
    emailDagangClicked: async function () {
      try {
        const selectedMainJob = (this.selectedJob || [])[0] || {};
        const selectedPartJob = (this.selectedsmkPartJob || [])[0] || {};

        const mainJobNo = String(selectedMainJob['Job No'] || '').trim();
        const partJobNo = String(selectedPartJob['SMK Job No'] || '').trim();
        const isPartJob = partJobNo !== '';
        const jobNo = isPartJob ? partJobNo : mainJobNo;

        if (!jobNo) {
          this.showDefaultPopup('error', 'Email Careline', 'Please select a job first.');
          return;
        }

        this.$fullscreenLoading('Retrieving latest Dagang Net response');

        let receiveResult = null;
        try {
          receiveResult = await this.$apiCallV2('/FreightForwarding/ReceiveDagangNetSMKResponse', {
            jobno: jobNo,
            smkjobno: jobNo,
            mainjobno: mainJobNo,
            sourcetable: isPartJob ? 'SMKJOB' : '',
          });
        } catch (error) {
          this.showDefaultPopup(
            'error',
            'Error Checking Dagang Net Response',
            error?.message || 'Unable to check Dagang Net latest response. Please contact DSM Support.',
          );
          this.$fullscreenLoading();
          return;
        }
        this.$fullscreenLoading();
        //console.log(receiveResult)

        const latestMailboxRequestType = String(receiveResult?.latestMatchedRequestType || '')
          .trim()
          .toUpperCase();

        if (Number(receiveResult?.filesMatched || 0) > 0) {
          this.showDefaultPopup(
            'info',
            'Dagang Net Response Found',
            `Latest Dagang Net response ${latestMailboxRequestType || ''} was found for ${jobNo}. Please receive the response in 4G before sending email.`,
          );
          return;
        }

        await this.loadSMKDetailsForSelection(isPartJob ? 'PART' : 'JOB');

        const smkStatusList = this.smkSubmissionList || [];
        const latestStatus = smkStatusList[0] || {};
        const requestType = String(latestStatus['Request Type'] || '')
          .trim()
          .toUpperCase();
        //const statusCode = String(latestStatus['Status Code'] || '').trim();

        // const hasCusAckOrCusErr = smkStatusList.some((s) => {
        //   const type = String(s['Request Type'] || '')
        //     .trim()
        //     .toUpperCase();
        //   return ['CUSACK', 'CUSERR'].includes(type);
        // });

        if (['CUSACK', 'ZBCACK'].includes(requestType)) {
          this.showDefaultPopup(
            'success',
            'Response Received',
            `Latest Dagang Net response status is ${requestType || '-'}. Email is not required.`,
          );
          return;
        }

        let message = '';
        let recipientType = '';

        if (requestType === 'SUBMIT JOB') {
          recipientType = 'Careline';
          message = 'Kindly assist to check the SMK job below due to no response received.';
        } else if (requestType === 'CUSERR') {
          recipientType = 'DSM';
          message = 'Kindly assist to provide more information on the error(s) returned for the SMK job below.';
        } else if (requestType === '') {
          this.showDefaultPopup(
            'error',
            'Email Careline',
            `No status found for the selected job. Email template was not opened.`,
          );
          return;
        } else {
          this.showDefaultPopup(
            'error',
            'Email Careline',
            `Latest status is ${requestType || '-'}. Email template was not opened.`,
          );
          return;
        }

        const toEmailSettingItem = recipientType === 'DSM' ? 'SMKDSMToEmail' : 'SMKCarelineToEmail';
        const ccEmailSettingItem = recipientType === 'DSM' ? 'SMKDSMCCEmail' : 'SMKCarelineCCEmail';

        const toEmailSettings = await this.$apiCallV2(
          `/FreightForwarding/GetSettingsSystem?settingsItem=${toEmailSettingItem}`,
        );
        const ccEmailSettings = await this.$apiCallV2(
          `/FreightForwarding/GetSettingsSystem?settingsItem=${ccEmailSettingItem}`,
        );
        const agentCodeSettings = await this.$apiCallV2('/FreightForwarding/GetSettingsSystem?settingsItem=FACode');

        const defaultToEmail = recipientType === 'DSM' ? 'dsmsupport@dsm.com.my' : 'careline@dagangnet.com';
        const defaultCcEmail = recipientType === 'DSM' ? '' : 'dsmsupport@dsm.com.my';

        const toEmail = toEmailSettings?.[0]?.['SettingsValue'] || defaultToEmail;
        const ccEmails = String(ccEmailSettings?.[0]?.['SettingsValue'] || defaultCcEmail)
          .split(',')
          .map((email) => email.trim())
          .filter(Boolean);
        const agentCode = agentCodeSettings?.[0]?.['SettingsValue'] || '';

        const submitJobStatus =
          smkStatusList.find(
            (s) =>
              String(s['Request Type'] || '')
                .trim()
                .toUpperCase() === 'SUBMIT JOB',
          ) || {};

        const snrfNo = submitJobStatus['SNRF'] || latestStatus['SNRF'] || '-';
        const refNo = submitJobStatus['Ref No'] || latestStatus['Ref No'] || '-';
        const dateSend = submitJobStatus['Submit Date Time'] || '-';

        const subject = [
          recipientType === 'DSM' ? 'SMK CUSERR' : 'No Response',
          jobNo,
          snrfNo,
          //`${requestType || 'STATUS'}${statusCode ? `/${statusCode}` : ''}`,
        ]
          .filter(Boolean)
          .join(' - ');

        const body = [
          `Dear ${recipientType},`,
          '',
          message,
          '',
          `SNRF number : ${snrfNo}`,
          `Ref number : ${refNo}`,
          `Job number : ${jobNo}`,
          `Agent code : ${agentCode || '-'}`,
          `Date send : ${dateSend}`,
          '',
          'Thank you.',
          '',
          'Regards,',
          this.loginDetails?.['LoginUserId'] || '',
        ].join('\r\n');

        const mailto =
          `mailto:${encodeURIComponent(toEmail)}` +
          `?cc=${encodeURIComponent(ccEmails.join(','))}` +
          `&subject=${encodeURIComponent(subject)}` +
          `&body=${encodeURIComponent(body)}`;

        this.showDefaultPopup('info', 'Opening Email', 'Opening your default email application.');

        setTimeout(() => {
          window.location.href = mailto;
        }, 300);
      } catch (error) {
        this.showDefaultPopup(
          'error',
          'Email Careline',
          error?.message || 'Unable to check Dagang Net response before opening email.',
        );
      }
    },

    toggleMilestones() {
      this.showMilestones = !this.showMilestones;

      this.$nextTick(() => {
        this.updateMilestoneHeight();

        setTimeout(() => {
          this.updateMilestoneHeight();
        }, 100);
      });
    },
    updateMilestoneHeight() {
      const milestone = this.$el.querySelector('#popupMilestone');

      if (!milestone) {
        this.milestoneHeight = 0;
        return;
      }

      this.milestoneHeight = milestone.offsetHeight + 8;
    },
    //#region for SMK Item
    setActiveSMKItemRow: function (row, event) {
      if (!row) return;

      const target = event && event.target;

      if (target && target.closest('.smk-grid-input-query')) {
        if (this.smkItemDutyPanelPinned) {
          this.cancelSMKItemDuty();
        } else {
          this.closeSMKItemDutyPanel();
        }

        return;
      }

      if (target && target.closest('.select-col')) return;

      this.activeSMKItemRow = row;
    },

    showSMKItemDutyPanel(row, event) {
      if (!row) return;

      if (this.smkItemDutyPanelPinned) {
        if (this.smkItemList.includes(this.pinnedSMKItemDutyRow)) return;
        this.closeSMKItemDutyPanel();
      }

      this.cancelSMKItemDutyHide();
      this.hoverSMKItemRow = row;
      this.moveSMKItemDutyPanel(event);
    },

    moveSMKItemDutyPanel: function (event) {
      if (!event || this.smkItemDutyPanelPinned) return;

      const panelWidth = this.showSMKCessOnHover ? 710 : 430;
      const panelHeight = 175;
      const gap = 4;
      const maxLeft = Math.max(4, window.innerWidth - panelWidth - 4);
      const maxTop = Math.max(4, window.innerHeight - panelHeight - 4);

      this.hoverSMKItemPanelX = Math.min(event.clientX + gap, maxLeft);
      this.hoverSMKItemPanelY = Math.min(event.clientY + gap, maxTop);
    },

    hideSMKItemDutyPanel(row) {
      if (this.smkItemDutyPanelPinned) return;

      clearTimeout(this.smkItemDutyHideTimer);
      this.smkItemDutyHideTimer = setTimeout(() => {
        if (!this.smkItemDutyPanelPinned && this.hoverSMKItemRow === row) this.hoverSMKItemRow = null;
      }, 300);
    },
    cancelSMKItemDutyHide() {
      clearTimeout(this.smkItemDutyHideTimer);
      this.smkItemDutyHideTimer = null;
    },

    pinSMKItemDutyPanel: function () {
      const row = this.selectedSMKItemRowForDuty;
      if (!row || this.smkItemDutyPanelPinned) return;

      this.cancelSMKItemDutyHide();
      this.smkItemDutyOriginal = JSON.parse(JSON.stringify(row));
      this.smkItemDutyOriginal.ManufactureDate = row.ManufactureDate ? new Date(row.ManufactureDate) : null;
      this.pinnedSMKItemDutyRow = row;
      this.activeSMKItemRow = row;
      this.smkItemDutyPanelPinned = true;
    },

    updateSMKItemDuty: function () {
      this.smkItemDutyOriginal = null;
      this.closeSMKItemDutyPanel();
    },

    cancelSMKItemDuty: function () {
      const row = this.pinnedSMKItemDutyRow;
      const original = this.smkItemDutyOriginal;

      this.smkDutyCalculationGeneration++;

      if (row && original) {
        Object.keys(row).forEach((key) => {
          if (!Object.prototype.hasOwnProperty.call(original, key)) this.$delete(row, key);
        });

        Object.keys(original).forEach((key) => {
          this.$set(row, key, original[key]);
        });
      }

      this.smkItemDutyOriginal = null;
      this.closeSMKItemDutyPanel();
    },

    closeSMKItemDutyPanel: function () {
      clearTimeout(this.smkItemDutyHideTimer);
      this.smkItemDutyPanelPinned = false;
      this.pinnedSMKItemDutyRow = null;
      this.hoverSMKItemRow = null;
    },

    smkExemptionChanged: async function (field, type, event) {
      const item = this.selectedSMKItemRowForDuty;
      if (!item || !field) return;

      const value = String(event.target.value || '').trim();
      const formattedValue = value === '' ? '' : value + type;
      const generation = this.smkDutyCalculationGeneration;

      item[field] = formattedValue;
      item['_raw'] = {
        ...(item['_raw'] || {}),
        [field]: formattedValue,
      };

      await this.calculateSMKItemDutyCess(item, generation);
    },

    smkItemRaw: function (row, key) {
      if (!row) return '';
      const raw = row._raw || {};
      if (raw[key] !== null && raw[key] !== undefined && raw[key] !== '') return raw[key];
      if (row[key] !== null && row[key] !== undefined && row[key] !== '') return row[key];

      const rawKey = Object.keys(raw).find((x) => x.toLowerCase() === String(key).toLowerCase());
      if (rawKey && raw[rawKey] !== null && raw[rawKey] !== undefined && raw[rawKey] !== '') return raw[rawKey];

      const rowKey = Object.keys(row).find((x) => x.toLowerCase() === String(key).toLowerCase());
      if (rowKey && row[rowKey] !== null && row[rowKey] !== undefined && row[rowKey] !== '') return row[rowKey];

      return '';
    },

    smkItemText: function (row, key) {
      const value = this.smkItemRaw(row, key);
      if (value === null || value === undefined) return '';
      return String(value).trim();
    },

    smkNum: function (value) {
      if (value === null || value === undefined || value === '') return 0;
      const n = Number(
        String(value)
          .replace(/,/g, '')
          .replace(/%/g, '')
          .replace(/\$/g, '')
          .replace(/MYR/gi, '')
          .replace(/RM/gi, '')
          .trim(),
      );
      return Number.isFinite(n) ? n : 0;
    },

    smkNumText: function (row, key) {
      const n = this.smkNum(this.smkItemRaw(row, key));
      return n === 0 ? '0' : String(n);
    },

    smkSumText: function (row, keys) {
      const total = (keys || []).reduce((sum, key) => sum + this.smkNum(this.smkItemRaw(row, key)), 0);
      return total === 0 ? '0' : String(total);
    },

    smkSplitRate: function (value) {
      const text = String(value || '').trim();
      if (!text) return { percent: '0', fixed: '0' };

      const upper = text.toUpperCase();
      const number = String(this.smkNum(upper));

      if (upper.includes('%')) return { percent: number, fixed: '0' };
      if (upper.includes('$') || upper.includes('MYR') || upper.includes('RM')) return { percent: '0', fixed: number };

      return { percent: number === '0' ? '0' : number, fixed: '0' };
    },

    smkTreasuryDutyAmount: function (row) {
      const dutyCategory = this.smkItemText(row, 'DutyCategory').trim().toUpperCase();
      const calDuty = this.smkNum(this.smkItemRaw(row, 'CalDuty'));
      const calDuty2 = this.smkNum(this.smkItemRaw(row, 'CalDuty2'));

      // 4G - MSHFlexGrid1_Click displays comparison duty as the larger side, composite as both sides.
      if (dutyCategory === 'H') return String(Math.max(calDuty, calDuty2));
      return calDuty + calDuty2 === 0 ? '0' : String(calDuty + calDuty2);
    },

    addSMKItem: function () {
      this.smkItemList.push({
        selected: false,
        _raw: {},
        _rowKey: this.nextSMKItemRowKey(),
        ItemCode: '',
        ItemCodeObj: null,
        Product: '',
        ProductObj: null,
        CountryOfOrigin: this.selectedSmkInfoData['selectedCountryOfOrigin'] || null,
        HSCode: null,
        InvoiceQty: '',
        InvoiceUOM: null,
        TariffQty: '',
        TariffUOQ: null,
        ItemAmount: '',
        ItemDescription: '',
        LongDescription: '',
        LongDescriptionTouched: false,
        UnitPrice: '',
        DutyUOM: null,
        DutyQty: '',
        TxnId: '',
        GSTExemptType: '',
        GSTHSCode: '',
        AlcoholContent: '',
        AlcoholQualifier: '',

        Model: '',
        ChassisNo: '',
        EngineNo: '',
        Brand: '',
        EngineCapacityQlf: '',
        EngineCapacityValue: '',
        ManufactureDate: null,

        WarehouseLotNo: '',
        WarehouseLocation: '',
        AseanCept: false,
        AseanPta: false,
        AseanAD: false,
        CessRate: '0',
        CessReplantRate: '0',
        CessResearchRate: '0',
        CessFlatDuty: '0',
        CessReplantDuty: '0',
        CessResearchDuty: '0',
      });
    },
    openBatchAddPopup: function () {
      this.batchAddCount = '';
      this.showBatchAddPopup = true;
    },
    batchAddPopupButtonClicked: async function (buttonValue) {
      if (buttonValue !== 'Add') {
        this.showBatchAddPopup = false;
        return;
      }

      const count = parseInt(this.batchAddCount);
      if (!count || count <= 0) {
        await this.$showAlert('error', 'Invalid Number', 'Please enter a valid number', [{ text: 'OK' }]);
        return;
      }

      this.showBatchAddPopup = false;

      await this.$nextTick();

      await this.batchAddSMKItem(count);
    },
    batchAddSMKItem: async function (count) {
      this.$fullscreenLoading('Adding SMK Items...');
      await this.$nextTick();

      setTimeout(async () => {
        const CHUNK = 50;

        for (let i = 0; i < count; i++) {
          this.addSMKItem();

          if (i % CHUNK === 0) {
            await new Promise((r) => setTimeout(r, 0));
          }
        }

        this.$fullscreenLoading('');
      }, 0);
    },

    deleteSMKItem: function (index) {
      this.smkItemList.splice(index, 1);
    },
    deleteSMKItemAll: async function () {
      const deleteSMKItem = await this.$showAlert(
        'warning',
        'SMK Item Delete',
        `Are you sure you want to delete all items ?`,
        [{ text: 'Delete' }, { text: 'Cancel' }],
      );

      if (deleteSMKItem === 'Delete') {
        this.smkItemList.splice(0, this.smkItemList.length);
      }
    },
    deleteSMKItemAllSideBar: async function () {
      const selectedMainJob = (this.selectedJob || [])[0] || {};
      const selectedPartJob = (this.selectedsmkPartJob || [])[0] || {};
      const mainJobNo = String(selectedMainJob['Job No'] || '').trim();
      const partJobNo = String(selectedPartJob['SMK Job No'] || '').trim();
      const isPartJob = partJobNo !== '';
      const jobno = isPartJob ? partJobNo : mainJobNo;

      if (!jobno) {
        this.$showAlert('error', 'Delete All SMK Item', 'Please select a job.');
        return;
      }

      const deleteSMKItem = await this.$showAlert(
        'warning',
        'Delete All SMK Item',
        `Are you sure you want to delete all items for Job <b>${jobno}</b>? <br><br> <b>Note: Delete action is not reversible!</b>`,
        [{ text: 'Delete', color: 'Red', textColor: 'white' }, { text: 'Cancel' }],
      );

      if (deleteSMKItem === 'Delete') {
        try {
          this.menuLoading = true;
          this.$fullscreenLoading('Deleting SMK Items');

          const result = await this.$apiCallV2('/FreightForwarding/DeleteSMKJobInvItems', {
            jobno,
            smkjobno: jobno,
            mainjobno: mainJobNo,
            sourcetable: isPartJob ? 'SMKJOB' : '',
          });

          const resultStatus = String(result?.status ?? result?.[0]?.Results ?? '');
          const resultMessage = result?.message || result?.[0]?.ErrMsg || result?.[0]?.Message || '';

          if (resultStatus !== '0') {
            this.$showAlert('error', 'Delete All SMK Item', resultMessage || 'Delete failed.');
            return;
          }

          this.smkItemList.splice(0, this.smkItemList.length);
          this.clearSelected();
          await this.loadSMKDetailsForSelection(isPartJob ? 'PART' : 'JOB');
          if (this.$refs.smkDetailsSideBar) {
            this.$refs.smkDetailsSideBar.showItemTablePopup = false;
            this.$refs.smkDetailsSideBar.hoverSMKItemRow = null;
          }
          this.$showAlert('success', 'Delete All SMK Item', resultMessage || 'Delete Complete.');
        } catch (err) {
          this.$showAlert('error', 'Delete All SMK Item', err && err.message ? err.message : err);
        } finally {
          this.menuLoading = false;
          this.$fullscreenLoading('');
        }
      }
    },
    deleteSMKItemByRow: function (row) {
      const index = this.smkItemList.indexOf(row);
      if (index !== -1) this.deleteSMKItem(index);
    },
    toggleSelectAll: function () {
      const targetRows = this.filteredSMKItemList;

      this.$fullscreenLoading(this.selectAll ? 'Selecting items...' : 'Unselecting items...');

      setTimeout(async () => {
        const CHUNK = 50;

        for (let i = 0; i < targetRows.length; i++) {
          this.$set(targetRows[i], 'selected', this.selectAll);

          if (i % CHUNK === 0) {
            await new Promise((r) => setTimeout(r, 0));
          }
        }

        this.$fullscreenLoading('');
      }, 0);
    },

    clearSelected: function () {
      this.selectAll = false;
      this.smkItemList.forEach((row) => (row.selected = false));
    },

    deleteSelected: async function () {
      const deleteSMKItem = await this.$showAlert(
        'warning',
        'SMK Item Delete',
        `Are you sure you want to delete ${this.selectedCount} selected items?`,
        [{ text: 'Delete' }, { text: 'Cancel' }],
      );

      if (deleteSMKItem !== 'Delete') return;

      this.$fullscreenLoading('Loading...');

      setTimeout(async () => {
        // chunked delete to keep UI responsive
        const remaining = [];
        const CHUNK = 50;

        for (let i = 0; i < this.smkItemList.length; i++) {
          if (!this.smkItemList[i].selected) {
            remaining.push(this.smkItemList[i]);
          }

          if (i % CHUNK === 0) {
            await new Promise((r) => setTimeout(r, 0));
          }
        }

        this.smkItemList = remaining;
        this.selectAll = false;

        this.$fullscreenLoading('');
      }, 0);
    },

    applyBatchEdit: function () {
      if (!this.batchField) return;
      if (this.batchField === 'AseanCept' && !this.isSMKPreferentialDeclaration) return;

      const config = this.fieldConfig[this.batchField];

      this.smkItemList.forEach((row) => {
        if (!row.selected) return;

        if (config.type === 'dropdown') {
          const selected =
            this.batchQueryObject && typeof this.batchQueryObject === 'object' ?
              JSON.parse(JSON.stringify(this.batchQueryObject))
            : null;

          const value =
            selected && config.itemKey ?
              String(selected[config.itemKey] || '').trim()
            : String(this.batchValue || '').trim();

          if (this.batchField === 'ItemCode') {
            row['ItemCode'] = value;

            if (selected) {
              this.smkItemCodeSelected(row, selected);
            } else {
              row['ItemCodeObj'] = null;
            }
          } else if (this.batchField === 'Product') {
            row['ProductObj'] = selected;
            row['Product'] = value;
          } else if (this.batchField === 'Alcohol') {
            const alcohol = this.smkAlcoholObject(selected || value);
            row['Alcohol'] = alcohol;
            row['AlcoholContent'] = this.smkAlcoholCode(alcohol);
          } else {
            row[this.batchField] = selected || (value ? { [config.itemKey]: value } : null);

            if (this.batchField === 'HSCode') {
              this.selectedHSCodeByRow(row);
            }
          }
        } else if (config.type === 'checkbox') {
          row[this.batchField] = Boolean(this.batchValue);
        } else {
          row[this.batchField] = this.batchValue;
        }

        if (
          this.batchField !== 'ItemCode' &&
          this.batchField !== 'HSCode' &&
          [
            'ItemAmount',
            'TariffQty',
            'DutyQty',
            'Alcohol',
            'AlcoholContent',
            'AseanCept',
            'AseanPta',
            'AseanAD',
          ].includes(this.batchField)
        ) {
          this.calculateSMKItemDutyCess(row);
        }
      });
    },

    // SHIFT-CLICK SELECT (Excel style)
    shiftSelect: function (row, filteredIndex, event) {
      row.selected = !row.selected;

      if (row.selected) {
        this.activeSMKItemRow = row;
      } else if (this.activeSMKItemRow === row) {
        this.activeSMKItemRow = null;
      }

      if (event.shiftKey && this.lastCheckedIndex !== null) {
        const start = Math.min(filteredIndex, this.lastCheckedIndex);
        const end = Math.max(filteredIndex, this.lastCheckedIndex);
        const shouldSelect = row.selected;

        for (let i = start; i <= end; i++) {
          this.filteredSMKItemList[i].selected = shouldSelect;
        }
      }

      this.lastCheckedIndex = filteredIndex;
    },

    startColResize: function (e, colIndex) {
      const colEl = e.target.closest('.table-column');
      if (!colEl) return;

      const startX = e.pageX;
      const startWidth = colEl.offsetWidth;

      const onMove = (ev) => {
        const newWidth = startWidth + (ev.pageX - startX);
        if (newWidth < 60) return;

        this.$set(this.displayColumns, colIndex, {
          ...this.displayColumns[colIndex],
          width: newWidth,
        });
      };

      const onUp = () => {
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
        document.body.style.userSelect = '';
        document.body.style.cursor = '';
      };

      document.body.style.userSelect = 'none';
      document.body.style.cursor = 'col-resize';

      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onUp);
    },
    autoFit: function (e, colIndex) {
      const colEl = e.currentTarget;
      const rows = this.$el.querySelectorAll('.smk-edit-table .table-row');

      let maxWidth = 60;

      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      rows.forEach((row) => {
        const cell = row.children[colIndex];
        if (!cell) return;

        const input = cell.querySelector('input, textarea');
        let text = '';

        if (input) {
          text = input.value || input.placeholder || '';
        } else {
          text = cell.innerText || '';
        }

        const style = window.getComputedStyle(cell);
        ctx.font = `${style.fontSize} ${style.fontFamily}`;

        const textWidth = ctx.measureText(text).width + 30;
        maxWidth = Math.max(maxWidth, textWidth);
      });

      // also consider header text
      const headerText = colEl.innerText || '';
      const headerStyle = window.getComputedStyle(colEl);
      ctx.font = `${headerStyle.fontSize} ${headerStyle.fontFamily}`;
      maxWidth = Math.max(maxWidth, ctx.measureText(headerText).width + 30);

      if (maxWidth < 60) maxWidth = 60;

      this.$set(this.displayColumns, colIndex, {
        ...this.displayColumns[colIndex],
        width: Math.ceil(maxWidth),
      });
    },
    fitAllColumns: function () {
      this.$nextTick(() => {
        const headerColumns = this.$el.querySelectorAll('.table-header .table-column');
        const rows = this.filteredSMKItemList || this.smkItemList || [];

        if (!headerColumns.length || !rows.length) return;

        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        const getRowCellText = (row, colKey) => {
          const value = row[colKey];
          if (value == null) return '';

          if (typeof value === 'object') {
            const config = this.fieldConfig[colKey];
            if (config && config.type === 'dropdown') {
              return String(value[config.descKey] || value[config.itemKey] || '').trim();
            }
            return '';
          }

          return String(value).trim();
        };

        this.displayColumns.forEach((col, colIndex) => {
          if (['select', 'seq', 'action'].includes(col.key)) return;

          let maxWidth = col.width || 60;

          rows.forEach((row) => {
            const text = getRowCellText(row, col.key);
            if (!text) return;

            const headerEl = headerColumns[colIndex];
            const style = headerEl ? window.getComputedStyle(headerEl) : null;
            if (style) {
              ctx.font = `${style.fontSize} ${style.fontFamily}`;
            }

            const textWidth = ctx.measureText(text).width + 30;
            if (textWidth > maxWidth) {
              maxWidth = textWidth;
            }
          });

          const headerEl = headerColumns[colIndex];
          const headerText = headerEl ? (headerEl.innerText || '').trim() : '';
          if (headerEl && headerText) {
            const headerStyle = window.getComputedStyle(headerEl);
            ctx.font = `${headerStyle.fontSize} ${headerStyle.fontFamily}`;
            const headerWidth = ctx.measureText(headerText).width + 30;
            if (headerWidth > maxWidth) {
              maxWidth = headerWidth;
            }
          }

          if (maxWidth > 350) maxWidth = 350;

          // only expand
          if (maxWidth > (col.width || 60)) {
            this.$set(this.displayColumns, colIndex, {
              ...this.displayColumns[colIndex],
              width: Math.ceil(maxWidth),
            });
          }
        });
      });
    },
    initColumnFilters: function () {
      const obj = {};
      (this.displayColumns || []).forEach((col) => {
        obj[col.key] = this.columnFilters[col.key] || '';
      });
      this.columnFilters = obj;
    },

    getSearchableCellValue: function (row, key) {
      const value = row[key];

      if (value == null) return '';

      // if InputQuery stores object
      if (typeof value === 'object') {
        return (
          value['Tariff Code'] ||
          value['UOM Code'] ||
          value['Country Code'] ||
          value['Country'] ||
          value['Name'] ||
          value.label ||
          value.value ||
          ''
        );
      }

      return value;
    },

    onColumnDragStart: function (index) {
      this.draggingColumnIndex = index;
    },

    onColumnDrop: function (dropIndex) {
      const dragIndex = this.draggingColumnIndex;
      if (dragIndex === null || dragIndex === dropIndex) return;

      const cols = [...this.displayColumns];
      const dragged = cols.splice(dragIndex, 1)[0];
      cols.splice(dropIndex, 0, dragged);

      this.displayColumns = cols;
      this.draggingColumnIndex = null;
    },

    isFreeText: function (index, fieldKey, list, listKey) {
      const codeObj = this.smkItemList[index][fieldKey];
      if (!codeObj || !codeObj[listKey]) return true;

      return !list.some((item) => item[listKey] === codeObj[listKey]);
    },
    isFreeTextByRow: function (row, key, list, compareKey) {
      const value = row[key];

      let raw = '';

      if (typeof value === 'object' && value !== null) {
        raw = value[compareKey] || value.Name || value.value || '';
      } else {
        raw = value || '';
      }

      const normalized = String(raw).trim().toUpperCase();

      // empty also count as warning
      if (!normalized) return true;

      return !list.some((item) => {
        const itemVal = String(item[compareKey] || '')
          .trim()
          .toUpperCase();

        return itemVal === normalized;
      });
    },
    selectedHSCode: function (index) {
      // select Tariff Code will auto populate Tariff UOM
      const hscodeUOM = this.smkItemList[index]?.HSCode?.UOM || '';
      const valueToMatch = (hscodeUOM || '').toString().trim();
      // Match against uomList
      const selected = this.generalInfoData['uomList'].getSelected(valueToMatch, 'UOM Code') || null;
      // 4G - TariffCode selects the item UOQ/TcUOQ column.
      this.smkItemList[index]['TariffUOQ'] = selected;
      this.smkItemList[index]['DeclaredUOM'] = selected;
      this.smkItemList[index]['InvoiceUOM'] = selected;
      this.isFreeText(index, 'HSCode', this.generalInfoData.tcList, 'Tariff Code');
    },
    selectedHSCodeByRow: function (row) {
      const index = this.smkItemList.indexOf(row);
      if (index === -1) return;

      this.selectedHSCode(index);

      const tc = row.HSCode || {};
      const uom = String(tc.UOM || '')
        .trim()
        .toUpperCase();

      const qualifiers = [
        tc.tcImpDutyQualifier,
        tc.tcImpCA1Qualifier,
        tc.tcImpCA2Qualifier,
        tc.tcImpCO1Qualifier,
        tc.tcImpCO2Qualifier,
        tc.tcExpDutyQualifier,
        tc.tcExpDutyQualifier2,
        tc.tcTaxDutyQualifier,
        tc.ExciseQualifier,
        tc.ExciseQualifier1,
        tc.AntiDumpingQualifier,
        tc.AntiDumpingQualifier1,
        tc.tcAseanCEPTQualifier,
        tc.tcAseanPTAQualifier,
      ];

      const dutyQualifier = qualifiers
        .map((value) =>
          String(value || '')
            .trim()
            .toUpperCase(),
        )
        .find((value) => value && value !== uom);

      if (dutyQualifier) {
        row.DutyUOM = (this.generalInfoData.uomList || []).find(
          (item) =>
            String(item['UOM Code'] || '')
              .trim()
              .toUpperCase() === dutyQualifier,
        ) || { 'UOM Code': dutyQualifier };
      } else {
        row.DutyQty = '';
        row.DutyUOM = null;
      }

      row.AlcoholQualifier = String(tc.AlcoholQualifier || '').trim();
      if (!this.canEnterSMKAlcohol(row)) row.AlcoholContent = '0';

      this.calculateSMKItemDutyCess(row);
    },
    exportSMKItemExcel: async function () {
      const data = this.smkItemList.map((item) => {
        const clone = { ...item };
        delete clone._raw;
        delete clone._rowid;
        delete clone.id;
        delete clone.selected;
        delete clone.StatisticalQty;
        delete clone.StatisticalUOM;
        delete clone.DeclaredQty;
        delete clone.DeclaredUOM;
        delete clone.CEPT;
        delete clone.AlcoholContent;

        // convert dropdown objects into strings
        Object.keys(clone).forEach((key) => {
          //console.log('key', key);
          if (clone[key] && typeof clone[key] === 'object') {
            const config = this.fieldConfig[key];

            // SPECIAL RULE for Alcohol → use descKey
            if (key === 'Alcohol' && config && config.type === 'dropdown') {
              clone[key] = clone[key][config.descKey] ?? '';
            } else if (config && config.type === 'dropdown') {
              clone[key] = clone[key][config.itemKey] ?? '';
            } else {
              // fallback for unexpected objects
              clone[key] = JSON.stringify(clone[key]);
            }
          }
        });
        return clone;
      });

      if (data.length === 0) {
        this.$showAlert('error', 'No data', 'No SMK Items to export');
        return;
      }
      const currentDateTime = new Date().formatString('dd/MM/yyyy HH:mm:ss');

      const exportName = `SMK_Import_Items_${currentDateTime}`;
      const templateType = 'SMKImportItem';
      await this.$jsonToExcel(exportName, data, templateType, null, false);
    },
    toggleSMKItemExpand: function () {
      this.isSMKItemExpanded = !this.isSMKItemExpanded;

      this.$nextTick(() => {
        this.updateMilestoneHeight && this.updateMilestoneHeight();

        setTimeout(() => {
          this.updateMilestoneHeight && this.updateMilestoneHeight();
        }, 100);
      });
    },
    //#endregion

    findMenu: function (key) {
      if (!key) return null;

      return this.menu.find((m) => String(m.key).toLowerCase() === String(key).toLowerCase());
    },

    getMenuTitle: function (key, fallback) {
      const menu = this.findMenu(key);
      return menu && menu.title ? menu.title : fallback;
    },

    isMenuEnabled: function (key) {
      if (this.menuLoading) return false;

      const menu = this.findMenu(key);

      if (!menu) return true;

      return menu.enabled !== false;
    },

    customMenuClicked: function (key, fallbackTitle) {
      const menu = this.findMenu(key);

      if (menu) {
        this.menuClicked(menu);
        return;
      }

      this.menuClicked({
        title: fallbackTitle,
        enabled: true,
      });
    },
    filterBy: function (list, conditions) {
      return (list || []).filter((item) => {
        return conditions.every((condition) => condition(item));
      });
    },
    filterSMKlist: function () {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const customer =
        this.pageType === 'Export' ?
          this.selectedHeaderInfoData['selectedShipper']
        : this.selectedHeaderInfoData['selectedConsignee'];

      const customerCode = String(
        customer?.[this.pageType === 'Export' ? 'Shipper Code' : 'Consignee Code'] || '',
      ).trim();

      const belongsToCustomer = (x) => String(x['Customer No'] || '').trim() === customerCode;

      const belongsToGroup = (x, group) => String(x['Exemp Group'] || '').trim() === group;

      const isNotExpired = (x) => {
        if (!x['Expiry Date']) return false;

        const expiryDate = new Date(x['Expiry Date']);
        expiryDate.setHours(0, 0, 0, 0);

        return expiryDate >= today;
      };

      this.smkInfoData['exemptNoListTE'] = (this.smkInfoData['exemptNoList'] || []).filter(
        (x) => belongsToCustomer(x) && belongsToGroup(x, 'TE') && isNotExpired(x),
      );

      this.smkInfoData['exemptNoListST'] = (this.smkInfoData['exemptNoList'] || []).filter(
        (x) => belongsToCustomer(x) && belongsToGroup(x, 'ST') && isNotExpired(x),
      );

      this.smkInfoData['exemptNoListAP'] = (this.smkInfoData['exemptNoList'] || []).filter(
        (x) => belongsToCustomer(x) && belongsToGroup(x, 'AP'),
      );

      this.smkInfoData['exemptTypeListTE'] = (this.smkInfoData['exemptTypeList'] || []).filter((x) =>
        belongsToGroup(x, 'TE'),
      );

      this.smkInfoData['exemptTypeListST'] = (this.smkInfoData['exemptTypeList'] || []).filter((x) =>
        belongsToGroup(x, 'ST'),
      );

      this.smkInfoData['exemptTypeListAP'] = (this.smkInfoData['exemptTypeList'] || []).filter((x) =>
        belongsToGroup(x, 'AP'),
      );
    },
    teExemptNoSelected: function () {
      const selected = this.selectedSmkInfoData['exemptNoTreasury'];
      const type = selected ? selected['Type'] : '';

      this.selectedSmkInfoData['exemptTypeTreasury'] = this.smkInfoData['exemptTypeListTE'].getSelected(type, 'Type');

      this.selectedSmkInfoData['expiryDateTE'] =
        selected && selected['Expiry Date'] ? new Date(selected['Expiry Date']) : null;
    },

    stExemptNoSelected: function () {
      const selected = this.selectedSmkInfoData['exemptNoSalesTax'];
      const type = selected ? selected['Type'] : '';

      this.selectedSmkInfoData['exemptTypeSalesTax'] = this.smkInfoData['exemptTypeListST'].getSelected(type, 'Type');
    },

    apExemptNoSelected: function () {
      const selected = this.selectedSmkInfoData['exemptNoSpecialTreatment'];

      const type = selected ? selected['Type'] : '';

      this.selectedSmkInfoData['exemptTypeSpecialTreatment'] = this.smkInfoData['exemptTypeListAP'].getSelected(
        type,
        'Type',
      );
    },

    clauseCodeSelected: function () {
      const selected = this.selectedSmkInfoData['clauseCode'];
      const clauseCode = selected ? selected['Clause Code'] : '';

      const clause = this.smkInfoData['clauseList'].getSelected(clauseCode, 'Clause Code');

      this.clauseText = clause ? clause['Clause Text'] || '' : '';
    },
    getSMKSubmissionBackColor(s) {
      if (!this.selectedJob[0]) return '';
      const requestType = String(s['Request Type'] || '').trim();
      const statusCode = String(s['Status Code'] || '').trim();
      const source = String(this.selectedJob[0]['SMK Form Type'] || '')
        .trim()
        .toUpperCase();

      // Error request type always red
      if (['CUSERR', 'ZBCERR', 'FSPGERR'].includes(requestType)) {
        return '#FAAFB5';
      }

      // Final successful status
      if (source.startsWith('K') && ['21', '87', '88'].includes(statusCode)) {
        // select * from SMKStatusCode where statuscode in ('21','87','88')
        return '#79d279'; // green
      }

      if (source.startsWith('ZB') && ['44'].includes(statusCode)) {
        //select * from SMKStatusCode where statuscode in ('44')
        return '#79d279'; // green
      }

      // Submitted job
      if (requestType === 'SUBMIT JOB') {
        return '#cfe2ff'; // blue
      }

      // ACK but not final yet
      if (['CUSACK', 'ZBCACK'].includes(requestType)) {
        return '#ffff99'; // yellow
      }

      return '#e9ecef';
    },

    getSMKSubmissionTooltip(s) {
      // const data = [
      //   ['Remarks', s['Remarks']],
      //   ['SMK #', s['SMK #']],
      //   ['Duty Type', s['Duty Type']],
      //   ['Amount', s['Amount']],
      //   ['Submit Date', s['Submit Date Time']],
      //   ['Date Updated', s['DateUpdate']],
      //   ['SNRF', s['SNRF']],
      //   ['Ref No', s['Ref No']],
      // ];

      // return data
      //   .map(([label, value]) => {
      //     return `${label.padEnd(13, ' ')} : ${value || '-'}`;
      //   })
      //   .join('\n');

      return s['Remarks'] ? s['Remarks'] : '-';
    },
    getHeaderSMKFormType: function () {
      const selected = this.selectedHeaderInfoData && this.selectedHeaderInfoData['selectedSmkFormType'];

      return String(selected && selected['Form Type'] ? selected['Form Type'] : '')
        .trim()
        .toUpperCase();
    },

    isHeaderSMKFormTypeChanged: function () {
      return (
        String(this.originalSMKFormType || '')
          .trim()
          .toUpperCase() !== this.getHeaderSMKFormType()
      );
    },

    confirmSMKFormTypeChange: async function () {
      if (!this.isHeaderSMKFormTypeChanged()) return true;

      const oldFormType = this.originalSMKFormType || '(blank)';
      const newFormType = this.getHeaderSMKFormType() || '(blank)';

      const confirmChange = await this.$showAlert(
        'warning',
        'SMK Form Type Changed',
        `SMK Form Type has changed from <b>${oldFormType}</b> to <b>${newFormType}</b>.<br>Are you sure you want to save this change?`,
        [{ text: 'Save' }, { text: 'Cancel', color: 'lightgray' }],
      );

      return confirmChange === 'Save';
    },

    resetSMKFormData: function (clearPartJobs = false) {
      this.selectedSmkInfoData = {
        selectedSmkFormType: null,
        selectedDeclarationType: null,
        selectedDoc: [],

        k3Type: null,
        k3MoveTo: null,

        k8Type: null,
        movementType: null,
        moveDate: null,
        moveFromStation: null,
        moveToStation: null,
        moveFromWarehouse: '',
        moveToWarehouse: '',

        k9Warehouse: null,
        k9WarehouseType: null,
        k9Station: null,
        k9License: '',
        k9LicenseDate: null,
        k9DepositDate: null,
        k9DepositReceipt: '',
      };
      this.clauseText = '';
      this.flatFilePreview = {
        jobno: '',
        fileName: '',
        text: '',
        errors: [],
      };
      this.showFlatFilePreviewPopup = false;
      this.showFlatFilePreview = false;
      this.flatFilePreviewText = '';
      this.flatFilePreviewErrors = '';
      this.flatFilePreviewFileName = '';
      this.flatFilePreviewBase64 = '';
      this.flatFilePreviewJobNo = '';
      this.smkTabIndex = 0;

      this.clearSMKDetails(clearPartJobs);
      this.applySMKViewTabAccess(false);
    },
    clearSMKDetails: function (clearPartJobs = false) {
      this.smkSummaryDetails = [];
      this.smkExemptDetails = [];
      this.jobSummaryDetails = {};
      this.smkDocList = [];
      this.smkSubmissionList = [];
      this.smkItemList = [];
      this.activeSMKItemRow = null;
      this.hoverSMKItemRow = null;
      this.smkExempClause = [];

      this.smkFreightCurrencyDetails = [];
      this.smkFreightExchangeRates = null;

      this.smkDocMode = '';
      this.smkDocDraft = null;
      this.smkDocDeletedList = [];
      this.smkDocUid = 0;

      this.smkTransportList = [];
      this.selectedSMKTransportRows = [];
      this.smkTransportMode = '';
      this.smkTransportDraft = null;
      this.smkTransportTableVersion += 1;

      if (clearPartJobs) {
        this.smkPartJobList = [];
      }
    },
    clearSMKSideDetails: function () {
      this.smkSideSummaryDetails = [];
      this.smkSideExemptDetails = [];
      this.smkSideDocList = [];
      this.smkSideSubmissionList = [];
      this.smkSideItemList = [];
      this.smkSideJobSummaryDetails = {};
      this.smkSideExempClause = [];
      this.smkSideFormType = '';
    },

    loadSMKDetailsForSelection: async function (from = 'JOB') {
      if (!this.enableSMKmodule) return;

      const isPartJob = from === 'PART';

      const mainJobNo = this.selectedJob.length > 0 ? (this.selectedJob[0]['Job No'] || '').trim() : '';

      const jobno =
        (
          isPartJob // if main job use jobno, else part job no
        ) ?
          this.selectedsmkPartJob.length > 0 ?
            (this.selectedsmkPartJob[0]['SMK Job No'] || '').trim()
          : ''
        : mainJobNo;

      if (!jobno) return;

      const selectedSMKJob = isPartJob ? (this.selectedsmkPartJob || [])[0] || {} : (this.selectedJob || [])[0] || {};
      this.smkSideFormType = String(
        selectedSMKJob['SMK Form Type'] || selectedSMKJob.FormType || selectedSMKJob.JobFormType || '',
      )
        .trim()
        .toUpperCase();

      const dataToPost = {
        jobtype: this.pageType[0],
        jobno,
        smkjobno: isPartJob ? jobno : mainJobNo,
      };

      const smkDetails = (await this.$apiCallV2(`/FreightForwarding/GetSMKDetails`, dataToPost)) || {};

      const nextSmkSummaryDetails = smkDetails.smkSummaryDetails || [];
      const nextSmkExemptDetails = smkDetails.smkExemptDetails || [];
      const nextSmkDocList = smkDetails.smkDocList || [];
      const rawSmkItemList = smkDetails.smkItemList || [];
      const nextSmkItemList = this.mapSMKItemList(rawSmkItemList);
      const nextSmkSideItemList = this.mapSMKItemList(rawSmkItemList);
      const nextSmkSubmissionList = (smkDetails.smkSubmissionList || []).map((s) => ({
        ...s,
        BackColor: this.getSMKSubmissionBackColor(s),
      }));
      const nextSmkExempClause = smkDetails.smkExempClause || [];

      this.smkSummaryDetails = nextSmkSummaryDetails;
      this.smkExemptDetails = nextSmkExemptDetails;
      //this.smkDocList = nextSmkDocList;
      this.smkItemList = nextSmkItemList;
      this.smkSubmissionList = nextSmkSubmissionList;
      this.smkExempClause = nextSmkExempClause;

      this.smkSideSummaryDetails = nextSmkSummaryDetails;
      this.smkSideExemptDetails = nextSmkExemptDetails;
      //this.smkSideDocList = nextSmkDocList;
      this.smkSideItemList = nextSmkSideItemList;
      this.smkSideSubmissionList = nextSmkSubmissionList;
      this.smkSideExempClause = nextSmkExempClause;
      this.smkFreightCurrencyDetails = smkDetails.smkFreightCurrencyDetails || [];

      // SMK Documents
      this.smkDocDeletedList = [];
      this.cancelSMKDoc();
      this.selectedSmkInfoData.selectedDoc = [];
      this.smkDocList = nextSmkDocList.map((doc) => ({
        ...doc,
        _smkDocUid: ++this.smkDocUid,
        _smkSaved: true,
        _smkOriginalCategory: doc.Doc,
        _smkOriginalRef: doc['SMK Ref #'], // preserve the raw original value
      }));
      this.smkSideDocList = nextSmkDocList.map((doc) => ({ ...doc }));

      const mainjobno = mainJobNo;

      const jobDetailsUrl =
        `/FreightForwarding/JobDetails?jobno=${encodeURIComponent(jobno)}` +
        `${isPartJob ? '&sourcetable=SMKJOB' : ''}` +
        `${isPartJob ? `&mainjobno=${encodeURIComponent(mainjobno)}` : ''}`;

      const getJobDetails = await this.$apiCallV2(jobDetailsUrl);
      // console.log(getJobDetails)
      const nextJobSummaryDetails = getJobDetails && getJobDetails.JobDetails ? getJobDetails.JobDetails.Job : {};

      this.jobSummaryDetails = nextJobSummaryDetails;
      this.smkSideJobSummaryDetails = nextJobSummaryDetails;
      // console.log(this.jobSummaryDetails)
      if (!isPartJob) {
        this.smkPartJobList =
          (await this.$apiCallV2(`/FreightForwarding/GetListJobTracking`, {
            jobtype: this.pageType[0],
            jobno: mainJobNo,
            sourcetable: 'SMKJOB', // If part job, get part job listing
            searchfield: '',
            searchcriteria: '',
            searchvalue: '',
            stjobdate: '',
            edjobdate: '',
          })) || [];

        this.showSMKDetails = this.smkPartJobList.length > 0;
      }

      this.smkTransportMode = '';
      this.smkTransportDraft = null;
      this.selectedSMKTransportRows = [];

      this.smkTransportList = (smkDetails.smkTransportDetails || []).map((row, index) => ({
        SeqNo: Number(row.SeqNo || 0),
        'Seq #': Number(row.SeqNo || index + 1),
        'Transport Type': String(row['Transport Type'] || '').trim(),
        'Transport Description': String(row['Transport Description'] || '').trim(),
        'Transport ID': String(row['Transport ID'] || '').trim(),
        Station: String(row.Station || '').trim(),
        License: String(row.License || '').trim(),
        Year: String(row.Year || '').trim(),
        _smkTransportUid: ++this.smkTransportUid,
        _smkSaved: true,
      }));

      this.smkTransportTableVersion += 1;

      this.showSMKRightMenu = true;
    },
    getSelectedSMKFormType: function (from = 'JOB') {
      if (from === 'PART') {
        const part = (this.selectedsmkPartJob || [])[0] || {};
        const smkSummary = (this.smkSummaryDetails || [])[0] || {};

        return String(
          part['SMK Form Type'] ||
            part['Form Type'] ||
            smkSummary.JobFormType ||
            smkSummary.FormType ||
            this.jobSummaryDetails['Form Type'] ||
            '',
        )
          .trim()
          .toUpperCase();
      }

      const job = (this.selectedJob || [])[0] || {};

      return String(job['SMK Form Type'] || '')
        .trim()
        .toUpperCase();
    },

    hasSMKFormTypeAccess: function (formType) {
      const source = String(formType || '')
        .trim()
        .toUpperCase();
      const denied = this.smkDeniedControls || [];

      if (!source) return false;

      // Not implemented yet , remove later
      if (['ZB1', 'ZB2', 'ZB3'].includes(source)) {
        return false;
      }

      if (source === 'K8') {
        if (denied.includes('MNUK8')) return false; // If K8 is denied, then all K8 forms are denied

        if (this.pageType === 'Import' && denied.includes('MNUK8IMP')) return false; // If K8 Import is denied, then K8 Import forms are denied
        if (this.pageType === 'Export' && denied.includes('MNUK8EXP')) return false; // If K8 Export is denied, then K8 Export forms are denied

        return true;
      }

      return !denied.includes(`MNU${source}`);
    },
    applySMKViewTabAccess: function (hasSMKAccess) {
      const hasHeaderSMKFormType = Boolean(this.getHeaderSMKFormType());
      const canOpenSMKTab = this.enableSMKmodule && hasHeaderSMKFormType && hasSMKAccess;

      this.tabsItems[9]['disabled'] = !canOpenSMKTab;

      this.smktabsItems[0]['disabled'] = !canOpenSMKTab;
      this.smktabsItems[1]['disabled'] = !canOpenSMKTab;
      this.smktabsItems[2]['disabled'] = !canOpenSMKTab;

      this.smktabsItems[3]['disabled'] = !this.enableSMKmodule;

      if (!canOpenSMKTab && this.currentTabIndex == 9) {
        this.currentTabIndex = 1;
      }

      const firstEnabledIndex = this.smktabsItems.findIndex((x) => !x.disabled);
      this.smkTabIndex = firstEnabledIndex >= 0 ? firstEnabledIndex : 0;
    },
    // #region FlatFile
    previewFlatFileClicked: async function () {
      const selectedMainJob = (this.selectedJob || [])[0] || {};
      const selectedPartJob = (this.selectedsmkPartJob || [])[0] || {};

      const mainJobNo = String(selectedMainJob['Job No'] || '').trim();
      const partJobNo = String(selectedPartJob['SMK Job No'] || '').trim();
      const isPartJob = partJobNo !== '';

      const jobno = isPartJob ? partJobNo : mainJobNo;
      const formtype = String(
        isPartJob ? selectedPartJob['SMK Form Type'] || '' : selectedMainJob['SMK Form Type'] || '',
      ).trim();

      if (!jobno) {
        this.$showAlert('error', 'Preview FlatFile Error', 'Please select a job.');
        return;
      }

      try {
        this.menuLoading = true;
        this.$fullscreenLoading('Generating FlatFile Preview');

        const params = new URLSearchParams({
          jobno,
          mainjobno: mainJobNo,
          formtype,
          jobtype: this.pageType[0] || '',
          sourcetable: isPartJob ? 'SMKJOB' : '',
        });

        const result = await this.$apiCallV2(`/FreightForwarding/PreviewSMKFlatFile?${params.toString()}`);
        //console.log(result)
        const preview = result?.preview || '';
        //console.log(JSON.stringify(preview.slice(-10)));
        const message = result?.message || '';

        if (!preview && !message) {
          this.$showAlert('error', 'Preview FlatFile Error', message || 'No preview generated.');
          return;
        }
        this.showFlatFilePreview = true;
        this.flatFilePreviewJobNo = jobno;
        this.flatFilePreviewText = preview;
        //console.log(this.flatFilePreviewText)
        this.flatFilePreviewErrors = message.replace(/\r\n\r\n/g, '\r\n').replace(/\n\n/g, '\n');
        this.flatFilePreviewFileName = result?.fileName || `${jobno}.Flt`;
        this.flatFilePreviewBase64 = result?.fileBase64 || '';
      } catch (err) {
        this.$showAlert('error', 'Preview FlatFile Error', err && err.message ? err.message : err);
      } finally {
        this.menuLoading = false;
        this.$fullscreenLoading();
      }
    },
    downloadFlatFilePreview: function () {
      const fileName = this.flatFilePreviewFileName || 'PreviewSMKFlatFile.Flt';
      let bytes;

      if (this.flatFilePreviewBase64) {
        const raw = atob(this.flatFilePreviewBase64);
        bytes = new Uint8Array(raw.length);
        for (let i = 0; i < raw.length; i += 1) {
          bytes[i] = raw.charCodeAt(i);
        }
      } else {
        bytes = [this.flatFilePreviewText || ''];
      }

      const blob = new Blob([bytes], { type: 'text/plain;charset=us-ascii' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    // #endregion

    // #region Duplicate From Other Company
    dpoRefreshClicked: async function () {
      this.dpoJobList = [];

      let hasError = false;
      if (!this.selectedCompanyDPO && this.showDPOPopup) {
        this.dpoCompanyErr = 'Select a company!';
        hasError = true;
      }
      if (this.dpoSearchInvalid) {
        this.dpoSearchByErr = !this.dpoSearchBy ? 'Select search by!' : '';
        this.dpoSearchCriteriaErr = !this.dpoSearchCriteria ? 'Select search criteria!' : '';
        this.dpoSearchInputErr = !this.dpoSearchInput ? 'Enter search input!' : '';
        hasError = true;
      }
      if (this.dpoDateInvalid) {
        this.dpoFromDateErr = !this.dpoFromDate ? 'Select start date!' : '';
        this.dpoToDateErr = !this.dpoToDate ? 'Select end date!' : '';
        hasError = true;
      }

      if (hasError) return;

      const dataToPost = {
        stjobdate: this.dpoFilterByDate ? new Date(this.dpoFromDate).formatString('yyyy-MM-dd') : '',
        edjobdate: this.dpoFilterByDate ? new Date(this.dpoToDate).formatString('yyyy-MM-dd') : '',
        jobtype: this.pageType[0],
        searchfield: this.dpoFilterBySearch ? this.dpoSearchBy['Search Criteria'] : '',
        searchcriteria: this.dpoFilterBySearch ? this.dpoSearchCriteria['name'] : '',
        searchvalue: this.dpoFilterBySearch ? this.dpoSearchInput : '',
        duplicatecocode: this.selectedCompanyDPO ? this.selectedCompanyDPO['Company Code'] : '',
      };

      const filterItems = [];
      if (this.dpoFilterByDate) {
        filterItems.push(
          `date from ${this.dpoFromDate.formatString('yyyy-MM-dd')} to ${this.dpoToDate.formatString('yyyy-MM-dd')}`,
        );
      }
      if (this.dpoFilterBySearch) {
        filterItems.push(
          `${this.dpoSearchBy['Search Criteria']} ${this.dpoSearchCriteria['name']} ${this.dpoSearchInput}`,
        );
      }
      this.dpoFilterText = `Filter by ${filterItems.join(', ')}`;
      this.dpoFilterOpen = false;

      if (this.selectedCompanyDPO) {
        this.$fullscreenLoading('Getting Jobs ...');
        this.dpoJobList = await this.$apiCallV2(`/FreightForwarding/GetListJobTracking`, dataToPost);
        this.$fullscreenLoading();
      }

      this.dpoLastRefreshed = new Date().formatString('yyyy-MM-dd HH:mm');
    },
    dpoSearchBySelected: function () {
      if (this.dpoSearchBy['Search Criteria'] == 'Required Date') {
        this.dpoSearchCriteria = this.searchCriteriaItems[0];
        this.dpoSearchCriteriaDisabled = true;
      } else {
        this.dpoSearchCriteriaDisabled = false;
      }
    },
    dpoConfirmClicked: function () {
      if (this.selectedJobDPO.length == 0) {
        this.$showAlert('error', 'No Job Selected', 'Please select a job to duplicate');
        return;
      }
      this.dpoFlag = 'CPO'; // flag for SP NewForwardingJob
      this.showDPOPopup = false;
      this.showPopup = true;
      this.popupTitle = `New ${this.pageType} Job`;
      this.viewEditClicked('e', true, this.dpoCopyContainers, {
        jobno: this.selectedJobDPO[0]['Job No'],
        duplicatecocode: this.selectedCompanyDPO['Company Code'],
      });
      this.clearDPOPopup();
    },
    clearDPOPopup: function () {
      this.showDPOPopup = false;
      this.dpoFilterByDate = true;
      this.dpoFromDate = new Date();
      this.dpoToDate = new Date();
      this.dpoFromDateErr = '';
      this.dpoToDateErr = '';

      this.dpoFilterBySearch = false;
      this.dpoSearchBy = null;
      this.dpoSearchByErr = '';
      this.dpoSearchCriteria = null;
      this.dpoSearchCriteriaErr = '';
      this.dpoSearchInput = '';
      this.dpoSearchInputErr = '';
      this.dpoSearchCriteriaDisabled = false;

      this.dpoFilterText = '';
      this.dpoLastRefreshed = null;
      this.selectedCompanyDPO = null;
      this.dpoCompanyErr = '';
      this.dpoJobList = [];
      this.dpoCopyContainers = false;
      this.selectedJobDPO = [];
    },
    // #endregion

    buildSMKSavePayload: function (jobNo, action, options = {}) {
      const text = (value, fallback = '') => {
        if (value === null || value === undefined || value === '') return fallback;
        return String(value).trim();
      };
      const code = (value, key) => {
        if (!value) return '';
        if (typeof value === 'object') return text(value[key]);
        return text(value);
      };
      const dateText = (value) => {
        if (!value) return '';
        return new Date(value).formatString('yyyy-MM-dd');
      };
      const itemCode = (row, field, key) => code(row[field], key);
      const rawSummary = (this.smkSummaryDetails || [])[0] || {};
      const smk = this.selectedSmkInfoData || {};

      const sourceTable = String(options.sourceTable || '')
        .trim()
        .toUpperCase();
      const isPartJob = sourceTable === 'SMKJOB';
      const mainJobNo = text(options.mainJobNo, jobNo);
      const smkJobNo = text(options.smkJobNo, jobNo);
      const forwardingPostData = options.forwarding || {};

      const boolText = (value) => (value ? 'Y' : '');

      return {
        action: action,
        partjobmode: options.partJobMode || '',
        jobno: isPartJob ? mainJobNo : jobNo,
        smkjobno: isPartJob ? smkJobNo : jobNo,
        mainjobno: isPartJob ? mainJobNo : jobNo,
        sourcetable: sourceTable,
        jobtype: this.pageType[0],
        jobdetail: forwardingPostData,
        goodsdescription: text(this.selectedShippingInfoData['goodsDescription']),
        shipmark: text(this.selectedShippingInfoData['shippingMarks']),
        containerdetail: forwardingPostData['containerdetail'] || [],
        transmode:
          this.selectedHeaderInfoData['selectedTransMode'] ?
            this.selectedHeaderInfoData['selectedTransMode']['Trans Mode']
          : '',
        cunumber:
          this.pageType[0] == 'E' ?
            code(this.selectedHeaderInfoData['selectedShipper'], 'Shipper Code')
          : code(this.selectedHeaderInfoData['selectedConsignee'], 'Consignee Code'),
        formtype:
          code(smk['selectedSmkFormType'], 'Form Type') ||
          code(this.selectedHeaderInfoData['selectedSmkFormType'], 'Form Type'),
        smk: {
          declaretype:
            smk['selectedDeclarationType'] ?
              String(smk['selectedDeclarationType']['Declare Type'] || '').replace(/\s+$/, '')
            : '',
          shiptype: code(smk['selectedShipmentType'], 'Code'),
          ctryorigin: code(smk['selectedCountryOfOrigin'], 'Country Code'),
          frttype: code(smk['invoiceTypeFreight'], 'Currency Code'),
          frtamt: text(smk['amountFreight'], '0'),

          freightCurrency:
            this.hasSMKAdditionalFreightCurrency ?
              {
                currencyCode: code(smk['invoiceTypeFreight'], 'Currency Code'),
                foreignAmount: text(smk['amountFreight'], '0'),
                exchangeRate: text(smk['freightForeignRate'], '0'),
                exchangeDate: dateText(smk['freightForeignDate']),
                amountMYR: text(smk['freightAmountMYR'], '0'),
              }
            : null,
          frtqlf: code(smk['qualifierFreight'], 'Qualifier'),
          instype: code(smk['invoiceTypeInsurance'], 'Currency Code'),
          insamt: text(smk['amountInsurance'], '0'),
          insqlf: code(smk['qualifierInsurance'], 'Qualifier'),
          upltype: code(smk['invoiceTypeUplift'], 'Currency Code'),
          uplamt: text(smk['amountUplift'], '0'),
          uplqlf: code(smk['qualifierUplift'], 'Qualifier'),
          bctype: code(smk['invoiceTypeBuyingComm'], 'Currency Code'),
          bcamt: text(smk['amountBuyingComm'], '0'),
          bcqlf: code(smk['qualifierBuyingComm'], 'Qualifier'),
          pctype: code(smk['invoiceTypePortCharges'], 'Currency Code'),
          pcamt: text(smk['amountPortCharges'], '0'),
          pcqlf: code(smk['qualifierPortCharges'], 'Qualifier'),
          dctype: code(smk['invoiceTypeDiscount'], 'Currency Code'),
          dcamt: text(smk['amountDiscount'], '0'),
          dcqlf: code(smk['qualifierDiscount'], 'Qualifier'),
          othtype: code(smk['invoiceTypeOther'], 'Currency Code'),
          othamt: text(smk['amountOther'], '0'),
          othqlf: code(smk['qualifierOther'], 'Qualifier'),
          ttltype: code(smk['invoiceTypeAmount'], 'Currency Code'),
          ttlamt: text(smk['amountAmount'], '0'),
          ttlqlf: code(smk['qualifierAmount'], 'Qualifier'),
          excode: code(smk['currency1'], 'Currency Code'),
          exrate: text(smk['exchangeRate1'], '0'),
          exdate: dateText(this.selectedHeaderInfoData['exchangeRateDate1']),
          jobformtype:
            code(smk['selectedSmkFormType'], 'Form Type') ||
            code(this.selectedHeaderInfoData['selectedSmkFormType'], 'Form Type'),
          calFob: text(rawSummary['CalFob'], '0'),
          calFrt: text(rawSummary['CalFrt'], '0'),
          calIns: text(rawSummary['CalIns'], '0'),
          calUP: text(rawSummary['CalUP'], '0'),
          calBC: text(rawSummary['CalBC'], '0'),
          calPC: text(rawSummary['CalPC'], '0'),
          calOT: text(rawSummary['CalOT'], '0'),
          calMOM: text(rawSummary['calMOM'], '0'),
          calDC: text(rawSummary['CalDC'], '0'),
          gsttreatmenttype: text(rawSummary['GSTTreatmentType']),

          k3type: this.currentSMKFormType === 'K3' ? code(smk['k3Type'], 'Code') : code(smk['k8Type'], 'Code'),

          moveto: code(smk['k3MoveTo'], 'Station Code'),
          movetype: code(smk['movementType'], 'Move Type'),
          movedate: dateText(smk['moveDate']),
          movefrstation: code(smk['moveFromStation'], 'Station Code'),
          movetostation: code(smk['moveToStation'], 'Station Code'),
          movefrwhse: text(smk['moveFromWarehouse']),
          movetowhse: text(smk['moveToWarehouse']),

          whsecode: code(smk['k9Warehouse'], 'Warehouse Code'),
          whsetype: code(smk['k9WarehouseType'], 'Warehouse Type'),
          stt: code(smk['k9Station'], 'Station Code'),
          license: text(smk['k9License']),
          licensedate: dateText(smk['k9LicenseDate']),
          depdate: dateText(smk['k9DepositDate']),
          deprecpt: text(smk['k9DepositReceipt']),
        },
        exemption: {
          tetype: code(smk['exemptTypeTreasury'], 'Type'),
          terefno: code(smk['exemptNoTreasury'], 'Exemption No'),
          teexpirydate: dateText(smk['expiryDateTE']),
          sttype: code(smk['exemptTypeSalesTax'], 'Type'),
          strefno: code(smk['exemptNoSalesTax'], 'Exemption No'),
          stregdate: dateText(smk['registrationDateST']),
          stexpirydate: dateText(smk['expiryDateST']),
          ststationcode: text(smk['stationCode']),
          aptype: code(smk['exemptTypeSpecialTreatment'], 'Type'),
          aprefno: code(smk['exemptNoSpecialTreatment'], 'Exemption No'),
          cmname: text(smk['claimentName']),
          cmcompany: text(smk['claimentCompany']),
          cmstatus: text(smk['claimentStatus']),
          cmnric: text(smk['claimentNRIC']),
        },
        clause: {
          clausecode: code(smk['clauseCode'], 'Clause Code'),
          clausetext: text(this.clauseText),
        },
        smkdocuments: (this.smkDocList || []).map((doc) => ({
          doccategory: doc.Doc,
          smkdoccode: doc.SmkDoc,
          docrefno: doc['SMK Ref #'],
          issuedate: doc.IssueDate || '',
          expirydate: doc.ExpiryDate || '',
          invoicedate: doc.InvoiceDate || '',
          stationcode: doc.StationCode || '',
          ogacode: doc.OGACode || '',
          ogabranchcode: doc.OGABranchCode || '',
          persisted: Boolean(doc._smkSaved),
          originaldoccategory: doc._smkOriginalCategory || '',
          originaldocrefno: doc._smkOriginalRef || '',
        })),
        deletedsmkdocuments: this.smkDocDeletedList.map((doc) => ({ ...doc })),
        smktransportdetails: (this.smkTransportList || []).map((row) => ({
          seqno: Number(row.SeqNo || 0),
          transtype: text(row['Transport Type']),
          transid: text(row['Transport ID']),
          station: text(row.Station),
          license: text(row.License),
          year: text(row.Year),
        })),
        smkitems: (this.smkItemList || []).map((row, _index) => ({
          seqno: text(row.SeqNo),
          txnid: text(row.TxnId),
          itemdesc: text(row.ItemDescription),
          longdescription: text(row.LongDescription),
          tc: itemCode(row, 'HSCode', 'Tariff Code'),
          tcuoq: itemCode(row, 'TariffUOQ', 'UOM Code'),
          scanuom: itemCode(row, 'TariffUOQ', 'UOM Code'),
          scanqty: text(row.TariffQty, '0'),
          invqty: text(row.InvoiceQty, '0'),
          invuom: itemCode(row, 'InvoiceUOM', 'UOM Code'),
          dutyqty: text(row.DutyQty, '0'),
          dutyuom: itemCode(row, 'DutyUOM', 'UOM Code'),
          invunitprice: text(row.UnitPrice, '0'),
          ttlamt: text(row.ItemAmount, '0'),
          coo: itemCode(row, 'CountryOfOrigin', 'Country Code'),
          duty: text(row.Duty),
          duty2: text(row.Duty2),
          salestax: text(row.SalesTax),
          dutytypex1: text(row.DutyTypeX1, '0%'),
          dutytypex2: text(row.DutyTypeX2, this.getHeaderSMKFormType() === 'K2' ? '0%' : '0$'),
          taxtypex: text(row.TaxTypeX, '0%'),
          exemptedduty: text(row.ExemptedDuty, '0'),
          exemptedduty2: text(row.ExemptedDuty2, '0'),
          exemptedtax: text(row.ExemptedTax, '0'),
          dutycategory: text(row.DutyCategory),
          calduty: text(row.CalDuty, '0'),
          calduty2: text(row.CalDuty2, '0'),
          taxcategory: text(row.TaxCategory),
          caltax: text(row.CalTax, '0'),
          excise: text(row.Excise),
          excise2: text(row.Excise2),
          calexcise: text(row.calExcise, '0'),
          calexcise2: text(row.CalExcise2, '0'),
          excisetypex: text(row.ExciseTypeX, '0%'),
          excisetypex2: text(row.ExciseTypeX2, '0$'),
          exemptedexcise: text(row.ExemptedExcise, '0'),
          exemptedexcise2: text(row.ExemptedExcise2, '0'),
          excisecategory: text(row.ExciseCategory),
          antis: text(row.AntiDumping),
          antidumping2: text(row.AntiDumping2),
          calantidumping: text(row.calAntiDumping, '0'),
          calantidumping2: text(row.calAntiDumping2, '0'),
          antidumpingtypex: text(row.AntiDumpingTypeX, '0%'),
          antidumpingtypex2: text(row.AntiDumpingTypeX2, '0$'),
          exemptedantidumping: text(row.ExemptedAntiDumping, '0'),
          exemptedantidumping2: text(row.ExemptedAntiDumping2, '0'),
          antidumpingcategory: text(row.AntiDumpingCategory),
          gstexempttype: text(row.GSTExemptType || row.CEPT),
          gsthscode: text(row.GSTHSCode),
          alcoholcontent: text(row.AlcoholContent, '0'),
          alcoholqualifier: text(row.AlcoholQualifier),
          vehicle: {
            brand: text(row.Brand),
            model: text(row.Model),
            engineno: text(row.EngineNo),
            chasisno: text(row.ChassisNo),
            cc: text(row.EngineCapacityValue),
            engcapqlf: text(row.EngineCapacityQlf),
            manufacturedate: dateText(row.ManufactureDate),
          },
          prodcode: code(row.ProductObj, 'Product Code') || text(row.Product),
          itemcode: code(row.ItemCodeObj, 'Item Code') || text(row.ItemCode),
          aseancept: boolText(row.AseanCept),
          aseanpta: boolText(row.AseanPta),
          aseanad: boolText(row.AseanAD),
          cessrate: text(row.CessRate, '0'),
          cessreplantrate: text(row.CessReplantRate, '0'),
          cessresearchrate: text(row.CessResearchRate, '0'),
          cessflatduty: text(row.CessFlatDuty, '0'),
          cessreplantduty: text(row.CessReplantDuty, '0'),
          cessresearchduty: text(row.CessResearchDuty, '0'),
          warehouselotno: text(row.WarehouseLotNo),
          warehouselocation: text(row.WarehouseLocation),
        })),
      };
    },

    saveSMKDetails: async function (jobNo, action, options = {}) {
      const formType =
        this.selectedSmkInfoData['selectedSmkFormType'] ? this.selectedSmkInfoData['selectedSmkFormType']['Form Type']
        : this.selectedHeaderInfoData['selectedSmkFormType'] ?
          this.selectedHeaderInfoData['selectedSmkFormType']['Form Type']
        : '';

      if (!this.enableSMKmodule || !formType || !this.hasSMKFormTypeAccess(formType)) return null;

      const smkPayload = this.buildSMKSavePayload(jobNo, action, options);
      return await this.$apiCallV2('/FreightForwarding/SaveSMKDetails', smkPayload);
    },

    getSelectedMainJobNo: function () {
      const selectedMainJob = (this.selectedJob || [])[0] || {};

      return String(selectedMainJob['Job No'] || '').trim();
    },

    getSelectedPartJobNo: function () {
      const selectedPartJob = (this.selectedsmkPartJob || [])[0] || {};

      return String(selectedPartJob['SMK Job No'] || selectedPartJob['Job No'] || '').trim();
    },

    setSMKPartJobContext: function (mainJobNo, smkJobNo) {
      this.smkPartJobContext = {
        isPartJob: true,
        mainJobNo,
        smkJobNo,
        sourceTable: 'SMKJOB',
      };
    },

    clearSMKPartJobContext: function () {
      this.smkPartJobContext = {
        isPartJob: false,
        mainJobNo: '',
        smkJobNo: '',
        sourceTable: '',
      };
    },

    isSMKPartJobPopup: function () {
      return Boolean(this.smkPartJobContext && this.smkPartJobContext.isPartJob);
    },

    getPartJobSettingValue: async function () {
      // Part Job No based on SettingsItem "SMK_PartJob"
      //- Missing/blank `SMK_PartJob`: defaults to `0`, same as 4G.
      //- Non-numeric `SMK_PartJob`: defaults to `0`.
      const settings = await this.$apiCallV2('/FreightForwarding/GetSettingsSystem?settingsItem=SMK_PartJob');
      const value = String(
        settings && settings[0] && settings[0]['SettingsValue'] ? settings[0]['SettingsValue'] : '',
      ).trim();
      if (!/^\d+$/.test(value)) return '0';
      if (Number(value) === 0) return '0';
      return value;
    },

    getNextSMKPartJobNo: async function (mainJobNo) {
      const partJobMax = await this.getPartJobSettingValue();
      const existingPartJobs = (this.smkPartJobList || [])
        .map((x) => String(x['SMK Job No'] || x['Job No'] || '').trim())
        .filter((x) => x && x.toUpperCase().startsWith(`${mainJobNo.toUpperCase()}-`));

      if (partJobMax !== '0') {
        const maxPartJob = Number(partJobMax);
        const nextPartNo = existingPartJobs.length + 1;

        if (Number.isFinite(maxPartJob) && nextPartNo > maxPartJob) {
          this.$showAlert('error', 'New Part Job', `Max Part Job available is ${partJobMax}.`);
          return '';
        }

        return `${mainJobNo}-${String(nextPartNo).padStart(partJobMax.length, '0')}`;
      }

      let suffix = '';
      if (existingPartJobs.length >= 26) {
        const numericSuffix = existingPartJobs.length - 26;
        if (numericSuffix >= 10) {
          this.$showAlert('error', 'New Part Job', `File extension -${numericSuffix}, exceed permitted value.`);
          return '';
        }
        suffix = String(numericSuffix);
      } else {
        suffix = String.fromCharCode(65 + existingPartJobs.length);
      }

      return `${mainJobNo}-${suffix}`;
    },

    setPartJobPopupTabs: function (hasSMKAccess) {
      this.tabsItems[5]['disabled'] = true;
      this.tabsItems[6]['disabled'] = true;
      this.tabsItems[7]['disabled'] = true;
      this.tabsItems[8]['disabled'] = true;
      this.applySMKViewTabAccess(hasSMKAccess);
    },

    buildSMKItemDutyRows: function (row) {
      const dutyCategory = this.smkItemText(row, 'DutyCategory').trim().toUpperCase();
      const isCess = dutyCategory === 'F' || dutyCategory === 'C';

      const treasuryDuty = this.smkSplitRate(this.smkItemText(row, 'Duty'));
      const treasuryDuty2 = this.smkSplitRate(this.smkItemText(row, 'Duty2'));
      const treasuryExempt = this.smkSplitRate(this.smkItemText(row, 'DutyTypeX1'));
      const treasuryExempt2 = this.smkSplitRate(this.smkItemText(row, 'DutyTypeX2'));
      const exciseDuty = this.smkSplitRate(this.smkItemText(row, 'Excise'));
      const exciseDuty2 = this.smkSplitRate(this.smkItemText(row, 'Excise2'));
      const exciseExempt = this.smkSplitRate(this.smkItemText(row, 'ExciseTypeX'));
      const exciseExempt2 = this.smkSplitRate(this.smkItemText(row, 'ExciseTypeX2'));
      const antiDumpingDuty = this.smkSplitRate(this.smkItemText(row, 'AntiDumping'));
      const antiDumpingDuty2 = this.smkSplitRate(this.smkItemText(row, 'AntiDumping2'));
      const antiDumpingExempt = this.smkSplitRate(this.smkItemText(row, 'AntiDumpingTypeX'));
      const antiDumpingExempt2 = this.smkSplitRate(this.smkItemText(row, 'AntiDumpingTypeX2'));
      const salesTax = this.smkSplitRate(this.smkItemText(row, 'SalesTax'));
      const salesTaxExempt = this.smkSplitRate(this.smkItemText(row, 'TaxTypeX'));

      return [
        {
          label: 'Treasury',
          dutyPercent: treasuryDuty.percent || treasuryDuty2.percent,
          dutyFixed: treasuryDuty.fixed || treasuryDuty2.fixed,
          dutyAmount: this.smkTreasuryDutyAmount(row),

          exemptPercent: isCess ? '0' : treasuryExempt.percent || treasuryExempt2.percent,
          exemptFixed: isCess ? '0' : treasuryExempt.fixed || treasuryExempt2.fixed,
          exemptAmount: isCess ? '0' : this.smkSumText(row, ['ExemptedDuty', 'ExemptedDuty2']),

          exemptPercentField: isCess ? null : 'DutyTypeX1',
          exemptFixedField: isCess ? null : 'DutyTypeX2',
        },
        {
          label: 'Excise',
          dutyPercent: exciseDuty.percent || exciseDuty2.percent,
          dutyFixed: exciseDuty.fixed || exciseDuty2.fixed,
          dutyAmount: this.smkSumText(row, ['calExcise', 'CalExcise2']),
          exemptPercent: isCess ? '0' : exciseExempt.percent || exciseExempt2.percent,
          exemptFixed: exciseExempt.fixed || exciseExempt2.fixed,
          exemptAmount: this.smkSumText(row, ['ExemptedExcise', 'ExemptedExcise2']),
          exemptPercentField: 'ExciseTypeX',
          exemptFixedField: 'ExciseTypeX2',
        },
        {
          label: 'Anti Dumping',
          dutyPercent: antiDumpingDuty.percent || antiDumpingDuty2.percent,
          dutyFixed: antiDumpingDuty.fixed || antiDumpingDuty2.fixed,
          dutyAmount: this.smkSumText(row, ['calAntiDumping', 'calAntiDumping2']),
          exemptPercent: antiDumpingExempt.percent || antiDumpingExempt2.percent,
          exemptFixed: antiDumpingExempt.fixed || antiDumpingExempt2.fixed,
          exemptAmount: this.smkSumText(row, ['ExemptedAntiDumping', 'ExemptedAntiDumping2']),
          exemptPercentField: 'AntiDumpingTypeX',
          exemptFixedField: 'AntiDumpingTypeX2',
        },
        {
          label: 'Sales Tax',
          dutyPercent: salesTax.percent,
          dutyFixed: salesTax.fixed,
          dutyAmount: this.smkNumText(row, 'CalTax'),
          exemptPercent: salesTaxExempt.percent,
          exemptFixed: salesTaxExempt.fixed,
          exemptAmount: this.smkNumText(row, 'ExemptedTax'),
          exemptPercentField: 'TaxTypeX',
          exemptFixedField: null,
        },
        {
          label: 'Special',
          // 4G - MSHFlexGrid1_Click sets item special treatment txtitem(23/20/26) to 0.
          dutyPercent: '0',
          dutyFixed: '0',
          dutyAmount: '0',
          exemptPercent: '0',
          exemptFixed: '0',
          exemptAmount: '0',
          exemptPercentField: null,
          exemptFixedField: null,
        },
      ];
    },

    buildSMKItemCessRows: function (row) {
      const flat = this.smkSplitRate(this.smkItemText(row, 'CessRate'));
      const replant = this.smkSplitRate(this.smkItemText(row, 'CessReplantRate'));
      const research = this.smkSplitRate(this.smkItemText(row, 'CessResearchRate'));
      const x1 = this.smkSplitRate(this.smkItemText(row, 'DutyTypeX1'));
      const x2 = this.smkSplitRate(this.smkItemText(row, 'DutyTypeX2'));
      const formType = this.getHeaderSMKFormType();

      return [
        {
          label: 'Replant/Flat',
          cessRate: Number(flat.percent) !== 0 ? flat.percent : replant.fixed,
          cessAmount: this.smkSumText(row, ['CessFlatDuty', 'CessReplantDuty']),
          exemptPercent: x1.percent,
          exemptAmount: this.smkNumText(row, 'ExemptedDuty'),
          exemptPercentField: 'DutyTypeX1',
        },
        {
          label: 'Research',
          cessRate: research.fixed,
          cessAmount: this.smkNumText(row, 'CessResearchDuty'),
          exemptPercent: x2.percent,
          exemptAmount: this.smkNumText(row, 'ExemptedDuty2'),
          exemptPercentField: formType === 'K2' ? 'DutyTypeX2' : null,
        },
      ];
    },

    calculateSMKItemDutyCess: async function (row, generation) {
      if (!row || this.isSMKItemViewOnly) return;

      const formType = this.getHeaderSMKFormType();
      if (!['K1', 'K2', 'K3', 'K8', 'K9'].includes(formType)) return;

      const text = (value, fallback = '') => {
        if (value === null || value === undefined || value === '') return fallback;
        return String(value).trim();
      };
      const code = (value, key) => {
        if (!value) return '';
        if (typeof value === 'object') return text(value[key]);
        return text(value);
      };

      const hsCode = code(row.HSCode, 'Tariff Code');
      if (!hsCode) return;

      const result = await this.$apiCallV2('/FreightForwarding/CalculateSMKItemDutyCess', {
        jobno: this.selectedHeaderInfoData['jobNo'] || this.getSelectedMainJobNo(),
        smkjobno: this.getSelectedPartJobNo() || this.selectedHeaderInfoData['jobNo'] || this.getSelectedMainJobNo(),
        jobtype: this.pageType[0],
        formtype: formType,
        tc: hsCode,
        itemamount: text(row.ItemAmount, '0'),
        tariffqty: text(row.TariffQty, '0'),
        dutyqty: text(row.DutyQty, '0'),
        alcoholcontent: text(row.AlcoholContent, '0'),
        aseancept: Boolean(row.AseanCept),
        aseanpta: Boolean(row.AseanPta),
        aseanad: Boolean(row.AseanAD),
        dutytypex1: text(row.DutyTypeX1),
        dutytypex2: text(row.DutyTypeX2),
        taxtypex: text(row.TaxTypeX),
        excisetypex: text(row.ExciseTypeX),
        excisetypex2: text(row.ExciseTypeX2),
        antidumpingtypex: text(row.AntiDumpingTypeX),
        antidumpingtypex2: text(row.AntiDumpingTypeX2),
      });

      if (!result || String(result.status) !== '0') return;

      const item = result.item || {};

      if (generation !== undefined && generation !== this.smkDutyCalculationGeneration) return;

      // Update editable row
      Object.keys(item).forEach((key) => {
        row[key] = item[key];
      });

      // Hover table reads _raw, so update it too
      row['_raw'] = {
        ...(row['_raw'] || {}),
        ...item,
      };
    },

    smkCode: function (value, key) {
      if (!value) return '';
      if (typeof value === 'object') return String(value[key] || '').trim();
      return String(value).trim();
    },

    smkAlcoholCode: function (value) {
      let raw = value;

      if (value && typeof value === 'object') {
        if (Object.prototype.hasOwnProperty.call(value, 'Alcohol')) {
          raw = value.Alcohol || value.AlcoholContent || '';
        } else if (Object.prototype.hasOwnProperty.call(value, 'Code')) {
          raw = value.Code;
        } else if (Object.prototype.hasOwnProperty.call(value, 'Name')) {
          raw = value.Name;
        }
      }

      if (raw && typeof raw === 'object') {
        raw = raw.Code ?? raw.Name ?? '';
      }

      const text = String(raw ?? '')
        .trim()
        .toUpperCase();
      return ['Yes'].includes(text) ? '1' : '0';
    },

    smkAlcoholObject: function (value) {
      const code = this.smkAlcoholCode(value);
      const list = this.generalInfoData && this.generalInfoData.alcoholList ? this.generalInfoData.alcoholList : [];

      return (
        list.find((x) => String(x.Code).trim() === code) || {
          Name: code === '1' ? 'Yes' : 'No',
          Code: code === '1' ? 1 : 0,
        }
      );
    },

    smkAlcoholSelected: function (row, selected) {
      if (!row) return;

      const alcohol = this.smkAlcoholObject(selected);

      row['Alcohol'] = alcohol;
      row['AlcoholContent'] = this.smkAlcoholCode(alcohol);

      this.calculateSMKItemDutyCess(row);
    },

    smkItemMasterItemsByRow: function (row) {
      let rows = this.generalInfoData['smkItemMasterList'] || [];

      const customerCode = this.currentSMKCustomerCode;
      const productCode = this.smkCode(row && (row.ProductObj || row.Product), 'Product Code');

      if (!this.showAllSMKItems && customerCode) {
        rows = rows.filter((x) => String(x['Customer Code'] || '').trim() === customerCode);
      }

      if (productCode) {
        rows = rows.filter((x) => String(x['Product Code'] || '').trim() === productCode);
      }

      return rows;
    },

    smkProductSelected: function (row, selected) {
      if (!row) return;

      row['ProductObj'] = selected || null;

      if (selected && selected['Product Code']) {
        row['Product'] = selected['Product Code'];
      }
    },

    smkItemCodeSelected: function (row, selected) {
      if (!row) return;

      row['ItemCodeObj'] = selected || null;
      if (!selected) return;

      if (selected['Item Code']) {
        row['ItemCode'] = selected['Item Code'];
      }

      if (selected['Item Name']) {
        row['ItemDescription'] = selected['Item Name'];
      }

      if (selected['Product Code']) {
        row['Product'] = selected['Product Code'];
        row['ProductObj'] = this.generalInfoData['smkProductList'].getSelected(
          selected['Product Code'],
          'Product Code',
        );
      }

      if (selected['Tariff Code']) {
        const tariffCode = String(selected['Tariff Code']).trim();

        row['HSCode'] = this.generalInfoData['tcList'].getSelected(tariffCode, 'Tariff Code') || {
          'Tariff Code': tariffCode,
        };

        const index = this.smkItemList.indexOf(row);

        if (index !== -1) {
          this.selectedHSCode(index);
        }
      }

      this.calculateSMKItemDutyCess(row);
    },
    smkDecimalText: function (value, places) {
      const number = Number(String(value ?? 0).replace(/,/g, ''));
      return Number.isFinite(number) ? number.toFixed(places) : (0).toFixed(places);
    },
    smkItemValueChanged: function (row, field, focused) {
      if (!row || focused) return;

      const format = (value, places) => {
        const n = Number(String(value || 0).replace(/,/g, ''));
        return Number.isFinite(n) ? n.toFixed(places) : (0).toFixed(places);
      };

      if (field === 'InvoiceQty') {
        row.InvoiceQty = format(row.InvoiceQty, 5);
        row.TariffQty = row.InvoiceQty;
        row.StatisticalQty = row.InvoiceQty;
        row.DeclaredQty = row.InvoiceQty;
      }

      if (field === 'TariffQty') row.TariffQty = format(row.TariffQty, 5);
      if (field === 'DutyQty') row.DutyQty = format(row.DutyQty, 5);
      if (field === 'ItemAmount') row.ItemAmount = format(row.ItemAmount, 4);

      if (['InvoiceQty', 'ItemAmount', 'UnitPrice'].includes(field)) {
        const qty = Number(row.InvoiceQty);
        const amount = Number(row.ItemAmount);

        if (qty > 0 && Number.isFinite(amount)) {
          row.UnitPrice = (amount / qty).toFixed(5);
        } else if (field === 'UnitPrice') {
          row.UnitPrice = format(row.UnitPrice, 5);
        }
      }

      this.calculateSMKItemDutyCess(row);
    },
    smkCurrencyChanged: async function (currency, target = 'invoice') {
      if (target === 'freight') {
        this.smkFreightExchangeRates = null;
      } else {
        this.smkExchangeRates = null;
      }

      const exCode = String(currency?.['Currency Code'] || '')
        .trim()
        .toUpperCase();

      if (!exCode) return;

      if (exCode === 'MYR') {
        if (target === 'freight') {
          this.selectedSmkInfoData['freightForeignRate'] = '1.0000';
          this.updateSMKFreightMYRAmount();
        } else {
          this.selectedSmkInfoData['exchangeRate1'] = '1.0000';
        }

        return;
      }

      const result = await this.$apiCallV2('/FreightForwarding/GetSMKExchangeRates', {
        excode: exCode,
        jobtype: this.pageType[0],
      });

      if (!result || String(result.status) !== '0') {
        await this.$showAlert('error', 'Exchange Rate', result?.message || 'Exchange Rate not available.');
        return;
      }

      if (target === 'freight') {
        this.smkFreightExchangeRates = result.rates;
      } else {
        this.smkExchangeRates = result.rates;
      }
    },

    selectSMKExchangeRate: function (rate, date, target = 'invoice') {
      if (target === 'freight') {
        this.selectedSmkInfoData['freightForeignRate'] = rate;
        this.selectedSmkInfoData['freightForeignDate'] = date ? new Date(`${date}T00:00:00`) : null;

        this.smkFreightExchangeRates = null;
        this.updateSMKFreightMYRAmount();
        return;
      }

      this.selectedSmkInfoData['exchangeRate1'] = rate;
      this.selectedHeaderInfoData['exchangeRateDate1'] = date ? new Date(`${date}T00:00:00`) : null;

      this.smkExchangeRates = null;
    },

    selectSMKFreightExchangeRate: function (rate, date) {
      this.selectedSmkInfoData['freightForeignRate'] = rate;
      this.selectedSmkInfoData['freightForeignDate'] = date ? new Date(`${date}T00:00:00`) : null;

      this.smkFreightExchangeRates = null;
      this.updateSMKFreightMYRAmount();
    },

    updateSMKFreightMYRAmount: function () {
      if (!this.hasSMKAdditionalFreightCurrency) return;

      const amount = Number(String(this.selectedSmkInfoData['amountFreight'] || 0).replaceAll(',', ''));

      const rate = Number(String(this.selectedSmkInfoData['freightForeignRate'] || 0).replaceAll(',', ''));

      this.selectedSmkInfoData['freightAmountMYR'] = (amount * rate).toFixed(2);
    },
    setNewSmkInvoiceDefaults: function () {
      const myr = this.smkInvoiceTypeList.getSelected('MYR', 'Currency Code') || {
        'Currency Code': 'MYR',
      };
      const percent = this.smkInvoiceTypeList.getSelected('%', 'Currency Code') || {
        'Currency Code': '%',
      };
      const cnf = this.smkInvoiceQualifierList.getSelected('CNF', 'Qualifier') || {
        Qualifier: 'CNF',
      };
      const port033 = this.smkPortQualifierList.getSelected('0.33', 'Qualifier') || {
        Qualifier: '0.33',
      };

      this.selectedSmkInfoData['invoiceTypeFreight'] = percent;
      this.selectedSmkInfoData['amountFreight'] = '4';
      this.selectedSmkInfoData['qualifierFreight'] = null;

      this.selectedSmkInfoData['invoiceTypeInsurance'] = percent;
      this.selectedSmkInfoData['amountInsurance'] = '1';
      this.selectedSmkInfoData['qualifierInsurance'] = cnf;

      this.selectedSmkInfoData['invoiceTypeUplift'] = myr;
      this.selectedSmkInfoData['invoiceTypeBuyingComm'] = myr;
      this.selectedSmkInfoData['invoiceTypePortCharges'] = myr;
      this.selectedSmkInfoData['invoiceTypeDiscount'] = myr;
      this.selectedSmkInfoData['invoiceTypeOther'] = myr;
      this.selectedSmkInfoData['invoiceTypeAmount'] = myr;

      this.selectedSmkInfoData['amountUplift'] = '0.00';
      this.selectedSmkInfoData['amountBuyingComm'] = '0.00';
      this.selectedSmkInfoData['amountPortCharges'] = '0.00';
      this.selectedSmkInfoData['amountDiscount'] = '0.00';
      this.selectedSmkInfoData['amountOther'] = '0.00';
      this.selectedSmkInfoData['amountAmount'] = '0.00';

      this.selectedSmkInfoData['qualifierUplift'] = null;
      this.selectedSmkInfoData['qualifierBuyingComm'] = null;
      this.selectedSmkInfoData['qualifierPortCharges'] = port033;
      this.selectedSmkInfoData['qualifierDiscount'] = null;
      this.selectedSmkInfoData['qualifierOther'] = null;
      this.selectedSmkInfoData['qualifierAmount'] = null;

      this.selectedSmkInfoData['currency1'] = null;
      this.selectedSmkInfoData['exchangeRate1'] = '';
      this.selectedHeaderInfoData['exchangeRateDate1'] = null;
      this.smkExchangeRates = null;

      this.selectedSmkInfoData['freightForeignRate'] = '';
      this.selectedSmkInfoData['freightForeignDate'] = null;
      this.selectedSmkInfoData['freightAmountMYR'] = '';
      this.smkFreightExchangeRates = null;
      this.smkFreightCurrencyDetails = [];
    },
    getSmkInvoiceCode: function (field) {
      const value = this.selectedSmkInfoData[field];

      if (!value) return '';

      return String(typeof value === 'object' ? value['Currency Code'] : value).trim();
    },

    smkInvoiceTypeChanged: function (typeField, amountField, qualifierField) {
      const type = this.getSmkInvoiceCode(typeField);

      if (typeField === 'invoiceTypeFreight') {
        if (type === '%') {
          if (Number(this.selectedSmkInfoData[amountField] || 0) === 0) {
            this.selectedSmkInfoData[amountField] = '4';
          }

          this.selectedSmkInfoData[qualifierField] = this.selectedSmkInfoData['qualifierAmount'];

          return;
        }

        // MYR, main currency or Additional Freight Currency.
        this.selectedSmkInfoData[qualifierField] = null;
        return;
      }

      if (typeField === 'invoiceTypeInsurance' && type !== '%') {
        this.selectedSmkInfoData[qualifierField] = null;
      }
    },

    validateSmkInvoiceDetails: function () {
      const smk = this.selectedSmkInfoData;

      const qualifier = (field) => {
        const value = smk[field];
        return String(value && typeof value === 'object' ? value.Qualifier : value || '').trim();
      };

      const number = (value) => Number(String(value || 0).replaceAll(',', ''));

      if (!qualifier('qualifierAmount')) {
        this.$showAlert('error', 'Invoice Details', 'Total Amount Qualifier is required.');
        return false;
      }

      const percentageFields = [
        ['Freight', 'invoiceTypeFreight', 'qualifierFreight'],
        ['Insurance', 'invoiceTypeInsurance', 'qualifierInsurance'],
        ['Uplift', 'invoiceTypeUplift', 'qualifierUplift'],
        ['Buying Comm', 'invoiceTypeBuyingComm', 'qualifierBuyingComm'],
        ['Port Charges', 'invoiceTypePortCharges', 'qualifierPortCharges'],
        ['Discount', 'invoiceTypeDiscount', 'qualifierDiscount'],
        ['Other', 'invoiceTypeOther', 'qualifierOther'],
      ];

      for (const [label, typeField, qualifierField] of percentageFields) {
        if (this.getSmkInvoiceCode(typeField) === '%' && !qualifier(qualifierField)) {
          this.$showAlert('error', 'Invoice Details', `${label} Qualifier is required when Type is %.`);
          return false;
        }
      }

      if (this.getSmkInvoiceCode('invoiceTypePortCharges') === '%' && qualifier('qualifierPortCharges') === '0.33') {
        this.$showAlert('error', 'Invoice Details', 'Select FOB, CNF, CFR, CNI or CIF for Port Charges percentage.');
        return false;
      }

      if (
        this.getSmkInvoiceCode('invoiceTypeFreight') === '%' &&
        qualifier('qualifierFreight') !== qualifier('qualifierAmount')
      ) {
        this.$showAlert(
          'error',
          'Invoice Details',
          'Freight Qualifier must match Total Amount Qualifier when Freight Type is %.',
        );
        return false;
      }

      const currencyCode = String(smk['currency1']?.['Currency Code'] || '').trim();

      const freightType = this.getSmkInvoiceCode('invoiceTypeFreight');

      const normalForeignFields = [
        'invoiceTypeInsurance',
        'invoiceTypeUplift',
        'invoiceTypeBuyingComm',
        'invoiceTypePortCharges',
        'invoiceTypeDiscount',
        'invoiceTypeOther',
        'invoiceTypeAmount',
      ];

      const foreignTypes = normalForeignFields
        .map((field) => this.getSmkInvoiceCode(field))
        .filter((type) => type && type !== 'MYR' && type !== '%');

      const freightUsesMainCurrency =
        freightType && freightType !== 'MYR' && freightType !== '%' && !this.hasSMKAdditionalFreightCurrency;

      if (freightUsesMainCurrency) {
        foreignTypes.push(freightType);
      }

      if (foreignTypes.length > 0) {
        if (!currencyCode) {
          this.$showAlert('error', 'Invoice Details', 'Select the main Currency Code and Exchange Rate.');
          return false;
        }

        if (foreignTypes.some((type) => type !== currencyCode)) {
          this.$showAlert(
            'error',
            'Invoice Details',
            `Foreign Type must match the selected Currency (${currencyCode}). Only Freight may use an additional currency.`,
          );
          return false;
        }

        if (number(smk['exchangeRate1']) <= 0) {
          this.$showAlert('error', 'Invoice Details', 'Main Exchange Rate must be greater than zero.');
          return false;
        }

        if (!(this.selectedHeaderInfoData['exchangeRateDate1'] instanceof Date)) {
          this.$showAlert('error', 'Invoice Details', 'Main Exchange Rate Date is required.');
          return false;
        }
      }

      if (this.hasSMKAdditionalFreightCurrency) {
        if (number(smk['amountFreight']) <= 0) {
          this.$showAlert('error', 'Invoice Details', 'Additional Freight Currency Amount must be greater than zero.');
          return false;
        }

        if (number(smk['freightForeignRate']) <= 0) {
          this.$showAlert(
            'error',
            'Invoice Details',
            'Additional Freight Currency Exchange Rate must be greater than zero.',
          );
          return false;
        }

        if (!(smk['freightForeignDate'] instanceof Date)) {
          this.$showAlert('error', 'Invoice Details', 'Additional Freight Currency Exchange Rate Date is required.');
          return false;
        }

        if (number(smk['freightAmountMYR']) <= 0) {
          this.$showAlert(
            'error',
            'Invoice Details',
            'Additional Freight Currency MYR Amount must be greater than zero.',
          );
          return false;
        }
      }

      return true;
    },

    smkDutyOptionChanged: function (row, selectedField, checked) {
      if (!row) return;
      if (selectedField === 'AseanCept' && checked && !this.isSMKPreferentialDeclaration) return;

      ['AseanCept', 'AseanPta', 'AseanAD'].forEach((field) => {
        row[field] = checked && field === selectedField;
      });

      this.calculateSMKItemDutyCess(row);
    },
    openSMKLongDescription: function (row) {
      if (!row) return;

      this.activeSMKLongDescriptionRow = row;
      this.smkLongDescriptionDraft = String(row.LongDescription || '');
      this.showSMKLongDescriptionPopup = true;
    },

    closeSMKLongDescription: function () {
      this.showSMKLongDescriptionPopup = false;
      this.activeSMKLongDescriptionRow = null;
      this.smkLongDescriptionDraft = '';
    },

    smkLongDescriptionPopupButtonClicked: function (buttonText) {
      switch (buttonText) {
        case 'Update':
          if (!this.activeSMKLongDescriptionRow) {
            this.closeSMKLongDescription();
            return;
          }

          this.activeSMKLongDescriptionRow['LongDescription'] = String(this.smkLongDescriptionDraft || '').trim();
          this.activeSMKLongDescriptionRow['LongDescriptionTouched'] = true;

          this.closeSMKLongDescription();
          break;

        case 'Delete':
          if (!this.activeSMKLongDescriptionRow) {
            this.closeSMKLongDescription();
            return;
          }

          // Mark locally as deleted.
          // SaveSMKDetails will delete it in the same item transaction.
          this.activeSMKLongDescriptionRow['LongDescription'] = '';
          this.activeSMKLongDescriptionRow['LongDescriptionTouched'] = true;

          this.closeSMKLongDescription();
          break;

        case 'Cancel':
        case 'Close':
        default:
          // Discard popup changes.
          this.closeSMKLongDescription();
          break;
      }
    },
    loadSMKItemDisplaySettings: async function () {
      const [duty, vehicle, warehouse] = await Promise.all([
        this.$apiCallV2('/FreightForwarding/GetSettingsSystem?settingsItem=6G_SMK_ShowDutyTable'),
        this.$apiCallV2('/FreightForwarding/GetSettingsSystem?settingsItem=6G_SMK_ShowVehicle'),
        this.$apiCallV2('/FreightForwarding/GetSettingsSystem?settingsItem=6G_SMK_ShowWarehouse'),
      ]);

      const isOn = (result) => {
        const value = String(result?.[0]?.SettingsValue || '')
          .trim()
          .toUpperCase();
        return ['1'].includes(value);
      };

      this.showSMKItemHoverTables = isOn(duty);
      this.showSMKVehicleColumns = isOn(vehicle);
      this.showSMKWarehouseColumns = isOn(warehouse);
    },
    formatSMKItemSummaryAmount: function (value) {
      return this.smkNum(value).toLocaleString('en-MY', {
        minimumFractionDigits: 4,
        maximumFractionDigits: 4,
      });
    },
    smkWarehouseSelected: function (warehouse) {
      if (!warehouse) {
        this.selectedSmkInfoData['k9WarehouseType'] = null;
        this.selectedSmkInfoData['k9Station'] = null;
        this.selectedSmkInfoData['k9License'] = '';
        this.selectedSmkInfoData['k9LicenseDate'] = null;
        return;
      }

      this.selectedSmkInfoData['k9WarehouseType'] = this.smkInfoData['warehouseTypeList'].getSelected(
        warehouse['Warehouse Type'],
        'Warehouse Type',
      );

      this.selectedSmkInfoData['k9Station'] = this.shippingInfoData['station'].getSelected(
        warehouse['Station Code'],
        'Station Code',
      );

      this.selectedSmkInfoData['k9License'] = warehouse['License No'] || '';

      this.selectedSmkInfoData['k9LicenseDate'] =
        warehouse['License Date'] ? new Date(warehouse['License Date']) : null;
    },
    canEnterSMKAlcohol: function (row) {
      const jobType = String(this.pageType[0] || '').toUpperCase();
      const formType = this.getHeaderSMKFormType();
      const qualifier = String(row.AlcoholQualifier || '').trim();

      return qualifier !== '' && (jobType === 'I' || (jobType === 'E' && formType === 'K8'));
    },
    smkFreightTypeSelected: async function (selected) {
      this.selectedSmkInfoData['invoiceTypeFreight'] = selected || null;

      this.smkFreightExchangeRates = null;

      const freightType = String(selected?.['Currency Code'] || '')
        .trim()
        .toUpperCase();

      const mainCurrency = String(this.selectedSmkInfoData['currency1']?.['Currency Code'] || '')
        .trim()
        .toUpperCase();

      const isAdditional = freightType && freightType !== 'MYR' && freightType !== '%' && freightType !== mainCurrency;

      if (!isAdditional) {
        this.selectedSmkInfoData['freightForeignRate'] = '';
        this.selectedSmkInfoData['freightForeignDate'] = null;
        this.selectedSmkInfoData['freightAmountMYR'] = '';
        return;
      }

      this.selectedSmkInfoData['qualifierFreight'] = null;

      const result = await this.$apiCallV2('/FreightForwarding/GetSMKExchangeRates', {
        excode: freightType,
        jobtype: this.pageType[0],
      });

      if (!result || String(result.status) !== '0') {
        await this.$showAlert('error', 'Exchange Rate', result?.message || 'Exchange Rate not available.');
        return;
      }

      this.smkFreightExchangeRates = result.rates;
    },
    nextSMKItemRowKey() {
      this.smkItemRowKeySeed += 1;
      return `draft-${this.smkItemRowKeySeed}`;
    },
    showSMKItemDutyQty: function (row) {
      const tc = row.HSCode || {};
      const uom = String(tc.UOM || '')
        .trim()
        .toUpperCase();

      const qualifiers = [
        tc.tcImpDutyQualifier,
        tc.tcImpCA1Qualifier,
        tc.tcImpCA2Qualifier,
        tc.tcImpCO1Qualifier,
        tc.tcImpCO2Qualifier,
        tc.tcExpDutyQualifier,
        tc.tcExpDutyQualifier2,
        tc.tcTaxDutyQualifier,
        tc.ExciseQualifier,
        tc.ExciseQualifier1,
        tc.AntiDumpingQualifier,
        tc.AntiDumpingQualifier1,
        tc.tcAseanCEPTQualifier,
        tc.tcAseanPTAQualifier,
      ];

      return qualifiers.some((value) => {
        const qualifier = String(value || '')
          .trim()
          .toUpperCase();
        return qualifier !== '' && qualifier !== uom;
      });
    },

    showSMKItemAlcohol: function (row) {
      const jobType = String(this.pageType[0] || '').toUpperCase();
      const formType = this.getHeaderSMKFormType();
      const proofOfLitre = String(row.HSCode?.AlcoholQualifier || '').trim();

      return proofOfLitre !== '' && (jobType === 'I' || (jobType === 'E' && formType === 'K8'));
    },
    newSMKDocDraft: function () {
      return {
        master: null,
        part1: '',
        part2: '',
        part3: '',
        part4: '',
        issueDate: null,
        expiryDate: null,
        invoiceDate: null,
        _smkDocUid: null,
        _smkSaved: false,
        _smkOriginalCategory: '',
        _smkOriginalRef: '',
      };
    },

    smkDocDate: function (value) {
      if (!value) return null;
      const date = value instanceof Date ? value : new Date(value);
      return Number.isNaN(date.getTime()) ? null : date;
    },

    smkDocDateText: function (value) {
      return value ? new Date(value).formatString('yyyy-MM-dd') : '';
    },

    smkDocMasterSelected: function (master) {
      if (!this.smkDocDraft || this.smkDocMode === 'E') return;

      this.smkDocDraft.master = master || null;
      this.smkDocDraft.part1 = '';
      this.smkDocDraft.part2 = '';
      this.smkDocDraft.part3 = '';
      this.smkDocDraft.part4 = '';
      this.smkDocDraft.issueDate = null;
      this.smkDocDraft.expiryDate = null;
      this.smkDocDraft.invoiceDate = null;
    },

    startSMKDocAdd: function () {
      this.selectedSmkInfoData.selectedDoc = [];
      this.smkDocDraft = this.newSMKDocDraft();
      this.smkDocMode = 'N';
    },

    startSMKDocEdit: function () {
      const row = this.selectedSMKDocRow;
      if (!row) return;

      this.resetSMKDocErrors();

      const clean = (value) => String(value || '').trim();
      const master = this.availableSMKDocMasterList.find(
        (doc) => clean(doc['Doc Code']) === clean(row.Doc) && clean(doc['SMK Doc Code']) === clean(row.SmkDoc),
      );
      if (!master) {
        this.smkDocErrors.table = `Document master not found for ${row.Doc}.`;
        return;
      }

      const draft = this.newSMKDocDraft();
      const ref = String(row['SMK Ref #'] || '');
      let offset = 0;

      draft.master = master;
      for (let n = 1; n <= 3; n++) {
        const size = Number(master[`Size ${n}`]) || 0;
        draft[`part${n}`] = ref.slice(offset, offset + size).trim();
        offset += size;
      }
      draft.part4 = ref.slice(offset).trim();
      draft.issueDate = this.smkDocDate(row.IssueDate);
      draft.expiryDate = this.smkDocDate(row.ExpiryDate);
      draft.invoiceDate = this.smkDocDate(row.InvoiceDate);
      draft._smkDocUid = row._smkDocUid;
      draft._smkSaved = row._smkSaved;
      draft._smkOriginalCategory = row._smkOriginalCategory;
      draft._smkOriginalRef = row._smkOriginalRef;

      this.smkDocDraft = draft;
      this.smkDocMode = 'E';
    },

    updateSMKDoc: function () {
      this.resetSMKDocErrors();

      const draft = this.smkDocDraft;
      const master = draft && draft.master;

      if (!master) {
        this.smkDocErrors.master = 'Select a Document Code.';
        return;
      }

      if (master['Detail 1'] && !String(draft.part1 || '').trim()) {
        this.smkDocErrors.part1 = 'Reference # is required.';
        return;
      }

      if (master['Doc Code'] === 'INV1' && !draft.invoiceDate) {
        this.smkDocErrors.invoiceDate = 'Invoice Date is required.';
        return;
      }

      // Legacy pads segments 1–3 to their master sizes before joining them.
      const ref =
        [1, 2, 3]
          .map((n) => {
            const size = Number(master[`Size ${n}`]) || 0;
            return size ? String(draft[`part${n}`] || '').padEnd(size, ' ') : '';
          })
          .join('') + String(draft.part4 || '');

      const oldIndex =
        this.smkDocMode === 'E' ? this.smkDocList.findIndex((row) => row._smkDocUid === draft._smkDocUid) : -1;

      if (this.smkDocMode === 'E' && oldIndex < 0) {
        this.smkDocErrors.form = 'The selected document row was not found.';
        return;
      }

      const oldRow = oldIndex >= 0 ? this.smkDocList[oldIndex] : {};
      const row = {
        ...oldRow,
        Doc: master['Doc Code'],
        SmkDoc: master['SMK Doc Code'],
        'SMK Ref #': ref,
        IssueDate: this.smkDocDateText(draft.issueDate),
        ExpiryDate: this.smkDocDateText(draft.expiryDate),
        InvoiceDate: this.smkDocDateText(draft.invoiceDate),
        StationCode: oldRow.StationCode || '',
        OGACode: master['Doc Code'] === '811' ? String(draft.part1 || '').trim() : '',
        OGABranchCode: master['Doc Code'] === '811' ? String(draft.part2 || '').trim() : '',
        _smkDocUid: oldIndex >= 0 ? draft._smkDocUid : ++this.smkDocUid,
        _smkSaved: draft._smkSaved,
        _smkOriginalCategory: draft._smkOriginalCategory,
        _smkOriginalRef: draft._smkOriginalRef,
      };

      const nextDocs = [...this.smkDocList];

      if (oldIndex >= 0) {
        nextDocs.splice(oldIndex, 1, row);
      } else {
        nextDocs.push(row);
      }

      this.smkDocList = nextDocs;
      this.smkDocTableVersion += 1;
      this.selectedSmkInfoData.selectedDoc = [];

      this.$nextTick(() => {
        this.cancelSMKDoc();
      });
    },

    deleteSMKDoc: async function () {
      const row = this.selectedSMKDocRow;
      if (!row) return;

      const confirmDelete = await this.$showAlert(
        'warning',
        'Delete SMK Document',
        `Delete ${row.Doc} - ${String(row['SMK Ref #'] || '').trim()}?`,
        [
          { text: 'Delete', color: 'red', textColor: 'white' },
          { text: 'Cancel', color: 'lightgray', textColor: 'black' },
        ],
      );

      if (confirmDelete !== 'Delete') return;

      const index = this.smkDocList.findIndex((doc) => doc._smkDocUid === row._smkDocUid);
      if (index < 0) return;

      if (row._smkSaved) {
        this.smkDocDeletedList.push({
          doccategory: row._smkOriginalCategory,
          docrefno: row._smkOriginalRef,
        });
      }

      const nextDocs = [...this.smkDocList];
      nextDocs.splice(index, 1);
      this.smkDocList = nextDocs;
      this.smkDocTableVersion += 1;

      this.selectedSmkInfoData.selectedDoc = [];
      this.cancelSMKDoc();
    },

    cancelSMKDoc: function () {
      this.resetSMKDocErrors();
      this.smkDocMode = '';
      this.smkDocDraft = null;
    },

    resetSMKDocErrors() {
      this.smkDocErrors = {
        master: '',
        part1: '',
        invoiceDate: '',
        table: '',
        form: '',
      };
    },
    smkDocRowSelected(clickedRow, selected) {
      if (!selected) {
        this.selectedSmkInfoData.selectedDoc = [];
        return;
      }

      const row = Array.isArray(clickedRow) ? clickedRow[0] : clickedRow;
      if (row && typeof row === 'object') {
        this.selectedSmkInfoData.selectedDoc = [row];
      }
    },
    smkAmountQualifierSelected: function (selected) {
      this.selectedSmkInfoData['qualifierAmount'] = selected || null;
      this.selectedSmkInfoData['qualifierFreight'] =
        this.getSmkInvoiceCode('invoiceTypeFreight') === '%' ? selected || null : null;
    },
    newSMKTransportDraft: function () {
      return {
        seqNo: 0,
        transportType: null,
        transportId: '',
        station: null,
        license: '',
        year: '',
        _smkTransportUid: null,
        _smkSaved: false,
      };
    },

    startSMKTransportEdit: function () {
      const row = this.selectedSMKTransportRow;
      if (!row) return;

      this.resetSMKTransportErrors();

      const transportTypeCode = String(row['Transport Type'] || '').trim();

      const stationCode = String(row.Station || '').trim();

      const draft = this.newSMKTransportDraft();

      draft.seqNo = Number(row.SeqNo || 0);

      draft.transportType = this.smkInfoData['transportTypeList'].getSelected(transportTypeCode, 'Transport Type') || {
        'Transport Type': transportTypeCode,
        'Code - Desc': transportTypeCode,
      };

      draft.transportId = String(row['Transport ID'] || '').trim();

      draft.station = this.shippingInfoData['station'].getSelected(stationCode, 'Station Code') || {
        'Station Code': stationCode,
        'Code - Name': stationCode,
      };

      draft.license = String(row.License || '').trim();

      draft.year = String(row.Year || '').trim();

      draft._smkTransportUid = row._smkTransportUid;
      draft._smkSaved = Boolean(row._smkSaved);

      this.smkTransportDraft = draft;
      this.smkTransportMode = 'E';
    },

    updateSMKTransport: function () {
      this.resetSMKTransportErrors();
      const draft = this.smkTransportDraft;
      if (!draft) return;

      const transportType = String(draft.transportType?.['Transport Type'] || '').trim();

      const station = String(draft.station?.['Station Code'] || '').trim();

      const transportId = String(draft.transportId || '').trim();

      const license = String(draft.license || '').trim();

      const year = String(draft.year || '').trim();

      if (!transportType) {
        this.smkTransportErrors.transportType = 'Select a Transport Type.';
        return;
      }

      if (year && !/^\d{4}$/.test(year)) {
        this.smkTransportErrors.year = 'Year must contain 4 digits.';
        return;
      }

      const oldIndex =
        this.smkTransportMode === 'E' ?
          this.smkTransportList.findIndex((row) => row._smkTransportUid === draft._smkTransportUid)
        : -1;

      if (this.smkTransportMode === 'E' && oldIndex < 0) {
        this.smkTransportErrors.form = 'The selected Transport Detail was not found.';
        return;
      }
      const transportDescription = String(draft.transportType?.['Transport Description'] || '').trim();

      const oldRow = oldIndex >= 0 ? this.smkTransportList[oldIndex] : {};

      const row = {
        ...oldRow,
        SeqNo: oldIndex >= 0 ? Number(oldRow.SeqNo || 0) : 0,
        'Seq #': oldIndex >= 0 ? oldRow['Seq #'] : this.smkTransportList.length + 1,
        'Transport Type': transportType,
        'Transport Description': transportDescription,
        'Transport ID': transportId,
        Station: station,
        License: license,
        Year: year,
        _smkTransportUid: oldIndex >= 0 ? draft._smkTransportUid : ++this.smkTransportUid,
        _smkSaved: oldIndex >= 0 ? draft._smkSaved : false,
      };

      const nextTransportList = [...this.smkTransportList];

      if (oldIndex >= 0) {
        nextTransportList.splice(oldIndex, 1, row);
      } else {
        nextTransportList.push(row);
      }

      this.smkTransportList = nextTransportList.map((item, index) => ({
        ...item,
        'Seq #': index + 1,
      }));

      this.smkTransportTableVersion += 1;
      this.selectedSMKTransportRows = [];

      this.$nextTick(() => {
        this.cancelSMKTransport();
      });
    },

    deleteSMKTransport: async function () {
      const row = this.selectedSMKTransportRow;
      if (!row) return;

      const confirmDelete = await this.$showAlert(
        'warning',
        'Delete Transport Detail',
        `Delete Transport ${row['Transport Type']} - ${row['Transport ID']}?`,
        [
          {
            text: 'Delete',
            color: 'red',
            textColor: 'white',
          },
          {
            text: 'Cancel',
            color: 'lightgray',
            textColor: 'black',
          },
        ],
      );

      if (confirmDelete !== 'Delete') return;

      const index = this.smkTransportList.findIndex((item) => item._smkTransportUid === row._smkTransportUid);

      if (index < 0) return;

      const nextTransportList = [...this.smkTransportList];

      nextTransportList.splice(index, 1);

      this.smkTransportList = nextTransportList.map((item, rowIndex) => ({
        ...item,
        'Seq #': rowIndex + 1,
      }));

      this.smkTransportTableVersion += 1;
      this.selectedSMKTransportRows = [];
      this.cancelSMKTransport();
    },

    cancelSMKTransport: function () {
      this.resetSMKTransportErrors();
      this.smkTransportMode = '';
      this.smkTransportDraft = null;
    },
    resetSMKTransportErrors: function () {
      this.smkTransportErrors = {
        transportType: '',
        year: '',
        form: '',
      };
    },
    startSMKTransportAdd: function () {
      this.resetSMKTransportErrors();
      this.selectedSMKTransportRows = [];
      this.smkTransportDraft = this.newSMKTransportDraft();
      this.smkTransportMode = 'N';
    },

    //#region Query notifications
    vesselScheduleUpdated: async function (data) {
      if (data['configcode'].includes(this.loginDetails['ConfigCode']) && data['userid'] == this.loginDetails['LoginUserId']) {
        this.shipCallNoLoading = true;
        await this.refreshVesselSchedule();
      }
    },
    refreshVesselSchedule: async function () {
      this.shippingInfoData['shipCallNoList'] = await this.$apiCallV2('/Master/GetListMaster?save=true', { 
        masterfile: 'shipcallno' 
      });
      this.shipCallNoLoading = false;
    },
    //#endregion
  },
  async mounted() {
    this.userParam = this.$route.params['user'];
    this.$fullscreenLoading('Loading');
    this.userParam = this.$route.params['user'];

    // Get the page type before API calls to ensure the correct data is loaded
    const pageRoute = this.$route.path.split('/');
    this.pageType = pageRoute[pageRoute.length - 1].split(' ')[0];

    this.$fullscreenLoading();

    // init listener for vessel schedule updates
    this.hub = await this.$signal.get('notifications');
    this.hub.on('VesselScheduleUpdate', this.vesselScheduleUpdated);

    let mountedPromises = [];
    let promisesFulfilled = 0;

    //this.searchFilterItems = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'jobquery', module: 'FMS' });
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'jobquery', module: 'FMS' }).then((result) => {
        this.searchFilterItems = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'DUPLICATEFROMCOMPANYLIST' }).then((result) => {
        this.dpoCompanyList = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );

    const query = this.$route.query;
    let queryEdit = false;
    if (query['date'] && query['job']) {
      this.prePopulate = true;
      this.preJob = query['job'];
      this.preDate = query['date'];
      queryEdit = query['edit'] ? query['edit'] == 'Y' : false;
    }

    if (this.prePopulate) {
      this.$fullscreenLoading('Please wait');
      this.refreshStart = new Date(this.preDate);
      this.refreshEnd = new Date(this.preDate);
      this.refreshClicked();
    } else {
      this.refreshStart = new Date(new Date().setDate(new Date().getDate() - 3));
      this.refreshEnd = new Date();
    }

    if (!this.selectedSearchBy) {
      this.selectedSearchBy = this.searchFilterItems[0];
    }

    if (!this.selectedCriteria) {
      this.selectedCriteria = this.searchCriteriaItems[2];
    }
    this.loginDetails = await this.$apiCallV2('/Login/GetDetails');
    this.userid = this.loginDetails.LoginUserId;
    const userRoles = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'user' });
    this.userRole = userRoles.find((a) => a['UserID'].trim() == this.userid);

    this.refreshClicked(true);

    const getHeaderInfoTabDetailsPromises = this.getHeaderInfoTabDetails().map((promise) => {
      return promise.then(() => {
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      });
    });
    mountedPromises = mountedPromises.concat(getHeaderInfoTabDetailsPromises);

    const getGeneralInfoTabDetailsPromises = this.getGeneralInfoTabDetails().map((promise) => {
      return promise.then(() => {
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      });
    });
    mountedPromises = mountedPromises.concat(getGeneralInfoTabDetailsPromises);

    const getShippingInfoTabDetailsPromises = this.getShippingInfoTabDetails().map((promise) => {
      return promise.then(() => {
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      });
    });
    mountedPromises = mountedPromises.concat(getShippingInfoTabDetailsPromises);

    const getShippingInfoTabDetailsByTransModePromises = this.getShippingInfoTabDetailsByTransMode().map((promise) => {
      return promise.then(() => {
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      });
    });
    mountedPromises = mountedPromises.concat(getShippingInfoTabDetailsByTransModePromises);

    const getCargoInfoTabDetailsPromises = this.getCargoInfoTabDetails().map((promise) => {
      return promise.then(() => {
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      });
    });
    mountedPromises = mountedPromises.concat(getCargoInfoTabDetailsPromises);

    const getLargeDataPromises = this.getLargeData().map((promise) => {
      return promise.then(() => {
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      });
    });
    mountedPromises = mountedPromises.concat(getLargeDataPromises);

    const getSMKItemPromises = this.getSMKItemDetails().map((promise) => {
      return promise.then(() => {
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      });
    });
    mountedPromises = mountedPromises.concat(getSMKItemPromises);

    await Promise.allSettled(mountedPromises);
    await this.pageChanges();
    this.openFromParams();
    if (this.prePopulate) {
      this.$fullscreenLoading();
      this.menuClicked({ title: `${queryEdit ? 'Edit' : 'View'} Import Job`, enabled: true });
    }

    // For delete popup
    this.deleteLayout = document.createElement('div');
    this.deleteLayout.style.fontSize = '0.9em';

    this.deleteMessage = document.createElement('span');

    this.deleteAllBtn = document.createElement('button');
    this.deleteAllBtn.innerHTML = '';
    this.deleteAllBtn.className = 'swal2-confirm swal2-styled';
    this.deleteAllBtn.style.backgroundColor = 'red';
    this.deleteAllBtn.style.marginTop = '15px';
    this.deleteAllBtn.onclick = this.deleteButtonClicked;

    this.deleteSelectedBtn = document.createElement('button');
    this.deleteSelectedBtn.innerHTML = '';
    this.deleteSelectedBtn.className = 'swal2-confirm swal2-styled';
    this.deleteSelectedBtn.style.backgroundColor = '#ffa73a';
    this.deleteSelectedBtn.onclick = this.deleteButtonClicked;

    const cancel = document.createElement('button');
    cancel.innerHTML = 'Cancel';
    cancel.className = 'swal2-cancel swal2-styled';
    cancel.onclick = function () {
      // eslint-disable-next-line no-undef -- Sweet Alert should should be replaced with <PopupV2> in the future
      Swal.close();
    };

    this.deleteLayout.appendChild(this.deleteMessage);
    this.deleteLayout.appendChild(this.deleteSelectedBtn);
    this.deleteLayout.appendChild(this.deleteAllBtn);
    this.deleteLayout.appendChild(cancel);

    await this.loadSMKItemDisplaySettings();

    //#region for SMK ITEM
    this.displayColumns = this.activeColumns.map((x) => ({ ...x }));
    this.initColumnFilters();
    //#endregion
  },
  beforeDestroy() {
    this.hub.off('VesselScheduleUpdate');
  },
  watch: {
    async $route() {
      this.reportPopup = false; // When switching from export to import job page or vice versa, the popup still there
      await this.pageChanges();
    },
    
    showPopup: function (val) {
      if (!val) {
        this.clearPopupData();
      }
    },
    selectedUnconfirmReason: function () {
      this.popupValidation();
    },
    unconfirmRemarks: function () {
      this.popupValidation();
    },
    currentTabIndex: function (val) {
      if (val == 9 && this.tabsItems[9] && this.tabsItems[9]['disabled']) {
        this.$nextTick(() => {
          this.currentTabIndex = 1;
        });
        return;
      }
      if (val == 4) {
        // Repopulating the tableboxes for cargo info tab
        this.selectedCargoInfoData['selectedSubPkgs'] = [];
        this.selectedCargoInfoData['selectedContDetails'] = [];

        if (this.selectedCargoInfoData['subPkgList'].length > 0) {
          const temp = this.selectedCargoInfoData['subPkgList'];
          this.selectedCargoInfoData['subPkgList'] = [];
          this.$nextTick(() => (this.selectedCargoInfoData['subPkgList'] = temp));
        }
        if (this.selectedCargoInfoData['contDetailsList'].length > 0) {
          const temp = this.selectedCargoInfoData['contDetailsList'];
          this.selectedCargoInfoData['contDetailsList'] = [];
          this.$nextTick(() => (this.selectedCargoInfoData['contDetailsList'] = temp));
        }
      }
    },
    showEJobPopup: function (val) {
      if (!val) {
        this.ejobFilterOpen = false;
      } else {
        this.refreshEJobClicked();
      }
    },
    'selectedShippingInfoData.isFumigation': function (newValue) {
      if (newValue !== '1' && newValue !== true) {
        this.selectedShippingInfoData['selectedFumigator'] = null;
        this.selectedShippingInfoData['selectedLocation'] = null;
        this.selectedShippingInfoData['fumigateTime'] = null;
        this.selectedShippingInfoData['ventilationTime'] = null;
        this.selectedShippingInfoData['phytoMarking'] = '';
      }
    },
    isTranshipmentRequired: function (newValue) {
      if (!newValue) {
        // Perform the actions when isTranshipmentRequired is false
        this.selectedShippingInfoData['selectedMVesselID'] = null;
        this.selectedShippingInfoData['mVoyNo'] = '';
        this.selectedShippingInfoData['selectedPortDischarge2'] = null;
        this.selectedShippingInfoData['ETATime'] = null;
      }
    },
    selectedJob(val) {
      const hasSelection = val && Object.keys(val).length > 0;

      if (hasSelection && this.enableSMKmodule) {
        this.setSMKMenuEnabled(false);
      } else {
        this.setSMKMenuEnabled(true);
      }
    },
    selectedsmkPartJob: {
      deep: true,
      handler(val) {
        const hasSelection = Array.isArray(val) ? val.length > 0 : val && Object.keys(val).length > 0;

        if (hasSelection) {
          this.actionsBoxContainer = true;
          this.smkBoxContainer = false;
          this.othersBoxContainer = true;
        } else {
          this.actionsBoxContainer = false;
          this.smkBoxContainer = false;
          this.othersBoxContainer = false;
        }
      },
    },
    //#region for SMK Item
    batchField(newField) {
      if (!newField) {
        this.batchValue = null;
        this.batchQueryObject = null;
        return;
      }

      const type = this.fieldConfig[newField].type;
      this.batchQueryObject = null;

      if (type === 'text' || type === 'number') {
        this.batchValue = '';
      } else if (type === 'dropdown') {
        this.batchValue = null;
      } else if (type === 'checkbox') {
        this.batchValue = false;
      }
    },

    selectedTemplateType: {
      deep: true,
      handler() {
        this.displayColumns = this.activeColumns.map((x) => ({ ...x }));
        this.initColumnFilters();
      },
    },

    columns: {
      deep: true,
      handler() {
        this.displayColumns = this.activeColumns.map((x) => ({ ...x }));
        this.initColumnFilters();
      },
    },
    //#endregion
    'selectedHeaderInfoData.selectedSmkFormType': function (newValue) {
      const formType = this.getHeaderSMKFormType();
      const hasSMKAccess = this.hasSMKFormTypeAccess(formType);

      this.applySMKViewTabAccess(hasSMKAccess);
      this.displayColumns = this.activeColumns.map((col) => ({ ...col }));
      this.initColumnFilters();

      this.selectedSmkInfoData['selectedSmkFormType'] = newValue || null;

      if (!newValue) {
        this.selectedSmkInfoData['selectedDeclarationType'] = null;
      }
    },

    'selectedSmkInfoData.selectedSmkFormType': function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.selectedSmkInfoData['selectedDeclarationType'] = null;
      }
    },

    'selectedSmkInfoData.amountFreight': function () {
      this.updateSMKFreightMYRAmount();
    },

    'selectedSmkInfoData.freightForeignRate': function () {
      this.updateSMKFreightMYRAmount();
    },
    showSMKVehicleColumns: function () {
      this.displayColumns = this.activeColumns.map((x) => ({ ...x }));
      this.initColumnFilters();
    },
    showSMKWarehouseColumns: function () {
      this.displayColumns = this.activeColumns.map((x) => ({ ...x }));
      this.initColumnFilters();
    },
    'selectedSmkInfoData.invoiceTypeFreight': function () {
      this.smkInvoiceTypeChanged('invoiceTypeFreight', 'amountFreight', 'qualifierFreight');
    },

    'selectedSmkInfoData.invoiceTypeInsurance': function () {
      this.smkInvoiceTypeChanged('invoiceTypeInsurance', 'amountInsurance', 'qualifierInsurance');
    },

    'selectedSmkInfoData.invoiceTypeUplift': function () {
      this.smkInvoiceTypeChanged('invoiceTypeUplift', 'amountUplift', 'qualifierUplift');
    },

    'selectedSmkInfoData.invoiceTypeBuyingComm': function () {
      this.smkInvoiceTypeChanged('invoiceTypeBuyingComm', 'amountBuyingComm', 'qualifierBuyingComm');
    },

    'selectedSmkInfoData.invoiceTypePortCharges': function () {
      this.smkInvoiceTypeChanged('invoiceTypePortCharges', 'amountPortCharges', 'qualifierPortCharges');
    },

    'selectedSmkInfoData.invoiceTypeDiscount': function () {
      this.smkInvoiceTypeChanged('invoiceTypeDiscount', 'amountDiscount', 'qualifierDiscount');
    },

    'selectedSmkInfoData.invoiceTypeOther': function () {
      this.smkInvoiceTypeChanged('invoiceTypeOther', 'amountOther', 'qualifierOther');
    },
    'selectedSmkInfoData.qualifierAmount': function (newValue) {
      if (this.getSmkInvoiceCode('invoiceTypeFreight') === '%') {
        this.selectedSmkInfoData['qualifierFreight'] = newValue || null;
      } else {
        this.selectedSmkInfoData['qualifierFreight'] = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.import-job-main {
  width: 100%;
  height: 100%;
  padding: 10px 10px 10px 45px;
  font-size: 12px;
  display: flex;
  min-width: 0;
}

.page-layout {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}

.top-section-job,
.bottom-section-job {
  display: flex;
  width: 100%;
  min-height: 0;
  overflow: hidden;
  align-items: stretch;
}

.menu-section {
  height: 100%;
  overflow: auto;
  min-width: fit-content;
  flex-shrink: 0;
}

.section-content {
  display: flex;
  width: 100%;
  height: 100%;
  margin-left: 5px;
  min-width: 0;
  overflow: hidden;
}

.right-tabulator {
  flex: 1;
  min-width: 0;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.tabulator-area {
  flex: 1;
  min-height: 0;
  height: auto !important;
  background-color: white;
  margin-top: 5px;
  border-radius: 5px;
  padding: 5px;
  overflow: hidden;
}

.hresizer {
  height: 8px;
  min-height: 8px;
  cursor: row-resize;
  background-color: #263746;
  margin: 5px 0;
  flex-shrink: 0;
  position: relative !important;
}

.job-listing-section {
  display: flex;
  width: 100%;
  height: 100%;
  margin-left: 5px;
  min-width: 0;
  overflow: hidden;
}

.smk-content {
  flex: 1;
  min-width: 0;
  min-height: 0;
  background-color: white;
  border-radius: 5px;
  padding: 5px;
  overflow: hidden;
}

.filter-area {
  background-color: white;
  padding: 5px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  > * {
    margin-left: 5px;
  }
}

.delete-popup {
  text-align: left;
  padding: 20px;
}

.popup-milestones {
  border: 1px solid rgba(0, 0, 0, 0.3);
  width: 100%;
  padding: 5px;
  margin-bottom: 8px;
  position: relative;
  font-size: 10px;

  > .milestones-row {
    display: flex;
    align-items: center;

    > * {
      margin-right: 5px;
    }

    > .milestones-block {
      position: relative;
      margin-bottom: 2px;

      > .milestones-item {
        border: 1px solid rgba(128, 128, 128, 0.5);
        max-width: 100px;
        min-width: 100px;
        height: 50px;
        -webkit-line-clamp: 2;
        display: -webkit-box;
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-box-orient: vertical;
        cursor: default;
        padding: 3px 20px 3px 3px;
      }

      > .milestone-tooltip {
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
      }
    }

    > .legend-items {
      display: flex;
      align-items: center;

      > .legend-box {
        height: 10px;
        width: 10px;
        border: 1px solid rgba(128, 128, 128, 0.5);
        margin-right: 3px;
      }
    }
  }

  > .collapse-milestone {
    position: absolute;
    bottom: 2px;
    right: 2px;
    transition: 0.3s;
    cursor: pointer;
  }
}

.popup-details {
  display: flex;
  height: 100%;

  > .summary {
    width: 115px;
    min-width: 115px;
    margin-right: 5px;
  }
}

.tas-kpi-slot {
  height: 100%;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
}

.slot-body-block {
  display: flex;
  position: relative;

  > .slot-content-column {
    width: calc(100% / 3);
    margin-right: 5px;

    > .datetime-row {
      display: flex;
      flex-direction: row;
      gap: 5px;
      margin-bottom: 5px;

      > * {
        flex: 1;
        min-width: 0;
      }

      > .free-input-group {
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 4px;

        > .unit-toggle {
          display: flex;
          flex-shrink: 0;
          border: 1px solid #b3c4ff;
          border-radius: 4px;
          overflow: hidden;

          &.disabled {
            opacity: 0.5;
            pointer-events: none;
          }

          .toggle-btn {
            padding: 0 8px;
            height: 28px;
            font-size: 11px;
            border: none;
            background-color: #f0f0f0;
            color: #555;
            cursor: pointer;
            transition:
              background-color 0.15s,
              color 0.15s;

            &:first-child {
              border-right: 1px solid rgba(0, 0, 0, 0.15);
            }

            &.active {
              background-color: #6e6eff;
              color: #fff;
              font-weight: 600;
            }

            &:hover:not(:disabled):not(.active) {
              background-color: #b3c4ff;
              color: #fff;
            }
          }
        }
      }
    }

    > .box-container {
      border: 1px solid rgba(0, 0, 0, 0.3);
      border-radius: 5px;
      padding: 10px 5px 5px 5px;
      margin-right: 5px;
      position: relative;
      margin-top: 10px;
    }

    > .address {
      height: 100%;
      border-radius: 3px;
      border: 1px solid rgba(128, 128, 128, 0.5);
      min-height: 100px;
      position: relative;
      display: flex;
      flex-direction: column;
      // padding: 5px;
      overflow: auto;
      margin-bottom: 5px;

      > .edit-area {
        position: absolute;
        top: 3px;
        right: 3px;
        display: flex;
        align-items: center;

        > button {
          padding: 1px 10px;
        }

        > img {
          transition: 0.3s;
          cursor: pointer;
        }

        > .img-hide {
          transform: scaleY(1);
        }

        > .img-show {
          transform: scaleY(-1);
        }
      }

      > .address-block {
        overflow: auto;
        padding: 5px;
      }
    }

    > .address-collapse {
      max-height: 28px;
      min-height: 28px;
      justify-content: center;
      padding-left: 5px;
    }
  }

  > .column-flex {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  > .edit-address-popup {
    position: absolute;
    left: 0;
    top: 0;
    background-color: rgba(128, 128, 128, 0.5);
    height: 100%;
    width: 100%;
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;

    > .edit-content {
      width: 90%;
      max-width: 500px;
      background-color: white;
      padding: 10px;

      > .title {
        font-weight: bold;
        font-size: 13px;
        margin-bottom: 5px;
      }

      > .button-section {
        display: flex;
        justify-content: flex-end;

        > button {
          margin-left: 5px;
        }
      }
    }
  }
}

.shipping-textarea {
  display: flex;
  height: calc(100% - 305px);
  min-height: 100px;

  > * {
    margin: 3px;
  }
}

.status-container {
  border: 1px solid rgb(200, 200, 200);
  padding: 3px;
  margin-right: 5px;
  margin-left: 3px;
}

.outstanding-prog {
  display: flex;
  border: 1px solid rgb(200, 200, 200);
  position: relative;
  width: calc(100% - 2px);
  margin-left: 3px;
  padding: 3px;

  > .progress-ind {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 50%;
    background-color: rgba(51, 231, 255, 0.5);
  }
}

.table-container {
  > .tabulator-title {
    display: flex;
    align-items: center;
    margin-bottom: 5px;

    > button {
      margin-left: 3px;
    }
  }
}

.tab-block {
  display: flex;
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.5);
  margin-top: 10px;
  margin-bottom: 10px;
  position: relative;
  padding-top: 10px;
  padding-left: 5px;

  > .tab-title {
    width: fit-content;
    background-color: white;
    position: absolute;
    top: -10px;
    left: 10px;
    padding: 0 10px;
  }

  > .details-column {
    width: calc(100% / 3);
    margin-right: 5px;
  }
}

.top-button-section {
  display: flex;
  width: 100%;
  background: white;

  > button {
    margin-right: 5px;
  }
}

.save-content {
  max-height: 150px;
  overflow: auto;
  box-shadow: inset 0 0 5px 0 gray;
  padding: 10px;
  text-align: left;
  margin: 5px 0;
}

.popup-error {
  color: red;
  text-align: center;
}

.report-popup-selection {
  position: fixed;
  width: 100%;
  height: 100%;
  padding-top: 50px;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 99999;
  transition: 0.3s;

  > .report-popup-container {
    background-color: white;
    width: 100%;
    max-width: 300px;
    max-height: 180px;
    padding: 0 10px;
    overflow: auto;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    > .report-link {
      color: black;
      border: 1px solid black;
      width: 100%;
      margin-top: 5px;
      padding: 5px;
      text-align: left;
      background-color: transparent;
      border-radius: 0;

      &:disabled {
        color: rgba(0, 0, 0, 0.3);
        border: 1px solid rgba(0, 0, 0, 0.3);
      }

      &:hover:enabled {
        background-color: rgba(0, 0, 0, 0.2);
      }

      // &:hover:disabled::after {
      //   content: ' - No container available';
      //   color: red;
      // }
    }

    > .report-disabled-container:hover::after {
      content: ' - No container available';
      color: red;
    }

    > .report-disabled-cancelled:hover::after {
      content: ' - Job is cancelled';
      color: red;
    }

    > .report-disabled-cargo-type:hover::after {
      content: ' - Cargo Type invalid';
      color: red;
    }
  }

  > .report-popup-title {
    width: 100%;
    max-width: 300px;
    background-color: white;
    text-align: center;
    font-weight: bold;
    padding: 5px;
  }

  > .report-popup-cancel {
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 300px;

    > button {
      margin: 5px 0;
    }
  }
}

.import-cont-table {
  display: flex;
  height: calc(100% - 233px);
  width: 100%;

  > .legend {
    height: 100%;
    min-width: 200px;
    max-width: 200px;
    margin-left: 5px;
    overflow: auto;

    > .legend-item {
      display: flex;
      align-items: center;
      padding: 5px;
      text-align: left;

      > img {
        width: 20px;
        margin-right: 5px;
      }
    }
  }
}

.ejob-reject-content {
  text-align: left;
  margin: 0 10px;

  > .collapsible-title-container {
    display: flex;
    align-items: center;
    cursor: pointer;

    > img {
      height: 20px;
      transition: 0.3s;
    }
  }

  > .message-reason-container {
    height: 100px;
  }
}

.container-popup-row {
  overflow: visible !important;
  display: flex;
  align-items: baseline;
}

.modal-content table {
  width: 100%;
  border-collapse: collapse;
}

.modal-content th,
.modal-content td {
  padding: 8px;
  text-align: center;
  border: 1px solid #ddd;
}

.modal-content th:first-child,
.modal-content td:first-child {
  text-align: left;
}

.disabled-row {
  opacity: 0.5;
  pointer-events: none;
}
.different-value {
  color: red;
}

//attachment popup
.attchWin-main {
  width: calc(100%);
  height: calc(100% - 10px);
  padding: 5px;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  background-color: #00000048;
  z-index: 999;

  > .attchWin-close {
    height: 30px;
    width: 30px;
    font-weight: bold;
    border-radius: 50%;
    background-color: white;
    color: black;
    text-align: center;
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 0;
    margin: 20px;
    font-size: 14px;
  }

  > .attchWin-display {
    width: 80%;
    margin: 0 auto;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background-color: #eaeaea;
    border-radius: 3px;
    display: flex;
    height: 90vh;

    > .left {
      position: relative;
      float: left;
      width: 100%;
      height: 100%;
      border: 1px solid black;
      background: black;
      height: 100%;
      text-align: center;
      display: flex;

      > .leftButton {
        width: auto;
        height: 100%;
        float: left;
        align-items: center;
        left: 0;

        > .navButton-left {
          margin: 0 auot;
          position: relative;
          z-index: 300;
          font-size: 36px;
          color: white;
          background: none;
          top: 50%;

          &:hover {
            cursor: pointer;
            background: rgba(200, 200, 200, 0.8);
          }
        }
      }

      > .rightButton {
        width: auto;
        height: 100%;
        float: right;
        align-items: center;

        > .navButton-right {
          margin: 0;
          position: relative;
          top: 50%;
          float: right;
          /* -webkit-transform: translateY(-50%);
      transform: translateY(-50%); */
          z-index: 300;
          font-size: 36px;
          color: white;
          background: none;

          &:hover {
            cursor: pointer;
            background: rgba(200, 200, 200, 0.8);
          }
        }
      }

      > .attchWin-attachment {
        position: relative;
        //margin: 0 auto;
        width: 100%;
        height: 100%;
        text-align: center;
        -o-object-fit: contain;
        object-fit: contain;
        float: left;
        align-self: center;
        //top: 25%;

        img {
          width: 70%;
          object-fit: contain;
          margin: 0 auto;
          max-height: 90vh;
        }

        &:hover {
          cursor: pointer;
        }

        iframe {
          width: 100%;
          height: 100%;
          min-height: 600px;
        }

        > .attachment-not-projectable-container {
          height: 100%;
          width: 100%;
          background-color: rgba(0, 0, 0, 0.7);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
          font-size: 40px;

          > span {
            margin: 10px 0 10px 0;
            color: white;
          }

          > button {
            height: 50px;
            width: 150px;
            margin: 10px 0 10px 0;
            font-size: 16px;

            > img {
              height: 24px;
              width: 24px;
            }
          }
        }
        .video-wrapper {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100%;
          width: 100%;
        }
      }
    }

    > .right {
      //position: relative;
      float: left;
      width: 500px;
      height: 100%;
      min-width: 250px;
      border: 1px solid black;
      display: grid;

      > .attchWin-info {
        position: relative;
        margin: auto 5px 0;
        text-align: left;
        margin: 5px;
        height: fit-content;
        overflow-x: auto;

        #infoHeader {
          width: 100%;
          table-layout: fixed;
          font-size: 12px;
          border-collapse: collapse;
          background: #d4dfeb;
          margin: 5px 0px;
          border: 1px solid black;

          td {
            padding: 3px;
          }
          th {
            font-weight: bold;
            width: 92px;
          }
        }

        #tableContent {
          width: 100%;
          position: relative;
          table-layout: fixed;
          font-size: 12px;
          border-collapse: collapse;
          margin: 20px auto;
          background: #fff;
          align-self: center;
          text-align: left;

          tr {
            border: 1px solid black;
            padding: 3px;
          }
          td {
            padding: 3px;
            border: 1px solid black;
            overflow-x: auto;
          }
          th {
            font-weight: bold;
            background: #d4dfeb;
            border: 1px solid black;
            padding: 3px;
            width: 97px;
          }
        }
      }
      > .count {
        position: relative;
        width: auto;
        text-align: center;
        margin: auto 3px 0;
        height: fit-content;
        border: 1px solid black;
        background: #a1a9b2;
      }
    }
  }
}

.right-menu {
  display: flex;
  flex-direction: column;
  height: 100%;

  > .right-menu-body-scroll {
    flex: 1;
    overflow-y: auto;

    > .header {
      margin-top: 5px;
      border-radius: 5px;
      height: 30px;
      width: 100%;
      background-color: #535cda;
      padding-left: 5px;
      display: flex;
      align-items: center;

      > .title {
        color: white;
        font-weight: bold;
      }
    }
  }

  > .right-menu-footer {
    width: 100%;
    background-color: #535cda;
    border-radius: 5px;
    display: flex;
    align-items: center;
    padding: 5px;
    position: relative;
    transition: 0.3s;
    justify-content: flex-end;
    max-height: 45px;

    > * {
      border-radius: 2.5px;
      background-color: white;
      width: 100%;
      height: 100%;
    }

    > .message-container {
      flex: 2;
      overflow: auto;
      padding: 5px;
      transition: 0.3s;
      position: absolute;
      left: 5px;
      bottom: 5px;
      max-height: calc(100% - 10px);
      height: 100%;
      max-width: calc(100% - 170px);
      width: 100%;
      z-index: 99;
      background: lightyellow;

      > * > * {
        > a {
          /* color: black; */
          cursor: pointer;
          padding: 2px;
          text-decoration: underline;
          color: blue;
        }
        a:hover {
          text-decoration: underline;
          background-color: yellow;
        }

        a:active {
          text-decoration: underline;
          background-color: royalblue;
        }
      }
    }
    > .buttons-container {
      display: flex;
      flex-direction: initial;
      background-color: #535cda;

      > * {
        display: flex;
        align-items: center;
        text-align: center;
        margin-left: 3px;

        > img {
          height: 25px;
          width: 25px;
          margin-right: 5px;
        }
      }
    }
  }
}

.right-menu-content-container {
  background-color: white;
  border-radius: 5px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 98;

  > * {
    width: 100%;
    padding: 5px;
    display: flex;
  }

  > .header-container {
    min-height: 30px;
    max-height: 30px;
    width: 100%;
    background-color: #535cda !important;
    // background-color: #f24a01;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: white;
    font-weight: bold;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    border-radius: 5px 5px 0 0;
    margin-bottom: 5px;

    > .header-back-button {
      padding-left: 5px;
      padding-right: 10px;
      cursor: pointer;
    }

    > .header-title {
      width: calc(100% - 30px);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      user-select: none;
    }
  }

  > .body-container {
    height: 100%;
    background-color: #eaeaea;
    overflow: auto;
  }

  > .footer-container {
    min-height: 50px;
    max-height: 50px;
    background-color: #eaeaea;
    align-items: center;
    border-top: 1px solid rgba(64, 64, 64, 0.5);
    width: 100%;

    > .message-container {
      width: 100%;
      height: 100%;
      border-radius: 5px;
      padding: 5px;
      overflow: auto;
    }
  }
}

.menu-action {
  margin-bottom: 5px;
  display: flex;
  gap: 5px;
  text-align: left;
  width: 100%;

  > .menu-action-icon {
    height: 20px;
    width: 20px;
  }
}

.left-menu-wrapper {
  display: flex;
  height: 100%;
  min-width: fit-content;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.vresizer {
  height: 3px;
  cursor: ns-resize;
  background-color: black;
  flex-shrink: 0;

  &:hover {
    background-color: #999;
  }
}

.details-wrapper-smk {
  display: flex;
  gap: 15px;
  width: 100%;
  align-items: flex-start;
  margin-top: 1px;
}

.details-wrapper-exemption {
  display: flex;
  gap: 15px;
  width: 100%;
  flex-direction: column;
  margin-top: 1px;
}

.tab-block-smk {
  border: 1px solid rgba(0, 0, 0, 0.5);
  position: relative;
  padding: 15px 10px 10px 10px;
  border-radius: 4px;
  background: white;
}

.tab-title-smk {
  width: fit-content;
  background-color: white;
  position: absolute;
  top: -10px;
  left: 10px;
  padding: 0 10px;
  font-weight: bold;
}

.smk-panel {
  width: 25%;
}

.invoice-panel {
  width: 75%;
  box-sizing: border-box;
}

.invoice-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(320px, 1fr);
  gap: 24px;
  width: 100%;
}

.invoice-left {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.invoice-headings,
.invoice-row {
  display: grid;
  grid-template-columns: 100px repeat(3, minmax(0, 1fr));
  align-items: center;
  gap: 8px;
  width: 100%;
}

.invoice-headings {
  text-align: center;
  font-size: 12px;
}

.invoice-row .label {
  min-width: 0;
}

.invoice-exchange-panel {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
}

.exchange-field-row {
  display: grid;
  grid-template-columns: 110px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
}

.exchange-rate-row {
  display: grid;
  grid-template-columns: 110px 110px minmax(150px, 1fr);
  align-items: center;
  gap: 8px;
}

.exchange-label {
  white-space: nowrap;
}

.smk-exchange-rate-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-left: 110px;
}

.smk-exchange-rate-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 62px;
  padding: 7px 12px;
  border: 1px solid #777;
  background: #f4f4f4;
  color: #111;
  cursor: pointer;
}

.smk-exchange-rate-button:hover {
  background: #e5e5e5;
}

.invoice-total-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}

.invoice-total-label {
  width: 192px;
  font-size: 1.1em;
}

.invoice-total-value {
  background-color: #467cdc;
  color: white;
  font-size: 1.1em;
  font-weight: bold;
}

.label {
  min-width: 80px;
}

.total-block {
  border: 1px solid rgba(128, 128, 128, 0.5);
  max-width: 150px;
  min-width: 150px;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  text-overflow: ellipsis;
  overflow: hidden;
  cursor: default;
  padding: 3px;
}

.exemption-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.field-wrapper {
  flex: 1;
}

.exemption-layout {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.left-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.right-section {
  width: 50%;
}

.clause-container ::v-deep textarea {
  height: 249px !important;
}

//#region for SMK Item
.table-container.top-right-div {
  width: 100% !important;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.table-container.top-right-div.has-batch-panel {
  --batch-panel-height: 48px;
}

.smk-wrapper {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.add-button-container {
  padding: 4px 2px;
  display: flex;
  justify-content: center;
  gap: 5px;
  position: sticky;
  left: 0;
  bottom: 0;
  background: white;
}

.add-item-btn {
  margin-bottom: 10px;
  padding: 4px 10px;
  background-color: #4caf50;
  color: white;
  border: none;
  cursor: pointer;
  width: 70%;
  text-align: center;
}

.deleteall-item-btn {
  margin-bottom: 10px;
  padding: 4px 10px;
  background-color: #f44336;
  color: white;
  border: none;
  cursor: pointer;
  text-align: center;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 10;
}

.batch-panel {
  position: sticky;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  background: #f0f0ff;
  padding: 8px 12px;
  border-bottom: 1px solid #c5c5ff;
  height: var(--batch-panel-height);
}

.batch-panel button {
  padding: 5px 12px;
  cursor: pointer;
}

.smk-title-row {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.title {
  font-weight: bold;
  font-size: 1.2em;
  margin-right: 10px;
}

.smk-edit-table.table-box-main {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.smk-edit-table .top-block {
  min-height: 34px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 8px;
  border: 1px solid #d8dcff;
  border-bottom: none;
  background: #fff;
  position: sticky;
  left: 0;
  top: 0;
  width: 100%;
}

.smk-edit-table .right-section,
.smk-edit-table .left-section {
  display: flex;
  align-items: center;
  gap: 8px;
}

.smk-edit-table .left-section {
  display: flex;
  align-items: self-end;
  gap: 8px;
}

.table-search {
  height: 24px;
  min-width: 220px;
  padding: 0 8px;
  border: 1px solid #cfd4ff;
  outline: none;
  box-sizing: border-box;
  font-size: 12px;
}

.smk-edit-table .table-block {
  flex: 1;
  min-height: 0;
  overflow: auto;
}

.smk-edit-table .table-header {
  display: flex;
  position: sticky;
  top: var(--batch-panel-height);
  z-index: 30;
  width: max-content;
}

.smk-edit-table .table-column {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  position: relative;
  box-sizing: border-box;
  border-right: 1px solid white;
  background-color: #535cda;
  color: #fff;
  overflow: visible;
}

.smk-edit-table .title-block {
  height: 24px;
  min-height: 24px;
  display: flex;
  align-items: center;
  padding: 0 4px;
  font-weight: 600;
  font-size: 12px;
  user-select: none;
  cursor: move;
  white-space: nowrap;
  justify-content: center;
}

.smk-edit-table .filter-block {
  padding: 2px 3px 3px;
  background: #535cda;
}

.smk-edit-table .column-filter {
  width: 100%;
  height: 20px;
  border: none;
  outline: none;
  padding: 0 4px;
  box-sizing: border-box;
  font-size: 11px;
}

.smk-edit-table .table-row {
  display: flex;
  overflow: visible;
  width: max-content;
}

.smk-edit-table .row-data {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  height: 32px;
  min-height: 32px;
  padding: 1px 3px;
  box-sizing: border-box;
  border-right: 1px solid rgba(128, 128, 128, 0.5);
  border-bottom: 1px solid #d6daf0;
  background: transparent;
  overflow: visible;
  position: relative;
}

.smk-edit-table .sticky-column {
  position: sticky;
  left: 0;
  z-index: 20;
  background: inherit;
  box-shadow: none !important;
}

.smk-edit-table .table-header .sticky-column {
  z-index: 35;
  background-color: #535cda !important;
}

.smk-edit-table .table-row .sticky-column {
  background: white !important;
  border-right: 1px solid #d6daf0;
}

.smk-edit-table .table-row:nth-child(even) .sticky-column {
  background: #e2e4ff !important;
}

.smk-edit-table .select-col {
  min-width: 40px;
  max-width: 40px;
  justify-content: center;
  padding: 0 2px;
}

.smk-edit-table .seq-col {
  min-width: 50px;
  max-width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.smk-edit-table .action-col {
  min-width: 120px;
  max-width: 120px;
  justify-content: center;
}

.smk-edit-table .input-with-icon {
  gap: 4px;
}

.smk-edit-table .input-with-icon > *:first-child {
  flex-shrink: 0;
}

.big-checkbox {
  width: 18px;
  height: 18px;
  vertical-align: middle;
}

.smk-edit-table .row-data button {
  height: 22px;
  padding: 0 10px;
  border: 1px solid #cfd4ff;
  background: white;
  cursor: pointer;
  font-size: 12px;
}

.col-resizer {
  position: absolute;
  right: 0;
  top: 0;
  width: 6px;
  height: 100%;
  cursor: ew-resize;
  user-select: none;
}

.col-resizer:hover {
  background: rgba(0, 0, 0, 0.15);
}

.smk-edit-table .blue-theme-row input:disabled,
.smk-edit-table .blue-theme-row textarea:disabled {
  pointer-events: none;
}

.smk-edit-table .blue-theme-row:nth-child(even) > .select-col.sticky-column {
  background: #e2e4ff !important;
}

.smk-edit-table .blue-theme-row:hover > .select-col.sticky-column {
  background: rgb(170, 170, 255) !important;
}

.smk-edit-table .blue-theme-row-selected > .row-data {
  background: rgb(170, 170, 255) !important;
  color: black !important;
}

.smk-edit-table .blue-theme-row-selected ::v-deep input:not([type='checkbox']),
.smk-edit-table .blue-theme-row-selected ::v-deep textarea,
.smk-edit-table .blue-theme-row-selected ::v-deep select {
  color: black !important;
  -webkit-text-fill-color: black !important;
  background: transparent !important;
  opacity: 1 !important;
}

.smk-edit-table .blue-theme-row-selected > .select-col.sticky-column,
.smk-edit-table .blue-theme-row-selected:nth-child(even) > .select-col.sticky-column,
.smk-edit-table .blue-theme-row-selected:hover > .select-col.sticky-column {
  background: rgb(170, 170, 255) !important;
  color: black !important;
}

.smk-item-slot {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.smk-item-slot .table-container.top-right-div {
  flex: 1;
  min-height: 0;
  height: 100% !important;
  width: 100% !important;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.smk-item-slot .add-button-container {
  flex-shrink: 0;
  margin-bottom: 0;
  padding: 4px 2px;
  height: 45px;
}

.smk-item-slot .batch-panel {
  position: relative !important;
  top: auto !important;
  left: auto !important;
  flex-shrink: 0;
  height: 42px;
  min-height: 42px;
  z-index: 5;
}

.smk-item-slot .smk-wrapper {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.smk-item-slot .smk-title-row {
  flex-shrink: 0;
  margin-bottom: 4px;
  height: 21px;
}

.smk-item-slot .smk-edit-table.table-box-main {
  flex: 1;
  min-height: 0;
  height: auto !important;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.smk-item-slot .smk-edit-table .top-block {
  flex-shrink: 0;
  position: relative !important;
  top: auto !important;
  left: auto !important;
  z-index: 4;
}

.smk-item-slot .smk-edit-table .table-block {
  flex: 1;
  min-height: 0;
  height: auto !important;
  overflow: auto !important;
}

.smk-item-slot .sticky-top {
  position: relative !important;
  top: auto !important;
}

.smk-item-slot .smk-edit-table .table-header {
  position: sticky;
  top: 0 !important;
  z-index: 50 !important;
  background: #535cda;
}

.smk-item-slot .smk-edit-table .table-header .select-col {
  position: sticky;
  left: 0;
  z-index: 80 !important;
  background: #535cda !important;
}

.smk-item-slot .smk-edit-table .table-row .select-col {
  position: sticky;
  left: 0;
  z-index: 20;
}

.smk-item-expand-btn {
  width: 22px;
  height: 22px;
  padding: 2px;
  margin-right: 6px;
  border: 1px solid #7d8be8;
  background: #eef1ff;
  border-radius: 3px;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
}

.smk-item-expand-btn:hover {
  background: #dfe5ff;
}

.smk-item-expand-icon {
  width: 14px;
  height: 14px;
  object-fit: contain;
  display: block;
  transition: 0.3s;

  &:hover {
    height: 20px;
    width: 20px;
  }
}

.smk-item-slot.smk-item-popup-expanded {
  position: fixed !important;
  z-index: 99999 !important;

  top: 75px;
  left: 45px;
  right: 45px;
  bottom: 85px;

  background: white;
  padding: 10px 10px 18px 10px;
  border: 1px solid #999;
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.15);

  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
}

.smk-item-slot.smk-item-popup-expanded .table-container.top-right-div,
.smk-item-slot.smk-item-popup-expanded .smk-wrapper,
.smk-item-slot.smk-item-popup-expanded .smk-edit-table.table-box-main {
  flex: 1 !important;
  min-height: 0 !important;
  height: auto !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
}

.smk-item-slot.smk-item-popup-expanded .smk-edit-table .top-block {
  flex-shrink: 0 !important;
}

.smk-item-slot.smk-item-popup-expanded .smk-edit-table .table-block {
  flex: 1 !important;
  min-height: 0 !important;
  height: auto !important;
  max-height: calc(100vh - 230px) !important;
  overflow-x: scroll !important;
  overflow-y: scroll !important;
  box-sizing: border-box;
}

.smk-item-slot.smk-item-popup-expanded .smk-edit-table .table-header,
.smk-item-slot.smk-item-popup-expanded .smk-edit-table .table-row {
  width: max-content !important;
  min-width: max-content !important;
}

.smk-item-duty-panel {
  position: fixed;
  z-index: 900;
  width: 430px;
  max-width: calc(100vw - 16px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
  pointer-events: auto;
}

.smk-item-duty-panel.pinned {
  z-index: 950;
}

.smk-item-duty-toolbar {
  height: 22px;
  padding: 0 4px 0 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #c7d5e3;
  border: 1px solid #7d8d9d;
  border-bottom: 0;

  button {
    width: 18px;
    height: 18px;
    padding: 0;
    border: 0;
    background: transparent;
    color: #333;
    font-size: 18px;
    line-height: 18px;
    cursor: pointer;
  }
}

.smk-duty-edit {
  width: 100%;
  height: 22px;
  padding: 1px 3px;
  border: 1px solid #777;
  background: white;
  text-align: right;
  box-sizing: border-box;
}

.smk-item-duty-table {
  border-collapse: collapse;
  width: 100%;
  font-size: 11px;
  background: #f3f3f3;
}

.smk-item-duty-table th,
.smk-item-duty-table td {
  border: 1px solid #7e8791;
  height: 20px;
  min-width: 42px;
  padding: 1px 5px;
  text-align: center;
  box-sizing: border-box;
}

.smk-item-duty-table th {
  background: #c7d5e4;
  font-weight: normal;
}

.smk-item-duty-table td:first-child {
  min-width: 78px;
  text-align: left;
  background: #d8e0e9;
}

.smk-item-duty-table td:nth-child(2),
.smk-item-duty-table td:nth-child(3),
.smk-item-duty-table td:nth-child(4) {
  background: #cbcaff;
}

.smk-item-duty-table td:nth-child(7) {
  background: #00e2df;
}

.ejob-popup {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  top: 50px;
  left: 0;
  height: calc(100% - 50px);
  width: 100%;
  z-index: 199;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  > .ejob-content {
    background-color: lightgray;
    padding: 5px;
    width: calc(100% - 90px);
    height: calc(100% - 20px);
    position: relative;
    display: flex;
    flex-direction: column;

    > .top-section,
    > .table-section,
    > .bottom-section {
      background-color: white;
      border-radius: 5px;
      padding: 5px;
    }

    > .top-section,
    > .bottom-section {
      display: flex;
      justify-content: flex-end;
    }

    > .top-section {
      align-items: center;

      > :first-child {
        margin-right: 5px;
      }

      > :last-child {
        margin-left: 5px;
      }
    }

    > .table-section {
      height: 100%;
      margin-top: 5px;
      overflow: hidden;

      > .verification-upload {
        display: flex;
        flex-direction: column;
        height: 100%;

        > object {
          background-color: lightgray;
          height: 100%;
        }
      }
    }

    > .bottom-section {
      margin-top: 5px;

      > button {
        margin-left: 5px;
        color: white;
      }

      > :nth-child(1) {
        background-color: green;
      }

      > :nth-child(2) {
        background-color: red;
      }

      > :nth-child(3),
      > .cancel-btn {
        background-color: gray;
      }
    }
  }
}

.milestones-item-smk {
  border: 1px solid rgba(128, 128, 128, 0.5);
  max-width: 100px;
  min-width: 100px;
  height: 50px;
  cursor: default;
  padding: 3px 20px 3px 3px;
  box-sizing: border-box;
  overflow: hidden;
}

.milestones-item-smk .smk-request-type,
.milestones-item-smk .smk-status-code {
  display: block;
  width: 100%;
  white-space: nowrap;
  overflow: visible;
  text-overflow: unset;
  line-height: 14px;
}

.milestones-item-smk .smk-remarks {
  display: block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 14px;
}
//#endregion

.smk-documents-layout,
.smk-documents-section,
.smk-documents-panel,
.smk-documents-table-scroll {
  width: 100%;
  min-width: 0;
}

.smk-documents-panel {
  overflow: hidden;
}

.smk-documents-table-scroll {
  overflow-x: auto;
  overflow-y: hidden;
}

.smk-documents-table-scroll ::v-deep .table-box-main {
  width: 100%;
  min-width: 0;
}

.smk-documents-table-scroll ::v-deep .table-block {
  overflow-x: auto !important;
  overflow-y: auto;
}

.smk-documents-table-scroll ::v-deep .table-header,
.smk-documents-table-scroll ::v-deep .table-row {
  width: max-content;
}

.smk-documents-split {
  display: flex;
  align-items: stretch;
  gap: 4px;
  width: 100%;
  min-width: 0;
}

.smk-documents-list-pane {
  flex: 1 1 100%;
  width: 100%;
  min-width: 0;
}

.smk-documents-list-pane--half {
  flex: 0 0 calc(50% - 2px);
  width: calc(50% - 2px);
}

.smk-documents-editor-pane {
  flex: 0 0 calc(50% - 2px);
  width: calc(50% - 2px);
  min-width: 0;
  overflow: auto;
}

.smk-documents-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.smk-documents-toolbar button + button {
  margin-left: 3px;
}

.smk-documents-editor-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  padding: 8px;
}

.smk-documents-editor-fields > * {
  min-width: 0;
}

.smk-doc-form-error {
  color: #c62828;
  font-size: 12px;
  padding: 4px 8px;
}

.smk-documents-table-scroll {
  width: 100%;
  min-width: 0;
  overflow-x: auto;
}

.menu-disabled-wrapper {
  display: block;
  width: 100%;
}

.menu-disabled-wrapper .menu-action {
  width: 100%;
  cursor: not-allowed;
  opacity: 0.55;
}

.flat-file-preview {
  width: 100%;
  max-width: none;
  box-sizing: border-box;
}

.flat-file-preview-header {
  display: flex;
  gap: 24px;
  margin-bottom: 10px;
}

.flat-file-preview-text {
  width: 100%;
  height: 60vh;
  font-family: Consolas, monospace;
  font-size: 12px;
  white-space: pre;
  overflow: auto;
  resize: none;
}

.flat-file-errors {
  color: #b00020;
  white-space: pre-wrap;
}

.dpo-popup {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.3);
  top: 50px;
  left: 0;
  height: calc(100% - 50px);
  width: 100%;
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  > .dpo-popup-content {
    background-color: white;
    width: calc(100% - 90px);
    height: 95%;
    border-radius: 3px;
    position: relative;
    display: flex;
    overflow: hidden;
    flex-direction: column;

    > .dpo-popup-header,
    > .dpo-popup-body,
    > .dpo-popup-footer {
      padding: 5px;
      gap: 5px;
    }

    > .dpo-popup-header,
    > .dpo-popup-footer {
      display: flex;
      justify-content: flex-end;
    }

    > .dpo-popup-header {
      align-items: center;
      border-bottom: 2px solid #b4b4b4;
      padding: 10px;

      > .header-left {
        display: flex;
        flex-grow: 1;
        gap: 15px;
      }

      > .header-right {
        width: 50%;
        display: flex;
        gap: 5px;
        align-items: center;
        justify-content: flex-end;
      }

      > .company-select {
        margin-right: 50%;
        flex-grow: 1;
        display: flex;
        flex-direction: row;
      }
    }

    > .dpo-popup-body {
      height: 100%;
      overflow: hidden;
    }

    > .dpo-popup-footer {
      border-top: 2px solid #b4b4b4;

      > button > img {
        height: 25px;
        width: 25px;
      }
    }
  }
}

.flat-file-preview-error {
  font-weight: bold;
  background-color: lightyellow;
  color: red;
  min-height: 100px;
  white-space: pre-wrap;
  box-sizing: border-box;
  width: 100%;
}

.flat-file-preview-actions {
  margin-top: 10px;
}

.tooltip-icon {
  cursor: pointer;
  margin-right: 5px;
  z-index: 9999;
}

.smk-edit-table .row-data .smk-master-warning-icon {
  position: relative;
  z-index: 1;
}

.smk-edit-table .row-data:focus-within {
  z-index: 120;
}

.job-documents-table {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
}

.job-documents-table ::v-deep .table-box-main {
  width: fit-content !important;
  min-width: 0 !important;
  max-width: none !important;
}

.job-documents-table ::v-deep .table-block {
  width: fit-content !important;
  min-width: 0 !important;
  overflow: visible !important;
}

.job-documents-table ::v-deep .table-header,
.job-documents-table ::v-deep .table-row {
  width: max-content !important;
  min-width: max-content !important;
}

.smk-grid-input-query ::v-deep .bottom-block {
  height: 40px;
  min-height: 40px;
  max-height: 40px;
  flex: 0 0 40px;
  overflow: hidden;
}

.smk-grid-input-query ::v-deep .bottom-block .bottom-content {
  height: 40px;
  min-height: 40px;
  max-height: 40px;
  align-items: center;
  overflow: hidden;
}

.smk-grid-input-query ::v-deep .bottom-block .bottom-spacer {
  flex: 1 1 auto;
  width: auto !important;
  min-width: 5px;
}

.smk-grid-input-query ::v-deep .bottom-block .buttons-content {
  flex: 0 0 auto;
  width: auto !important;
  height: 40px;
  white-space: nowrap;
  align-items: center;
}

.smk-grid-input-query ::v-deep .bottom-block .buttons-content > div {
  display: flex;
  flex: 0 0 auto;
  white-space: nowrap;
}

.smk-grid-input-query ::v-deep .bottom-block .buttons-content > button,
.smk-grid-input-query ::v-deep .bottom-block .buttons-content > div > button {
  flex: 0 0 auto;
  height: 26px;
  line-height: 20px;
  min-width: 28px;
  width: auto !important;
  white-space: nowrap;
}

.smk-column-toggle-button {
  height: 27px;
  margin-bottom: 10px;
  padding: 3px 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border: 1px solid #b8b8b8;
  border-radius: 4px;
  background: #fff;
  color: #333;
  cursor: pointer;
  white-space: nowrap;
}

.smk-column-toggle-button img {
  width: 24px;
  height: 24px;
  object-fit: contain;

  // Untoggled: black and white.
  filter: grayscale(1);
  opacity: 0.65;
}

.smk-column-toggle-button.active {
  border-color: #4caf50;
  background: #edf9ee;
  color: #16731c;
}

.smk-column-toggle-button.active img {
  // Toggled: original coloured icon.
  filter: none;
  opacity: 1;
}

.smk-column-title-with-toggle {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.smk-header-toggle {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-size: 10px;
  font-weight: normal;
  cursor: pointer;
  white-space: nowrap;
}

.smk-header-toggle input {
  width: 13px;
  height: 13px;
  margin: 0;
  cursor: pointer;
}

.smk-header-toggle input:disabled {
  cursor: not-allowed;
}

.smk-exclusive-checkbox-cell {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.smk-exclusive-checkbox-cell .big-checkbox {
  display: block;
  margin: 0;
}

.smk-long-description-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.smk-long-description-details {
  flex: 0 0 auto;
  display: flex;
  gap: 30px;
  margin-bottom: 10px;
}

.smk-long-description-textarea {
  flex: 1;
  width: 100%;
  padding: 8px;
  resize: none;
  box-sizing: border-box;
  border: 1px solid #aaa;
  outline: none;
  font: inherit;
}

.smk-long-description-textarea:focus {
  border-color: #467cdc;
}

.smk-long-description-textarea:disabled {
  background: #f2f2f2;
  color: #555;
}

.smk-item-description-cell {
  width: 100%;
  height: 28px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 26px;
  align-items: center;
  gap: 2px;
  overflow: hidden;
}

.smk-item-description-input {
  width: 100% !important;
  min-width: 0 !important;
  margin: 0 !important;
}

.smk-edit-table .row-data .smk-long-description-button {
  position: static;
  width: 24px;
  min-width: 24px;
  height: 24px;
  margin: 0;
  padding: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 2px;
  background: transparent;
  cursor: pointer;
}

.smk-long-description-button img {
  width: 20px;
  height: 20px;
  object-fit: contain;
  filter: grayscale(1);
  opacity: 0.65;
}

.smk-long-description-button:hover {
  background: #e8ecff !important;
}

.smk-long-description-button.active img {
  filter: none;
  opacity: 1;
}

.smk-item-duty-actions {
  .smk-duty-update {
    background-color: green !important;
    color: white !important;
  }

  .smk-duty-cancel {
    background-color: grey !important;
    color: white !important;
  }
}
.smk-item-duty-panel.with-cess {
  width: 740px;
  overflow-x: auto;
}

.smk-item-hover-tables {
  display: flex;
  align-items: flex-start;
  gap: 6px;
}

.smk-item-duty-table {
  flex: 0 0 430px;
}

.smk-item-cess-table {
  flex: 0 0 270px;
  width: 270px;
  border-collapse: collapse;
  font-size: 11px;
  background: #f3f3f3;
}

.smk-item-cess-table th,
.smk-item-cess-table td {
  height: 20px;
  padding: 1px 4px;
  border: 1px solid #7e8791;
  text-align: center;
  box-sizing: border-box;
}

.smk-item-cess-table th {
  background: #c7d5e4;
  font-weight: normal;
  white-space: nowrap;
}

.smk-item-cess-table td:first-child {
  min-width: 82px;
  text-align: left;
  background: #d8e0e9;
}

.smk-item-cess-table td:nth-child(2),
.smk-item-cess-table td:nth-child(3) {
  background: #cbcaff;
}

.smk-item-cess-table td:nth-child(4) {
  background: white;
}

.smk-item-cess-table td:nth-child(5) {
  background: #00e2df;
}

.smk-edit-table {
  .smk-group-item {
    --smk-group-color: #087f73;
  }

  .smk-group-tariff {
    --smk-group-color: #07ae28;
  }

  .smk-group-invoice-qty {
    --smk-group-color: #2878b5;
  }

  .smk-group-tariff-qty {
    --smk-group-color: #7655a6;
  }

  .smk-group-price {
    --smk-group-color: #b44c67;
  }

  .smk-group-duty-qty {
    --smk-group-color: #4d7c45;
  }

  .smk-group-alcohol {
    --smk-group-color: #566573;
  }

  .smk-group-vehicle {
    --smk-group-color: #f18030;
  }

  .smk-group-warehouse {
    --smk-group-color: #16718c;
  }

  .table-column.smk-field-group {
    background-color: var(--smk-group-color) !important;
    border-top: 2px solid var(--smk-group-color);
    border-bottom: 3px solid var(--smk-group-color);
  }

  .table-column.smk-field-group .filter-block {
    background-color: var(--smk-group-color) !important;
  }

  .row-data.smk-field-group {
    border-top: 0;
    border-bottom: 1px solid #d6daf0;
  }

  .table-column.smk-group-start,
  .row-data.smk-group-start {
    margin-left: 0px;
    border-left: 3px solid var(--smk-group-color) !important;
  }

  .table-column.smk-group-end,
  .row-data.smk-group-end {
    border-right: 3px solid var(--smk-group-color) !important;
  }

  .table-column.smk-group-start {
    border-radius: 4px 0 0 0;
  }

  .table-column.smk-group-end {
    border-radius: 0 4px 0 0;
  }
}
.smk-transport-section {
  margin-top: 10px;
  width: 100%;
  border: 1px solid #b8b8b8;
  padding: 8px;
}

.smk-transport-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 8px;
  width: 100%;
}

.smk-transport-layout.editing {
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
}

.smk-transport-table,
.smk-transport-editor {
  min-width: 0;
  width: 100%;
}

.smk-transport-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
}

.smk-transport-editor-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 5px;
  margin-top: 8px;
}
</style>
